(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("Dz4HH", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return EffectScope; });
$parcel$export(module.exports, "ReactiveEffect", function () { return ReactiveEffect; });
$parcel$export(module.exports, "resetTracking", function () { return resetTracking; });
$parcel$export(module.exports, "pauseTracking", function () { return pauseTracking; });
$parcel$export(module.exports, "track", function () { return track; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "toRaw", function () { return toRaw; });
$parcel$export(module.exports, "isRef", function () { return isRef; });
$parcel$export(module.exports, "reactive", function () { return reactive; });
$parcel$export(module.exports, "shallowReactive", function () { return shallowReactive; });
$parcel$export(module.exports, "isReactive", function () { return isReactive; });
$parcel$export(module.exports, "isProxy", function () { return isProxy; });
$parcel$export(module.exports, "markRaw", function () { return markRaw; });
$parcel$export(module.exports, "ref", function () { return ref; });
$parcel$export(module.exports, "shallowRef", function () { return shallowRef; });
$parcel$export(module.exports, "unref", function () { return unref; });
$parcel$export(module.exports, "proxyRefs", function () { return proxyRefs; });
$parcel$export(module.exports, "computed", function () { return computed; });

var $juqrk = parcelRequire("juqrk");

var $bNI6E = parcelRequire("bNI6E");

var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");

var $j3cSI = parcelRequire("j3cSI");
function warn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "[Vue warn] ".concat(msg)
    ].concat((0, $aYXpI._)(args)));
}
var activeEffectScope;
var effectScopeStack = [];
var EffectScope = /*#__PURE__*/ function() {
    "use strict";
    function EffectScope() {
        var detached = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $juqrk._)(this, EffectScope);
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        if (!detached && activeEffectScope) {
            this.parent = activeEffectScope;
            this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    (0, $bNI6E._)(EffectScope, [
        {
            key: "run",
            value: function run(fn) {
                if (this.active) try {
                    this.on();
                    return fn();
                } finally{
                    this.off();
                }
            }
        },
        {
            key: "on",
            value: function on() {
                if (this.active) {
                    effectScopeStack.push(this);
                    activeEffectScope = this;
                }
            }
        },
        {
            key: "off",
            value: function off() {
                if (this.active) {
                    effectScopeStack.pop();
                    activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
                }
            }
        },
        {
            key: "stop",
            value: function stop(fromParent) {
                if (this.active) {
                    this.effects.forEach(function(e) {
                        return e.stop();
                    });
                    this.cleanups.forEach(function(cleanup) {
                        return cleanup();
                    });
                    if (this.scopes) this.scopes.forEach(function(e) {
                        return e.stop(true);
                    });
                    // nested scope, dereference from parent to avoid memory leaks
                    if (this.parent && !fromParent) {
                        // optimized O(1) removal
                        var last = this.parent.scopes.pop();
                        if (last && last !== this) {
                            this.parent.scopes[this.index] = last;
                            last.index = this.index;
                        }
                    }
                    this.active = false;
                }
            }
        }
    ]);
    return EffectScope;
}();
function effectScope(detached) {
    return new EffectScope(detached);
}
function recordEffectScope(effect, scope) {
    scope = scope || activeEffectScope;
    if (scope && scope.active) scope.effects.push(effect);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
var createDep = function(effects) {
    var dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
var wasTracked = function(dep) {
    return (dep.w & trackOpBit) > 0;
};
var newTracked = function(dep) {
    return (dep.n & trackOpBit) > 0;
};
var initDepMarkers = function(param) {
    var deps = param.deps;
    if (deps.length) for(var i = 0; i < deps.length; i++)deps[i].w |= trackOpBit; // set was tracked
};
var finalizeDepMarkers = function(effect) {
    var deps = effect.deps;
    if (deps.length) {
        var ptr = 0;
        for(var i = 0; i < deps.length; i++){
            var dep = deps[i];
            if (wasTracked(dep) && !newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            // clear bits
            dep.w &= ~trackOpBit;
            dep.n &= ~trackOpBit;
        }
        deps.length = ptr;
    }
};
var targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
var effectTrackDepth = 0;
var trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels op recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */ var maxMarkerBits = 30;
var effectStack = [];
var activeEffect;
var ITERATE_KEY = Symbol("");
var MAP_KEY_ITERATE_KEY = Symbol("");
var ReactiveEffect = /*#__PURE__*/ function() {
    "use strict";
    function ReactiveEffect(fn) {
        var scheduler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, scope = arguments.length > 2 ? arguments[2] : void 0;
        (0, $juqrk._)(this, ReactiveEffect);
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        recordEffectScope(this, scope);
    }
    (0, $bNI6E._)(ReactiveEffect, [
        {
            key: "run",
            value: function run() {
                if (!this.active) return this.fn();
                if (!effectStack.includes(this)) try {
                    effectStack.push(activeEffect = this);
                    enableTracking();
                    trackOpBit = 1 << ++effectTrackDepth;
                    if (effectTrackDepth <= maxMarkerBits) initDepMarkers(this);
                    else cleanupEffect(this);
                    return this.fn();
                } finally{
                    if (effectTrackDepth <= maxMarkerBits) finalizeDepMarkers(this);
                    trackOpBit = 1 << --effectTrackDepth;
                    resetTracking();
                    effectStack.pop();
                    var n = effectStack.length;
                    activeEffect = n > 0 ? effectStack[n - 1] : undefined;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.active) {
                    cleanupEffect(this);
                    if (this.onStop) this.onStop();
                    this.active = false;
                }
            }
        }
    ]);
    return ReactiveEffect;
}();
function cleanupEffect(effect) {
    var deps = effect.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect);
        deps.length = 0;
    }
}
function effect(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    var _effect = new ReactiveEffect(fn);
    if (options) {
        (0, $j3cSI.extend)(_effect, options);
        if (options.scope) recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    var runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
var shouldTrack = true;
var trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    var last = trackStack.pop();
    shouldTrack = last === undefined ? true : last;
}
function track(target, type, key) {
    if (!isTracking()) return;
    var depsMap = targetMap.get(target);
    if (!depsMap) targetMap.set(target, depsMap = new Map());
    var dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = createDep());
    var eventInfo = undefined;
    trackEffects(dep, eventInfo);
}
function isTracking() {
    return shouldTrack && activeEffect !== undefined;
}
function trackEffects(dep, debuggerEventExtraInfo) {
    var shouldTrack = false;
    if (effectTrackDepth <= maxMarkerBits) {
        if (!newTracked(dep)) {
            dep.n |= trackOpBit; // set newly tracked
            shouldTrack = !wasTracked(dep);
        }
    } else // Full cleanup mode.
    shouldTrack = !dep.has(activeEffect);
    if (shouldTrack) {
        dep.add(activeEffect);
        activeEffect.deps.push(dep);
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = targetMap.get(target);
    if (!depsMap) // never been tracked
    return;
    var deps = [];
    if (type === "clear" /* CLEAR */ ) // collection being cleared
    // trigger all effects for target
    deps = (0, $aYXpI._)(depsMap.values());
    else if (key === "length" && (0, $j3cSI.isArray)(target)) depsMap.forEach(function(dep, key) {
        if (key === "length" || key >= newValue) deps.push(dep);
    });
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) deps.push(depsMap.get(key));
        // also run for iteration key on ADD | DELETE | Map.SET
        switch(type){
            case "add" /* ADD */ :
                if (!(0, $j3cSI.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0, $j3cSI.isMap)(target)) deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                } else if ((0, $j3cSI.isIntegerKey)(key)) // new index added to array -> length changes
                deps.push(depsMap.get("length"));
                break;
            case "delete" /* DELETE */ :
                if (!(0, $j3cSI.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0, $j3cSI.isMap)(target)) deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set" /* SET */ :
                if ((0, $j3cSI.isMap)(target)) deps.push(depsMap.get(ITERATE_KEY));
                break;
        }
    }
    var eventInfo = undefined;
    if (deps.length === 1) {
        if (deps[0]) triggerEffects(deps[0]);
    } else {
        var _effects;
        var effects = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dep = _step.value;
                if (dep) (_effects = effects).push.apply(_effects, (0, $aYXpI._)(dep));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        triggerEffects(createDep(effects));
    }
}
function triggerEffects(dep, debuggerEventExtraInfo) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // spread into array for stabilization
        for(var _iterator = ((0, $j3cSI.isArray)(dep) ? dep : (0, $aYXpI._)(dep))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var effect = _step.value;
            if (effect !== activeEffect || effect.allowRecurse) {
                if (effect.scheduler) effect.scheduler();
                else effect.run();
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var isNonTrackableKeys = /*#__PURE__*/ (0, $j3cSI.makeMap)("__proto__,__v_isRef,__isVue");
var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter((0, $j3cSI.isSymbol)));
var get = /*#__PURE__*/ createGetter();
var shallowGet = /*#__PURE__*/ createGetter(false, true);
var readonlyGet = /*#__PURE__*/ createGetter(true);
var shallowReadonlyGet = /*#__PURE__*/ createGetter(true, true);
var arrayInstrumentations = /*#__PURE__*/ createArrayInstrumentations();
function createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)track(arr, "get" /* GET */ , i + "");
            // we run the method using the original args first (which may be reactive)
            var res = (_arr = arr)[key].apply(_arr, (0, $aYXpI._)(args));
            if (res === -1 || res === false) // if that didn't work, run it again using raw values.
            return (_arr1 = arr)[key].apply(_arr1, (0, $aYXpI._)(args.map(toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            pauseTracking();
            var res = toRaw(this)[key].apply(this, args);
            resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function createGetter() {
    var isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* RAW */  && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) return target;
        var targetIsArray = (0, $j3cSI.isArray)(target);
        if (!isReadonly && targetIsArray && (0, $j3cSI.hasOwn)(arrayInstrumentations, key)) return Reflect.get(arrayInstrumentations, key, receiver);
        var res = Reflect.get(target, key, receiver);
        if ((0, $j3cSI.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
        if (!isReadonly) track(target, "get" /* GET */ , key);
        if (shallow) return res;
        if (isRef(res)) {
            // ref unwrapping - does not apply for Array + integer key.
            var shouldUnwrap = !targetIsArray || !(0, $j3cSI.isIntegerKey)(key);
            return shouldUnwrap ? res.value : res;
        }
        if ((0, $j3cSI.isObject)(res)) // Convert returned value into a proxy as well. we do the isObject check
        // here to avoid invalid value warning. Also need to lazy access readonly
        // and reactive here to avoid circular dependency.
        return isReadonly ? readonly(res) : reactive(res);
        return res;
    };
}
var set = /*#__PURE__*/ createSetter();
var shallowSet = /*#__PURE__*/ createSetter(true);
function createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set(target, key, value, receiver) {
        var oldValue = target[key];
        if (!shallow) {
            value = toRaw(value);
            oldValue = toRaw(oldValue);
            if (!(0, $j3cSI.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = (0, $j3cSI.isArray)(target) && (0, $j3cSI.isIntegerKey)(key) ? Number(key) < target.length : (0, $j3cSI.hasOwn)(target, key);
        var result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === toRaw(receiver)) {
            if (!hadKey) trigger(target, "add" /* ADD */ , key, value);
            else if ((0, $j3cSI.hasChanged)(value, oldValue)) trigger(target, "set" /* SET */ , key, value, oldValue);
        }
        return result;
    };
}
function deleteProperty(target, key) {
    var hadKey = (0, $j3cSI.hasOwn)(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) trigger(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function has(target, key) {
    var result = Reflect.has(target, key);
    if (!(0, $j3cSI.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has" /* HAS */ , key);
    return result;
}
function ownKeys(target) {
    track(target, "iterate" /* ITERATE */ , (0, $j3cSI.isArray)(target) ? "length" : ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var mutableHandlers = {
    get: get,
    set: set,
    deleteProperty: deleteProperty,
    has: has,
    ownKeys: ownKeys
};
var readonlyHandlers = {
    get: readonlyGet,
    set: function(target, key) {
        return true;
    },
    deleteProperty: function(target, key) {
        return true;
    }
};
var shallowReactiveHandlers = /*#__PURE__*/ (0, $j3cSI.extend)({}, mutableHandlers, {
    get: shallowGet,
    set: shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
var shallowReadonlyHandlers = /*#__PURE__*/ (0, $j3cSI.extend)({}, readonlyHandlers, {
    get: shallowReadonlyGet
});
var toShallow = function(value) {
    return value;
};
var getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function get$1(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* RAW */ ];
    var rawTarget = toRaw(target);
    var rawKey = toRaw(key);
    if (key !== rawKey) !isReadonly && track(rawTarget, "get" /* GET */ , key);
    !isReadonly && track(rawTarget, "get" /* GET */ , rawKey);
    var _$has = getProto(rawTarget).has;
    var wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    if (_$has.call(rawTarget, key)) return wrap(target.get(key));
    else if (_$has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) // #3602 readonly(reactive(Map))
    // ensure that the nested reactive `Map` can do tracking for itself
    target.get(key);
}
function has$1(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw" /* RAW */ ];
    var rawTarget = toRaw(target);
    var rawKey = toRaw(key);
    if (key !== rawKey) !isReadonly && track(rawTarget, "has" /* HAS */ , key);
    !isReadonly && track(rawTarget, "has" /* HAS */ , rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw" /* RAW */ ];
    !isReadonly && track(toRaw(target), "iterate" /* ITERATE */ , ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function add(value) {
    value = toRaw(value);
    var target = toRaw(this);
    var proto = getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        trigger(target, "add" /* ADD */ , value, value);
    }
    return this;
}
function set$1(key, value) {
    value = toRaw(value);
    var target = toRaw(this);
    var _getProto = getProto(target), _$has = _getProto.has, get = _getProto.get;
    var hadKey = _$has.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = _$has.call(target, key);
    }
    var oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) trigger(target, "add" /* ADD */ , key, value);
    else if ((0, $j3cSI.hasChanged)(value, oldValue)) trigger(target, "set" /* SET */ , key, value, oldValue);
    return this;
}
function deleteEntry(key) {
    var target = toRaw(this);
    var _getProto = getProto(target), _$has = _getProto.has, get = _getProto.get;
    var hadKey = _$has.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = _$has.call(target, key);
    }
    var oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    var result = target.delete(key);
    if (hadKey) trigger(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function clear() {
    var target = toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = undefined;
    // forward the operation before queueing reactions
    var result = target.clear();
    if (hadItems) trigger(target, "clear" /* CLEAR */ , undefined, undefined, oldTarget);
    return result;
}
function createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw" /* RAW */ ];
        var rawTarget = toRaw(target);
        var wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
        !isReadonly && track(rawTarget, "iterate" /* ITERATE */ , ITERATE_KEY);
        return target.forEach(function(value, key) {
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw" /* RAW */ ];
        var rawTarget = toRaw(target);
        var targetIsMap = (0, $j3cSI.isMap)(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $aYXpI._)(args));
        var wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
        !isReadonly && track(rawTarget, "iterate" /* ITERATE */ , isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return(// iterable protocol
        (0, $ect5N._)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return type === "delete" /* DELETE */  ? false : this;
    };
}
function createInstrumentations() {
    var mutableInstrumentations = {
        get: function(key) {
            return get$1(this, key);
        },
        get size () {
            return size(this);
        },
        has: has$1,
        add: add,
        set: set$1,
        delete: deleteEntry,
        clear: clear,
        forEach: createForEach(false, false)
    };
    var shallowInstrumentations = {
        get: function(key) {
            return get$1(this, key, false, true);
        },
        get size () {
            return size(this);
        },
        has: has$1,
        add: add,
        set: set$1,
        delete: deleteEntry,
        clear: clear,
        forEach: createForEach(false, true)
    };
    var readonlyInstrumentations = {
        get: function(key) {
            return get$1(this, key, true);
        },
        get size () {
            return size(this, true);
        },
        has: function(key) {
            return has$1.call(this, key, true);
        },
        add: createReadonlyMethod("add" /* ADD */ ),
        set: createReadonlyMethod("set" /* SET */ ),
        delete: createReadonlyMethod("delete" /* DELETE */ ),
        clear: createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: createForEach(true, false)
    };
    var shallowReadonlyInstrumentations = {
        get: function(key) {
            return get$1(this, key, true, true);
        },
        get size () {
            return size(this, true);
        },
        has: function(key) {
            return has$1.call(this, key, true);
        },
        add: createReadonlyMethod("add" /* ADD */ ),
        set: createReadonlyMethod("set" /* SET */ ),
        delete: createReadonlyMethod("delete" /* DELETE */ ),
        clear: createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations[method] = createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = createIterableMethod(method, true, false);
        shallowInstrumentations[method] = createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
var /* #__PURE__*/ _createInstrumentations = (0, $fGQt0._)(createInstrumentations(), 4), mutableInstrumentations = _createInstrumentations[0], readonlyInstrumentations = _createInstrumentations[1], shallowInstrumentations = _createInstrumentations[2], shallowReadonlyInstrumentations = _createInstrumentations[3];
function createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* RAW */ ) return target;
        return Reflect.get((0, $j3cSI.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var mutableCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(false, false)
};
var shallowCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(false, true)
};
var readonlyCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(true, false)
};
var shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    var rawKey = toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        var type = (0, $j3cSI.toRawType)(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive ") + "versions of the same object".concat(type === "Map" ? " as keys" : "", ", ") + "which can lead to inconsistencies. " + "Avoid differentiating between the raw and reactive versions " + "of an object and only use the reactive version if possible.");
    }
}
var reactiveMap = new WeakMap();
var shallowReactiveMap = new WeakMap();
var readonlyMap = new WeakMap();
var shallowReadonlyMap = new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip" /* SKIP */ ] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, $j3cSI.toRawType)(value));
}
function reactive(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (target && target["__v_isReadonly" /* IS_READONLY */ ]) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */ function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $j3cSI.isObject)(target)) return target;
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* RAW */ ] && !(isReadonly && target["__v_isReactive" /* IS_REACTIVE */ ])) return target;
    // target already has corresponding Proxy
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    // only a whitelist of value types can be observed.
    var targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    var proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    (0, $j3cSI.def)(value, "__v_skip" /* SKIP */ , true);
    return value;
}
var toReactive = function(value) {
    return (0, $j3cSI.isObject)(value) ? reactive(value) : value;
};
var toReadonly = function(value) {
    return (0, $j3cSI.isObject)(value) ? readonly(value) : value;
};
function trackRefValue(ref) {
    if (isTracking()) {
        ref = toRaw(ref);
        if (!ref.dep) ref.dep = createDep();
        trackEffects(ref.dep);
    }
}
function triggerRefValue(ref, newVal) {
    ref = toRaw(ref);
    if (ref.dep) triggerEffects(ref.dep);
}
function isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
var RefImpl = /*#__PURE__*/ function() {
    "use strict";
    function RefImpl(value, _shallow) {
        (0, $juqrk._)(this, RefImpl);
        this._shallow = _shallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = _shallow ? value : toRaw(value);
        this._value = _shallow ? value : toReactive(value);
    }
    (0, $bNI6E._)(RefImpl, [
        {
            key: "value",
            get: function get() {
                trackRefValue(this);
                return this._value;
            },
            set: function set(newVal) {
                newVal = this._shallow ? newVal : toRaw(newVal);
                if ((0, $j3cSI.hasChanged)(newVal, this._rawValue)) {
                    this._rawValue = newVal;
                    this._value = this._shallow ? newVal : toReactive(newVal);
                    triggerRefValue(this, newVal);
                }
            }
        }
    ]);
    return RefImpl;
}();
function triggerRef(ref) {
    triggerRefValue(ref, void 0);
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
var shallowUnwrapHandlers = {
    get: function(target, key, receiver) {
        return unref(Reflect.get(target, key, receiver));
    },
    set: function(target, key, value, receiver) {
        var oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
var CustomRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function CustomRefImpl(factory) {
        var _this = this;
        (0, $juqrk._)(this, CustomRefImpl);
        this.dep = undefined;
        this.__v_isRef = true;
        var _factory = factory(function() {
            return trackRefValue(_this);
        }, function() {
            return triggerRefValue(_this);
        }), get = _factory.get, set = _factory.set;
        this._get = get;
        this._set = set;
    }
    (0, $bNI6E._)(CustomRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._get();
            },
            set: function set(newVal) {
                this._set(newVal);
            }
        }
    ]);
    return CustomRefImpl;
}();
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    var ret = (0, $j3cSI.isArray)(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = toRef(object, key);
    return ret;
}
var ObjectRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ObjectRefImpl(_object, _key) {
        (0, $juqrk._)(this, ObjectRefImpl);
        this._object = _object;
        this._key = _key;
        this.__v_isRef = true;
    }
    (0, $bNI6E._)(ObjectRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._object[this._key];
            },
            set: function set(newVal) {
                this._object[this._key] = newVal;
            }
        }
    ]);
    return ObjectRefImpl;
}();
function toRef(object, key) {
    var val = object[key];
    return isRef(val) ? val : new ObjectRefImpl(object, key);
}
var ComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ComputedRefImpl(getter, _setter, isReadonly) {
        var _this = this;
        (0, $juqrk._)(this, ComputedRefImpl);
        this._setter = _setter;
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this.effect = new ReactiveEffect(getter, function() {
            if (!_this._dirty) {
                _this._dirty = true;
                triggerRefValue(_this);
            }
        });
        this["__v_isReadonly" /* IS_READONLY */ ] = isReadonly;
    }
    (0, $bNI6E._)(ComputedRefImpl, [
        {
            key: "value",
            get: function get() {
                // the computed ref may get wrapped by other proxies e.g. readonly() #3376
                var self = toRaw(this);
                trackRefValue(self);
                if (self._dirty) {
                    self._dirty = false;
                    self._value = self.effect.run();
                }
                return self._value;
            },
            set: function set(newValue) {
                this._setter(newValue);
            }
        }
    ]);
    return ComputedRefImpl;
}();
function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = (0, $j3cSI.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $j3cSI.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter);
    return cRef;
}
var _a;
var tick = Promise.resolve();
var queue = [];
var queued = false;
var scheduler = function(fn) {
    queue.push(fn);
    if (!queued) {
        queued = true;
        tick.then(flush);
    }
};
var flush = function() {
    for(var i = 0; i < queue.length; i++)queue[i]();
    queue.length = 0;
    queued = false;
};
var DeferredComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function DeferredComputedRefImpl(getter) {
        var _this = this;
        (0, $juqrk._)(this, DeferredComputedRefImpl);
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[_a] = true;
        var compareTarget;
        var hasCompareTarget = false;
        var scheduled = false;
        this.effect = new ReactiveEffect(getter, function(computedTrigger) {
            if (_this.dep) {
                if (computedTrigger) {
                    compareTarget = _this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    var valueToCompare = hasCompareTarget ? compareTarget : _this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    scheduler(function() {
                        if (_this.effect.active && _this._get() !== valueToCompare) triggerRefValue(_this);
                        scheduled = false;
                    });
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // chained upstream computeds are notified synchronously to ensure
                    // value invalidation in case of sync access; normal effects are
                    // deferred to be triggered in scheduler.
                    for(var _iterator = _this.dep[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        if (e.computed) e.scheduler(true);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            _this._dirty = true;
        });
        this.effect.computed = true;
    }
    (0, $bNI6E._)(DeferredComputedRefImpl, [
        {
            key: "_get",
            value: function _get() {
                if (this._dirty) {
                    this._dirty = false;
                    return this._value = this.effect.run();
                }
                return this._value;
            }
        },
        {
            key: "value",
            get: function get() {
                trackRefValue(this);
                // the computed ref may get wrapped by other proxies e.g. readonly() #3376
                return toRaw(this)._get();
            }
        }
    ]);
    return DeferredComputedRefImpl;
}();
_a = "__v_isReadonly" /* IS_READONLY */ ;
function deferredComputed(getter) {
    return new DeferredComputedRefImpl(getter);
}

});
parcelRegister("juqrk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e3055412a69a0bec$export$2996f80ef42b8419; });
function $e3055412a69a0bec$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bNI6E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89767be5ae191d10$export$d60067ff2358eee8; });
function $89767be5ae191d10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $89767be5ae191d10$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $89767be5ae191d10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $89767be5ae191d10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("ect5N", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $a568c0d5880c90ba$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $a568c0d5880c90ba$export$1e71eb4bef00f6b0; });
function $a568c0d5880c90ba$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("fGQt0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6c37a1b08cb752d$export$fdf2a89c76341bbf; });

var $jPS0G = parcelRequire("jPS0G");

var $iQVao = parcelRequire("iQVao");

var $2TBLM = parcelRequire("2TBLM");

var $avvGs = parcelRequire("avvGs");
function $b6c37a1b08cb752d$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jPS0G._array_with_holes)(arr) || (0, $iQVao._iterable_to_array_limit)(arr, i) || (0, $avvGs._unsupported_iterable_to_array)(arr, i) || (0, $2TBLM._non_iterable_rest)();
}

});
parcelRegister("jPS0G", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $e70cad04b84cd1c0$export$e6256bf45c68d561; });
function $e70cad04b84cd1c0$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("iQVao", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $db996d728bd6bdbf$export$2fd15edff6687200; });
function $db996d728bd6bdbf$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("2TBLM", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $21be0414e7551937$export$60dbc22abd7da546; });
function $21be0414e7551937$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("avvGs", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $7a656066cb9fb4bf$export$a5be06335b3a083c; });

var $gLGHe = parcelRequire("gLGHe");
function $7a656066cb9fb4bf$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gLGHe._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gLGHe._array_like_to_array)(o, minLen);
}

});
parcelRegister("gLGHe", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $c35227b66bb73462$export$79e617b1955a2616; });
function $c35227b66bb73462$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("aYXpI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7fed984c591c61d1$export$1b5e630bc3aea29f; });

var $8FgSx = parcelRequire("8FgSx");

var $jSYmc = parcelRequire("jSYmc");

var $6TTBR = parcelRequire("6TTBR");

var $avvGs = parcelRequire("avvGs");
function $7fed984c591c61d1$export$1b5e630bc3aea29f(arr) {
    return (0, $8FgSx._array_without_holes)(arr) || (0, $jSYmc._iterable_to_array)(arr) || (0, $avvGs._unsupported_iterable_to_array)(arr) || (0, $6TTBR._non_iterable_spread)();
}

});
parcelRegister("8FgSx", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $64ef3ecb073cf3d1$export$7e0947b5ad3404e2; });

var $gLGHe = parcelRequire("gLGHe");
function $64ef3ecb073cf3d1$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $gLGHe._array_like_to_array)(arr);
}

});

parcelRegister("jSYmc", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $e7a1e1249a38f823$export$1eb58a6e75231000; });
function $e7a1e1249a38f823$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("6TTBR", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $5063040d55f66da2$export$e6f3c4780d19eb2b; });
function $5063040d55f66da2$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("j3cSI", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $dde84a1dcd51f438$export$b41394a5437791c8; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $dde84a1dcd51f438$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $dde84a1dcd51f438$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $dde84a1dcd51f438$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "normalizeStyle", function () { return $dde84a1dcd51f438$export$8756898546458274; });
$parcel$export(module.exports, "isArray", function () { return $dde84a1dcd51f438$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isString", function () { return $dde84a1dcd51f438$export$844ec244b1367d54; });
$parcel$export(module.exports, "isObject", function () { return $dde84a1dcd51f438$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "hyphenate", function () { return $dde84a1dcd51f438$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "normalizeClass", function () { return $dde84a1dcd51f438$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $dde84a1dcd51f438$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $dde84a1dcd51f438$export$6328ce7565ea1049; });
$parcel$export(module.exports, "looseEqual", function () { return $dde84a1dcd51f438$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $dde84a1dcd51f438$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $dde84a1dcd51f438$export$b5b1545233b45293; });
$parcel$export(module.exports, "isFunction", function () { return $dde84a1dcd51f438$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isMap", function () { return $dde84a1dcd51f438$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $dde84a1dcd51f438$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isPlainObject", function () { return $dde84a1dcd51f438$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $dde84a1dcd51f438$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $dde84a1dcd51f438$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $dde84a1dcd51f438$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $dde84a1dcd51f438$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $dde84a1dcd51f438$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $dde84a1dcd51f438$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $dde84a1dcd51f438$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $dde84a1dcd51f438$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $dde84a1dcd51f438$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isSymbol", function () { return $dde84a1dcd51f438$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isPromise", function () { return $dde84a1dcd51f438$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $dde84a1dcd51f438$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isIntegerKey", function () { return $dde84a1dcd51f438$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $dde84a1dcd51f438$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "camelize", function () { return $dde84a1dcd51f438$export$161d051f5dd25de7; });
$parcel$export(module.exports, "capitalize", function () { return $dde84a1dcd51f438$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $dde84a1dcd51f438$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $dde84a1dcd51f438$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $dde84a1dcd51f438$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $dde84a1dcd51f438$export$8afb76124cf08683; });
$parcel$export(module.exports, "toNumber", function () { return $dde84a1dcd51f438$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $dde84a1dcd51f438$export$ff5f2eeb11fc7e14; });
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ 
var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");

var $6aBn7 = parcelRequire("6aBn7");
function $dde84a1dcd51f438$export$b41394a5437791c8(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $dde84a1dcd51f438$var$_obj;
/**
 * dev only flag -> name mapping
 */ var $dde84a1dcd51f438$export$def7dc2c2e95a08a = ($dde84a1dcd51f438$var$_obj = {}, (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 1 /* TEXT */ , "TEXT"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 2 /* CLASS */ , "CLASS"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 4 /* STYLE */ , "STYLE"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 8 /* PROPS */ , "PROPS"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 16 /* FULL_PROPS */ , "FULL_PROPS"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 32 /* HYDRATE_EVENTS */ , "HYDRATE_EVENTS"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 64 /* STABLE_FRAGMENT */ , "STABLE_FRAGMENT"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 128 /* KEYED_FRAGMENT */ , "KEYED_FRAGMENT"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 256 /* UNKEYED_FRAGMENT */ , "UNKEYED_FRAGMENT"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 512 /* NEED_PATCH */ , "NEED_PATCH"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 1024 /* DYNAMIC_SLOTS */ , "DYNAMIC_SLOTS"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, 2048 /* DEV_ROOT_FRAGMENT */ , "DEV_ROOT_FRAGMENT"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, -1 /* HOISTED */ , "HOISTED"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj, -2 /* BAIL */ , "BAIL"), $dde84a1dcd51f438$var$_obj);
var $dde84a1dcd51f438$var$_obj1;
/**
 * Dev only
 */ var $dde84a1dcd51f438$export$624972196ed3745f = ($dde84a1dcd51f438$var$_obj1 = {}, (0, $ect5N._)($dde84a1dcd51f438$var$_obj1, 1 /* STABLE */ , "STABLE"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj1, 2 /* DYNAMIC */ , "DYNAMIC"), (0, $ect5N._)($dde84a1dcd51f438$var$_obj1, 3 /* FORWARDED */ , "FORWARDED"), $dde84a1dcd51f438$var$_obj1);
var $dde84a1dcd51f438$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
var $dde84a1dcd51f438$export$d6571a1911e4f27e = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$GLOBALS_WHITE_LISTED);
var $dde84a1dcd51f438$var$range = 2;
function $dde84a1dcd51f438$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    var lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    var newlineSequences = lines.filter(function(_, idx) {
        return idx % 2 === 1;
    });
    lines = lines.filter(function(_, idx) {
        return idx % 2 === 0;
    });
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(var j = i - $dde84a1dcd51f438$var$range; j <= i + $dde84a1dcd51f438$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(Math.max(3 - String(line).length, 0)), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                var newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    var pad = start - (count - (lineLength + newLineSeqLength));
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ var $dde84a1dcd51f438$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $dde84a1dcd51f438$export$d186f5eb2e810715 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ var $dde84a1dcd51f438$export$f763ba3b84e9cd8c = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden," + "loop,open,required,reversed,scoped,seamless," + "checked,muted,multiple,selected");
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. <select multiple> compiles to { multiple: '' }
 */ function $dde84a1dcd51f438$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
var $dde84a1dcd51f438$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
var $dde84a1dcd51f438$var$attrValidationCache = {};
function $dde84a1dcd51f438$export$d55ef77660f30d12(name) {
    if ($dde84a1dcd51f438$var$attrValidationCache.hasOwnProperty(name)) return $dde84a1dcd51f438$var$attrValidationCache[name];
    var isUnsafe = $dde84a1dcd51f438$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error("unsafe attribute name: ".concat(name));
    return $dde84a1dcd51f438$var$attrValidationCache[name] = !isUnsafe;
}
var $dde84a1dcd51f438$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ var $dde84a1dcd51f438$export$84da53524c6b1314 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8("animation-iteration-count,border-image-outset,border-image-slice," + "border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count," + "columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order," + "grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column," + "grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp," + "line-height,opacity,order,orphans,tab-size,widows,z-index,zoom," + "fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset," + "stroke-miterlimit,stroke-opacity,stroke-width");
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ var $dde84a1dcd51f438$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async," + "autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor," + "border,buffered,capture,challenge,charset,checked,cite,class,code," + "codebase,color,cols,colspan,content,contenteditable,contextmenu,controls," + "coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname," + "disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form," + "formaction,formenctype,formmethod,formnovalidate,formtarget,headers," + "height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity," + "ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low," + "manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate," + "open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly," + "referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped," + "selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset," + "start,step,style,summary,tabindex,target,title,translate,type,usemap," + "value,width,wrap");
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ var $dde84a1dcd51f438$export$80da416f43933831 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude," + "arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency," + "baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class," + "clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation," + "color-interpolation-filters,color-profile,color-rendering," + "contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate," + "descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx," + "dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity," + "fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity," + "font-family,font-size,font-size-adjust,font-stretch,font-style," + "font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name," + "glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef," + "gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x," + "horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3," + "k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes," + "lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local," + "marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth," + "mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode," + "name,numOctaves,offset,opacity,operator,order,orient,orientation,origin," + "overflow,overline-position,overline-thickness,panose-1,paint-order,path," + "pathLength,patternContentUnits,patternTransform,patternUnits,ping," + "pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha," + "preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel," + "rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures," + "restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing," + "specularConstant,specularExponent,speed,spreadMethod,startOffset," + "stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity," + "strikethrough-position,strikethrough-thickness,string,stroke," + "stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin," + "stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale," + "systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor," + "text-decoration,text-rendering,textLength,to,transform,transform-origin," + "type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi," + "unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic," + "v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x," + "vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing," + "writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole," + "xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang," + "xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
function $dde84a1dcd51f438$export$8756898546458274(value) {
    if ($dde84a1dcd51f438$export$43bee75e5e14138e(value)) {
        var res = {};
        for(var i = 0; i < value.length; i++){
            var item = value[i];
            var normalized = $dde84a1dcd51f438$export$844ec244b1367d54(item) ? $dde84a1dcd51f438$export$76a205ce979d066a(item) : $dde84a1dcd51f438$export$8756898546458274(item);
            if (normalized) for(var key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($dde84a1dcd51f438$export$844ec244b1367d54(value)) return value;
    else if ($dde84a1dcd51f438$export$a6cdc56e425d0d0a(value)) return value;
}
var $dde84a1dcd51f438$var$listDelimiterRE = /;(?![^(]*\))/g;
var $dde84a1dcd51f438$var$propertyDelimiterRE = /:(.+)/;
function $dde84a1dcd51f438$export$76a205ce979d066a(cssText) {
    var ret = {};
    cssText.split($dde84a1dcd51f438$var$listDelimiterRE).forEach(function(item) {
        if (item) {
            var tmp = item.split($dde84a1dcd51f438$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $dde84a1dcd51f438$export$9466a5a0ee6f1479(styles) {
    var ret = "";
    if (!styles || $dde84a1dcd51f438$export$844ec244b1367d54(styles)) return ret;
    for(var key in styles){
        var value = styles[key];
        var normalizedKey = key.startsWith("--") ? key : $dde84a1dcd51f438$export$6e6a0a3676c4b8bb(key);
        if ($dde84a1dcd51f438$export$844ec244b1367d54(value) || typeof value === "number" && $dde84a1dcd51f438$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += "".concat(normalizedKey, ":").concat(value, ";");
    }
    return ret;
}
function $dde84a1dcd51f438$export$4f7022d2d68e2c5a(value) {
    var res = "";
    if ($dde84a1dcd51f438$export$844ec244b1367d54(value)) res = value;
    else if ($dde84a1dcd51f438$export$43bee75e5e14138e(value)) for(var i = 0; i < value.length; i++){
        var normalized = $dde84a1dcd51f438$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($dde84a1dcd51f438$export$a6cdc56e425d0d0a(value)) {
        for(var name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $dde84a1dcd51f438$export$601abcd8103db5e4(props) {
    if (!props) return null;
    var klass = props.class, style = props.style;
    if (klass && !$dde84a1dcd51f438$export$844ec244b1367d54(klass)) props.class = $dde84a1dcd51f438$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $dde84a1dcd51f438$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
var $dde84a1dcd51f438$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
var $dde84a1dcd51f438$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
var $dde84a1dcd51f438$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
var $dde84a1dcd51f438$export$1ccf854a0984f890 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$HTML_TAGS);
var $dde84a1dcd51f438$export$6328ce7565ea1049 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$SVG_TAGS);
var $dde84a1dcd51f438$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$VOID_TAGS);
var $dde84a1dcd51f438$var$escapeRE = /["'&<>]/;
function $dde84a1dcd51f438$export$4cf11838cdc2a8a8(string) {
    var str = "" + string;
    var match = $dde84a1dcd51f438$var$escapeRE.exec(str);
    if (!match) return str;
    var html = "";
    var escaped;
    var index;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
var $dde84a1dcd51f438$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $dde84a1dcd51f438$export$7b105034a53bde5f(src) {
    return src.replace($dde84a1dcd51f438$var$commentStripRE, "");
}
function $dde84a1dcd51f438$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    var equal = true;
    for(var i = 0; equal && i < a.length; i++)equal = $dde84a1dcd51f438$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $dde84a1dcd51f438$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    var aValidType = $dde84a1dcd51f438$export$871608497c498473(a);
    var bValidType = $dde84a1dcd51f438$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $dde84a1dcd51f438$export$43bee75e5e14138e(a);
    bValidType = $dde84a1dcd51f438$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $dde84a1dcd51f438$var$looseCompareArrays(a, b) : false;
    aValidType = $dde84a1dcd51f438$export$a6cdc56e425d0d0a(a);
    bValidType = $dde84a1dcd51f438$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        var aKeysCount = Object.keys(a).length;
        var bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(var key in a){
            var aHasKey = a.hasOwnProperty(key);
            var bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$dde84a1dcd51f438$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $dde84a1dcd51f438$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex(function(item) {
        return $dde84a1dcd51f438$export$ae8015769846262c(item, val);
    });
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ var $dde84a1dcd51f438$export$b5b1545233b45293 = function(val) {
    return val == null ? "" : $dde84a1dcd51f438$export$43bee75e5e14138e(val) || $dde84a1dcd51f438$export$a6cdc56e425d0d0a(val) && (val.toString === $dde84a1dcd51f438$export$830c053460e5ddf6 || !$dde84a1dcd51f438$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $dde84a1dcd51f438$var$replacer, 2) : String(val);
};
var $dde84a1dcd51f438$var$replacer = function(_key, val) {
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $dde84a1dcd51f438$var$replacer(_key, val.value);
    else if ($dde84a1dcd51f438$export$5c90113a285f2241(val)) return (0, $ect5N._)({}, "Map(".concat(val.size, ")"), (0, $aYXpI._)(val.entries()).reduce(function(entries, param) {
        var _param = (0, $fGQt0._)(param, 2), key = _param[0], _$val = _param[1];
        entries["".concat(key, " =>")] = _$val;
        return entries;
    }, {}));
    else if ($dde84a1dcd51f438$export$6750766a7c7ec627(val)) return (0, $ect5N._)({}, "Set(".concat(val.size, ")"), (0, $aYXpI._)(val.values()));
    else if ($dde84a1dcd51f438$export$a6cdc56e425d0d0a(val) && !$dde84a1dcd51f438$export$43bee75e5e14138e(val) && !$dde84a1dcd51f438$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
var $dde84a1dcd51f438$export$cf583d23ab39677c = {};
var $dde84a1dcd51f438$export$6bd8558f433f1cc1 = [];
var $dde84a1dcd51f438$export$5702a91a6f42969f = function() {};
/**
 * Always return false.
 */ var $dde84a1dcd51f438$export$c01351c0af048e39 = function() {
    return false;
};
var $dde84a1dcd51f438$var$onRE = /^on[^a-z]/;
var $dde84a1dcd51f438$export$1a2d97de39ecbb75 = function(key) {
    return $dde84a1dcd51f438$var$onRE.test(key);
};
var $dde84a1dcd51f438$export$793aa5469768d691 = function(key) {
    return key.startsWith("onUpdate:");
};
var $dde84a1dcd51f438$export$8b58be045bf06082 = Object.assign;
var $dde84a1dcd51f438$export$cd7f480d6b8286c3 = function(arr, el) {
    var i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
var $dde84a1dcd51f438$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $dde84a1dcd51f438$export$b5a638e9b3fff9f3 = function(val, key) {
    return $dde84a1dcd51f438$var$hasOwnProperty.call(val, key);
};
var $dde84a1dcd51f438$export$43bee75e5e14138e = Array.isArray;
var $dde84a1dcd51f438$export$5c90113a285f2241 = function(val) {
    return $dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Map]";
};
var $dde84a1dcd51f438$export$6750766a7c7ec627 = function(val) {
    return $dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Set]";
};
var $dde84a1dcd51f438$export$871608497c498473 = function(val) {
    return val instanceof Date;
};
var $dde84a1dcd51f438$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $dde84a1dcd51f438$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $dde84a1dcd51f438$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $6aBn7._)(val)) === "symbol";
};
var $dde84a1dcd51f438$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && typeof val === "object";
};
var $dde84a1dcd51f438$export$4369c812aac99591 = function(val) {
    return $dde84a1dcd51f438$export$a6cdc56e425d0d0a(val) && $dde84a1dcd51f438$export$f6e2535fb5126e54(val.then) && $dde84a1dcd51f438$export$f6e2535fb5126e54(val.catch);
};
var $dde84a1dcd51f438$export$830c053460e5ddf6 = Object.prototype.toString;
var $dde84a1dcd51f438$export$1dccc787cc36538b = function(value) {
    return $dde84a1dcd51f438$export$830c053460e5ddf6.call(value);
};
var $dde84a1dcd51f438$export$5ad0a3c360b8fbb5 = function(value) {
    // extract "RawType" from strings like "[object RawType]"
    return $dde84a1dcd51f438$export$1dccc787cc36538b(value).slice(8, -1);
};
var $dde84a1dcd51f438$export$53b83ca8eaab0383 = function(val) {
    return $dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Object]";
};
var $dde84a1dcd51f438$export$e2a2b93446ec9fe = function(key) {
    return $dde84a1dcd51f438$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $dde84a1dcd51f438$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $dde84a1dcd51f438$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var $dde84a1dcd51f438$var$cacheStringFunction = function(fn) {
    var cache = Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $dde84a1dcd51f438$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ var $dde84a1dcd51f438$export$161d051f5dd25de7 = $dde84a1dcd51f438$var$cacheStringFunction(function(str) {
    return str.replace($dde84a1dcd51f438$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $dde84a1dcd51f438$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ var $dde84a1dcd51f438$export$6e6a0a3676c4b8bb = $dde84a1dcd51f438$var$cacheStringFunction(function(str) {
    return str.replace($dde84a1dcd51f438$var$hyphenateRE, "-$1").toLowerCase();
});
/**
 * @private
 */ var $dde84a1dcd51f438$export$9a00dee1beb8f576 = $dde84a1dcd51f438$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * @private
 */ var $dde84a1dcd51f438$export$8c022799eeaaefcd = $dde84a1dcd51f438$var$cacheStringFunction(function(str) {
    return str ? "on".concat($dde84a1dcd51f438$export$9a00dee1beb8f576(str)) : "";
});
// compare whether a value has changed, accounting for NaN.
var $dde84a1dcd51f438$export$f619eb8b89076d23 = function(value, oldValue) {
    return !Object.is(value, oldValue);
};
var $dde84a1dcd51f438$export$39951422d618a9d3 = function(fns, arg) {
    for(var i = 0; i < fns.length; i++)fns[i](arg);
};
var $dde84a1dcd51f438$export$8afb76124cf08683 = function(obj, key, value) {
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
var $dde84a1dcd51f438$export$a0a81dc3380ce7d3 = function(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};
var $dde84a1dcd51f438$var$_globalThis;
var $dde84a1dcd51f438$export$ff5f2eeb11fc7e14 = function() {
    return $dde84a1dcd51f438$var$_globalThis || ($dde84a1dcd51f438$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};

});
parcelRegister("6aBn7", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $47e0aa82139bfe16$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $47e0aa82139bfe16$export$5f0017c582d45a2d; });
function $47e0aa82139bfe16$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("kvz0p", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $eee1db4636d107a0$export$2e2bcd8739ae039; });
var $eee1db4636d107a0$export$2e2bcd8739ae039 = {};

});

parcelRegister("j2Oe7", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ddd52a3092dd56a9$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
function $ddd52a3092dd56a9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_router_view = (0, $9pglz.resolveComponent)("router-view");
    return (0, $9pglz.openBlock)(), (0, $9pglz.createBlock)(_component_router_view);
}

});
parcelRegister("hrKNH", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("Dz4HH")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("9pglz")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("9pglz")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("9pglz")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("9pglz")).createElementVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("9pglz")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("9pglz")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("9pglz")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("9pglz")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("9pglz")).getCurrentInstance; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("9pglz")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("9pglz")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("9pglz")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("Dz4HH")).isRef; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("9pglz")).nextTick; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("9pglz")).onActivated; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("9pglz")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("9pglz")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("9pglz")).onUnmounted; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("9pglz")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("9pglz")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("9pglz")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("9pglz")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("Dz4HH")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("Dz4HH")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("9pglz")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("9pglz")).resolveComponent; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("9pglz")).Text; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("9pglz")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("9pglz")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("9pglz")).withCtx; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("6zPDN")).createApp; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("j3cSI")).toDisplayString; });

var $9pglz = parcelRequire("9pglz");parcelRequire("6zPDN");
var $Dz4HH = parcelRequire("Dz4HH");parcelRequire("j3cSI");
function $cb3942e418027aec$var$initDev() {
    (0, $9pglz.initCustomFormatter)();
}
var $cb3942e418027aec$export$ef7acd7185315e22 = function() {};
$parcel$exportWildcard(module.exports, $Dz4HH);

});
parcelRegister("9pglz", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6d932106fee366bf$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $6d932106fee366bf$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Static", function () { return $6d932106fee366bf$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $6d932106fee366bf$export$dae85862a8d94378; });
$parcel$export(module.exports, "pushScopeId", function () { return $6d932106fee366bf$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $6d932106fee366bf$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $6d932106fee366bf$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $6d932106fee366bf$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $6d932106fee366bf$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "provide", function () { return $6d932106fee366bf$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $6d932106fee366bf$export$a976684a0efeb93f; });
$parcel$export(module.exports, "useTransitionState", function () { return $6d932106fee366bf$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $6d932106fee366bf$export$6d1641039221b5cb; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $6d932106fee366bf$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $6d932106fee366bf$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $6d932106fee366bf$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $6d932106fee366bf$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $6d932106fee366bf$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $6d932106fee366bf$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "watch", function () { return $6d932106fee366bf$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "onUpdated", function () { return $6d932106fee366bf$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $6d932106fee366bf$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $6d932106fee366bf$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $6d932106fee366bf$export$13348a43ccacfe58; });
$parcel$export(module.exports, "warn", function () { return $6d932106fee366bf$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "createTextVNode", function () { return $6d932106fee366bf$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $6d932106fee366bf$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $6d932106fee366bf$export$200524cf0d997ff0; });
$parcel$export(module.exports, "resolveComponent", function () { return $6d932106fee366bf$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "createElementBlock", function () { return $6d932106fee366bf$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $6d932106fee366bf$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createBlock", function () { return $6d932106fee366bf$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "createCommentVNode", function () { return $6d932106fee366bf$export$49553837c7236d3c; });
$parcel$export(module.exports, "renderList", function () { return $6d932106fee366bf$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "nextTick", function () { return $6d932106fee366bf$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $6d932106fee366bf$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "watchEffect", function () { return $6d932106fee366bf$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $6d932106fee366bf$export$b7f27ea67102d543; });
$parcel$export(module.exports, "h", function () { return $6d932106fee366bf$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $6d932106fee366bf$export$aed4979be6a60047; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("Dz4HH")).computed; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("Dz4HH")).isRef; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("Dz4HH")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("Dz4HH")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("Dz4HH")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("j3cSI")).camelize; });

var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");

var $6aBn7 = parcelRequire("6aBn7");

var $Dz4HH = parcelRequire("Dz4HH");

var $j3cSI = parcelRequire("j3cSI");
/* eslint-disable no-restricted-globals */ var $6d932106fee366bf$var$isHmrUpdating = false;
var $6d932106fee366bf$var$hmrDirtyComponents = new Set();
var $6d932106fee366bf$var$map = new Map();
function $6d932106fee366bf$var$registerHMR(instance) {
    var id = instance.type.__hmrId;
    var record = $6d932106fee366bf$var$map.get(id);
    if (!record) {
        $6d932106fee366bf$var$createRecord(id, instance.type);
        record = $6d932106fee366bf$var$map.get(id);
    }
    record.instances.add(instance);
}
function $6d932106fee366bf$var$unregisterHMR(instance) {
    $6d932106fee366bf$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $6d932106fee366bf$var$createRecord(id, initialDef) {
    if ($6d932106fee366bf$var$map.has(id)) return false;
    $6d932106fee366bf$var$map.set(id, {
        initialDef: $6d932106fee366bf$var$normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function $6d932106fee366bf$var$normalizeClassComponent(component) {
    return $6d932106fee366bf$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $6d932106fee366bf$var$rerender(id, newRender) {
    var record = $6d932106fee366bf$var$map.get(id);
    if (!record) return;
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    (0, $aYXpI._)(record.instances).forEach(function(instance) {
        if (newRender) {
            instance.render = newRender;
            $6d932106fee366bf$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        $6d932106fee366bf$var$isHmrUpdating = true;
        instance.update();
        $6d932106fee366bf$var$isHmrUpdating = false;
    });
}
function $6d932106fee366bf$var$reload(id, newComp) {
    var record = $6d932106fee366bf$var$map.get(id);
    if (!record) return;
    newComp = $6d932106fee366bf$var$normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    $6d932106fee366bf$var$updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    var instances = (0, $aYXpI._)(record.instances);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var instance = _step.value;
            var oldComp = $6d932106fee366bf$var$normalizeClassComponent(instance.type);
            if (!$6d932106fee366bf$var$hmrDirtyComponents.has(oldComp)) {
                // 1. Update existing comp definition to match new one
                if (oldComp !== record.initialDef) $6d932106fee366bf$var$updateComponentDef(oldComp, newComp);
                // 2. mark definition dirty. This forces the renderer to replace the
                // component on patch.
                $6d932106fee366bf$var$hmrDirtyComponents.add(oldComp);
            }
            // 3. invalidate options resolution cache
            instance.appContext.optionsCache.delete(instance.type);
            // 4. actually update
            if (instance.ceReload) {
                // custom element
                $6d932106fee366bf$var$hmrDirtyComponents.add(oldComp);
                instance.ceReload(newComp.styles);
                $6d932106fee366bf$var$hmrDirtyComponents.delete(oldComp);
            } else if (instance.parent) {
                // 4. Force the parent instance to re-render. This will cause all updated
                // components to be unmounted and re-mounted. Queue the update so that we
                // don't end up forcing the same parent to re-render multiple times.
                $6d932106fee366bf$var$queueJob(instance.parent.update);
                // instance is the inner component of an async custom element
                // invoke to reset styles
                if (instance.parent.type.__asyncLoader && instance.parent.ceReload) instance.parent.ceReload(newComp.styles);
            } else if (instance.appContext.reload) // root instance mounted via createApp() has a reload method
            instance.appContext.reload();
            else if (typeof window !== "undefined") // root instance inside tree created via raw render(). Force reload.
            window.location.reload();
            else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // 5. make sure to cleanup dirty hmr components after update
    $6d932106fee366bf$export$59536a0199721cab(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var instance = _step.value;
                $6d932106fee366bf$var$hmrDirtyComponents.delete($6d932106fee366bf$var$normalizeClassComponent(instance.type));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $6d932106fee366bf$var$updateComponentDef(oldComp, newComp) {
    (0, $j3cSI.extend)(oldComp, newComp);
    for(var key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $6d932106fee366bf$var$tryWrap(fn) {
    return function(id, arg) {
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. " + "Full reload required.");
        }
    };
}
var $6d932106fee366bf$export$6922d3b3a607469e;
var $6d932106fee366bf$var$buffer = [];
function $6d932106fee366bf$var$emit(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _devtools;
    if ($6d932106fee366bf$export$6922d3b3a607469e) (_devtools = $6d932106fee366bf$export$6922d3b3a607469e).emit.apply(_devtools, [
        event
    ].concat((0, $aYXpI._)(args)));
    else $6d932106fee366bf$var$buffer.push({
        event: event,
        args: args
    });
}
function $6d932106fee366bf$export$b0c258b32c26c785(hook, target) {
    $6d932106fee366bf$export$6922d3b3a607469e = hook;
    if ($6d932106fee366bf$export$6922d3b3a607469e) {
        var _devtools;
        $6d932106fee366bf$export$6922d3b3a607469e.enabled = true;
        $6d932106fee366bf$var$buffer.forEach(function(param) {
            var event = param.event, args = param.args;
            return (_devtools = $6d932106fee366bf$export$6922d3b3a607469e).emit.apply(_devtools, [
                event
            ].concat((0, $aYXpI._)(args)));
        });
        $6d932106fee366bf$var$buffer = [];
    } else {
        var replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push(function(newHook) {
            $6d932106fee366bf$export$b0c258b32c26c785(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(function() {
            $6d932106fee366bf$var$buffer = [];
        }, 3000);
    }
}
function $6d932106fee366bf$var$devtoolsInitApp(app, version) {
    $6d932106fee366bf$var$emit("app:init" /* APP_INIT */ , app, version, {
        Fragment: $6d932106fee366bf$export$ffb0004e005737fa,
        Text: $6d932106fee366bf$export$5f1af8db9871e1d6,
        Comment: $6d932106fee366bf$export$4d299b491347818a,
        Static: $6d932106fee366bf$export$c1b9a1d3af45b7b6
    });
}
function $6d932106fee366bf$var$devtoolsUnmountApp(app) {
    $6d932106fee366bf$var$emit("app:unmount" /* APP_UNMOUNT */ , app);
}
var $6d932106fee366bf$var$devtoolsComponentAdded = /*#__PURE__*/ $6d932106fee366bf$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
var $6d932106fee366bf$var$devtoolsComponentUpdated = /*#__PURE__*/ $6d932106fee366bf$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
var $6d932106fee366bf$var$devtoolsComponentRemoved = /*#__PURE__*/ $6d932106fee366bf$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
function $6d932106fee366bf$var$createDevtoolsComponentHook(hook) {
    return function(component) {
        $6d932106fee366bf$var$emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
var $6d932106fee366bf$var$devtoolsPerfStart = /*#__PURE__*/ $6d932106fee366bf$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
var $6d932106fee366bf$var$devtoolsPerfEnd = /*#__PURE__*/ $6d932106fee366bf$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $6d932106fee366bf$var$createDevtoolsPerformanceHook(hook) {
    return function(component, type, time) {
        $6d932106fee366bf$var$emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $6d932106fee366bf$var$devtoolsComponentEmit(component, event, params) {
    $6d932106fee366bf$var$emit("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $6d932106fee366bf$var$emit$1(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    var props = instance.vnode.props || (0, $j3cSI.EMPTY_OBJ);
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    // for v-model update:xxx events, apply modifiers on args
    var modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        var modifiersKey = "".concat(modelArg === "modelValue" ? "model" : modelArg, "Modifiers");
        var _ref = props[modifiersKey] || (0, $j3cSI.EMPTY_OBJ), number = _ref.number, trim = _ref.trim;
        if (trim) args = rawArgs.map(function(a) {
            return a.trim();
        });
        else if (number) args = rawArgs.map((0, $j3cSI.toNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentEmit(instance, event, args);
    var handlerName;
    var handler = props[handlerName = (0, $j3cSI.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $j3cSI.toHandlerKey)((0, $j3cSI.camelize)(event))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) handler = props[handlerName = (0, $j3cSI.toHandlerKey)((0, $j3cSI.hyphenate)(event))];
    if (handler) $6d932106fee366bf$export$dae85862a8d94378(handler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    var onceHandler = props[handlerName + "Once"];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $6d932106fee366bf$export$dae85862a8d94378(onceHandler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    }
}
function $6d932106fee366bf$var$normalizeEmitsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== undefined) return cached;
    var raw = comp.emits;
    var normalized = {};
    // apply mixin/extends props
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $j3cSI.isFunction)(comp)) {
        var extendEmits = function(raw) {
            var normalizedFromExtend = $6d932106fee366bf$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $j3cSI.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, null);
        return null;
    }
    if ((0, $j3cSI.isArray)(raw)) raw.forEach(function(key) {
        return normalized[key] = null;
    });
    else (0, $j3cSI.extend)(normalized, raw);
    cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function $6d932106fee366bf$var$isEmitListener(options, key) {
    if (!options || !(0, $j3cSI.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $j3cSI.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $j3cSI.hasOwn)(options, (0, $j3cSI.hyphenate)(key)) || (0, $j3cSI.hasOwn)(options, key);
}
/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */ var $6d932106fee366bf$var$currentRenderingInstance = null;
var $6d932106fee366bf$var$currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */ function $6d932106fee366bf$var$setCurrentRenderingInstance(instance) {
    var prev = $6d932106fee366bf$var$currentRenderingInstance;
    $6d932106fee366bf$var$currentRenderingInstance = instance;
    $6d932106fee366bf$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */ function $6d932106fee366bf$export$ac020265ca2cc4cd(id) {
    $6d932106fee366bf$var$currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */ function $6d932106fee366bf$export$f2dc6805dc11834e() {
    $6d932106fee366bf$var$currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */ var $6d932106fee366bf$export$15ba313e13f3dd04 = function(_id) {
    return $6d932106fee366bf$export$694b237e827a3d23;
};
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */ function $6d932106fee366bf$export$694b237e827a3d23(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6d932106fee366bf$var$currentRenderingInstance, isNonScopedSlot // false only
     = arguments.length > 2 ? arguments[2] : void 0;
    if (!ctx) return fn;
    // already normalized
    if (fn._n) return fn;
    var renderFnWithContext = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) $6d932106fee366bf$export$c20bee82f26f1e27(-1);
        var prevInstance = $6d932106fee366bf$var$setCurrentRenderingInstance(ctx);
        var res = fn.apply(void 0, (0, $aYXpI._)(args));
        $6d932106fee366bf$var$setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) $6d932106fee366bf$export$c20bee82f26f1e27(1);
        if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */ var $6d932106fee366bf$var$accessedAttrs = false;
function $6d932106fee366bf$var$markAttrsAccessed() {
    $6d932106fee366bf$var$accessedAttrs = true;
}
function $6d932106fee366bf$var$renderComponentRoot(instance) {
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, props = instance.props, _instance_propsOptions = (0, $fGQt0._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var result;
    var fallthroughAttrs;
    var prev = $6d932106fee366bf$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            var proxyToUse = withProxy || proxy;
            result = $6d932106fee366bf$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            // functional
            var render1 = Component;
            result = $6d932106fee366bf$var$normalizeVNode(render1.length > 1 ? render1(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render1(props, null));
            fallthroughAttrs = Component.props ? attrs : $6d932106fee366bf$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $6d932106fee366bf$var$blockStack.length = 0;
        $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, 1 /* RENDER_FUNCTION */ );
        result = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    var root = result;
    var setRoot = undefined;
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & 7 /* COMPONENT */ ) {
                if (propsOptions && keys.some((0, $j3cSI.isModelListener))) // If a v-model listener (onUpdate:xxx) has a corresponding declared
                // prop, it indicates this component expects to handle v-model and
                // it should not fallthrough.
                // related: #1543, #1643, #1989
                fallthroughAttrs = $6d932106fee366bf$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $6d932106fee366bf$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    // inherit directives
    if (vnode.dirs) root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    // inherit transition data
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $6d932106fee366bf$var$setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */ var $6d932106fee366bf$var$getChildRoot = function(vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = $6d932106fee366bf$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        undefined
    ];
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function(updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = (0, $aYXpI._)(dynamicChildren).concat([
                updatedRoot
            ]);
        }
    };
    return [
        $6d932106fee366bf$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $6d932106fee366bf$var$filterSingleRoot(children) {
    var singleRoot;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if ($6d932106fee366bf$export$3868d13f8734ae81(child)) // ignore user comment
        {
            if (child.type !== $6d932106fee366bf$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) // has more than 1 non-comment child, return now
                return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
var $6d932106fee366bf$var$getFunctionalFallthrough = function(attrs) {
    var res;
    for(var key in attrs)if (key === "class" || key === "style" || (0, $j3cSI.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
var $6d932106fee366bf$var$filterModelListeners = function(attrs, props) {
    var res = {};
    for(var key in attrs)if (!(0, $j3cSI.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
var $6d932106fee366bf$var$isElementRoot = function(vnode) {
    return vnode.shapeFlag & 7 /* ELEMENT */  || vnode.type === $6d932106fee366bf$export$4d299b491347818a // potential v-if branch switch
    ;
};
function $6d932106fee366bf$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* DYNAMIC_SLOTS */ ) // slot content that references values that might have changed,
        // e.g. in a v-for
        return true;
        if (patchFlag & 16 /* FULL_PROPS */ ) {
            if (!prevProps) return !!nextProps;
            // presence of this flag indicates props are always non-null
            return $6d932106fee366bf$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8 /* PROPS */ ) {
            var dynamicProps = nextVNode.dynamicProps;
            for(var i = 0; i < dynamicProps.length; i++){
                var key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$6d932106fee366bf$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $6d932106fee366bf$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $6d932106fee366bf$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(var i = 0; i < nextKeys.length; i++){
        var key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$6d932106fee366bf$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $6d932106fee366bf$var$updateHOCHostEl(param, el // HostNode
) {
    var vnode = param.vnode, parent = param.parent;
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
var $6d932106fee366bf$var$isSuspense = function(type) {
    return type.__isSuspense;
};
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
var $6d932106fee366bf$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) $6d932106fee366bf$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $6d932106fee366bf$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $6d932106fee366bf$var$hydrateSuspense,
    create: $6d932106fee366bf$var$createSuspenseBoundary,
    normalize: $6d932106fee366bf$var$normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
var $6d932106fee366bf$export$74bf444e3cd11ea5 = $6d932106fee366bf$var$SuspenseImpl;
function $6d932106fee366bf$var$triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if ((0, $j3cSI.isFunction)(eventListener)) eventListener();
}
function $6d932106fee366bf$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = $6d932106fee366bf$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    // start mounting the content subtree in an off-dom container
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        $6d932106fee366bf$var$triggerEvent(vnode, "onPending");
        $6d932106fee366bf$var$triggerEvent(vnode, "onFallback");
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds);
        $6d932106fee366bf$var$setActiveBranch(suspense, vnode.ssFallback);
    } else // Suspense has no async deps. Just resolve.
    suspense.resolve();
}
function $6d932106fee366bf$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, param) {
    var patch = param.p, unmount = param.um, createElement = param.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($6d932106fee366bf$var$isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $6d932106fee366bf$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                    $6d932106fee366bf$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $6d932106fee366bf$var$isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            } else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $6d932106fee366bf$var$isSameVNodeType(newBranch, activeBranch)) {
        // root did not change, just normal patch
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $6d932106fee366bf$var$setActiveBranch(suspense, newBranch);
    } else {
        // root node toggled
        // invoke @pending event
        $6d932106fee366bf$var$triggerEvent(n2, "onPending");
        // mount pending branch in off-dom container
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) // incoming branch has no async deps, resolve now.
        suspense.resolve();
        else {
            var timeout = suspense.timeout, pendingId = suspense.pendingId;
            if (timeout > 0) setTimeout(function() {
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
var $6d932106fee366bf$var$hasWarned = false;
function $6d932106fee366bf$var$createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals) {
    var isHydrating = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false;
    var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, _rendererInternals_o = rendererInternals.o, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove;
    var timeout = (0, $j3cSI.toNumber)(vnode.props && vnode.props.timeout);
    var suspense = {
        vnode: vnode,
        parent: parent,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve: function() {
            var resume = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            var _$vnode = suspense.vnode, activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, _$parentComponent = suspense.parentComponent, _$container = suspense.container;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                var delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = function() {
                    if (pendingId === suspense.pendingId) move(pendingBranch, _$container, _$anchor, 0 /* ENTER */ );
                };
                // this is initial anchor on mount
                var _$anchor = suspense.anchor;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    _$anchor = next(activeBranch);
                    unmount(activeBranch, _$parentComponent, suspense, true);
                }
                if (!delayEnter) // move content from off-dom container to actual container
                move(pendingBranch, _$container, _$anchor, 0 /* ENTER */ );
            }
            $6d932106fee366bf$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            var _$parent = suspense.parent;
            var hasUnresolvedAncestor = false;
            while(_$parent){
                if (_$parent.pendingBranch) {
                    var // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    _parent_effects;
                    (_parent_effects = _$parent.effects).push.apply(_parent_effects, (0, $aYXpI._)(effects));
                    hasUnresolvedAncestor = true;
                    break;
                }
                _$parent = _$parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) $6d932106fee366bf$export$59536a0199721cab(effects);
            suspense.effects = [];
            // invoke @resolve event
            $6d932106fee366bf$var$triggerEvent(_$vnode, "onResolve");
        },
        fallback: function(fallbackVNode) {
            if (!suspense.pendingBranch) return;
            var _$vnode = suspense.vnode, activeBranch = suspense.activeBranch, _$parentComponent = suspense.parentComponent, _$container = suspense.container, _$isSVG = suspense.isSVG;
            // invoke @fallback event
            $6d932106fee366bf$var$triggerEvent(_$vnode, "onFallback");
            var _$anchor = next(activeBranch);
            var mountFallback = function() {
                if (!suspense.isInFallback) return;
                // mount the fallback tree
                patch(null, fallbackVNode, _$container, _$anchor, _$parentComponent, null, _$isSVG, slotScopeIds, optimized);
                $6d932106fee366bf$var$setActiveBranch(suspense, fallbackVNode);
            };
            var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, _$parentComponent, null, true // shouldRemove
            );
            if (!delayEnter) mountFallback();
        },
        move: function(container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next: function() {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep: function(instance, setupRenderEffect) {
            var isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            var hydratedEl = instance.vnode.el;
            instance.asyncDep.catch(function(err) {
                $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, 0 /* SETUP_FUNCTION */ );
            }).then(function(asyncSetupResult) {
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                // retry from this component
                instance.asyncResolved = true;
                var _$vnode = instance.vnode;
                $6d932106fee366bf$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) // vnode may have been replaced if an update happened before the
                // async dep is resolved.
                _$vnode.el = hydratedEl;
                var placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, _$vnode, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $6d932106fee366bf$var$updateHOCHostEl(instance, _$vnode.el);
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount: function(parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $6d932106fee366bf$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */ var suspense = vnode.suspense = $6d932106fee366bf$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve();
    return result;
/* eslint-enable no-restricted-globals */ }
function $6d932106fee366bf$var$normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32 /* SLOTS_CHILDREN */ ;
    vnode.ssContent = $6d932106fee366bf$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $6d932106fee366bf$var$normalizeSuspenseSlot(children.fallback) : $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
}
function $6d932106fee366bf$var$normalizeSuspenseSlot(s) {
    var block;
    if ((0, $j3cSI.isFunction)(s)) {
        var trackBlock = $6d932106fee366bf$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            $6d932106fee366bf$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $6d932106fee366bf$var$currentBlock;
            $6d932106fee366bf$var$closeBlock();
        }
    }
    if ((0, $j3cSI.isArray)(s)) {
        var singleChild = $6d932106fee366bf$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $6d932106fee366bf$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter(function(c) {
        return c !== s;
    });
    return s;
}
function $6d932106fee366bf$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        var _suspense_effects;
        if ((0, $j3cSI.isArray)(fn)) (_suspense_effects = suspense.effects).push.apply(_suspense_effects, (0, $aYXpI._)(fn));
        else suspense.effects.push(fn);
    } else $6d932106fee366bf$export$59536a0199721cab(fn);
}
function $6d932106fee366bf$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = vnode.el = branch.el;
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $6d932106fee366bf$var$updateHOCHostEl(parentComponent, el);
    }
}
function $6d932106fee366bf$export$abe1e183e22e10ad(key, value) {
    if (!$6d932106fee366bf$var$currentInstance) ;
    else {
        var provides = $6d932106fee366bf$var$currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        var parentProvides = $6d932106fee366bf$var$currentInstance.parent && $6d932106fee366bf$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $6d932106fee366bf$var$currentInstance.provides = Object.create(parentProvides);
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function $6d932106fee366bf$export$a976684a0efeb93f(key, defaultValue) {
    var treatDefaultAsFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = $6d932106fee366bf$var$currentInstance || $6d932106fee366bf$var$currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the intance is at root
        var provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $j3cSI.isFunction)(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    }
}
function $6d932106fee366bf$export$d2a0a1bc267c90f6() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    $6d932106fee366bf$export$6d1641039221b5cb(function() {
        state.isMounted = true;
    });
    $6d932106fee366bf$export$40c420df62d2614(function() {
        state.isUnmounting = true;
    });
    return state;
}
var $6d932106fee366bf$var$TransitionHookValidator = [
    Function,
    Array
];
var $6d932106fee366bf$var$BaseTransitionImpl = {
    name: "BaseTransition",
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: $6d932106fee366bf$var$TransitionHookValidator,
        onEnter: $6d932106fee366bf$var$TransitionHookValidator,
        onAfterEnter: $6d932106fee366bf$var$TransitionHookValidator,
        onEnterCancelled: $6d932106fee366bf$var$TransitionHookValidator,
        // leave
        onBeforeLeave: $6d932106fee366bf$var$TransitionHookValidator,
        onLeave: $6d932106fee366bf$var$TransitionHookValidator,
        onAfterLeave: $6d932106fee366bf$var$TransitionHookValidator,
        onLeaveCancelled: $6d932106fee366bf$var$TransitionHookValidator,
        // appear
        onBeforeAppear: $6d932106fee366bf$var$TransitionHookValidator,
        onAppear: $6d932106fee366bf$var$TransitionHookValidator,
        onAfterAppear: $6d932106fee366bf$var$TransitionHookValidator,
        onAppearCancelled: $6d932106fee366bf$var$TransitionHookValidator
    },
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $6d932106fee366bf$export$f13e630aa3915748();
        var state = $6d932106fee366bf$export$d2a0a1bc267c90f6();
        var prevTransitionKey;
        return function() {
            var children = slots.default && $6d932106fee366bf$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            var rawProps = (0, $Dz4HH.toRaw)(props);
            var mode = rawProps.mode;
            // at this point children has a guaranteed length of 1.
            var child = children[0];
            if (state.isLeaving) return $6d932106fee366bf$var$emptyPlaceholder(child);
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            var innerChild = $6d932106fee366bf$var$getKeepAliveChild(child);
            if (!innerChild) return $6d932106fee366bf$var$emptyPlaceholder(child);
            var enterHooks = $6d932106fee366bf$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $6d932106fee366bf$export$7770a22486565649(innerChild, enterHooks);
            var oldChild = instance.subTree;
            var oldInnerChild = oldChild && $6d932106fee366bf$var$getKeepAliveChild(oldChild);
            var transitionKeyChanged = false;
            var getTransitionKey = innerChild.type.getTransitionKey;
            if (getTransitionKey) {
                var key = getTransitionKey();
                if (prevTransitionKey === undefined) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild && oldInnerChild.type !== $6d932106fee366bf$export$4d299b491347818a && (!$6d932106fee366bf$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                var leavingHooks = $6d932106fee366bf$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                $6d932106fee366bf$export$7770a22486565649(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === "out-in") {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = function() {
                        state.isLeaving = false;
                        instance.update();
                    };
                    return $6d932106fee366bf$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $6d932106fee366bf$export$4d299b491347818a) leavingHooks.delayLeave = function(el, earlyRemove, delayedLeave) {
                    var leavingVNodesCache = $6d932106fee366bf$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    // early removal callback
                    el._leaveCb = function() {
                        earlyRemove();
                        el._leaveCb = undefined;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
var $6d932106fee366bf$export$abd95b5f5e8a8837 = $6d932106fee366bf$var$BaseTransitionImpl;
function $6d932106fee366bf$var$getLeavingNodesForType(state, vnode) {
    var leavingVNodes = state.leavingVNodes;
    var leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function $6d932106fee366bf$export$76ac1779589cd824(vnode, props, state, instance) {
    var appear = props.appear, mode = props.mode, _props_persisted = props.persisted, persisted = _props_persisted === void 0 ? false : _props_persisted, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var key = String(vnode.key);
    var leavingVNodesCache = $6d932106fee366bf$var$getLeavingNodesForType(state, vnode);
    var callHook = function(hook, args) {
        hook && $6d932106fee366bf$export$dae85862a8d94378(hook, instance, 9 /* TRANSITION_HOOK */ , args);
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function(el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            // for same element (v-show)
            if (el._leaveCb) el._leaveCb(true);
            // for toggled element with same key (v-if)
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $6d932106fee366bf$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) // force early removal (not cancelled)
            leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter: function(el) {
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            var called = false;
            var done = el._enterCb = function(cancelled) {
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = undefined;
            };
            if (hook) {
                hook(el, done);
                if (hook.length <= 1) done();
            } else done();
        },
        leave: function(el, remove) {
            var key = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            var called = false;
            var done = el._leaveCb = function(cancelled) {
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
            };
            leavingVNodesCache[key] = vnode;
            if (onLeave) {
                onLeave(el, done);
                if (onLeave.length <= 1) done();
            } else done();
        },
        clone: function(vnode) {
            return $6d932106fee366bf$export$76ac1779589cd824(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function $6d932106fee366bf$var$emptyPlaceholder(vnode) {
    if ($6d932106fee366bf$var$isKeepAlive(vnode)) {
        vnode = $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $6d932106fee366bf$var$getKeepAliveChild(vnode) {
    return $6d932106fee366bf$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : undefined : vnode;
}
function $6d932106fee366bf$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* COMPONENT */  && vnode.component) $6d932106fee366bf$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $6d932106fee366bf$export$a67f9b1229c7c97a(children) {
    var keepComment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ret = [];
    var keyedFragmentCount = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        // handle fragment children case, e.g. v-for
        if (child.type === $6d932106fee366bf$export$ffb0004e005737fa) {
            if (child.patchFlag & 128 /* KEYED_FRAGMENT */ ) keyedFragmentCount++;
            ret = ret.concat($6d932106fee366bf$export$a67f9b1229c7c97a(child.children, keepComment));
        } else if (keepComment || child.type !== $6d932106fee366bf$export$4d299b491347818a) ret.push(child);
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) for(var i1 = 0; i1 < ret.length; i1++)ret[i1].patchFlag = -2 /* BAIL */ ;
    return ret;
}
// implementation, close to no-op
function $6d932106fee366bf$export$afa64b67e5a01c3b(options) {
    return (0, $j3cSI.isFunction)(options) ? {
        setup: options,
        name: options.name
    } : options;
}
var $6d932106fee366bf$var$isAsyncWrapper = function(i) {
    return !!i.type.__asyncLoader;
};
function $6d932106fee366bf$export$d75d499b4c16cf21(source) {
    if ((0, $j3cSI.isFunction)(source)) source = {
        loader: source
    };
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _source_delay = source.delay, delay = _source_delay === void 0 ? 200 : _source_delay, timeout = source.timeout, _source_suspensible = source.suspensible, suspensible = _source_suspensible === void 0 ? true : _source_suspensible, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $6d932106fee366bf$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup: function() {
            var instance = $6d932106fee366bf$var$currentInstance;
            // already resolved
            if (resolvedComp) return function() {
                return $6d932106fee366bf$var$createInnerComp(resolvedComp, instance);
            };
            var onError = function(err) {
                pendingRequest = null;
                $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, 13 /* ASYNC_COMPONENT_LOADER */ , !errorComponent /* do not throw in dev if user provided error component */ );
            };
            // suspense-controlled or SSR.
            if (suspensible && instance.suspense || $6d932106fee366bf$var$isInSSRComponentSetup) return load().then(function(comp) {
                return function() {
                    return $6d932106fee366bf$var$createInnerComp(comp, instance);
                };
            }).catch(function(err) {
                onError(err);
                return function() {
                    return errorComponent ? $6d932106fee366bf$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
                };
            });
            var loaded = (0, $Dz4HH.ref)(false);
            var error = (0, $Dz4HH.ref)();
            var delayed = (0, $Dz4HH.ref)(!!delay);
            if (delay) setTimeout(function() {
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(function() {
                if (!loaded.value && !error.value) {
                    var err = new Error("Async component timed out after ".concat(timeout, "ms."));
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(function() {
                loaded.value = true;
                if (instance.parent && $6d932106fee366bf$var$isKeepAlive(instance.parent.vnode)) // parent is keep-alive, force update so the loaded component's
                // name is taken into account
                $6d932106fee366bf$var$queueJob(instance.parent.update);
            }).catch(function(err) {
                onError(err);
                error.value = err;
            });
            return function() {
                if (loaded.value && resolvedComp) return $6d932106fee366bf$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $6d932106fee366bf$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $6d932106fee366bf$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $6d932106fee366bf$var$createInnerComp(comp, param) {
    var _param_vnode = param.vnode, ref = _param_vnode.ref, props = _param_vnode.props, children = _param_vnode.children;
    var vnode = $6d932106fee366bf$export$bf5c4cf060303d58(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}
var $6d932106fee366bf$var$isKeepAlive = function(vnode) {
    return vnode.type.__isKeepAlive;
};
var $6d932106fee366bf$var$KeepAliveImpl = {
    name: "KeepAlive",
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $6d932106fee366bf$export$f13e630aa3915748();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        var sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) return slots.default;
        var cache = new Map();
        var keys = new Set();
        var current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        var parentSuspense = instance.suspense;
        var _sharedContext_renderer = sharedContext.renderer, patch = _sharedContext_renderer.p, move = _sharedContext_renderer.m, _unmount = _sharedContext_renderer.um, createElement = _sharedContext_renderer.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.activate = function(vnode, container, anchor, isSVG, optimized) {
            var instance = vnode.component;
            move(vnode, container, anchor, 0 /* ENTER */ , parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $6d932106fee366bf$var$queuePostRenderEffect(function() {
                instance.isDeactivated = false;
                if (instance.a) (0, $j3cSI.invokeArrayFns)(instance.a);
                var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $6d932106fee366bf$var$devtoolsComponentAdded(instance);
        };
        sharedContext.deactivate = function(vnode) {
            var instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* LEAVE */ , parentSuspense);
            $6d932106fee366bf$var$queuePostRenderEffect(function() {
                if (instance.da) (0, $j3cSI.invokeArrayFns)(instance.da);
                var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
                instance.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $6d932106fee366bf$var$devtoolsComponentAdded(instance);
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            $6d932106fee366bf$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense);
        }
        function pruneCache(filter) {
            cache.forEach(function(vnode, key) {
                var name = $6d932106fee366bf$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (!current || cached.type !== current.type) unmount(cached);
            else if (current) // current active instance should no longer be kept-alive.
            // we can't unmount it now but it might be later, so reset its flag now.
            $6d932106fee366bf$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        $6d932106fee366bf$export$3db5d71bdb2d5499(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $fGQt0._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return $6d932106fee366bf$var$matches(include, name);
            });
            exclude && pruneCache(function(name) {
                return !$6d932106fee366bf$var$matches(exclude, name);
            });
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        // cache sub tree after render
        var pendingCacheKey = null;
        var cacheSubtree = function() {
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $6d932106fee366bf$var$getInnerChild(instance.subTree));
        };
        $6d932106fee366bf$export$6d1641039221b5cb(cacheSubtree);
        $6d932106fee366bf$export$5876c47052fb88b1(cacheSubtree);
        $6d932106fee366bf$export$40c420df62d2614(function() {
            cache.forEach(function(cached) {
                var subTree = instance.subTree, suspense = instance.suspense;
                var vnode = $6d932106fee366bf$var$getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    $6d932106fee366bf$var$resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    var da = vnode.component.da;
                    da && $6d932106fee366bf$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function() {
            pendingCacheKey = null;
            if (!slots.default) return null;
            var children = slots.default();
            var rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$6d932106fee366bf$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) && !(rawVNode.shapeFlag & 128 /* SUSPENSE */ )) {
                current = null;
                return rawVNode;
            }
            var vnode = $6d932106fee366bf$var$getInnerChild(rawVNode);
            var comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            var name = $6d932106fee366bf$var$getComponentName($6d932106fee366bf$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !$6d932106fee366bf$var$matches(include, name)) || exclude && name && $6d932106fee366bf$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128 /* SUSPENSE */ ) rawVNode.ssContent = vnode;
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) // recursively update transition hooks on subTree
                $6d932106fee366bf$export$7770a22486565649(vnode, vnode.transition);
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* COMPONENT_KEPT_ALIVE */ ;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
            current = vnode;
            return rawVNode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
var $6d932106fee366bf$export$70eb8a58709972df = $6d932106fee366bf$var$KeepAliveImpl;
function $6d932106fee366bf$var$matches(pattern, name) {
    if ((0, $j3cSI.isArray)(pattern)) return pattern.some(function(p) {
        return $6d932106fee366bf$var$matches(p, name);
    });
    else if ((0, $j3cSI.isString)(pattern)) return pattern.split(",").indexOf(name) > -1;
    else if (pattern.test) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $6d932106fee366bf$export$ba52d824b95a2154(hook, target) {
    $6d932106fee366bf$var$registerKeepAliveHook(hook, "a" /* ACTIVATED */ , target);
}
function $6d932106fee366bf$export$bf1440eeaf5fa709(hook, target) {
    $6d932106fee366bf$var$registerKeepAliveHook(hook, "da" /* DEACTIVATED */ , target);
}
function $6d932106fee366bf$var$registerKeepAliveHook(hook, type) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $6d932106fee366bf$var$currentInstance;
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    var wrappedHook = hook.__wdc || (hook.__wdc = function() {
        // only fire the hook if the target instance is NOT in a deactivated branch.
        var current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        hook();
    });
    $6d932106fee366bf$var$injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        var current = target.parent;
        while(current && current.parent){
            if ($6d932106fee366bf$var$isKeepAlive(current.parent.vnode)) $6d932106fee366bf$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $6d932106fee366bf$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    var injected = $6d932106fee366bf$var$injectHook(type, hook, keepAliveRoot, true);
    $6d932106fee366bf$export$13348a43ccacfe58(function() {
        (0, $j3cSI.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $6d932106fee366bf$var$resetShapeFlag(vnode) {
    var shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) shapeFlag -= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
    if (shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) shapeFlag -= 512 /* COMPONENT_KEPT_ALIVE */ ;
    vnode.shapeFlag = shapeFlag;
}
function $6d932106fee366bf$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* SUSPENSE */  ? vnode.ssContent : vnode;
}
function $6d932106fee366bf$var$injectHook(type, hook) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $6d932106fee366bf$var$currentInstance, prepend = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (target) {
        var hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        var wrappedHook = hook.__weh || (hook.__weh = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (target.isUnmounted) return;
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $Dz4HH.pauseTracking)();
            // Set currentInstance during hook invocation.
            // This assumes the hook does not synchronously trigger other hooks, which
            // can only be false when the user does something really funky.
            $6d932106fee366bf$var$setCurrentInstance(target);
            var res = $6d932106fee366bf$export$dae85862a8d94378(hook, target, type, args);
            $6d932106fee366bf$var$unsetCurrentInstance();
            (0, $Dz4HH.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
var $6d932106fee366bf$var$createHook = function(lifecycle) {
    return function(hook) {
        var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6d932106fee366bf$var$currentInstance;
        return(// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$6d932106fee366bf$var$isInSSRComponentSetup || lifecycle === "sp" /* SERVER_PREFETCH */ ) && $6d932106fee366bf$var$injectHook(lifecycle, hook, target));
    };
};
var $6d932106fee366bf$export$23b7aeb0d671f804 = $6d932106fee366bf$var$createHook("bm" /* BEFORE_MOUNT */ );
var $6d932106fee366bf$export$6d1641039221b5cb = $6d932106fee366bf$var$createHook("m" /* MOUNTED */ );
var $6d932106fee366bf$export$ab91988a13872e4c = $6d932106fee366bf$var$createHook("bu" /* BEFORE_UPDATE */ );
var $6d932106fee366bf$export$5876c47052fb88b1 = $6d932106fee366bf$var$createHook("u" /* UPDATED */ );
var $6d932106fee366bf$export$40c420df62d2614 = $6d932106fee366bf$var$createHook("bum" /* BEFORE_UNMOUNT */ );
var $6d932106fee366bf$export$13348a43ccacfe58 = $6d932106fee366bf$var$createHook("um" /* UNMOUNTED */ );
var $6d932106fee366bf$export$ebf0c601f267bceb = $6d932106fee366bf$var$createHook("sp" /* SERVER_PREFETCH */ );
var $6d932106fee366bf$export$898295a813d662eb = $6d932106fee366bf$var$createHook("rtg" /* RENDER_TRIGGERED */ );
var $6d932106fee366bf$export$2b41f4235363e921 = $6d932106fee366bf$var$createHook("rtc" /* RENDER_TRACKED */ );
function $6d932106fee366bf$export$6a3a15856e50ad19(hook) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $6d932106fee366bf$var$currentInstance;
    $6d932106fee366bf$var$injectHook("ec" /* ERROR_CAPTURED */ , hook, target);
}
function $6d932106fee366bf$var$createDuplicateChecker() {
    var cache = Object.create(null);
    return function(type, key) {
        if (cache[key]) $6d932106fee366bf$export$c106dd0671a0fc2d("".concat(type, ' property "').concat(key, '" is already defined in ').concat(cache[key], "."));
        else cache[key] = type;
    };
}
var $6d932106fee366bf$var$shouldCacheAccess = true;
function $6d932106fee366bf$var$applyOptions(instance) {
    var _loop = function(key1) {
        var opt = computedOptions[key1];
        var get = (0, $j3cSI.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $j3cSI.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $j3cSI.NOOP);
        var set = !(0, $j3cSI.isFunction)(opt) && (0, $j3cSI.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $j3cSI.NOOP);
        var c = (0, $Dz4HH.computed)({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key1, {
            enumerable: true,
            configurable: true,
            get: function() {
                return c.value;
            },
            set: function(v1) {
                return c.value = v1;
            }
        });
    };
    var options = $6d932106fee366bf$var$resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    $6d932106fee366bf$var$shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) $6d932106fee366bf$var$callHook(options.beforeCreate, instance, "bc" /* BEFORE_CREATE */ );
    var // state
    dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, // lifecycle
    created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, // public API
    expose = options.expose, inheritAttrs = options.inheritAttrs, // assets
    components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = null;
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) $6d932106fee366bf$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    if (methods) for(var key in methods){
        var methodHandler = methods[key];
        if ((0, $j3cSI.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        var data = dataOptions.call(publicThis, publicThis);
        if (!(0, $j3cSI.isObject)(data)) ;
        else instance.data = (0, $Dz4HH.reactive)(data);
    }
    // state initialization complete at this point - start caching access
    $6d932106fee366bf$var$shouldCacheAccess = true;
    if (computedOptions) for(var key1 in computedOptions)_loop(key1);
    if (watchOptions) for(var key2 in watchOptions)$6d932106fee366bf$var$createWatcher(watchOptions[key2], ctx, publicThis, key2);
    if (provideOptions) {
        var provides = (0, $j3cSI.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach(function(key) {
            $6d932106fee366bf$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $6d932106fee366bf$var$callHook(created, instance, "c" /* CREATED */ );
    function registerLifecycleHook(register, hook) {
        if ((0, $j3cSI.isArray)(hook)) hook.forEach(function(_hook) {
            return register(_hook.bind(publicThis));
        });
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($6d932106fee366bf$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($6d932106fee366bf$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($6d932106fee366bf$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($6d932106fee366bf$export$5876c47052fb88b1, updated);
    registerLifecycleHook($6d932106fee366bf$export$ba52d824b95a2154, activated);
    registerLifecycleHook($6d932106fee366bf$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($6d932106fee366bf$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($6d932106fee366bf$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($6d932106fee366bf$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($6d932106fee366bf$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($6d932106fee366bf$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($6d932106fee366bf$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $j3cSI.isArray)(expose)) {
        if (expose.length) {
            var exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(function(key) {
                Object.defineProperty(exposed, key, {
                    get: function() {
                        return publicThis[key];
                    },
                    set: function(val) {
                        return publicThis[key] = val;
                    }
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === (0, $j3cSI.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    // asset options.
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $6d932106fee366bf$var$resolveInjections(injectOptions, ctx) {
    var _loop = function(key) {
        var opt = injectOptions[key];
        var injected = void 0;
        if ((0, $j3cSI.isObject)(opt)) {
            if ("default" in opt) injected = $6d932106fee366bf$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $6d932106fee366bf$export$a976684a0efeb93f(opt.from || key);
        } else injected = $6d932106fee366bf$export$a976684a0efeb93f(opt);
        if ((0, $Dz4HH.isRef)(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return injected.value;
                },
                set: function(v1) {
                    return injected.value = v1;
                }
            });
            else ctx[key] = injected;
        } else ctx[key] = injected;
    };
    var checkDuplicateProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $j3cSI.NOOP), unwrapRef = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if ((0, $j3cSI.isArray)(injectOptions)) injectOptions = $6d932106fee366bf$var$normalizeInject(injectOptions);
    for(var key in injectOptions)_loop(key);
}
function $6d932106fee366bf$var$callHook(hook, instance, type) {
    $6d932106fee366bf$export$dae85862a8d94378((0, $j3cSI.isArray)(hook) ? hook.map(function(h) {
        return h.bind(instance.proxy);
    }) : hook.bind(instance.proxy), instance, type);
}
function $6d932106fee366bf$var$createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? $6d932106fee366bf$var$createPathGetter(publicThis, key) : function() {
        return publicThis[key];
    };
    if ((0, $j3cSI.isString)(raw)) {
        var handler = ctx[raw];
        if ((0, $j3cSI.isFunction)(handler)) $6d932106fee366bf$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $j3cSI.isFunction)(raw)) $6d932106fee366bf$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $j3cSI.isObject)(raw)) {
        if ((0, $j3cSI.isArray)(raw)) raw.forEach(function(r) {
            return $6d932106fee366bf$var$createWatcher(r, ctx, publicThis, key);
        });
        else {
            var handler1 = (0, $j3cSI.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $j3cSI.isFunction)(handler1)) $6d932106fee366bf$export$3db5d71bdb2d5499(getter, handler1, raw);
        }
    } else ;
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */ function $6d932106fee366bf$var$resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base.extends;
    var _instance_appContext = instance.appContext, globalMixins = _instance_appContext.mixins, cache = _instance_appContext.optionsCache, optionMergeStrategies = _instance_appContext.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach(function(m) {
            return $6d932106fee366bf$var$mergeOptions(resolved, m, optionMergeStrategies, true);
        });
        $6d932106fee366bf$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    cache.set(base, resolved);
    return resolved;
}
function $6d932106fee366bf$var$mergeOptions(to, from, strats) {
    var asMixin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var mixins = from.mixins, extendsOptions = from.extends;
    if (extendsOptions) $6d932106fee366bf$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach(function(m) {
        return $6d932106fee366bf$var$mergeOptions(to, m, strats, true);
    });
    for(var key in from){
        if (asMixin && key === "expose") ;
        else {
            var strat = $6d932106fee366bf$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
var $6d932106fee366bf$var$internalOptionMergeStrats = {
    data: $6d932106fee366bf$var$mergeDataFn,
    props: $6d932106fee366bf$var$mergeObjectOptions,
    emits: $6d932106fee366bf$var$mergeObjectOptions,
    // objects
    methods: $6d932106fee366bf$var$mergeObjectOptions,
    computed: $6d932106fee366bf$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $6d932106fee366bf$var$mergeAsArray,
    created: $6d932106fee366bf$var$mergeAsArray,
    beforeMount: $6d932106fee366bf$var$mergeAsArray,
    mounted: $6d932106fee366bf$var$mergeAsArray,
    beforeUpdate: $6d932106fee366bf$var$mergeAsArray,
    updated: $6d932106fee366bf$var$mergeAsArray,
    beforeDestroy: $6d932106fee366bf$var$mergeAsArray,
    beforeUnmount: $6d932106fee366bf$var$mergeAsArray,
    destroyed: $6d932106fee366bf$var$mergeAsArray,
    unmounted: $6d932106fee366bf$var$mergeAsArray,
    activated: $6d932106fee366bf$var$mergeAsArray,
    deactivated: $6d932106fee366bf$var$mergeAsArray,
    errorCaptured: $6d932106fee366bf$var$mergeAsArray,
    serverPrefetch: $6d932106fee366bf$var$mergeAsArray,
    // assets
    components: $6d932106fee366bf$var$mergeObjectOptions,
    directives: $6d932106fee366bf$var$mergeObjectOptions,
    // watch
    watch: $6d932106fee366bf$var$mergeWatchOptions,
    // provide / inject
    provide: $6d932106fee366bf$var$mergeDataFn,
    inject: $6d932106fee366bf$var$mergeInject
};
function $6d932106fee366bf$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $j3cSI.extend)((0, $j3cSI.isFunction)(to) ? to.call(this, this) : to, (0, $j3cSI.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $6d932106fee366bf$var$mergeInject(to, from) {
    return $6d932106fee366bf$var$mergeObjectOptions($6d932106fee366bf$var$normalizeInject(to), $6d932106fee366bf$var$normalizeInject(from));
}
function $6d932106fee366bf$var$normalizeInject(raw) {
    if ((0, $j3cSI.isArray)(raw)) {
        var res = {};
        for(var i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $6d932106fee366bf$var$mergeAsArray(to, from) {
    return to ? (0, $aYXpI._)(new Set([].concat(to, from))) : from;
}
function $6d932106fee366bf$var$mergeObjectOptions(to, from) {
    return to ? (0, $j3cSI.extend)((0, $j3cSI.extend)(Object.create(null), to), from) : from;
}
function $6d932106fee366bf$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    var merged = (0, $j3cSI.extend)(Object.create(null), to);
    for(var key in from)merged[key] = $6d932106fee366bf$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $6d932106fee366bf$var$initProps(instance, rawProps, isStateful) {
    var isSSR = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = {};
    var attrs = {};
    (0, $j3cSI.def)(attrs, $6d932106fee366bf$var$InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    $6d932106fee366bf$var$setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for(var key in instance.propsOptions[0])if (!(key in props)) props[key] = undefined;
    if (isStateful) // stateful
    instance.props = isSSR ? props : (0, $Dz4HH.shallowReactive)(props);
    else if (!instance.type.props) // functional w/ optional props, props === attrs
    instance.props = attrs;
    else // functional w/ declared props
    instance.props = props;
    instance.attrs = attrs;
}
function $6d932106fee366bf$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = (0, $Dz4HH.toRaw)(props);
    var _instance_propsOptions = (0, $fGQt0._)(instance.propsOptions, 1), options = _instance_propsOptions[0];
    var hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16 /* FULL_PROPS */ )) {
        if (patchFlag & 8 /* PROPS */ ) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            var propsToUpdate = instance.vnode.dynamicProps;
            for(var i = 0; i < propsToUpdate.length; i++){
                var key = propsToUpdate[i];
                // PROPS flag guarantees rawProps to be non-null
                var value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0, $j3cSI.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        var camelizedKey = (0, $j3cSI.camelize)(key);
                        props[camelizedKey] = $6d932106fee366bf$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        // full props update.
        if ($6d932106fee366bf$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        var kebabKey;
        for(var key1 in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $j3cSI.hasOwn)(rawProps, key1) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $j3cSI.hyphenate)(key1)) === key1 || !(0, $j3cSI.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key1] !== undefined || // for kebab-case
                rawPrevProps[kebabKey] !== undefined)) props[key1] = $6d932106fee366bf$var$resolvePropValue(options, rawCurrentProps, key1, undefined, instance, true);
            } else delete props[key1];
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for(var key2 in attrs)if (!rawProps || !(0, $j3cSI.hasOwn)(rawProps, key2)) {
                delete attrs[key2];
                hasAttrsChanged = true;
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) (0, $Dz4HH.trigger)(instance, "set" /* SET */ , "$attrs");
}
function $6d932106fee366bf$var$setFullProps(instance, rawProps, props, attrs) {
    var _instance_propsOptions = (0, $fGQt0._)(instance.propsOptions, 2), options = _instance_propsOptions[0], needCastKeys = _instance_propsOptions[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) for(var key in rawProps){
        // key, ref are reserved and never passed down
        if ((0, $j3cSI.isReservedProp)(key)) continue;
        var value = rawProps[key];
        // prop option names are camelized during normalization, so to support
        // kebab -> camel conversion here we need to camelize the key.
        var camelKey = void 0;
        if (options && (0, $j3cSI.hasOwn)(options, camelKey = (0, $j3cSI.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$6d932106fee366bf$var$isEmitListener(instance.emitsOptions, key)) {
            if (value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        var rawCurrentProps = (0, $Dz4HH.toRaw)(props);
        var castValues = rawCastValues || (0, $j3cSI.EMPTY_OBJ);
        for(var i = 0; i < needCastKeys.length; i++){
            var key1 = needCastKeys[i];
            props[key1] = $6d932106fee366bf$var$resolvePropValue(options, rawCurrentProps, key1, castValues[key1], instance, !(0, $j3cSI.hasOwn)(castValues, key1));
        }
    }
    return hasAttrsChanged;
}
function $6d932106fee366bf$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    var opt = options[key];
    if (opt != null) {
        var hasDefault = (0, $j3cSI.hasOwn)(opt, "default");
        // default values
        if (hasDefault && value === undefined) {
            var defaultValue = opt.default;
            if (opt.type !== Function && (0, $j3cSI.isFunction)(defaultValue)) {
                var propsDefaults = instance.propsDefaults;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    $6d932106fee366bf$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    $6d932106fee366bf$var$unsetCurrentInstance();
                }
            } else value = defaultValue;
        }
        // boolean casting
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $j3cSI.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $6d932106fee366bf$var$normalizePropsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) return cached;
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    // apply mixin/extends props
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $j3cSI.isFunction)(comp)) {
        var extendProps = function(raw) {
            var _needCastKeys;
            hasExtends = true;
            var _normalizePropsOptions = (0, $fGQt0._)($6d932106fee366bf$var$normalizePropsOptions(raw, appContext, true), 2), props = _normalizePropsOptions[0], keys = _normalizePropsOptions[1];
            (0, $j3cSI.extend)(normalized, props);
            if (keys) (_needCastKeys = needCastKeys).push.apply(_needCastKeys, (0, $aYXpI._)(keys));
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, (0, $j3cSI.EMPTY_ARR));
        return 0, $j3cSI.EMPTY_ARR;
    }
    if ((0, $j3cSI.isArray)(raw)) for(var i = 0; i < raw.length; i++){
        var normalizedKey = (0, $j3cSI.camelize)(raw[i]);
        if ($6d932106fee366bf$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $j3cSI.EMPTY_OBJ);
    }
    else if (raw) for(var key in raw){
        var normalizedKey1 = (0, $j3cSI.camelize)(key);
        if ($6d932106fee366bf$var$validatePropName(normalizedKey1)) {
            var opt = raw[key];
            var prop = normalized[normalizedKey1] = (0, $j3cSI.isArray)(opt) || (0, $j3cSI.isFunction)(opt) ? {
                type: opt
            } : opt;
            if (prop) {
                var booleanIndex = $6d932106fee366bf$var$getTypeIndex(Boolean, prop.type);
                var stringIndex = $6d932106fee366bf$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                // if the prop needs boolean casting or default value
                if (booleanIndex > -1 || (0, $j3cSI.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey1);
            }
        }
    }
    var res = [
        normalized,
        needCastKeys
    ];
    cache.set(comp, res);
    return res;
}
function $6d932106fee366bf$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function $6d932106fee366bf$var$getType(ctor) {
    var match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? "null" : "";
}
function $6d932106fee366bf$var$isSameType(a, b) {
    return $6d932106fee366bf$var$getType(a) === $6d932106fee366bf$var$getType(b);
}
function $6d932106fee366bf$var$getTypeIndex(type, expectedTypes) {
    if ((0, $j3cSI.isArray)(expectedTypes)) return expectedTypes.findIndex(function(t) {
        return $6d932106fee366bf$var$isSameType(t, type);
    });
    else if ((0, $j3cSI.isFunction)(expectedTypes)) return $6d932106fee366bf$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
/**
 * dev only
 */ function $6d932106fee366bf$var$validateProps(rawProps, props, instance) {
    var resolvedValues = (0, $Dz4HH.toRaw)(props);
    var options = instance.propsOptions[0];
    for(var key in options){
        var opt = options[key];
        if (opt == null) continue;
        $6d932106fee366bf$var$validateProp(key, resolvedValues[key], opt, !(0, $j3cSI.hasOwn)(rawProps, key) && !(0, $j3cSI.hasOwn)(rawProps, (0, $j3cSI.hyphenate)(key)));
    }
}
/**
 * dev only
 */ function $6d932106fee366bf$var$validateProp(name, value, prop, isAbsent) {
    var type = prop.type, required = prop.required, validator = prop.validator;
    // required!
    if (required && isAbsent) {
        $6d932106fee366bf$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) return;
    // type check
    if (type != null && type !== true) {
        var isValid = false;
        var types = (0, $j3cSI.isArray)(type) ? type : [
            type
        ];
        var expectedTypes = [];
        // value is valid as long as one of the specified types match
        for(var i = 0; i < types.length && !isValid; i++){
            var _assertType = $6d932106fee366bf$var$assertType(value, types[i]), valid = _assertType.valid, expectedType = _assertType.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $6d932106fee366bf$export$c106dd0671a0fc2d($6d932106fee366bf$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) $6d932106fee366bf$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
var $6d932106fee366bf$var$isSimpleType = /*#__PURE__*/ (0, $j3cSI.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
 * dev only
 */ function $6d932106fee366bf$var$assertType(value, type) {
    var valid;
    var expectedType = $6d932106fee366bf$var$getType(type);
    if ($6d932106fee366bf$var$isSimpleType(expectedType)) {
        var t = typeof value === "undefined" ? "undefined" : (0, $6aBn7._)(value);
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $j3cSI.isObject)(value);
    else if (expectedType === "Array") valid = (0, $j3cSI.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
 * dev only
 */ function $6d932106fee366bf$var$getInvalidTypeMessage(name, value, expectedTypes) {
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '".') + " Expected ".concat(expectedTypes.map((0, $j3cSI.capitalize)).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = (0, $j3cSI.toRawType)(value);
    var expectedValue = $6d932106fee366bf$var$styleValue(value, expectedType);
    var receivedValue = $6d932106fee366bf$var$styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $6d932106fee366bf$var$isExplicable(expectedType) && !$6d932106fee366bf$var$isBoolean(expectedType, receivedType)) message += " with value ".concat(expectedValue);
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if ($6d932106fee366bf$var$isExplicable(receivedType)) message += "with value ".concat(receivedValue, ".");
    return message;
}
/**
 * dev only
 */ function $6d932106fee366bf$var$styleValue(value, type) {
    if (type === "String") return '"'.concat(value, '"');
    else if (type === "Number") return "".concat(Number(value));
    else return "".concat(value);
}
/**
 * dev only
 */ function $6d932106fee366bf$var$isExplicable(type) {
    var explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some(function(elem) {
        return type.toLowerCase() === elem;
    });
}
/**
 * dev only
 */ function $6d932106fee366bf$var$isBoolean() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.some(function(elem) {
        return elem.toLowerCase() === "boolean";
    });
}
var $6d932106fee366bf$var$isInternalKey = function(key) {
    return key[0] === "_" || key === "$stable";
};
var $6d932106fee366bf$var$normalizeSlotValue = function(value) {
    return (0, $j3cSI.isArray)(value) ? value.map($6d932106fee366bf$var$normalizeVNode) : [
        $6d932106fee366bf$var$normalizeVNode(value)
    ];
};
var $6d932106fee366bf$var$normalizeSlot = function(key, rawSlot, ctx) {
    var normalized = $6d932106fee366bf$export$694b237e827a3d23(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $6d932106fee366bf$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $aYXpI._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var $6d932106fee366bf$var$normalizeObjectSlots = function(rawSlots, slots, instance) {
    var _loop = function(key) {
        if ($6d932106fee366bf$var$isInternalKey(key)) return "continue";
        var value = rawSlots[key];
        if ((0, $j3cSI.isFunction)(value)) slots[key] = $6d932106fee366bf$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            var normalized = $6d932106fee366bf$var$normalizeSlotValue(value);
            slots[key] = function() {
                return normalized;
            };
        }
    };
    var ctx = rawSlots._ctx;
    for(var key in rawSlots)_loop(key);
};
var $6d932106fee366bf$var$normalizeVNodeSlots = function(instance, children) {
    var normalized = $6d932106fee366bf$var$normalizeSlotValue(children);
    instance.slots.default = function() {
        return normalized;
    };
};
var $6d932106fee366bf$var$initSlots = function(instance, children) {
    if (instance.vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        var type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = (0, $Dz4HH.toRaw)(children);
            // make compiler marker non-enumerable
            (0, $j3cSI.def)(children, "_", type);
        } else $6d932106fee366bf$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $6d932106fee366bf$var$normalizeVNodeSlots(instance, children);
    }
    (0, $j3cSI.def)(instance.slots, $6d932106fee366bf$var$InternalObjectKey, 1);
};
var $6d932106fee366bf$var$updateSlots = function(instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = (0, $j3cSI.EMPTY_OBJ);
    if (vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        var type = children._;
        if (type) {
            if (optimized && type === 1 /* STABLE */ ) // compiled AND stable.
            // no need to update, and skip stale slots removal.
            needDeletionCheck = false;
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0, $j3cSI.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* STABLE */ ) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $6d932106fee366bf$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        // non slot object children (direct value) passed to a component
        $6d932106fee366bf$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for(var key in slots)if (!$6d932106fee366bf$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/ var $6d932106fee366bf$var$isBuiltInDirective = /*#__PURE__*/ (0, $j3cSI.makeMap)("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text");
function $6d932106fee366bf$var$validateDirectiveName(name) {
    if ($6d932106fee366bf$var$isBuiltInDirective(name)) $6d932106fee366bf$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
/**
 * Adds directives to a VNode.
 */ function $6d932106fee366bf$export$49729353e7c1e6c5(vnode, directives) {
    var internalInstance = $6d932106fee366bf$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    var instance = internalInstance.proxy;
    var bindings = vnode.dirs || (vnode.dirs = []);
    for(var i = 0; i < directives.length; i++){
        var _directives_i = (0, $fGQt0._)(directives[i], 4), dir = _directives_i[0], value = _directives_i[1], arg = _directives_i[2], tmp = _directives_i[3], modifiers = tmp === void 0 ? (0, $j3cSI.EMPTY_OBJ) : tmp;
        if ((0, $j3cSI.isFunction)(dir)) dir = {
            mounted: dir,
            updated: dir
        };
        if (dir.deep) $6d932106fee366bf$var$traverse(value);
        bindings.push({
            dir: dir,
            instance: instance,
            value: value,
            oldValue: void 0,
            arg: arg,
            modifiers: modifiers
        });
    }
    return vnode;
}
function $6d932106fee366bf$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for(var i = 0; i < bindings.length; i++){
        var binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        var hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $Dz4HH.pauseTracking)();
            $6d932106fee366bf$export$dae85862a8d94378(hook, instance, 8 /* DIRECTIVE_HOOK */ , [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $Dz4HH.resetTracking)();
        }
    }
}
function $6d932106fee366bf$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $j3cSI.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
var $6d932106fee366bf$var$uid = 0;
function $6d932106fee366bf$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent) {
        var rootProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (rootProps != null && !(0, $j3cSI.isObject)(rootProps)) rootProps = null;
        var context = $6d932106fee366bf$var$createAppContext();
        var installedPlugins = new Set();
        var isMounted = false;
        var app = context.app = {
            _uid: $6d932106fee366bf$var$uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $6d932106fee366bf$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use: function(plugin) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $j3cSI.isFunction)(plugin.install)) {
                    var _plugin;
                    installedPlugins.add(plugin);
                    (_plugin = plugin).install.apply(_plugin, [
                        app
                    ].concat((0, $aYXpI._)(options)));
                } else if ((0, $j3cSI.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, [
                        app
                    ].concat((0, $aYXpI._)(options)));
                }
                return app;
            },
            mixin: function(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component: function(name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive: function(name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount: function(rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    var vnode = $6d932106fee366bf$export$bf5c4cf060303d58(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $6d932106fee366bf$var$devtoolsInitApp(app, $6d932106fee366bf$export$83d89fbfd8236492);
                    }
                    return $6d932106fee366bf$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount: function() {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $6d932106fee366bf$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide: function(key, value) {
                // TypeScript doesn't allow symbols as index type
                // https://github.com/Microsoft/TypeScript/issues/24587
                context.provides[key] = value;
                return app;
            }
        };
        return app;
    };
}
var $6d932106fee366bf$var$hasMismatch = false;
var $6d932106fee366bf$var$isSVGContainer = function(container) {
    return /svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
};
var $6d932106fee366bf$var$isComment = function(node) {
    return node.nodeType === 8 /* COMMENT */ ;
};
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function $6d932106fee366bf$var$createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _rendererInternals_o = rendererInternals.o, patchProp = _rendererInternals_o.patchProp, nextSibling = _rendererInternals_o.nextSibling, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove, insert = _rendererInternals_o.insert, createComment = _rendererInternals_o.createComment;
    var hydrate = function(vnode, container) {
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $6d932106fee366bf$var$flushPostFlushCbs();
            return;
        }
        $6d932106fee366bf$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $6d932106fee366bf$var$flushPostFlushCbs();
        if ($6d932106fee366bf$var$hasMismatch && true) // this error should show up in production
        console.error("Hydration completed but contains mismatches.");
    };
    var hydrateNode = function(node, vnode, parentComponent, parentSuspense, slotScopeIds) {
        var optimized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        var isFragmentStart = $6d932106fee366bf$var$isComment(node) && node.data === "[";
        var onMismatch = function() {
            return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag;
        var domType = node.nodeType;
        vnode.el = node;
        var nextNode = null;
        switch(type){
            case $6d932106fee366bf$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) nextNode = onMismatch();
                else {
                    if (node.data !== vnode.children) {
                        $6d932106fee366bf$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $6d932106fee366bf$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $6d932106fee366bf$export$c1b9a1d3af45b7b6:
                if (domType !== 1 /* ELEMENT */ ) nextNode = onMismatch();
                else {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    var needToAdoptContent = !vnode.children.length;
                    for(var i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.outerHTML;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return nextNode;
                }
                break;
            case $6d932106fee366bf$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6 /* COMPONENT */ ) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $6d932106fee366bf$var$isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if ($6d932106fee366bf$var$isAsyncWrapper(vnode)) {
                        var subTree;
                        if (isFragmentStart) {
                            subTree = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $6d932106fee366bf$export$22f9b5ffd89dac9("") : $6d932106fee366bf$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64 /* TELEPORT */ ) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128 /* SUSPENSE */ ) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $6d932106fee366bf$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $6d932106fee366bf$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    var hydrateElement = function(el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        var forcePatchValue = type === "input" && dirs || type === "option";
        // skip props & children if this is hoisted static nodes
        if (forcePatchValue || patchFlag !== -1 /* HOISTED */ ) {
            if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48 /* HYDRATE_EVENTS */ ) {
                    for(var key in props)if (forcePatchValue && key.endsWith("value") || (0, $j3cSI.isOn)(key) && !(0, $j3cSI.isReservedProp)(key)) patchProp(el, key, null, props[key], false, undefined, parentComponent);
                } else if (props.onClick) // Fast path for click listeners (which is most often) to avoid
                // iterating through props.
                patchProp(el, "onClick", null, props.onClick, false, undefined, parentComponent);
            }
            // vnode / directive hooks
            var vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $6d932106fee366bf$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $6d932106fee366bf$var$queueEffectWithSuspense(function() {
                vnodeHooks && $6d932106fee366bf$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            // children
            if (shapeFlag & 16 /* ARRAY_CHILDREN */  && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                var hasWarned = false;
                while(next){
                    $6d932106fee366bf$var$hasMismatch = true;
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
                if (el.textContent !== vnode.children) {
                    $6d932106fee366bf$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    var hydrateChildren = function(node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasWarned = false;
        for(var i = 0; i < l; i++){
            var vnode = optimized ? children[i] : children[i] = $6d932106fee366bf$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $6d932106fee366bf$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $6d932106fee366bf$var$hasMismatch = true;
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, $6d932106fee366bf$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $6d932106fee366bf$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            $6d932106fee366bf$var$hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        $6d932106fee366bf$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            var end = locateClosingAsyncAnchor(node);
            while(true){
                var next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        var next1 = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next1, parentComponent, parentSuspense, $6d932106fee366bf$var$isSVGContainer(container), slotScopeIds);
        return next1;
    };
    var locateClosingAsyncAnchor = function(node) {
        var match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $6d932106fee366bf$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
var $6d932106fee366bf$var$supported;
var $6d932106fee366bf$var$perf;
function $6d932106fee366bf$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $6d932106fee366bf$var$isSupported()) $6d932106fee366bf$var$perf.mark("vue-".concat(type, "-").concat(instance.uid));
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsPerfStart(instance, type, $6d932106fee366bf$var$supported ? $6d932106fee366bf$var$perf.now() : Date.now());
}
function $6d932106fee366bf$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $6d932106fee366bf$var$isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        $6d932106fee366bf$var$perf.mark(endTag);
        $6d932106fee366bf$var$perf.measure("<".concat($6d932106fee366bf$var$formatComponentName(instance, instance.type), "> ").concat(type), startTag, endTag);
        $6d932106fee366bf$var$perf.clearMarks(startTag);
        $6d932106fee366bf$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsPerfEnd(instance, type, $6d932106fee366bf$var$supported ? $6d932106fee366bf$var$perf.now() : Date.now());
}
function $6d932106fee366bf$var$isSupported() {
    if ($6d932106fee366bf$var$supported !== undefined) return $6d932106fee366bf$var$supported;
    /* eslint-disable no-restricted-globals */ if (typeof window !== "undefined" && window.performance) {
        $6d932106fee366bf$var$supported = true;
        $6d932106fee366bf$var$perf = window.performance;
    } else $6d932106fee366bf$var$supported = false;
    /* eslint-enable no-restricted-globals */ return $6d932106fee366bf$var$supported;
}
/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */ function $6d932106fee366bf$var$initFeatureFlags() {
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $j3cSI.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $j3cSI.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
var $6d932106fee366bf$var$queuePostRenderEffect = $6d932106fee366bf$var$queueEffectWithSuspense;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */ function $6d932106fee366bf$export$53ae2f996c64e9a(options) {
    return $6d932106fee366bf$var$baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function $6d932106fee366bf$export$200524cf0d997ff0(options) {
    return $6d932106fee366bf$var$baseCreateRenderer(options, $6d932106fee366bf$var$createHydrationFunctions);
}
// implementation
function $6d932106fee366bf$var$baseCreateRenderer(options, createHydrationFns) {
    $6d932106fee366bf$var$initFeatureFlags();
    var target = (0, $j3cSI.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, tmp = options.setScopeId, hostSetScopeId = tmp === void 0 ? (0, $j3cSI.NOOP) : tmp, hostCloneNode = options.cloneNode, hostInsertStaticContent = options.insertStaticContent;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    var patch = function(n1, n2, container) {
        var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parentComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, isSVG = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, slotScopeIds = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !!n2.dynamicChildren;
        if (n1 === n2) return;
        // patching & not same type, unmount old tree
        if (n1 && !$6d932106fee366bf$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* BAIL */ ) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch(type){
            case $6d932106fee366bf$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $6d932106fee366bf$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $6d932106fee366bf$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $6d932106fee366bf$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6 /* COMPONENT */ ) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64 /* TELEPORT */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128 /* SUSPENSE */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        // set ref
        if (ref != null && parentComponent) $6d932106fee366bf$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    var processText = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    var processCommentNode = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else // there's no support for dynamic comments
        n2.el = n1.el;
    };
    var mountStaticNode = function(n2, container, anchor, isSVG) {
        var ref;
        ref = (0, $fGQt0._)(hostInsertStaticContent(n2.children, container, anchor, isSVG), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
    };
    /**
     * Dev / HMR only
     */ var patchStaticNode = function(n1, n2, container, isSVG) {
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            var ref;
            ref = (0, $fGQt0._)(hostInsertStaticContent(n2.children, container, anchor, isSVG), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function(param, container, nextSibling) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function(param) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    var mountElement = function(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var type = vnode.type, props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, patchFlag = vnode.patchFlag, dirs = vnode.dirs;
        if ((0, vnode.el) && hostCloneNode !== undefined && patchFlag === -1 /* HOISTED */ ) // If a vnode has non-null el, it means it's being reused.
        // Only static vnodes can be reused, so its mounted DOM nodes should be
        // exactly the same, and we can simply do a clone here.
        // only do this in production since cloned trees cannot be HMR updated.
        el = vnode.el = hostCloneNode(vnode.el);
        else {
            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
            // mount children first, since some props may rely on child content
            // being already rendered, e.g. `<select value>`
            if (shapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(el, vnode.children);
            else if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
            if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                for(var key in props)if (key !== "value" && !(0, $j3cSI.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                /**
                 * Special case for setting value on DOM elements:
                 * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
                 * - it needs to be forced (#1471)
                 * #2353 proposes adding another renderer option to configure this, but
                 * the properties affects are so finite it is worth special casing it
                 * here to reduce the complexity. (Special casing it also should not
                 * affect non-DOM renderers)
                 */ if ("value" in props) hostPatchProp(el, "value", null, props.value);
                if (vnodeHook = props.onVnodeBeforeMount) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            }
            // scopeId
            setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        var needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $6d932106fee366bf$var$queuePostRenderEffect(function() {
            vnodeHook && $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    var setScopeId = function(el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(var i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            var subTree = parentComponent.subTree;
            if (vnode === subTree) {
                var parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    var mountChildren = function(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var start = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
        for(var i = start; i < children.length; i++){
            var child = children[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(children[i]) : $6d932106fee366bf$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    var patchElement = function(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* FULL_PROPS */ ;
        var oldProps = n1.props || (0, $j3cSI.EMPTY_OBJ);
        var newProps = n2.props || (0, $j3cSI.EMPTY_OBJ);
        var vnodeHook;
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        var areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) // full diff
        patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* FULL_PROPS */ ) // element props contain dynamic keys, full diff needed
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* CLASS */ ) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* STYLE */ ) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PROPS */ ) {
                    // if the flag is present then dynamicProps must be non-null
                    var propsToUpdate = n2.dynamicProps;
                    for(var i = 0; i < propsToUpdate.length; i++){
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* TEXT */ ) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) // unoptimized, full diff
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $6d932106fee366bf$var$queuePostRenderEffect(function() {
            vnodeHook && $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $6d932106fee366bf$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    // The fast path for blocks.
    var patchBlockChildren = function(oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) {
        for(var i = 0; i < newChildren.length; i++){
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            var container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $6d932106fee366bf$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$6d932106fee366bf$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70 /* TELEPORT */ ) ? hostParentNode(oldVNode.el) : // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    var patchProps = function(el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) {
        if (oldProps !== newProps) {
            for(var key in newProps){
                // empty string is not valid prop
                if ((0, $j3cSI.isReservedProp)(key)) continue;
                var next = newProps[key];
                var prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if (oldProps !== (0, $j3cSI.EMPTY_OBJ)) {
                for(var key1 in oldProps)if (!(0, $j3cSI.isReservedProp)(key1) && !(key1 in newProps)) hostPatchProp(el, key1, oldProps[key1], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    var processFragment = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */  && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            // a stable fragment (template root or <template v-for>) doesn't need to
            // patch children order, but it may contain dynamicChildren.
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $6d932106fee366bf$var$traverseStaticChildren(n1, n2, true);
        } else // keyed / unkeyed, or manual fragments.
        // for keyed & unkeyed, since they are compiler generated from v-for,
        // each child is guaranteed to be a block so the fragment will never
        // have dynamicChildren.
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    var processComponent = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    var mountComponent = function(initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) {
        var instance = initialVNode.component = $6d932106fee366bf$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        // inject renderer internals for keepAlive
        if ($6d932106fee366bf$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $6d932106fee366bf$var$setupComponent(instance);
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                var placeholder = instance.subTree = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    var updateComponent = function(n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if ($6d932106fee366bf$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                $6d932106fee366bf$var$invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        } else {
            // no update needed. just copy over properties
            n2.component = n1.component;
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var setupRenderEffect = function(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) {
        var componentUpdateFn = function() {
            if (!instance.isMounted) {
                var vnodeHook;
                var el = initialVNode.el, props = initialVNode.props;
                var bm = instance.bm, m = instance.m, parent = instance.parent;
                var isAsyncWrapperVNode = $6d932106fee366bf$var$isAsyncWrapper(initialVNode);
                effect.allowRecurse = false;
                // beforeMount hook
                if (bm) (0, $j3cSI.invokeArrayFns)(bm);
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                effect.allowRecurse = true;
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    var hydrateSubTree = function() {
                        instance.subTree = $6d932106fee366bf$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    function() {
                        return !instance.isUnmounted && hydrateSubTree();
                    });
                    else hydrateSubTree();
                } else {
                    var subTree = instance.subTree = $6d932106fee366bf$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) $6d932106fee366bf$var$queuePostRenderEffect(m, parentSuspense);
                // onVnodeMounted
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    var scopedInitialVNode = initialVNode;
                    $6d932106fee366bf$var$queuePostRenderEffect(function() {
                        return $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
                    }, parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) instance.a && $6d932106fee366bf$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentAdded(instance);
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            } else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                var next = instance.next, bu = instance.bu, u = instance.u, parent1 = instance.parent, vnode = instance.vnode;
                var originNext = next;
                var vnodeHook1;
                // Disallow component effect recursion during pre-lifecycle hooks.
                effect.allowRecurse = false;
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                // beforeUpdate hook
                if (bu) (0, $j3cSI.invokeArrayFns)(bu);
                // onVnodeBeforeUpdate
                if (vnodeHook1 = next.props && next.props.onVnodeBeforeUpdate) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                effect.allowRecurse = true;
                var nextTree = $6d932106fee366bf$var$renderComponentRoot(instance);
                var prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) // self-triggered update. In case of HOC, update parent component
                // vnode el. HOC is indicated by parent instance's subTree pointing
                // to child component's vnode
                $6d932106fee366bf$var$updateHOCHostEl(instance, nextTree.el);
                // updated hook
                if (u) $6d932106fee366bf$var$queuePostRenderEffect(u, parentSuspense);
                // onVnodeUpdated
                if (vnodeHook1 = next.props && next.props.onVnodeUpdated) $6d932106fee366bf$var$queuePostRenderEffect(function() {
                    return $6d932106fee366bf$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                }, parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentUpdated(instance);
            }
        };
        // create reactive effect for rendering
        var effect = new (0, $Dz4HH.ReactiveEffect)(componentUpdateFn, function() {
            return $6d932106fee366bf$var$queueJob(instance.update);
        }, instance.scope // track it in component's effect scope
        );
        var update = instance.update = effect.run.bind(effect);
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        effect.allowRecurse = update.allowRecurse = true;
        var e, e1;
        update();
    };
    var updateComponentPreRender = function(instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $6d932106fee366bf$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $6d932106fee366bf$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $Dz4HH.pauseTracking)();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        $6d932106fee366bf$var$flushPreFlushCbs(undefined, instance.update);
        (0, $Dz4HH.resetTracking)();
    };
    var patchChildren = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds) {
        var optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* KEYED_FRAGMENT */ ) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256 /* UNKEYED_FRAGMENT */ ) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
            // text children fast path
            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            // prev children was array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) // two arrays, cannot assume anything, do full diff
            patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else // no new children, just unmount old
            unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            // prev children was text OR null
            // new children is array OR null
            if (prevShapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(container, "");
            // mount new if array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    var patchUnkeyedChildren = function(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        c1 = c1 || (0, $j3cSI.EMPTY_ARR);
        c2 = c2 || (0, $j3cSI.EMPTY_ARR);
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for(i = 0; i < commonLength; i++){
            var nextChild = c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) // remove old
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else // mount new
        mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    // can be all-keyed or mixed
    var patchKeyedChildren = function(c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1; // prev ending index
        var e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while(i <= e1 && i <= e2){
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]);
            if ($6d932106fee366bf$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while(i <= e1 && i <= e2){
            var n11 = c1[e1];
            var n21 = c2[e2] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[e2]) : $6d932106fee366bf$var$normalizeVNode(c2[e2]);
            if ($6d932106fee366bf$var$isSameVNodeType(n11, n21)) patch(n11, n21, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            var s1 = i; // prev starting index
            var s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            var keyToNewIndexMap = new Map();
            for(i = s2; i <= e2; i++){
                var nextChild = c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            var j;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            // used to track whether any node has moved
            var maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            var newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $6d932106fee366bf$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === undefined) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            var increasingNewIndexSequence = moved ? $6d932106fee366bf$var$getSequence(newIndexToOldIndexMap) : (0, $j3cSI.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for(i = toBePatched - 1; i >= 0; i--){
                var nextIndex = s2 + i;
                var nextChild1 = c2[nextIndex];
                var anchor1 = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) // mount new
                patch(null, nextChild1, container, anchor1, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild1, container, anchor1, 2 /* REORDER */ );
                    else j--;
                }
            }
        }
    };
    var move = function(vnode, container, anchor, moveType) {
        var parentSuspense = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if (shapeFlag & 6 /* COMPONENT */ ) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* SUSPENSE */ ) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $6d932106fee366bf$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(var i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $6d932106fee366bf$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        var needTransition = moveType !== 2 /* REORDER */  && shapeFlag & 1 /* ELEMENT */  && transition;
        if (needTransition) {
            if (moveType === 0 /* ENTER */ ) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $6d932106fee366bf$var$queuePostRenderEffect(function() {
                    return transition.enter(el);
                }, parentSuspense);
            } else {
                var leave = transition.leave, delayLeave = transition.delayLeave, afterLeave = transition.afterLeave;
                var remove = function() {
                    return hostInsert(el, container, anchor);
                };
                var performLeave = function() {
                    leave(el, function() {
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    var unmount = function(vnode, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs;
        // unset ref
        if (ref != null) $6d932106fee366bf$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 /* ELEMENT */  && dirs;
        var shouldInvokeVnodeHook = !$6d932106fee366bf$var$isAsyncWrapper(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6 /* COMPONENT */ ) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128 /* SUSPENSE */ ) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64 /* TELEPORT */ ) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $6d932106fee366bf$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */ )) // fast path for block nodes: only need to unmount dynamic children.
            unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $6d932106fee366bf$export$ffb0004e005737fa && patchFlag & 384 /* UNKEYED_FRAGMENT */  || !optimized && shapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $6d932106fee366bf$var$queuePostRenderEffect(function() {
            vnodeHook && $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    var remove = function(vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === $6d932106fee366bf$export$ffb0004e005737fa) {
            removeFragment(el, anchor);
            return;
        }
        if (type === $6d932106fee366bf$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        var performRemove = function() {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 /* ELEMENT */  && transition && !transition.persisted) {
            var leave = transition.leave, delayLeave = transition.delayLeave;
            var performLeave = function() {
                return leave(el, performRemove);
            };
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    var removeFragment = function(cur, end) {
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        var next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function(instance, parentSuspense, doRemove) {
        var bum = instance.bum, scope = instance.scope, update = instance.update, subTree = instance.subTree, um = instance.um;
        // beforeUnmount hook
        if (bum) (0, $j3cSI.invokeArrayFns)(bum);
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) $6d932106fee366bf$var$queuePostRenderEffect(um, parentSuspense);
        $6d932106fee366bf$var$queuePostRenderEffect(function() {
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentRemoved(instance);
    };
    var unmountChildren = function(children, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, start = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        for(var i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    var getNextHostNode = function(vnode) {
        if (vnode.shapeFlag & 6 /* COMPONENT */ ) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128 /* SUSPENSE */ ) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    var render = function(vnode, container, isSVG) {
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $6d932106fee366bf$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    var ref;
    if (createHydrationFns) ref = (0, $fGQt0._)(createHydrationFns(internals), 2), hydrate = ref[0], hydrateNode = ref[1], ref;
    return {
        render: render,
        hydrate: hydrate,
        createApp: $6d932106fee366bf$var$createAppAPI(render, hydrate)
    };
}
function $6d932106fee366bf$var$setRef(rawRef, oldRawRef, parentSuspense, vnode) {
    var isUnmount = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if ((0, $j3cSI.isArray)(rawRef)) {
        rawRef.forEach(function(r, i) {
            return $6d932106fee366bf$var$setRef(r, oldRawRef && ((0, $j3cSI.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount);
        });
        return;
    }
    if ($6d932106fee366bf$var$isAsyncWrapper(vnode) && !isUnmount) // when mounting async components, nothing needs to be done,
    // because the template ref is forwarded to inner component
    return;
    var refValue = vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */  ? $6d932106fee366bf$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    var value = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === (0, $j3cSI.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0, $j3cSI.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $j3cSI.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $Dz4HH.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $j3cSI.isString)(ref)) {
        var doSet = function() {
            refs[ref] = value;
            if ((0, $j3cSI.hasOwn)(setupState, ref)) setupState[ref] = value;
        };
        // #1789: for non-null values, set them after render
        // null values means this is unmount and it should not overwrite another
        // ref with the same key
        if (value) {
            doSet.id = -1;
            $6d932106fee366bf$var$queuePostRenderEffect(doSet, parentSuspense);
        } else doSet();
    } else if ((0, $Dz4HH.isRef)(ref)) {
        var doSet1 = function() {
            ref.value = value;
        };
        if (value) {
            doSet1.id = -1;
            $6d932106fee366bf$var$queuePostRenderEffect(doSet1, parentSuspense);
        } else doSet1();
    } else if ((0, $j3cSI.isFunction)(ref)) $6d932106fee366bf$export$b22fcaf88446e9bf(ref, owner, 12 /* FUNCTION_REF */ , [
        value,
        refs
    ]);
}
function $6d932106fee366bf$var$invokeVNodeHook(hook, instance, vnode) {
    var prevVNode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    $6d932106fee366bf$export$dae85862a8d94378(hook, instance, 7 /* VNODE_HOOK */ , [
        vnode,
        prevVNode
    ]);
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always moved so that need inherit el form previous nodes
 * to ensure correct moved position.
 */ function $6d932106fee366bf$var$traverseStaticChildren(n1, n2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ch1 = n1.children;
    var ch2 = n2.children;
    if ((0, $j3cSI.isArray)(ch1) && (0, $j3cSI.isArray)(ch2)) for(var i = 0; i < ch1.length; i++){
        // this is only called in the optimized path so array children are
        // guaranteed to be vnodes
        var c1 = ch1[i];
        var c2 = ch2[i];
        if (c2.shapeFlag & 1 /* ELEMENT */  && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* HYDRATE_EVENTS */ ) {
                c2 = ch2[i] = $6d932106fee366bf$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $6d932106fee366bf$var$traverseStaticChildren(c1, c2);
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function $6d932106fee366bf$var$getSequence(arr) {
    var p = arr.slice();
    var result = [
        0
    ];
    var i, j, u, v1, c;
    var len = arr.length;
    for(i = 0; i < len; i++){
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
var $6d932106fee366bf$var$isTeleport = function(type) {
    return type.__isTeleport;
};
var $6d932106fee366bf$var$isTeleportDisabled = function(props) {
    return props && (props.disabled || props.disabled === "");
};
var $6d932106fee366bf$var$isTargetSVG = function(target) {
    return typeof SVGElement !== "undefined" && target instanceof SVGElement;
};
var $6d932106fee366bf$var$resolveTarget = function(props, select) {
    var targetSelector = props && props.to;
    if ((0, $j3cSI.isString)(targetSelector)) {
        if (!select) return null;
        else {
            var target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
var $6d932106fee366bf$var$TeleportImpl = {
    __isTeleport: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _internals_o = internals.o, insert = _internals_o.insert, querySelector = _internals_o.querySelector, createText = _internals_o.createText, createComment = _internals_o.createComment;
        var disabled = $6d932106fee366bf$var$isTeleportDisabled(n2.props);
        var shapeFlag = n2.shapeFlag, children = n2.children, dynamicChildren = n2.dynamicChildren;
        if (n1 == null) {
            // insert anchors in the main view
            var placeholder = n2.el = createText("");
            var mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            var target = n2.target = $6d932106fee366bf$var$resolveTarget(n2.props, querySelector);
            var targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || $6d932106fee366bf$var$isTargetSVG(target);
            }
            var mount = function(container, anchor) {
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            // update content
            n2.el = n1.el;
            var mainAnchor1 = n2.anchor = n1.anchor;
            var target1 = n2.target = n1.target;
            var targetAnchor1 = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = $6d932106fee366bf$var$isTeleportDisabled(n1.props);
            var currentContainer = wasDisabled ? container : target1;
            var currentAnchor = wasDisabled ? mainAnchor1 : targetAnchor1;
            isSVG = isSVG || $6d932106fee366bf$var$isTargetSVG(target1);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                $6d932106fee366bf$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) // enabled -> disabled
                // move into main container
                $6d932106fee366bf$var$moveTeleport(n2, container, mainAnchor1, internals, 1 /* TOGGLE */ );
            } else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    var nextTarget = n2.target = $6d932106fee366bf$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $6d932106fee366bf$var$moveTeleport(n2, nextTarget, null, internals, 0 /* TARGET_CHANGE */ );
                } else if (wasDisabled) // disabled -> enabled
                // move into teleport target
                $6d932106fee366bf$var$moveTeleport(n2, target1, targetAnchor1, internals, 1 /* TOGGLE */ );
            }
        }
    },
    remove: function(vnode, parentComponent, parentSuspense, optimized, param, doRemove) {
        var unmount = param.um, _param_o = param.o, hostRemove = _param_o.remove;
        var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
        if (target) hostRemove(targetAnchor);
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !$6d932106fee366bf$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(var i = 0; i < children.length; i++){
                var child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $6d932106fee366bf$var$moveTeleport,
    hydrate: $6d932106fee366bf$var$hydrateTeleport
};
function $6d932106fee366bf$var$moveTeleport(vnode, container, parentAnchor, param) {
    var insert = param.o.insert, move = param.m, moveType = arguments.length > 4 && arguments[4] !== void 0 /* REORDER */  ? arguments[4] : 2;
    // move target anchor if this is a target change.
    if (moveType === 0 /* TARGET_CHANGE */ ) insert(vnode.targetAnchor, container, parentAnchor);
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2 /* REORDER */ ;
    // move main view anchor if this is a re-order.
    if (isReorder) insert(el, container, parentAnchor);
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || $6d932106fee366bf$var$isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(var i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2 /* REORDER */ );
    }
    // move main view anchor if this is a re-order.
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $6d932106fee366bf$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, param, hydrateChildren) {
    var _param_o = param.o, nextSibling = _param_o.nextSibling, parentNode = _param_o.parentNode, querySelector = _param_o.querySelector;
    var target = vnode.target = $6d932106fee366bf$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            if ($6d932106fee366bf$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                vnode.targetAnchor = hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
var $6d932106fee366bf$export$76d55a0304a371f4 = $6d932106fee366bf$var$TeleportImpl;
var $6d932106fee366bf$var$COMPONENTS = "components";
var $6d932106fee366bf$var$DIRECTIVES = "directives";
/**
 * @private
 */ function $6d932106fee366bf$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $6d932106fee366bf$var$resolveAsset($6d932106fee366bf$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
var $6d932106fee366bf$var$NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */ function $6d932106fee366bf$export$b44c564a05ca975(component) {
    if ((0, $j3cSI.isString)(component)) return $6d932106fee366bf$var$resolveAsset($6d932106fee366bf$var$COMPONENTS, component, false) || component;
    else // invalid types will fallthrough to createVNode and raise warning
    return component || $6d932106fee366bf$var$NULL_DYNAMIC_COMPONENT;
}
/**
 * @private
 */ function $6d932106fee366bf$export$a1989e995cd481be(name) {
    return $6d932106fee366bf$var$resolveAsset($6d932106fee366bf$var$DIRECTIVES, name);
}
// implementation
function $6d932106fee366bf$var$resolveAsset(type, name) {
    var warnMissing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, maybeSelfReference = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var instance = $6d932106fee366bf$var$currentRenderingInstance || $6d932106fee366bf$var$currentInstance;
    if (instance) {
        var Component = instance.type;
        // explicit self name has highest priority
        if (type === $6d932106fee366bf$var$COMPONENTS) {
            var selfName = $6d932106fee366bf$var$getComponentName(Component);
            if (selfName && (selfName === name || selfName === (0, $j3cSI.camelize)(name) || selfName === (0, $j3cSI.capitalize)((0, $j3cSI.camelize)(name)))) return Component;
        }
        var res = // local registration
        // check instance[type] first which is resolved for options API
        $6d932106fee366bf$var$resolve(instance[type] || Component[type], name) || // global registration
        $6d932106fee366bf$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) // fallback to implicit self-reference
        return Component;
        return res;
    }
}
function $6d932106fee366bf$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $j3cSI.camelize)(name)] || registry[(0, $j3cSI.capitalize)((0, $j3cSI.camelize)(name))]);
}
var $6d932106fee366bf$export$ffb0004e005737fa = Symbol(undefined);
var $6d932106fee366bf$export$5f1af8db9871e1d6 = Symbol(undefined);
var $6d932106fee366bf$export$4d299b491347818a = Symbol(undefined);
var $6d932106fee366bf$export$c1b9a1d3af45b7b6 = Symbol(undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
var $6d932106fee366bf$var$blockStack = [];
var $6d932106fee366bf$var$currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */ function $6d932106fee366bf$export$e7eaa45e502fe5cc() {
    var disableTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $6d932106fee366bf$var$blockStack.push($6d932106fee366bf$var$currentBlock = disableTracking ? null : []);
}
function $6d932106fee366bf$var$closeBlock() {
    $6d932106fee366bf$var$blockStack.pop();
    $6d932106fee366bf$var$currentBlock = $6d932106fee366bf$var$blockStack[$6d932106fee366bf$var$blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
var $6d932106fee366bf$var$isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */ function $6d932106fee366bf$export$c20bee82f26f1e27(value) {
    $6d932106fee366bf$var$isBlockTreeEnabled += value;
}
function $6d932106fee366bf$var$setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren = $6d932106fee366bf$var$isBlockTreeEnabled > 0 ? $6d932106fee366bf$var$currentBlock || (0, $j3cSI.EMPTY_ARR) : null;
    // close block
    $6d932106fee366bf$var$closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && $6d932106fee366bf$var$currentBlock) $6d932106fee366bf$var$currentBlock.push(vnode);
    return vnode;
}
/**
 * @private
 */ function $6d932106fee366bf$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $6d932106fee366bf$var$setupBlock($6d932106fee366bf$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */ function $6d932106fee366bf$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $6d932106fee366bf$var$setupBlock($6d932106fee366bf$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $6d932106fee366bf$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $6d932106fee366bf$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
var $6d932106fee366bf$var$vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */ function $6d932106fee366bf$export$83beccd3afeeb809(transformer) {
    $6d932106fee366bf$var$vnodeArgsTransformer = transformer;
}
var $6d932106fee366bf$var$createVNodeWithArgsTransform = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $6d932106fee366bf$var$_createVNode.apply(void 0, (0, $aYXpI._)($6d932106fee366bf$var$vnodeArgsTransformer ? $6d932106fee366bf$var$vnodeArgsTransformer(args, $6d932106fee366bf$var$currentRenderingInstance) : args));
};
var $6d932106fee366bf$var$InternalObjectKey = "__vInternal";
var $6d932106fee366bf$var$normalizeKey = function(param) {
    var key = param.key;
    return key != null ? key : null;
};
var $6d932106fee366bf$var$normalizeRef = function(param) {
    var ref = param.ref;
    return ref != null ? (0, $j3cSI.isString)(ref) || (0, $Dz4HH.isRef)(ref) || (0, $j3cSI.isFunction)(ref) ? {
        i: $6d932106fee366bf$var$currentRenderingInstance,
        r: ref
    } : ref : null;
};
function $6d932106fee366bf$export$42098e0eaa15c48e(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, shapeFlag = arguments.length > 5 && arguments[5] !== void 0 /* ELEMENT */  ? arguments[5] : type === $6d932106fee366bf$export$ffb0004e005737fa ? 0 : 1, isBlockNode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, needFullChildrenNormalization = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $6d932106fee366bf$var$normalizeKey(props),
        ref: props && $6d932106fee366bf$var$normalizeRef(props),
        scopeId: $6d932106fee366bf$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        $6d932106fee366bf$var$normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* SUSPENSE */ ) type.normalize(vnode);
    } else if (children) // compiled element vnode - if children is passed, only possible types are
    // string or Array.
    vnode.shapeFlag |= (0, $j3cSI.isString)(children) ? 8 /* TEXT_CHILDREN */  : 16 /* ARRAY_CHILDREN */ ;
    // track vnode for block tree
    if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $6d932106fee366bf$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6 /* COMPONENT */ ) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32 /* HYDRATE_EVENTS */ ) $6d932106fee366bf$var$currentBlock.push(vnode);
    return vnode;
}
var $6d932106fee366bf$export$bf5c4cf060303d58 = $6d932106fee366bf$var$_createVNode;
function $6d932106fee366bf$var$_createVNode(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isBlockNode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (!type || type === $6d932106fee366bf$var$NULL_DYNAMIC_COMPONENT) type = $6d932106fee366bf$export$4d299b491347818a;
    if ($6d932106fee366bf$export$3868d13f8734ae81(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        var cloned = $6d932106fee366bf$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $6d932106fee366bf$var$normalizeChildren(cloned, children);
        return cloned;
    }
    // class component normalization.
    if ($6d932106fee366bf$var$isClassComponent(type)) type = type.__vccOpts;
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = $6d932106fee366bf$export$1f1be0e0e384d7d2(props);
        var klass = props.class, style = props.style;
        if (klass && !(0, $j3cSI.isString)(klass)) props.class = (0, $j3cSI.normalizeClass)(klass);
        if ((0, $j3cSI.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if ((0, $Dz4HH.isProxy)(style) && !(0, $j3cSI.isArray)(style)) style = (0, $j3cSI.extend)({}, style);
            props.style = (0, $j3cSI.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    var shapeFlag = (0, $j3cSI.isString)(type) ? 1 /* ELEMENT */  : $6d932106fee366bf$var$isSuspense(type) ? 128 /* SUSPENSE */  : $6d932106fee366bf$var$isTeleport(type) ? 64 /* TELEPORT */  : (0, $j3cSI.isObject)(type) ? 4 /* STATEFUL_COMPONENT */  : (0, $j3cSI.isFunction)(type) ? 2 /* FUNCTIONAL_COMPONENT */  : 0;
    return $6d932106fee366bf$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $6d932106fee366bf$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $Dz4HH.isProxy)(props) || $6d932106fee366bf$var$InternalObjectKey in props ? (0, $j3cSI.extend)({}, props) : props;
}
function $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode, extraProps) {
    var mergeRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children;
    var mergedProps = extraProps ? $6d932106fee366bf$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $6d932106fee366bf$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $j3cSI.isArray)(ref) ? ref.concat($6d932106fee366bf$var$normalizeRef(extraProps)) : [
            ref,
            $6d932106fee366bf$var$normalizeRef(extraProps)
        ] : $6d932106fee366bf$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: perserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $6d932106fee366bf$export$ffb0004e005737fa ? patchFlag === -1 // hoisted node
         ? 16 /* FULL_PROPS */  : patchFlag | 16 /* FULL_PROPS */  : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */ function $6d932106fee366bf$var$deepCloneVNode(vnode) {
    var cloned = $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $j3cSI.isArray)(vnode.children)) cloned.children = vnode.children.map($6d932106fee366bf$var$deepCloneVNode);
    return cloned;
}
/**
 * @private
 */ function $6d932106fee366bf$export$22f9b5ffd89dac9() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$5f1af8db9871e1d6, null, text, flag);
}
/**
 * @private
 */ function $6d932106fee366bf$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    var vnode = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */ function $6d932106fee366bf$export$49553837c7236d3c() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", // when used as the v-else branch, the comment node must be created as a
    // block to ensure correct updates.
    asBlock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return asBlock ? ($6d932106fee366bf$export$e7eaa45e502fe5cc(), $6d932106fee366bf$export$9f2dfe8048dfb22b($6d932106fee366bf$export$4d299b491347818a, null, text)) : $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a, null, text);
}
function $6d932106fee366bf$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") // empty placeholder
    return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
    else if ((0, $j3cSI.isArray)(child)) // fragment
    return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") // already vnode, this should be the most common since compiled templates
    // always produce all-vnode children arrays
    return $6d932106fee366bf$var$cloneIfMounted(child);
    else // strings and numbers
    return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$5f1af8db9871e1d6, null, String(child));
}
// optimized normalization for template-compiled render fns
function $6d932106fee366bf$var$cloneIfMounted(child) {
    return child.el === null || child.memo ? child : $6d932106fee366bf$export$ee4f9e12c0a92a1a(child);
}
function $6d932106fee366bf$var$normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) children = null;
    else if ((0, $j3cSI.isArray)(children)) type = 16 /* ARRAY_CHILDREN */ ;
    else if (typeof children === "object") {
        if (shapeFlag & 65 /* TELEPORT */ ) {
            // Normalize slot to plain children for plain element and Teleport
            var slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                $6d932106fee366bf$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32 /* SLOTS_CHILDREN */ ;
            var slotFlag = children._;
            if (!slotFlag && !($6d932106fee366bf$var$InternalObjectKey in children)) children._ctx = $6d932106fee366bf$var$currentRenderingInstance;
            else if (slotFlag === 3 /* FORWARDED */  && $6d932106fee366bf$var$currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if ($6d932106fee366bf$var$currentRenderingInstance.slots._ === 1 /* STABLE */ ) children._ = 1 /* STABLE */ ;
                else {
                    children._ = 2 /* DYNAMIC */ ;
                    vnode.patchFlag |= 1024 /* DYNAMIC_SLOTS */ ;
                }
            }
        }
    } else if ((0, $j3cSI.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $6d932106fee366bf$var$currentRenderingInstance
        };
        type = 32 /* SLOTS_CHILDREN */ ;
    } else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type = 16 /* ARRAY_CHILDREN */ ;
            children = [
                $6d932106fee366bf$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8 /* TEXT_CHILDREN */ ;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $6d932106fee366bf$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ret = {};
    for(var i = 0; i < args.length; i++){
        var toMerge = args[i];
        for(var key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $j3cSI.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $j3cSI.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $j3cSI.isOn)(key)) {
                var existing = ret[key];
                var incoming = toMerge[key];
                if (existing !== incoming) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
/**
 * Actual implementation
 */ function $6d932106fee366bf$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    if ((0, $j3cSI.isArray)(source) || (0, $j3cSI.isString)(source)) {
        ret = new Array(source.length);
        for(var i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(var i1 = 0; i1 < source; i1++)ret[i1] = renderItem(i1 + 1, i1, undefined, cached && cached[i1]);
    } else if ((0, $j3cSI.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, function(item, i) {
            return renderItem(item, i, undefined, cached && cached[i]);
        });
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for(var i2 = 0, l1 = keys.length; i2 < l1; i2++){
                var key = keys[i2];
                ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */ function $6d932106fee366bf$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(var i = 0; i < dynamicSlots.length; i++){
        var slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0, $j3cSI.isArray)(slot)) for(var j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) // conditional single slot generated by <template v-if="..." #foo>
        slots[slot.name] = slot.fn;
    }
    return slots;
}
/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */ function $6d932106fee366bf$export$4abee4c34694ada1(slots, name) {
    var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, // this is not a user-facing function, so the fallback is always generated by
    // the compiler and guaranteed to be a function returning an array
    fallback = arguments.length > 3 ? arguments[3] : void 0, noSlotted = arguments.length > 4 ? arguments[4] : void 0;
    if ($6d932106fee366bf$var$currentRenderingInstance.isCE) return $6d932106fee366bf$export$bf5c4cf060303d58("slot", name === "default" ? null : {
        name: name
    }, fallback && fallback());
    var slot = slots[name];
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) slot._d = false;
    $6d932106fee366bf$export$e7eaa45e502fe5cc();
    var validSlotContent = slot && $6d932106fee366bf$var$ensureValidVNode(slot(props));
    var rendered = $6d932106fee366bf$export$9f2dfe8048dfb22b($6d932106fee366bf$export$ffb0004e005737fa, {
        key: props.key || "_".concat(name)
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* STABLE */  ? 64 /* STABLE_FRAGMENT */  : -2 /* BAIL */ );
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $6d932106fee366bf$var$ensureValidVNode(vnodes) {
    return vnodes.some(function(child) {
        if (!$6d932106fee366bf$export$3868d13f8734ae81(child)) return true;
        if (child.type === $6d932106fee366bf$export$4d299b491347818a) return false;
        if (child.type === $6d932106fee366bf$export$ffb0004e005737fa && !$6d932106fee366bf$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */ function $6d932106fee366bf$export$2fb94ff667a6a1a(obj) {
    var ret = {};
    for(var key in obj)ret[(0, $j3cSI.toHandlerKey)(key)] = obj[key];
    return ret;
}
/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */ var $6d932106fee366bf$var$getPublicInstance = function(i) {
    if (!i) return null;
    if ($6d932106fee366bf$var$isStatefulComponent(i)) return $6d932106fee366bf$var$getExposeProxy(i) || i.proxy;
    return $6d932106fee366bf$var$getPublicInstance(i.parent);
};
var $6d932106fee366bf$var$publicPropertiesMap = (0, $j3cSI.extend)(Object.create(null), {
    $: function(i) {
        return i;
    },
    $el: function(i) {
        return i.vnode.el;
    },
    $data: function(i) {
        return i.data;
    },
    $props: function(i) {
        return 0, i.props;
    },
    $attrs: function(i) {
        return 0, i.attrs;
    },
    $slots: function(i) {
        return 0, i.slots;
    },
    $refs: function(i) {
        return 0, i.refs;
    },
    $parent: function(i) {
        return $6d932106fee366bf$var$getPublicInstance(i.parent);
    },
    $root: function(i) {
        return $6d932106fee366bf$var$getPublicInstance(i.root);
    },
    $emit: function(i) {
        return i.emit;
    },
    $options: function(i) {
        return __VUE_OPTIONS_API__ ? $6d932106fee366bf$var$resolveMergedOptions(i) : i.type;
    },
    $forceUpdate: function(i) {
        return function() {
            return $6d932106fee366bf$var$queueJob(i.update);
        };
    },
    $nextTick: function(i) {
        return $6d932106fee366bf$export$bdd553fddd433dcb.bind(i.proxy);
    },
    $watch: function(i) {
        return __VUE_OPTIONS_API__ ? $6d932106fee366bf$var$instanceWatch.bind(i) : (0, $j3cSI.NOOP);
    }
});
var $6d932106fee366bf$var$PublicInstanceProxyHandlers = {
    get: function(param, key) {
        var instance = param._;
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        var normalizedProps;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== undefined) switch(n){
                case 0 /* SETUP */ :
                    return setupState[key];
                case 1 /* DATA */ :
                    return data[key];
                case 3 /* CONTEXT */ :
                    return ctx[key];
                case 2 /* PROPS */ :
                    return props[key];
            }
            else if (setupState !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(setupState, key)) {
                accessCache[key] = 0 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(data, key)) {
                accessCache[key] = 1 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $j3cSI.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 2 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(ctx, key)) {
                accessCache[key] = 3 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $6d932106fee366bf$var$shouldCacheAccess) accessCache[key] = 4 /* OTHER */ ;
        }
        var publicGetter = $6d932106fee366bf$var$publicPropertiesMap[key];
        var cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === "$attrs") (0, $Dz4HH.track)(instance, "get" /* GET */ , key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 3 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $j3cSI.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set: function(param, key, value) {
        var instance = param._;
        var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
        if (setupState !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(setupState, key)) setupState[key] = value;
        else if (data !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(data, key)) data[key] = value;
        else if ((0, $j3cSI.hasOwn)(instance.props, key)) return false;
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has: function(param, key) {
        var _param__ = param._, data = _param__.data, setupState = _param__.setupState, accessCache = _param__.accessCache, ctx = _param__.ctx, appContext = _param__.appContext, propsOptions = _param__.propsOptions;
        var normalizedProps;
        return accessCache[key] !== undefined || data !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(data, key) || setupState !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $j3cSI.hasOwn)(normalizedProps, key) || (0, $j3cSI.hasOwn)(ctx, key) || (0, $j3cSI.hasOwn)($6d932106fee366bf$var$publicPropertiesMap, key) || (0, $j3cSI.hasOwn)(appContext.config.globalProperties, key);
    }
};
var $6d932106fee366bf$var$target;
var $6d932106fee366bf$var$RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0, $j3cSI.extend)({}, $6d932106fee366bf$var$PublicInstanceProxyHandlers, {
    get: function(target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) return;
        return $6d932106fee366bf$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function(_, key) {
        var has = key[0] !== "_" && !(0, $j3cSI.isGloballyWhitelisted)(key);
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function $6d932106fee366bf$var$createDevRenderContext(instance) {
    var target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function() {
            return instance;
        }
    });
    // expose public properties
    Object.keys($6d932106fee366bf$var$publicPropertiesMap).forEach(function(key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function() {
                return $6d932106fee366bf$var$publicPropertiesMap[key](instance);
            },
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $j3cSI.NOOP)
        });
    });
    return target;
}
// dev only
function $6d932106fee366bf$var$exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _instance_propsOptions = (0, $fGQt0._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0];
    if (propsOptions) Object.keys(propsOptions).forEach(function(key) {
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return instance.props[key];
            },
            set: (0, $j3cSI.NOOP)
        });
    });
}
// dev only
function $6d932106fee366bf$var$exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys((0, $Dz4HH.toRaw)(setupState)).forEach(function(key) {
        if (!setupState.__isScriptSetup) {
            if (key[0] === "$" || key[0] === "_") {
                $6d932106fee366bf$export$c106dd0671a0fc2d("setup() return property ".concat(JSON.stringify(key), ' should not start with "$" or "_" ') + "which are reserved prefixes for Vue internals.");
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return setupState[key];
                },
                set: (0, $j3cSI.NOOP)
            });
        }
    });
}
var $6d932106fee366bf$var$emptyAppContext = $6d932106fee366bf$var$createAppContext();
var $6d932106fee366bf$var$uid$1 = 0;
function $6d932106fee366bf$var$createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    var appContext = (parent ? parent.appContext : vnode.appContext) || $6d932106fee366bf$var$emptyAppContext;
    var instance = {
        uid: $6d932106fee366bf$var$uid$1++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        update: null,
        scope: new (0, $Dz4HH.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resovled assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $6d932106fee366bf$var$normalizePropsOptions(type, appContext),
        emitsOptions: $6d932106fee366bf$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: (0, $j3cSI.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $j3cSI.EMPTY_OBJ),
        data: (0, $j3cSI.EMPTY_OBJ),
        props: (0, $j3cSI.EMPTY_OBJ),
        attrs: (0, $j3cSI.EMPTY_OBJ),
        slots: (0, $j3cSI.EMPTY_OBJ),
        refs: (0, $j3cSI.EMPTY_OBJ),
        setupState: (0, $j3cSI.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $6d932106fee366bf$var$emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
var $6d932106fee366bf$var$currentInstance = null;
var $6d932106fee366bf$export$f13e630aa3915748 = function() {
    return $6d932106fee366bf$var$currentInstance || $6d932106fee366bf$var$currentRenderingInstance;
};
var $6d932106fee366bf$var$setCurrentInstance = function(instance) {
    $6d932106fee366bf$var$currentInstance = instance;
    instance.scope.on();
};
var $6d932106fee366bf$var$unsetCurrentInstance = function() {
    $6d932106fee366bf$var$currentInstance && $6d932106fee366bf$var$currentInstance.scope.off();
    $6d932106fee366bf$var$currentInstance = null;
};
var $6d932106fee366bf$var$isBuiltInTag = /*#__PURE__*/ (0, $j3cSI.makeMap)("slot,component");
function $6d932106fee366bf$var$validateComponentName(name, config) {
    var appIsNativeTag = config.isNativeTag || (0, $j3cSI.NO);
    if ($6d932106fee366bf$var$isBuiltInTag(name) || appIsNativeTag(name)) $6d932106fee366bf$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $6d932106fee366bf$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ;
}
var $6d932106fee366bf$var$isInSSRComponentSetup = false;
function $6d932106fee366bf$var$setupComponent(instance) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $6d932106fee366bf$var$isInSSRComponentSetup = isSSR;
    var _instance_vnode = instance.vnode, props = _instance_vnode.props, children = _instance_vnode.children;
    var isStateful = $6d932106fee366bf$var$isStatefulComponent(instance);
    $6d932106fee366bf$var$initProps(instance, props, isStateful, isSSR);
    $6d932106fee366bf$var$initSlots(instance, children);
    var setupResult = isStateful ? $6d932106fee366bf$var$setupStatefulComponent(instance, isSSR) : undefined;
    $6d932106fee366bf$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $6d932106fee366bf$var$setupStatefulComponent(instance, isSSR) {
    var Component = instance.type;
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = (0, $Dz4HH.markRaw)(new Proxy(instance.ctx, $6d932106fee366bf$var$PublicInstanceProxyHandlers));
    // 2. call setup()
    var setup = Component.setup;
    if (setup) {
        var setupContext = instance.setupContext = setup.length > 1 ? $6d932106fee366bf$var$createSetupContext(instance) : null;
        $6d932106fee366bf$var$setCurrentInstance(instance);
        (0, $Dz4HH.pauseTracking)();
        var setupResult = $6d932106fee366bf$export$b22fcaf88446e9bf(setup, instance, 0 /* SETUP_FUNCTION */ , [
            (0, instance.props),
            setupContext
        ]);
        (0, $Dz4HH.resetTracking)();
        $6d932106fee366bf$var$unsetCurrentInstance();
        if ((0, $j3cSI.isPromise)(setupResult)) {
            setupResult.then($6d932106fee366bf$var$unsetCurrentInstance, $6d932106fee366bf$var$unsetCurrentInstance);
            if (isSSR) // return the promise so server-renderer can wait on it
            return setupResult.then(function(resolvedResult) {
                $6d932106fee366bf$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch(function(e) {
                $6d932106fee366bf$export$d3da1ecaf1206c58(e, instance, 0 /* SETUP_FUNCTION */ );
            });
            else // async setup returned Promise.
            // bail here and wait for re-entry.
            instance.asyncDep = setupResult;
        } else $6d932106fee366bf$var$handleSetupResult(instance, setupResult, isSSR);
    } else $6d932106fee366bf$var$finishComponentSetup(instance, isSSR);
}
function $6d932106fee366bf$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $j3cSI.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) // when the function's name is `ssrRender` (compiled by SFC inline mode),
        // set it as ssrRender instead.
        instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $j3cSI.isObject)(setupResult)) {
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $Dz4HH.proxyRefs)(setupResult);
    }
    $6d932106fee366bf$var$finishComponentSetup(instance, isSSR);
}
var $6d932106fee366bf$var$compile;
var $6d932106fee366bf$var$installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */ function $6d932106fee366bf$export$667bb5a67822b941(_compile) {
    $6d932106fee366bf$var$compile = _compile;
    $6d932106fee366bf$var$installWithProxy = function(i) {
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $6d932106fee366bf$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
// dev only
var $6d932106fee366bf$export$c93a9c496c5211fa = function() {
    return !$6d932106fee366bf$var$compile;
};
function $6d932106fee366bf$var$finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compliation
        // is done by server-renderer
        if (!isSSR && $6d932106fee366bf$var$compile && !Component.render) {
            var template = Component.template;
            if (template) {
                var _instance_appContext_config = instance.appContext.config, isCustomElement = _instance_appContext_config.isCustomElement, compilerOptions = _instance_appContext_config.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = (0, $j3cSI.extend)((0, $j3cSI.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $6d932106fee366bf$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $j3cSI.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if ($6d932106fee366bf$var$installWithProxy) $6d932106fee366bf$var$installWithProxy(instance);
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && true) {
        $6d932106fee366bf$var$setCurrentInstance(instance);
        (0, $Dz4HH.pauseTracking)();
        $6d932106fee366bf$var$applyOptions(instance);
        (0, $Dz4HH.resetTracking)();
        $6d932106fee366bf$var$unsetCurrentInstance();
    }
}
function $6d932106fee366bf$var$createAttrsProxy(instance) {
    return new Proxy(instance.attrs, {
        get: function(target, key) {
            (0, $Dz4HH.track)(instance, "get" /* GET */ , "$attrs");
            return target[key];
        }
    });
}
function $6d932106fee366bf$var$createSetupContext(instance) {
    var expose = function(exposed) {
        instance.exposed = exposed || {};
    };
    var attrs;
    var event, args;
    return {
        get attrs () {
            return attrs || (attrs = $6d932106fee366bf$var$createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $6d932106fee366bf$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $Dz4HH.proxyRefs)((0, $Dz4HH.markRaw)(instance.exposed)), {
        get: function(target, key) {
            if (key in target) return target[key];
            else if (key in $6d932106fee366bf$var$publicPropertiesMap) return $6d932106fee366bf$var$publicPropertiesMap[key](instance);
        }
    }));
}
var $6d932106fee366bf$var$classifyRE = /(?:^|[-_])(\w)/g;
var $6d932106fee366bf$var$classify = function(str) {
    return str.replace($6d932106fee366bf$var$classifyRE, function(c) {
        return c.toUpperCase();
    }).replace(/[-_]/g, "");
};
function $6d932106fee366bf$var$getComponentName(Component) {
    return (0, $j3cSI.isFunction)(Component) ? Component.displayName || Component.name : Component.name;
}
/* istanbul ignore next */ function $6d932106fee366bf$var$formatComponentName(instance, Component) {
    var isRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var name = $6d932106fee366bf$var$getComponentName(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        var inferFromRegistry = function(registry) {
            for(var key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $6d932106fee366bf$var$classify(name) : isRoot ? "App" : "Anonymous";
}
function $6d932106fee366bf$var$isClassComponent(value) {
    return (0, $j3cSI.isFunction)(value) && "__vccOpts" in value;
}
var $6d932106fee366bf$var$stack = [];
function $6d932106fee366bf$var$pushWarningContext(vnode) {
    $6d932106fee366bf$var$stack.push(vnode);
}
function $6d932106fee366bf$var$popWarningContext() {
    $6d932106fee366bf$var$stack.pop();
}
function $6d932106fee366bf$export$c106dd0671a0fc2d(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    (0, $Dz4HH.pauseTracking)();
    var instance = $6d932106fee366bf$var$stack.length ? $6d932106fee366bf$var$stack[$6d932106fee366bf$var$stack.length - 1].component : null;
    var appWarnHandler = instance && instance.appContext.config.warnHandler;
    var trace = $6d932106fee366bf$var$getComponentTrace();
    if (appWarnHandler) $6d932106fee366bf$export$b22fcaf88446e9bf(appWarnHandler, instance, 11 /* APP_WARN_HANDLER */ , [
        msg + args.join(""),
        instance && instance.proxy,
        trace.map(function(param) {
            var vnode = param.vnode;
            return "at <".concat($6d932106fee366bf$var$formatComponentName(instance, vnode.type), ">");
        }).join("\n"),
        trace
    ]);
    else {
        var _warnArgs, _console;
        var warnArgs = [
            "[Vue warn]: ".concat(msg)
        ].concat((0, $aYXpI._)(args));
        /* istanbul ignore if */ if (trace.length && // avoid spamming console during tests
        true) (_warnArgs = warnArgs).push.apply(_warnArgs, [
            "\n"
        ].concat((0, $aYXpI._)($6d932106fee366bf$var$formatTrace(trace))));
        (_console = console).warn.apply(_console, (0, $aYXpI._)(warnArgs));
    }
    (0, $Dz4HH.resetTracking)();
}
function $6d932106fee366bf$var$getComponentTrace() {
    var currentVNode = $6d932106fee366bf$var$stack[$6d932106fee366bf$var$stack.length - 1];
    if (!currentVNode) return [];
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    var normalizedStack = [];
    while(currentVNode){
        var last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        var parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */ function $6d932106fee366bf$var$formatTrace(trace) {
    var logs = [];
    trace.forEach(function(entry, i) {
        var _logs;
        (_logs = logs).push.apply(_logs, (0, $aYXpI._)(i === 0 ? [] : [
            "\n"
        ]).concat((0, $aYXpI._)($6d932106fee366bf$var$formatTraceEntry(entry))));
    });
    return logs;
}
function $6d932106fee366bf$var$formatTraceEntry(param) {
    var vnode = param.vnode, recurseCount = param.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var isRoot = vnode.component ? vnode.component.parent == null : false;
    var open = " at <".concat($6d932106fee366bf$var$formatComponentName(vnode.component, vnode.type, isRoot));
    var close = ">" + postfix;
    return vnode.props ? [
        open
    ].concat((0, $aYXpI._)($6d932106fee366bf$var$formatProps(vnode.props)), [
        close
    ]) : [
        open + close
    ];
}
/* istanbul ignore next */ function $6d932106fee366bf$var$formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function(key) {
        var _res;
        (_res = res).push.apply(_res, (0, $aYXpI._)($6d932106fee366bf$var$formatProp(key, props[key])));
    });
    if (keys.length > 3) res.push(" ...");
    return res;
}
/* istanbul ignore next */ function $6d932106fee366bf$var$formatProp(key, value, raw) {
    if ((0, $j3cSI.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            "".concat(key, "=").concat(value)
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        "".concat(key, "=").concat(value)
    ];
    else if ((0, $Dz4HH.isRef)(value)) {
        value = $6d932106fee366bf$var$formatProp(key, (0, $Dz4HH.toRaw)(value.value), true);
        return raw ? value : [
            "".concat(key, "=Ref<"),
            value,
            ">"
        ];
    } else if ((0, $j3cSI.isFunction)(value)) return [
        "".concat(key, "=fn").concat(value.name ? "<".concat(value.name, ">") : "")
    ];
    else {
        value = (0, $Dz4HH.toRaw)(value);
        return raw ? value : [
            "".concat(key, "="),
            value
        ];
    }
}
var $6d932106fee366bf$var$_obj;
var $6d932106fee366bf$var$ErrorTypeStrings = ($6d932106fee366bf$var$_obj = {}, (0, $ect5N._)($6d932106fee366bf$var$_obj, "sp" /* SERVER_PREFETCH */ , "serverPrefetch hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "bc" /* BEFORE_CREATE */ , "beforeCreate hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "c" /* CREATED */ , "created hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "bm" /* BEFORE_MOUNT */ , "beforeMount hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "m" /* MOUNTED */ , "mounted hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "bu" /* BEFORE_UPDATE */ , "beforeUpdate hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "u" /* UPDATED */ , "updated"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "bum" /* BEFORE_UNMOUNT */ , "beforeUnmount hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "um" /* UNMOUNTED */ , "unmounted hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "a" /* ACTIVATED */ , "activated hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "da" /* DEACTIVATED */ , "deactivated hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "ec" /* ERROR_CAPTURED */ , "errorCaptured hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "rtc" /* RENDER_TRACKED */ , "renderTracked hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, "rtg" /* RENDER_TRIGGERED */ , "renderTriggered hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 0 /* SETUP_FUNCTION */ , "setup function"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 1 /* RENDER_FUNCTION */ , "render function"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 2 /* WATCH_GETTER */ , "watcher getter"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 3 /* WATCH_CALLBACK */ , "watcher callback"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 4 /* WATCH_CLEANUP */ , "watcher cleanup function"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 5 /* NATIVE_EVENT_HANDLER */ , "native event handler"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 6 /* COMPONENT_EVENT_HANDLER */ , "component event handler"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 7 /* VNODE_HOOK */ , "vnode hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 8 /* DIRECTIVE_HOOK */ , "directive hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 9 /* TRANSITION_HOOK */ , "transition hook"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 10 /* APP_ERROR_HANDLER */ , "app errorHandler"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 11 /* APP_WARN_HANDLER */ , "app warnHandler"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 12 /* FUNCTION_REF */ , "ref function"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 13 /* ASYNC_COMPONENT_LOADER */ , "async component loader"), (0, $ect5N._)($6d932106fee366bf$var$_obj, 14 /* SCHEDULER */ , "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/vue-next"), $6d932106fee366bf$var$_obj);
function $6d932106fee366bf$export$b22fcaf88446e9bf(fn, instance, type, args) {
    var res;
    try {
        res = args ? fn.apply(void 0, (0, $aYXpI._)(args)) : fn();
    } catch (err) {
        $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $6d932106fee366bf$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $j3cSI.isFunction)(fn)) {
        var res = $6d932106fee366bf$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $j3cSI.isPromise)(res)) res.catch(function(err) {
            $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    var values = [];
    for(var i = 0; i < fn.length; i++)values.push($6d932106fee366bf$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, type) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var contextVNode = instance ? instance.vnode : null;
    if (instance) {
        var cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        var exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        var errorInfo = type;
        while(cur){
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(var i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        // app-level handling
        var appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $6d932106fee366bf$export$b22fcaf88446e9bf(appErrorHandler, null, 10 /* APP_ERROR_HANDLER */ , [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $6d932106fee366bf$var$logError(err, type, contextVNode, throwInDev);
}
function $6d932106fee366bf$var$logError(err, type, contextVNode) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    // recover in prod to reduce the impact on end-user
    console.error(err);
}
var $6d932106fee366bf$var$isFlushing = false;
var $6d932106fee366bf$var$isFlushPending = false;
var $6d932106fee366bf$var$queue = [];
var $6d932106fee366bf$var$flushIndex = 0;
var $6d932106fee366bf$var$pendingPreFlushCbs = [];
var $6d932106fee366bf$var$activePreFlushCbs = null;
var $6d932106fee366bf$var$preFlushIndex = 0;
var $6d932106fee366bf$var$pendingPostFlushCbs = [];
var $6d932106fee366bf$var$activePostFlushCbs = null;
var $6d932106fee366bf$var$postFlushIndex = 0;
var $6d932106fee366bf$var$resolvedPromise = Promise.resolve();
var $6d932106fee366bf$var$currentFlushPromise = null;
var $6d932106fee366bf$var$currentPreFlushParentJob = null;
var $6d932106fee366bf$var$RECURSION_LIMIT = 100;
function $6d932106fee366bf$export$bdd553fddd433dcb(fn) {
    var p = $6d932106fee366bf$var$currentFlushPromise || $6d932106fee366bf$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function $6d932106fee366bf$var$findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    var start = $6d932106fee366bf$var$flushIndex + 1;
    var end = $6d932106fee366bf$var$queue.length;
    while(start < end){
        var middle = start + end >>> 1;
        var middleJobId = $6d932106fee366bf$var$getId($6d932106fee366bf$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $6d932106fee366bf$var$queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if ((!$6d932106fee366bf$var$queue.length || !$6d932106fee366bf$var$queue.includes(job, $6d932106fee366bf$var$isFlushing && job.allowRecurse ? $6d932106fee366bf$var$flushIndex + 1 : $6d932106fee366bf$var$flushIndex)) && job !== $6d932106fee366bf$var$currentPreFlushParentJob) {
        if (job.id == null) $6d932106fee366bf$var$queue.push(job);
        else $6d932106fee366bf$var$queue.splice($6d932106fee366bf$var$findInsertionIndex(job.id), 0, job);
        $6d932106fee366bf$var$queueFlush();
    }
}
function $6d932106fee366bf$var$queueFlush() {
    if (!$6d932106fee366bf$var$isFlushing && !$6d932106fee366bf$var$isFlushPending) {
        $6d932106fee366bf$var$isFlushPending = true;
        $6d932106fee366bf$var$currentFlushPromise = $6d932106fee366bf$var$resolvedPromise.then($6d932106fee366bf$var$flushJobs);
    }
}
function $6d932106fee366bf$var$invalidateJob(job) {
    var i = $6d932106fee366bf$var$queue.indexOf(job);
    if (i > $6d932106fee366bf$var$flushIndex) $6d932106fee366bf$var$queue.splice(i, 1);
}
function $6d932106fee366bf$var$queueCb(cb, activeQueue, pendingQueue, index) {
    var // if cb is an array, it is a component lifecycle hook which can only be
    // triggered by a job, which is already deduped in the main queue, so
    // we can skip duplicate check here to improve perf
    _pendingQueue;
    if (!(0, $j3cSI.isArray)(cb)) {
        if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) pendingQueue.push(cb);
    } else (_pendingQueue = pendingQueue).push.apply(_pendingQueue, (0, $aYXpI._)(cb));
    $6d932106fee366bf$var$queueFlush();
}
function $6d932106fee366bf$var$queuePreFlushCb(cb) {
    $6d932106fee366bf$var$queueCb(cb, $6d932106fee366bf$var$activePreFlushCbs, $6d932106fee366bf$var$pendingPreFlushCbs, $6d932106fee366bf$var$preFlushIndex);
}
function $6d932106fee366bf$export$59536a0199721cab(cb) {
    $6d932106fee366bf$var$queueCb(cb, $6d932106fee366bf$var$activePostFlushCbs, $6d932106fee366bf$var$pendingPostFlushCbs, $6d932106fee366bf$var$postFlushIndex);
}
function $6d932106fee366bf$var$flushPreFlushCbs(seen) {
    var parentJob = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if ($6d932106fee366bf$var$pendingPreFlushCbs.length) {
        $6d932106fee366bf$var$currentPreFlushParentJob = parentJob;
        $6d932106fee366bf$var$activePreFlushCbs = (0, $aYXpI._)(new Set($6d932106fee366bf$var$pendingPreFlushCbs));
        $6d932106fee366bf$var$pendingPreFlushCbs.length = 0;
        for($6d932106fee366bf$var$preFlushIndex = 0; $6d932106fee366bf$var$preFlushIndex < $6d932106fee366bf$var$activePreFlushCbs.length; $6d932106fee366bf$var$preFlushIndex++)$6d932106fee366bf$var$activePreFlushCbs[$6d932106fee366bf$var$preFlushIndex]();
        $6d932106fee366bf$var$activePreFlushCbs = null;
        $6d932106fee366bf$var$preFlushIndex = 0;
        $6d932106fee366bf$var$currentPreFlushParentJob = null;
        // recursively flush until it drains
        $6d932106fee366bf$var$flushPreFlushCbs(seen, parentJob);
    }
}
function $6d932106fee366bf$var$flushPostFlushCbs(seen) {
    if ($6d932106fee366bf$var$pendingPostFlushCbs.length) {
        var deduped = (0, $aYXpI._)(new Set($6d932106fee366bf$var$pendingPostFlushCbs));
        $6d932106fee366bf$var$pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if ($6d932106fee366bf$var$activePostFlushCbs) {
            var _activePostFlushCbs;
            (_activePostFlushCbs = $6d932106fee366bf$var$activePostFlushCbs).push.apply(_activePostFlushCbs, (0, $aYXpI._)(deduped));
            return;
        }
        $6d932106fee366bf$var$activePostFlushCbs = deduped;
        $6d932106fee366bf$var$activePostFlushCbs.sort(function(a, b) {
            return $6d932106fee366bf$var$getId(a) - $6d932106fee366bf$var$getId(b);
        });
        for($6d932106fee366bf$var$postFlushIndex = 0; $6d932106fee366bf$var$postFlushIndex < $6d932106fee366bf$var$activePostFlushCbs.length; $6d932106fee366bf$var$postFlushIndex++)$6d932106fee366bf$var$activePostFlushCbs[$6d932106fee366bf$var$postFlushIndex]();
        $6d932106fee366bf$var$activePostFlushCbs = null;
        $6d932106fee366bf$var$postFlushIndex = 0;
    }
}
var $6d932106fee366bf$var$getId = function(job) {
    return job.id == null ? Infinity : job.id;
};
function $6d932106fee366bf$var$flushJobs(seen) {
    $6d932106fee366bf$var$isFlushPending = false;
    $6d932106fee366bf$var$isFlushing = true;
    $6d932106fee366bf$var$flushPreFlushCbs(seen);
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    $6d932106fee366bf$var$queue.sort(function(a, b) {
        return $6d932106fee366bf$var$getId(a) - $6d932106fee366bf$var$getId(b);
    });
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    var check = (0, $j3cSI.NOOP);
    try {
        for($6d932106fee366bf$var$flushIndex = 0; $6d932106fee366bf$var$flushIndex < $6d932106fee366bf$var$queue.length; $6d932106fee366bf$var$flushIndex++){
            var job = $6d932106fee366bf$var$queue[$6d932106fee366bf$var$flushIndex];
            if (job && job.active !== false) // console.log(`running:`, job.id)
            $6d932106fee366bf$export$b22fcaf88446e9bf(job, null, 14 /* SCHEDULER */ );
        }
    } finally{
        $6d932106fee366bf$var$flushIndex = 0;
        $6d932106fee366bf$var$queue.length = 0;
        $6d932106fee366bf$var$flushPostFlushCbs(seen);
        $6d932106fee366bf$var$isFlushing = false;
        $6d932106fee366bf$var$currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if ($6d932106fee366bf$var$queue.length || $6d932106fee366bf$var$pendingPreFlushCbs.length || $6d932106fee366bf$var$pendingPostFlushCbs.length) $6d932106fee366bf$var$flushJobs(seen);
    }
}
function $6d932106fee366bf$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        var count = seen.get(fn);
        if (count > $6d932106fee366bf$var$RECURSION_LIMIT) {
            var instance = fn.ownerInstance;
            var componentName = instance && $6d932106fee366bf$var$getComponentName(instance.type);
            $6d932106fee366bf$export$c106dd0671a0fc2d("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". ") + "This means you have a reactive effect that is mutating its own " + "dependencies and thus recursively triggering itself. Possible sources " + "include component template, render function, updated hook or " + "watcher source function.");
            return true;
        } else seen.set(fn, count + 1);
    }
}
// Simple effect.
function $6d932106fee366bf$export$ede35fc0e5500309(effect, options) {
    return $6d932106fee366bf$var$doWatch(effect, null, options);
}
function $6d932106fee366bf$export$b7f27ea67102d543(effect, options) {
    return $6d932106fee366bf$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $6d932106fee366bf$export$2035654f31b0e555(effect, options) {
    return $6d932106fee366bf$var$doWatch(effect, null, {
        flush: "sync"
    });
}
// initial value for watchers to trigger on undefined initial values
var $6d932106fee366bf$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $6d932106fee366bf$export$3db5d71bdb2d5499(source, cb, options) {
    return $6d932106fee366bf$var$doWatch(source, cb, options);
}
function $6d932106fee366bf$var$doWatch(source, cb) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $j3cSI.EMPTY_OBJ), immediate = _ref.immediate, deep = _ref.deep, flush = _ref.flush, onTrack = _ref.onTrack, onTrigger = _ref.onTrigger;
    var warnInvalidSource = function(s) {
        $6d932106fee366bf$export$c106dd0671a0fc2d("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, " + "a reactive object, or an array of these types.");
    };
    var instance = $6d932106fee366bf$var$currentInstance;
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if ((0, $Dz4HH.isRef)(source)) {
        getter = function() {
            return source.value;
        };
        forceTrigger = !!source._shallow;
    } else if ((0, $Dz4HH.isReactive)(source)) {
        getter = function() {
            return source;
        };
        deep = true;
    } else if ((0, $j3cSI.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((0, $Dz4HH.isReactive));
        getter = function() {
            return source.map(function(s) {
                if ((0, $Dz4HH.isRef)(s)) return s.value;
                else if ((0, $Dz4HH.isReactive)(s)) return $6d932106fee366bf$var$traverse(s);
                else if ((0, $j3cSI.isFunction)(s)) return $6d932106fee366bf$export$b22fcaf88446e9bf(s, instance, 2 /* WATCH_GETTER */ );
            });
        };
    } else if ((0, $j3cSI.isFunction)(source)) {
        if (cb) // getter with cb
        getter = function() {
            return $6d932106fee366bf$export$b22fcaf88446e9bf(source, instance, 2 /* WATCH_GETTER */ );
        };
        else // no cb -> simple effect
        getter = function() {
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $6d932106fee366bf$export$dae85862a8d94378(source, instance, 3 /* WATCH_CALLBACK */ , [
                onInvalidate
            ]);
        };
    } else getter = (0, $j3cSI.NOOP);
    if (cb && deep) {
        var baseGetter = getter;
        getter = function() {
            return $6d932106fee366bf$var$traverse(baseGetter());
        };
    }
    var cleanup;
    var onInvalidate = function(fn) {
        cleanup = effect.onStop = function() {
            $6d932106fee366bf$export$b22fcaf88446e9bf(fn, instance, 4 /* WATCH_CLEANUP */ );
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($6d932106fee366bf$var$isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onInvalidate = (0, $j3cSI.NOOP);
        if (!cb) getter();
        else if (immediate) $6d932106fee366bf$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
            getter(),
            isMultiSource ? [] : undefined,
            onInvalidate
        ]);
        return 0, $j3cSI.NOOP;
    }
    var oldValue = isMultiSource ? [] : $6d932106fee366bf$var$INITIAL_WATCHER_VALUE;
    var job = function() {
        if (!effect.active) return;
        if (cb) {
            // watch(source, cb)
            var newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function(v1, i) {
                return (0, $j3cSI.hasChanged)(v1, oldValue[i]);
            }) : (0, $j3cSI.hasChanged)(newValue, oldValue)) || false) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                $6d932106fee366bf$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $6d932106fee366bf$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onInvalidate
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        effect.run();
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    var scheduler;
    if (flush === "sync") scheduler = job; // the scheduler function gets called directly
    else if (flush === "post") scheduler = function() {
        return $6d932106fee366bf$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else // default: 'pre'
    scheduler = function() {
        if (!instance || instance.isMounted) $6d932106fee366bf$var$queuePreFlushCb(job);
        else // with 'pre' option, the first call must happen before
        // the component is mounted so it is called synchronously.
        job();
    };
    var effect = new (0, $Dz4HH.ReactiveEffect)(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $6d932106fee366bf$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    return function() {
        effect.stop();
        if (instance && instance.scope) (0, $j3cSI.remove)(instance.scope.effects, effect);
    };
}
// this.$watch
function $6d932106fee366bf$var$instanceWatch(source, value, options) {
    var publicThis = this.proxy;
    var getter = (0, $j3cSI.isString)(source) ? source.includes(".") ? $6d932106fee366bf$var$createPathGetter(publicThis, source) : function() {
        return publicThis[source];
    } : source.bind(publicThis, publicThis);
    var cb;
    if ((0, $j3cSI.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    var cur = $6d932106fee366bf$var$currentInstance;
    $6d932106fee366bf$var$setCurrentInstance(this);
    var res = $6d932106fee366bf$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $6d932106fee366bf$var$setCurrentInstance(cur);
    else $6d932106fee366bf$var$unsetCurrentInstance();
    return res;
}
function $6d932106fee366bf$var$createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function() {
        var cur = ctx;
        for(var i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $6d932106fee366bf$var$traverse(value, seen) {
    if (!(0, $j3cSI.isObject)(value) || value["__v_skip" /* SKIP */ ]) return value;
    seen = seen || new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $Dz4HH.isRef)(value)) $6d932106fee366bf$var$traverse(value.value, seen);
    else if ((0, $j3cSI.isArray)(value)) for(var i = 0; i < value.length; i++)$6d932106fee366bf$var$traverse(value[i], seen);
    else if ((0, $j3cSI.isSet)(value) || (0, $j3cSI.isMap)(value)) value.forEach(function(v1) {
        $6d932106fee366bf$var$traverse(v1, seen);
    });
    else if ((0, $j3cSI.isPlainObject)(value)) for(var key in value)$6d932106fee366bf$var$traverse(value[key], seen);
    return value;
}
// dev only
var $6d932106fee366bf$var$warnRuntimeUsage = function(method) {
    return $6d932106fee366bf$export$c106dd0671a0fc2d("".concat(method, "() is a compiler-hint helper that is only usable inside ") + "<script setup> of a single file component. Its arguments should be " + "compiled away and passing it at runtime has no effect.");
};
// implementation
function $6d932106fee366bf$export$80b33eababae110e() {
    return null;
}
// implementation
function $6d932106fee366bf$export$51ecece22fc17ddc() {
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. varaibles inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */ function $6d932106fee366bf$export$da25b65ca24b518a(exposed) {}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */ function $6d932106fee366bf$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $6d932106fee366bf$export$9203a8e84125433c() {
    return $6d932106fee366bf$var$getContext().slots;
}
function $6d932106fee366bf$export$75e29435042cd2ea() {
    return $6d932106fee366bf$var$getContext().attrs;
}
function $6d932106fee366bf$var$getContext() {
    var i = $6d932106fee366bf$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $6d932106fee366bf$var$createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $6d932106fee366bf$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = (0, $j3cSI.isArray)(raw) ? raw.reduce(function(normalized, p) {
        return normalized[p] = {}, normalized;
    }, {}) : raw;
    for(var key in defaults){
        var opt = props[key];
        if (opt) {
            if ((0, $j3cSI.isArray)(opt) || (0, $j3cSI.isFunction)(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */ function $6d932106fee366bf$export$7c343e855c563faa(props, excludedKeys) {
    var _loop = function(key) {
        if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
            enumerable: true,
            get: function() {
                return props[key];
            }
        });
    };
    var ret = {};
    for(var key in props)_loop(key);
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */ function $6d932106fee366bf$export$d6d6f7369f1fb104(getAwaitable) {
    var ctx = $6d932106fee366bf$export$f13e630aa3915748();
    var awaitable = getAwaitable();
    $6d932106fee366bf$var$unsetCurrentInstance();
    if ((0, $j3cSI.isPromise)(awaitable)) awaitable = awaitable.catch(function(e) {
        $6d932106fee366bf$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        function() {
            return $6d932106fee366bf$var$setCurrentInstance(ctx);
        }
    ];
}
// Actual implementation
function $6d932106fee366bf$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    var l = arguments.length;
    if (l === 2) {
        if ((0, $j3cSI.isObject)(propsOrChildren) && !(0, $j3cSI.isArray)(propsOrChildren)) {
            // single vnode without props
            if ($6d932106fee366bf$export$3868d13f8734ae81(propsOrChildren)) return $6d932106fee366bf$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            // props without children
            return $6d932106fee366bf$export$bf5c4cf060303d58(type, propsOrChildren);
        } else // omit props
        return $6d932106fee366bf$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $6d932106fee366bf$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $6d932106fee366bf$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
var $6d932106fee366bf$export$f2549a27e18acf2d = Symbol("");
var $6d932106fee366bf$export$6b1c54dc4befcda = function() {
    {
        var ctx = $6d932106fee366bf$export$a976684a0efeb93f($6d932106fee366bf$export$f2549a27e18acf2d);
        if (!ctx) $6d932106fee366bf$export$c106dd0671a0fc2d("Server rendering context not provided. Make sure to only call " + "useSSRContext() conditionally in the server build.");
        return ctx;
    }
};
function $6d932106fee366bf$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $Dz4HH.toRaw)(instance.props)));
        if (instance.setupState !== (0, $j3cSI.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $j3cSI.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $Dz4HH.toRaw)(instance.data)));
        var computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        var injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $j3cSI.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ].concat((0, $aYXpI._)(Object.keys(target).map(function(key) {
                return [
                    "div",
                    {},
                    [
                        "span",
                        keywordStyle,
                        key + ": "
                    ],
                    formatValue(target[key], false)
                ];
            })))
        ];
    }
    function formatValue(v1) {
        var asRaw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $j3cSI.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $Dz4HH.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        var Comp = instance.type;
        if ((0, $j3cSI.isFunction)(Comp)) return;
        var extracted = {};
        for(var key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if ((0, $j3cSI.isArray)(opts) && opts.includes(key) || (0, $j3cSI.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some(function(m) {
            return isKeyOfType(m, key, type);
        })) return true;
    }
    function genRefFlag(v1) {
        if (v1._shallow) return "ShallowRef";
        if (v1.effect) return "ComputedRef";
        return "Ref";
    }
}
function $6d932106fee366bf$export$2a6d714a4d738ae(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && $6d932106fee366bf$export$bf525184d622787c(cached, memo)) return cached;
    var ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $6d932106fee366bf$export$bf525184d622787c(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(var i = 0; i < prev.length; i++){
        if (prev[i] !== memo[i]) return false;
    }
    // make sure to let parent block track it when returning cached
    if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && $6d932106fee366bf$var$currentBlock) $6d932106fee366bf$var$currentBlock.push(cached);
    return true;
}
// Core API ------------------------------------------------------------------
var $6d932106fee366bf$export$83d89fbfd8236492 = "3.2.20";
var $6d932106fee366bf$var$_ssrUtils = {
    createComponentInstance: $6d932106fee366bf$var$createComponentInstance,
    setupComponent: $6d932106fee366bf$var$setupComponent,
    renderComponentRoot: $6d932106fee366bf$var$renderComponentRoot,
    setCurrentRenderingInstance: $6d932106fee366bf$var$setCurrentRenderingInstance,
    isVNode: $6d932106fee366bf$export$3868d13f8734ae81,
    normalizeVNode: $6d932106fee366bf$var$normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in cjs builds.
 * @internal
 */ var $6d932106fee366bf$export$a9679033567b336d = $6d932106fee366bf$var$_ssrUtils;
/**
 * @internal only exposed in compat builds
 */ var $6d932106fee366bf$export$83cf26e06ea620e1 = null;
/**
 * @internal only exposed in compat builds.
 */ var $6d932106fee366bf$export$dc678eddf276286e = null;

});

parcelRegister("6zPDN", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("9pglz")).BaseTransition; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("9pglz")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("j3cSI")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("Dz4HH")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("9pglz")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("9pglz")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("9pglz")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("9pglz")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("9pglz")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("9pglz")).createRenderer; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("9pglz")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("9pglz")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("9pglz")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("9pglz")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("9pglz")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("9pglz")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("9pglz")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("9pglz")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("9pglz")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("Dz4HH")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("9pglz")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("9pglz")).nextTick; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("9pglz")).onActivated; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("9pglz")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("9pglz")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("9pglz")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("9pglz")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("9pglz")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("9pglz")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("9pglz")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("9pglz")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("Dz4HH")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("Dz4HH")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("9pglz")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("9pglz")).resolveComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("9pglz")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("9pglz")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("9pglz")).Static; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("9pglz")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("Dz4HH")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("9pglz")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("9pglz")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("9pglz")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("9pglz")).watchEffect; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("9pglz")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("9pglz")).withCtx; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("j3cSI")).toDisplayString; });

$parcel$export(module.exports, "createApp", function () { return $4c9e11c6bdea98d0$export$4e373c34abfa8c68; });

var $cquyX = parcelRequire("cquyX");

var $juqrk = parcelRequire("juqrk");

var $bNI6E = parcelRequire("bNI6E");

var $jqfyu = parcelRequire("jqfyu");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");

var $6aBn7 = parcelRequire("6aBn7");

var $50zho = parcelRequire("50zho");

var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $Dz4HH = parcelRequire("Dz4HH");
var $Dz4HH = parcelRequire("Dz4HH");parcelRequire("j3cSI");

var $j3cSI = parcelRequire("j3cSI");
var $4c9e11c6bdea98d0$var$svgNS = "http://www.w3.org/2000/svg";
var $4c9e11c6bdea98d0$var$doc = typeof document !== "undefined" ? document : null;
var $4c9e11c6bdea98d0$var$staticTemplateCache = new Map();
var $4c9e11c6bdea98d0$var$nodeOps = {
    insert: function(child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function(child) {
        var parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: function(tag, isSVG, is, props) {
        var el = isSVG ? $4c9e11c6bdea98d0$var$doc.createElementNS($4c9e11c6bdea98d0$var$svgNS, tag) : $4c9e11c6bdea98d0$var$doc.createElement(tag, is ? {
            is: is
        } : undefined);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: function(text) {
        return $4c9e11c6bdea98d0$var$doc.createTextNode(text);
    },
    createComment: function(text) {
        return $4c9e11c6bdea98d0$var$doc.createComment(text);
    },
    setText: function(node, text) {
        node.nodeValue = text;
    },
    setElementText: function(el, text) {
        el.textContent = text;
    },
    parentNode: function(node) {
        return node.parentNode;
    },
    nextSibling: function(node) {
        return node.nextSibling;
    },
    querySelector: function(selector) {
        return $4c9e11c6bdea98d0$var$doc.querySelector(selector);
    },
    setScopeId: function(el, id) {
        el.setAttribute(id, "");
    },
    cloneNode: function(el) {
        var cloned = el.cloneNode(true);
        // #3072
        // - in `patchDOMProp`, we store the actual value in the `el._value` property.
        // - normally, elements using `:value` bindings will not be hoisted, but if
        //   the bound value is a constant, e.g. `:value="true"` - they do get
        //   hoisted.
        // - in production, hoisted nodes are cloned when subsequent inserts, but
        //   cloneNode() does not copy the custom property we attached.
        // - This may need to account for other custom DOM properties we attach to
        //   elements in addition to `_value` in the future.
        if ("_value" in el) cloned._value = el._value;
        return cloned;
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent: function(content, parent, anchor, isSVG) {
        // <parent> before | first ... last | anchor </parent>
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        var template = $4c9e11c6bdea98d0$var$staticTemplateCache.get(content);
        if (!template) {
            var t = $4c9e11c6bdea98d0$var$doc.createElement("template");
            t.innerHTML = isSVG ? "<svg>".concat(content, "</svg>") : content;
            template = t.content;
            if (isSVG) {
                // remove outer svg wrapper
                var wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            $4c9e11c6bdea98d0$var$staticTemplateCache.set(content, template);
        }
        parent.insertBefore(template.cloneNode(true), anchor);
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function $4c9e11c6bdea98d0$var$patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    var transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value
    ].concat((0, $aYXpI._)(transitionClasses)) : (0, $aYXpI._)(transitionClasses)).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $4c9e11c6bdea98d0$var$patchStyle(el, prev, next) {
    var style = el.style;
    var currentDisplay = style.display;
    if (!next) el.removeAttribute("style");
    else if ((0, $j3cSI.isString)(next)) {
        if (prev !== next) style.cssText = next;
    } else {
        for(var key in next)$4c9e11c6bdea98d0$var$setStyle(style, key, next[key]);
        if (prev && !(0, $j3cSI.isString)(prev)) {
            for(var key1 in prev)if (next[key1] == null) $4c9e11c6bdea98d0$var$setStyle(style, key1, "");
        }
    }
    // indicates that the `display` of the element is controlled by `v-show`,
    // so we always keep the current `display` value regardless of the `style` value,
    // thus handing over control to `v-show`.
    if ("_vod" in el) style.display = currentDisplay;
}
var $4c9e11c6bdea98d0$var$importantRE = /\s*!important$/;
function $4c9e11c6bdea98d0$var$setStyle(style, name, val) {
    if ((0, $j3cSI.isArray)(val)) val.forEach(function(v) {
        return $4c9e11c6bdea98d0$var$setStyle(style, name, v);
    });
    else if (name.startsWith("--")) // custom property definition
    style.setProperty(name, val);
    else {
        var prefixed = $4c9e11c6bdea98d0$var$autoPrefix(style, name);
        if ($4c9e11c6bdea98d0$var$importantRE.test(val)) // !important
        style.setProperty((0, $j3cSI.hyphenate)(prefixed), val.replace($4c9e11c6bdea98d0$var$importantRE, ""), "important");
        else style[prefixed] = val;
    }
}
var $4c9e11c6bdea98d0$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
var $4c9e11c6bdea98d0$var$prefixCache = {};
function $4c9e11c6bdea98d0$var$autoPrefix(style, rawName) {
    var cached = $4c9e11c6bdea98d0$var$prefixCache[rawName];
    if (cached) return cached;
    var name = (0, $j3cSI.camelize)(rawName);
    if (name !== "filter" && name in style) return $4c9e11c6bdea98d0$var$prefixCache[rawName] = name;
    name = (0, $j3cSI.capitalize)(name);
    for(var i = 0; i < $4c9e11c6bdea98d0$var$prefixes.length; i++){
        var prefixed = $4c9e11c6bdea98d0$var$prefixes[i] + name;
        if (prefixed in style) return $4c9e11c6bdea98d0$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
var $4c9e11c6bdea98d0$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $4c9e11c6bdea98d0$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($4c9e11c6bdea98d0$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($4c9e11c6bdea98d0$var$xlinkNS, key, value);
    } else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        var isBoolean = (0, $j3cSI.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $j3cSI.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function $4c9e11c6bdea98d0$var$patchDOMProp(el, key, value, // the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    if (key === "value" && el.tagName !== "PROGRESS") {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        var newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    if (value === "" || value == null) {
        var type = (0, $6aBn7._)(el[key]);
        if (type === "boolean") {
            // e.g. <select multiple> compiles to { multiple: '' }
            el[key] = (0, $j3cSI.includeBooleanAttr)(value);
            return;
        } else if (value == null && type === "string") {
            // e.g. <div :id="null">
            el[key] = "";
            el.removeAttribute(key);
            return;
        } else if (type === "number") {
            // e.g. <img :width="null">
            // the value of some IDL attr must be greater than 0, e.g. input.size = 0 -> error
            try {
                el[key] = 0;
            } catch (_a) {}
            el.removeAttribute(key);
            return;
        }
    }
    // some properties perform value validation and throw
    try {
        el[key] = value;
    } catch (e) {}
}
// Async edge case fix requires storing an event listener's attach timestamp.
var $4c9e11c6bdea98d0$var$_getNow = Date.now;
var $4c9e11c6bdea98d0$var$skipTimestampCheck = false;
if (typeof window !== "undefined") {
    // Determine what event timestamp the browser is using. Annoyingly, the
    // timestamp can either be hi-res (relative to page load) or low-res
    // (relative to UNIX epoch), so in order to compare time we have to use the
    // same timestamp type when saving the flush timestamp.
    if ($4c9e11c6bdea98d0$var$_getNow() > document.createEvent("Event").timeStamp) // if the low-res timestamp which is bigger than the event timestamp
    // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listeners as well.
    $4c9e11c6bdea98d0$var$_getNow = function() {
        return performance.now();
    };
    // #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
    // and does not fire microtasks in between event propagation, so safe to exclude.
    var $4c9e11c6bdea98d0$var$ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
    $4c9e11c6bdea98d0$var$skipTimestampCheck = !!($4c9e11c6bdea98d0$var$ffMatch && Number($4c9e11c6bdea98d0$var$ffMatch[1]) <= 53);
}
// To avoid the overhead of repeatedly calling performance.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
var $4c9e11c6bdea98d0$var$cachedNow = 0;
var $4c9e11c6bdea98d0$var$p = Promise.resolve();
var $4c9e11c6bdea98d0$var$reset = function() {
    $4c9e11c6bdea98d0$var$cachedNow = 0;
};
var $4c9e11c6bdea98d0$var$getNow = function() {
    return $4c9e11c6bdea98d0$var$cachedNow || ($4c9e11c6bdea98d0$var$p.then($4c9e11c6bdea98d0$var$reset), $4c9e11c6bdea98d0$var$cachedNow = $4c9e11c6bdea98d0$var$_getNow());
};
function $4c9e11c6bdea98d0$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $4c9e11c6bdea98d0$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $4c9e11c6bdea98d0$var$patchEvent(el, rawName, prevValue, nextValue) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    // vei = vue event invokers
    var invokers = el._vei || (el._vei = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) // patch
    existingInvoker.value = nextValue;
    else {
        var _parseName = (0, $fGQt0._)($4c9e11c6bdea98d0$var$parseName(rawName), 2), name = _parseName[0], options = _parseName[1];
        if (nextValue) {
            // add
            var invoker = invokers[rawName] = $4c9e11c6bdea98d0$var$createInvoker(nextValue, instance);
            $4c9e11c6bdea98d0$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            // remove
            $4c9e11c6bdea98d0$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
var $4c9e11c6bdea98d0$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $4c9e11c6bdea98d0$var$parseName(name) {
    var options;
    if ($4c9e11c6bdea98d0$var$optionsModifierRE.test(name)) {
        options = {};
        var m;
        while(m = name.match($4c9e11c6bdea98d0$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    return [
        (0, $j3cSI.hyphenate)(name.slice(2)),
        options
    ];
}
function $4c9e11c6bdea98d0$var$createInvoker(initialValue, instance) {
    var invoker = function(e) {
        // async edge case #6566: inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // the solution is simple: we save the timestamp when a handler is attached,
        // and the handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        var timeStamp = e.timeStamp || $4c9e11c6bdea98d0$var$_getNow();
        if ($4c9e11c6bdea98d0$var$skipTimestampCheck || timeStamp >= invoker.attached - 1) (0, $9pglz.callWithAsyncErrorHandling)($4c9e11c6bdea98d0$var$patchStopImmediatePropagation(e, invoker.value), instance, 5 /* NATIVE_EVENT_HANDLER */ , [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $4c9e11c6bdea98d0$var$getNow();
    return invoker;
}
function $4c9e11c6bdea98d0$var$patchStopImmediatePropagation(e, value) {
    if ((0, $j3cSI.isArray)(value)) {
        var originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = function() {
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map(function(fn) {
            return function(e) {
                return !e._stopped && fn(e);
            };
        });
    } else return value;
}
var $4c9e11c6bdea98d0$var$nativeOnRE = /^on[a-z]/;
var $4c9e11c6bdea98d0$var$patchProp = function(el, key, prevValue, nextValue) {
    var isSVG = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, prevChildren = arguments.length > 5 ? arguments[5] : void 0, parentComponent = arguments.length > 6 ? arguments[6] : void 0, parentSuspense = arguments.length > 7 ? arguments[7] : void 0, unmountChildren = arguments.length > 8 ? arguments[8] : void 0;
    if (key === "class") $4c9e11c6bdea98d0$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $4c9e11c6bdea98d0$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $j3cSI.isOn)(key)) // ignore v-model listeners
    {
        if (!(0, $j3cSI.isModelListener)(key)) $4c9e11c6bdea98d0$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $4c9e11c6bdea98d0$var$shouldSetAsProp(el, key, nextValue, isSVG)) $4c9e11c6bdea98d0$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $4c9e11c6bdea98d0$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $4c9e11c6bdea98d0$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === "innerHTML" || key === "textContent") return true;
        // or native onclick with function values
        if (key in el && $4c9e11c6bdea98d0$var$nativeOnRE.test(key) && (0, $j3cSI.isFunction)(value)) return true;
        return false;
    }
    // spellcheck and draggable are numerated attrs, however their
    // corresponding DOM properties are actually booleans - this leads to
    // setting it with a string "false" value leading it to be coerced to
    // `true`, so we need to always treat them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === "spellcheck" || key === "draggable") return false;
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === "form") return false;
    // #1526 <input list> must be set as attribute
    if (key === "list" && el.tagName === "INPUT") return false;
    // #2766 <textarea type> must be set as attribute
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    // native onclick with string value, must be set as attribute
    if ($4c9e11c6bdea98d0$var$nativeOnRE.test(key) && (0, $j3cSI.isString)(value)) return false;
    return key in el;
}
function $4c9e11c6bdea98d0$export$a00e2346eabbdbef(options, hydate) {
    var Comp = (0, $9pglz.defineComponent)(options);
    var VueCustomElement = /*#__PURE__*/ function(VueElement) {
        "use strict";
        (0, $jqfyu._)(VueCustomElement, VueElement);
        var _super = (0, $50zho._)(VueCustomElement);
        function VueCustomElement(initialProps) {
            (0, $juqrk._)(this, VueCustomElement);
            return _super.call(this, Comp, initialProps, hydate);
        }
        return VueCustomElement;
    }($4c9e11c6bdea98d0$export$b337c1a55163dbe3);
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
var $4c9e11c6bdea98d0$export$6debb2e68f212638 = function(options) {
    // @ts-ignore
    return $4c9e11c6bdea98d0$export$a00e2346eabbdbef(options, $4c9e11c6bdea98d0$export$fa8d919ba61d84db);
};
var $4c9e11c6bdea98d0$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : function _class() {
    "use strict";
    (0, $juqrk._)(this, _class);
};
var $4c9e11c6bdea98d0$export$b337c1a55163dbe3 = /*#__PURE__*/ function(BaseClass) {
    "use strict";
    (0, $jqfyu._)(VueElement, BaseClass);
    var _super = (0, $50zho._)(VueElement);
    function VueElement(_def) {
        var _props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, hydrate = arguments.length > 2 ? arguments[2] : void 0;
        (0, $juqrk._)(this, VueElement);
        var _this;
        _this = _super.call(this);
        _this._def = _def;
        _this._props = _props;
        /**
         * @internal
         */ _this._instance = null;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        if (_this.shadowRoot && hydrate) hydrate(_this._createVNode(), _this.shadowRoot);
        else _this.attachShadow({
            mode: "open"
        });
        // set initial attrs
        for(var i = 0; i < _this.attributes.length; i++)_this._setAttr(_this.attributes[i].name);
        // watch future attr changes
        new MutationObserver(function(mutations) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var m = _step.value;
                    _this._setAttr(m.attributeName);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }).observe((0, $cquyX._)(_this), {
            attributes: true
        });
        return _this;
    }
    (0, $bNI6E._)(VueElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                this._connected = true;
                if (!this._instance) {
                    this._resolveDef();
                    this._update();
                }
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this = this;
                this._connected = false;
                (0, $9pglz.nextTick)(function() {
                    if (!_this._connected) {
                        $4c9e11c6bdea98d0$export$b3890eb0ae9dca99(null, _this.shadowRoot);
                        _this._instance = null;
                    }
                });
            }
        },
        {
            /**
     * resolve inner component definition (handle possible async component)
     */ key: "_resolveDef",
            value: function _resolveDef() {
                var _this = this;
                if (this._resolved) return;
                var resolve = function(def) {
                    _this._resolved = true;
                    var props = def.props, styles = def.styles;
                    var hasOptions = !(0, $j3cSI.isArray)(props);
                    var rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
                    // cast Number-type props set before resolve
                    var numberProps;
                    if (hasOptions) for(var key in _this._props){
                        var opt = props[key];
                        if (opt === Number || opt && opt.type === Number) {
                            _this._props[key] = (0, $j3cSI.toNumber)(_this._props[key]);
                            (numberProps || (numberProps = Object.create(null)))[key] = true;
                        }
                    }
                    if (numberProps) {
                        _this._numberProps = numberProps;
                        _this._update();
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // check if there are props set pre-upgrade or connect
                        for(var _iterator = Object.keys(_this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key1 = _step.value;
                            if (key1[0] !== "_") _this._setProp(key1, _this[key1]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        var _loop = function() {
                            var key = _step1.value;
                            Object.defineProperty(_this, key, {
                                get: function() {
                                    return this._getProp(key);
                                },
                                set: function(val) {
                                    this._setProp(key, val);
                                }
                            });
                        };
                        // defining getter/setters on prototype
                        for(var _iterator1 = rawKeys.map((0, $j3cSI.camelize))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _this._applyStyles(styles);
                };
                var asyncDef = this._def.__asyncLoader;
                if (asyncDef) asyncDef().then(resolve);
                else resolve(this._def);
            }
        },
        {
            key: "_setAttr",
            value: function _setAttr(key) {
                var value = this.getAttribute(key);
                if (this._numberProps && this._numberProps[key]) value = (0, $j3cSI.toNumber)(value);
                this._setProp((0, $j3cSI.camelize)(key), value, false);
            }
        },
        {
            /**
     * @internal
     */ key: "_getProp",
            value: function _getProp(key) {
                return this._props[key];
            }
        },
        {
            /**
     * @internal
     */ key: "_setProp",
            value: function _setProp(key, val) {
                var shouldReflect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (val !== this._props[key]) {
                    this._props[key] = val;
                    if (this._instance) this._update();
                    // reflect
                    if (shouldReflect) {
                        if (val === true) this.setAttribute((0, $j3cSI.hyphenate)(key), "");
                        else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $j3cSI.hyphenate)(key), val + "");
                        else if (!val) this.removeAttribute((0, $j3cSI.hyphenate)(key));
                    }
                }
            }
        },
        {
            key: "_update",
            value: function _update() {
                $4c9e11c6bdea98d0$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
            }
        },
        {
            key: "_createVNode",
            value: function _createVNode() {
                var _this = this;
                var vnode = (0, $9pglz.createVNode)(this._def, (0, $j3cSI.extend)({}, this._props));
                if (!this._instance) vnode.ce = function(instance) {
                    var _this1 = _this;
                    _this._instance = instance;
                    instance.isCE = true;
                    var newStyles, s;
                    // intercept emit
                    instance.emit = function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        _this1.dispatchEvent(new CustomEvent(event, {
                            detail: args
                        }));
                    };
                    // locate nearest Vue custom element parent for provide/inject
                    var parent = _this;
                    while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
                        instance.parent = parent._instance;
                        break;
                    }
                };
                return vnode;
            }
        },
        {
            key: "_applyStyles",
            value: function _applyStyles(styles) {
                var _this = this;
                if (styles) styles.forEach(function(css) {
                    var s = document.createElement("style");
                    s.textContent = css;
                    _this.shadowRoot.appendChild(s);
                });
            }
        }
    ]);
    return VueElement;
}($4c9e11c6bdea98d0$var$BaseClass);
function $4c9e11c6bdea98d0$export$9300d5b90d56e3d1() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
    /* istanbul ignore else */ {
        var instance = (0, $9pglz.getCurrentInstance)();
        if (!instance) return 0, $j3cSI.EMPTY_OBJ;
        var modules = instance.type.__cssModules;
        if (!modules) return 0, $j3cSI.EMPTY_OBJ;
        var mod = modules[name];
        if (!mod) return 0, $j3cSI.EMPTY_OBJ;
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $4c9e11c6bdea98d0$export$ef28b76f07940108(getter) {
    var instance = (0, $9pglz.getCurrentInstance)();
    /* istanbul ignore next */ if (!instance) return;
    var setVars = function() {
        return $4c9e11c6bdea98d0$var$setVarsOnVNode(instance.subTree, getter(instance.proxy));
    };
    (0, $9pglz.watchPostEffect)(setVars);
    (0, $9pglz.onMounted)(function() {
        var ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $9pglz.onUnmounted)(function() {
            return ob.disconnect();
        });
    });
}
function $4c9e11c6bdea98d0$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        var suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(function() {
            $4c9e11c6bdea98d0$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    // drill down HOCs until it's a non-component vnode
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 /* ELEMENT */  && vnode.el) $4c9e11c6bdea98d0$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $9pglz.Fragment)) vnode.children.forEach(function(c) {
        return $4c9e11c6bdea98d0$var$setVarsOnVNode(c, vars);
    });
    else if (vnode.type === (0, $9pglz.Static)) {
        var el = vnode.el, anchor = vnode.anchor;
        while(el){
            $4c9e11c6bdea98d0$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $4c9e11c6bdea98d0$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        for(var key in vars)style.setProperty("--".concat(key), vars[key]);
    }
}
var $4c9e11c6bdea98d0$var$TRANSITION = "transition";
var $4c9e11c6bdea98d0$var$ANIMATION = "animation";
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
var $4c9e11c6bdea98d0$export$be58926105124dd4 = function(props, param) {
    var slots = param.slots;
    return (0, $9pglz.h)((0, $9pglz.BaseTransition), $4c9e11c6bdea98d0$var$resolveTransitionProps(props), slots);
};
$4c9e11c6bdea98d0$export$be58926105124dd4.displayName = "Transition";
var $4c9e11c6bdea98d0$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var $4c9e11c6bdea98d0$var$TransitionPropsValidators = $4c9e11c6bdea98d0$export$be58926105124dd4.props = /*#__PURE__*/ (0, $j3cSI.extend)({}, (0, $9pglz.BaseTransition).props, $4c9e11c6bdea98d0$var$DOMTransitionPropsValidators);
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */ var $4c9e11c6bdea98d0$var$callHook = function(hook) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if ((0, $j3cSI.isArray)(hook)) hook.forEach(function(h) {
        return h.apply(void 0, (0, $aYXpI._)(args));
    });
    else if (hook) hook.apply(void 0, (0, $aYXpI._)(args));
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */ var $4c9e11c6bdea98d0$var$hasExplicitCallback = function(hook) {
    return hook ? (0, $j3cSI.isArray)(hook) ? hook.some(function(h) {
        return h.length > 1;
    }) : hook.length > 1 : false;
};
function $4c9e11c6bdea98d0$var$resolveTransitionProps(rawProps) {
    var baseProps = {};
    for(var key in rawProps)if (!(key in $4c9e11c6bdea98d0$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    var _rawProps_name = rawProps.name, name = _rawProps_name === void 0 ? "v" : _rawProps_name, type = rawProps.type, duration = rawProps.duration, _rawProps_enterFromClass = rawProps.enterFromClass, enterFromClass = _rawProps_enterFromClass === void 0 ? "".concat(name, "-enter-from") : _rawProps_enterFromClass, _rawProps_enterActiveClass = rawProps.enterActiveClass, enterActiveClass = _rawProps_enterActiveClass === void 0 ? "".concat(name, "-enter-active") : _rawProps_enterActiveClass, _rawProps_enterToClass = rawProps.enterToClass, enterToClass = _rawProps_enterToClass === void 0 ? "".concat(name, "-enter-to") : _rawProps_enterToClass, _rawProps_appearFromClass = rawProps.appearFromClass, appearFromClass = _rawProps_appearFromClass === void 0 ? enterFromClass : _rawProps_appearFromClass, _rawProps_appearActiveClass = rawProps.appearActiveClass, appearActiveClass = _rawProps_appearActiveClass === void 0 ? enterActiveClass : _rawProps_appearActiveClass, _rawProps_appearToClass = rawProps.appearToClass, appearToClass = _rawProps_appearToClass === void 0 ? enterToClass : _rawProps_appearToClass, _rawProps_leaveFromClass = rawProps.leaveFromClass, leaveFromClass = _rawProps_leaveFromClass === void 0 ? "".concat(name, "-leave-from") : _rawProps_leaveFromClass, _rawProps_leaveActiveClass = rawProps.leaveActiveClass, leaveActiveClass = _rawProps_leaveActiveClass === void 0 ? "".concat(name, "-leave-active") : _rawProps_leaveActiveClass, _rawProps_leaveToClass = rawProps.leaveToClass, leaveToClass = _rawProps_leaveToClass === void 0 ? "".concat(name, "-leave-to") : _rawProps_leaveToClass;
    var durations = $4c9e11c6bdea98d0$var$normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _baseProps_onBeforeAppear = baseProps.onBeforeAppear, onBeforeAppear = _baseProps_onBeforeAppear === void 0 ? onBeforeEnter : _baseProps_onBeforeAppear, _baseProps_onAppear = baseProps.onAppear, onAppear = _baseProps_onAppear === void 0 ? onEnter : _baseProps_onAppear, _baseProps_onAppearCancelled = baseProps.onAppearCancelled, onAppearCancelled = _baseProps_onAppearCancelled === void 0 ? onEnterCancelled : _baseProps_onAppearCancelled;
    var finishEnter = function(el, isAppear, done) {
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function(el, done) {
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveToClass);
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function(isAppear) {
        return function(el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function() {
                return finishEnter(el, isAppear, done);
            };
            $4c9e11c6bdea98d0$var$callHook(hook, [
                el,
                resolve
            ]);
            $4c9e11c6bdea98d0$var$nextFrame(function() {
                $4c9e11c6bdea98d0$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $4c9e11c6bdea98d0$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$4c9e11c6bdea98d0$var$hasExplicitCallback(hook)) $4c9e11c6bdea98d0$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $j3cSI.extend)(baseProps, {
        onBeforeEnter: function(el) {
            $4c9e11c6bdea98d0$var$callHook(onBeforeEnter, [
                el
            ]);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, enterFromClass);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function(el) {
            $4c9e11c6bdea98d0$var$callHook(onBeforeAppear, [
                el
            ]);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, appearFromClass);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function(el, done) {
            var resolve = function() {
                return finishLeave(el, done);
            };
            $4c9e11c6bdea98d0$var$addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            $4c9e11c6bdea98d0$var$forceReflow();
            $4c9e11c6bdea98d0$var$addTransitionClass(el, leaveActiveClass);
            $4c9e11c6bdea98d0$var$nextFrame(function() {
                $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveFromClass);
                $4c9e11c6bdea98d0$var$addTransitionClass(el, leaveToClass);
                if (!$4c9e11c6bdea98d0$var$hasExplicitCallback(onLeave)) $4c9e11c6bdea98d0$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $4c9e11c6bdea98d0$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled: function(el) {
            finishEnter(el, false);
            $4c9e11c6bdea98d0$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled: function(el) {
            finishEnter(el, true);
            $4c9e11c6bdea98d0$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled: function(el) {
            finishLeave(el);
            $4c9e11c6bdea98d0$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $4c9e11c6bdea98d0$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $j3cSI.isObject)(duration)) return [
        $4c9e11c6bdea98d0$var$NumberOf(duration.enter),
        $4c9e11c6bdea98d0$var$NumberOf(duration.leave)
    ];
    else {
        var n = $4c9e11c6bdea98d0$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $4c9e11c6bdea98d0$var$NumberOf(val) {
    var res = (0, $j3cSI.toNumber)(val);
    return res;
}
function $4c9e11c6bdea98d0$var$validateDuration(val) {
    if (typeof val !== "number") (0, $9pglz.warn)("<transition> explicit duration is not a valid number - " + "got ".concat(JSON.stringify(val), "."));
    else if (isNaN(val)) (0, $9pglz.warn)("<transition> explicit duration is NaN - " + "the duration expression might be incorrect.");
}
function $4c9e11c6bdea98d0$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.add(c);
    });
    (el._vtc || (el._vtc = new Set())).add(cls);
}
function $4c9e11c6bdea98d0$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.remove(c);
    });
    var _vtc = el._vtc;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = undefined;
    }
}
function $4c9e11c6bdea98d0$var$nextFrame(cb) {
    requestAnimationFrame(function() {
        requestAnimationFrame(cb);
    });
}
var $4c9e11c6bdea98d0$var$endId = 0;
function $4c9e11c6bdea98d0$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++$4c9e11c6bdea98d0$var$endId;
    var resolveIfNotStale = function() {
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    var _getTransitionInfo = $4c9e11c6bdea98d0$var$getTransitionInfo(el, expectedType), type = _getTransitionInfo.type, timeout = _getTransitionInfo.timeout, propCount = _getTransitionInfo.propCount;
    if (!type) return resolve();
    var endEvent = type + "end";
    var ended = 0;
    var end = function() {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function(e) {
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $4c9e11c6bdea98d0$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var getStyleProperties = function(key) {
        return (styles[key] || "").split(", ");
    };
    var transitionDelays = getStyleProperties($4c9e11c6bdea98d0$var$TRANSITION + "Delay");
    var transitionDurations = getStyleProperties($4c9e11c6bdea98d0$var$TRANSITION + "Duration");
    var transitionTimeout = $4c9e11c6bdea98d0$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties($4c9e11c6bdea98d0$var$ANIMATION + "Delay");
    var animationDurations = getStyleProperties($4c9e11c6bdea98d0$var$ANIMATION + "Duration");
    var animationTimeout = $4c9e11c6bdea98d0$var$getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */ if (expectedType === $4c9e11c6bdea98d0$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $4c9e11c6bdea98d0$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $4c9e11c6bdea98d0$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $4c9e11c6bdea98d0$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $4c9e11c6bdea98d0$var$TRANSITION : $4c9e11c6bdea98d0$var$ANIMATION : null;
        propCount = type ? type === $4c9e11c6bdea98d0$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $4c9e11c6bdea98d0$var$TRANSITION && /\b(transform|all)(,|$)/.test(styles[$4c9e11c6bdea98d0$var$TRANSITION + "Property"]);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $4c9e11c6bdea98d0$var$getTimeout(delays, durations) {
    var _Math;
    while(delays.length < durations.length)delays = delays.concat(delays);
    return (_Math = Math).max.apply(_Math, (0, $aYXpI._)(durations.map(function(d, i) {
        return $4c9e11c6bdea98d0$var$toMs(d) + $4c9e11c6bdea98d0$var$toMs(delays[i]);
    })));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function $4c9e11c6bdea98d0$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1000;
}
// synchronously force layout to put elements into a certain state
function $4c9e11c6bdea98d0$var$forceReflow() {
    return document.body.offsetHeight;
}
var $4c9e11c6bdea98d0$var$positionMap = new WeakMap();
var $4c9e11c6bdea98d0$var$newPositionMap = new WeakMap();
var $4c9e11c6bdea98d0$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /*#__PURE__*/ (0, $j3cSI.extend)({}, $4c9e11c6bdea98d0$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots;
        var instance = (0, $9pglz.getCurrentInstance)();
        var state = (0, $9pglz.useTransitionState)();
        var prevChildren;
        var children;
        (0, $9pglz.onUpdated)(function() {
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!$4c9e11c6bdea98d0$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach($4c9e11c6bdea98d0$var$callPendingCbs);
            prevChildren.forEach($4c9e11c6bdea98d0$var$recordPosition);
            var movedChildren = prevChildren.filter($4c9e11c6bdea98d0$var$applyTranslation);
            // force reflow to put everything in position
            $4c9e11c6bdea98d0$var$forceReflow();
            movedChildren.forEach(function(c) {
                var el = c.el;
                var style = el.style;
                $4c9e11c6bdea98d0$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                var cb = el._moveCb = function(e) {
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $4c9e11c6bdea98d0$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return function() {
            var rawProps = (0, $Dz4HH.toRaw)(props);
            var cssTransitionProps = $4c9e11c6bdea98d0$var$resolveTransitionProps(rawProps);
            var tag = rawProps.tag || (0, $9pglz.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $9pglz.getTransitionRawChildren)(slots.default()) : [];
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.key != null) (0, $9pglz.setTransitionHooks)(child, (0, $9pglz.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(var i1 = 0; i1 < prevChildren.length; i1++){
                var child1 = prevChildren[i1];
                (0, $9pglz.setTransitionHooks)(child1, (0, $9pglz.resolveTransitionHooks)(child1, cssTransitionProps, state, instance));
                $4c9e11c6bdea98d0$var$positionMap.set(child1, child1.el.getBoundingClientRect());
            }
            return (0, $9pglz.createVNode)(tag, null, children);
        };
    }
};
var $4c9e11c6bdea98d0$export$19ffa8f511f7bc2e = $4c9e11c6bdea98d0$var$TransitionGroupImpl;
function $4c9e11c6bdea98d0$var$callPendingCbs(c) {
    var el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $4c9e11c6bdea98d0$var$recordPosition(c) {
    $4c9e11c6bdea98d0$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $4c9e11c6bdea98d0$var$applyTranslation(c) {
    var oldPos = $4c9e11c6bdea98d0$var$positionMap.get(c);
    var newPos = $4c9e11c6bdea98d0$var$newPositionMap.get(c);
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = c.el.style;
        s.transform = s.webkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
        return c;
    }
}
function $4c9e11c6bdea98d0$var$hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    var clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach(function(cls) {
        cls.split(/\s+/).forEach(function(c) {
            return c && clone.classList.remove(c);
        });
    });
    moveClass.split(/\s+/).forEach(function(c) {
        return c && clone.classList.add(c);
    });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = $4c9e11c6bdea98d0$var$getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var $4c9e11c6bdea98d0$var$getModelAssigner = function(vnode) {
    var fn = vnode.props["onUpdate:modelValue"];
    return (0, $j3cSI.isArray)(fn) ? function(value) {
        return (0, $j3cSI.invokeArrayFns)(fn, value);
    } : fn;
};
function $4c9e11c6bdea98d0$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $4c9e11c6bdea98d0$var$onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        $4c9e11c6bdea98d0$var$trigger(target, "input");
    }
}
function $4c9e11c6bdea98d0$var$trigger(el, type) {
    var e = document.createEvent("HTMLEvents");
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
var $4c9e11c6bdea98d0$export$f1f88689f5728478 = {
    created: function(el, param, vnode) {
        var _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        var castToNumber = number || vnode.props && vnode.props.type === "number";
        $4c9e11c6bdea98d0$var$addEventListener(el, lazy ? "change" : "input", function(e) {
            if (e.target.composing) return;
            var domValue = el.value;
            if (trim) domValue = domValue.trim();
            else if (castToNumber) domValue = (0, $j3cSI.toNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $4c9e11c6bdea98d0$var$addEventListener(el, "change", function() {
            el.value = el.value.trim();
        });
        if (!lazy) {
            $4c9e11c6bdea98d0$var$addEventListener(el, "compositionstart", $4c9e11c6bdea98d0$var$onCompositionStart);
            $4c9e11c6bdea98d0$var$addEventListener(el, "compositionend", $4c9e11c6bdea98d0$var$onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            $4c9e11c6bdea98d0$var$addEventListener(el, "change", $4c9e11c6bdea98d0$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted: function(el, param) {
        var value = param.value;
        el.value = value == null ? "" : value;
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing) return;
        if (document.activeElement === el) {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $j3cSI.toNumber)(el.value) === value) return;
        }
        var newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
var $4c9e11c6bdea98d0$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created: function(el, _, vnode) {
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        $4c9e11c6bdea98d0$var$addEventListener(el, "change", function() {
            var modelValue = el._modelValue;
            var elementValue = $4c9e11c6bdea98d0$var$getValue(el);
            var checked = el.checked;
            var assign = el._assign;
            if ((0, $j3cSI.isArray)(modelValue)) {
                var index = (0, $j3cSI.looseIndexOf)(modelValue, elementValue);
                var found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    var filtered = (0, $aYXpI._)(modelValue);
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $j3cSI.isSet)(modelValue)) {
                var cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($4c9e11c6bdea98d0$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $4c9e11c6bdea98d0$var$setChecked,
    beforeUpdate: function(el, binding, vnode) {
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        $4c9e11c6bdea98d0$var$setChecked(el, binding, vnode);
    }
};
function $4c9e11c6bdea98d0$var$setChecked(el, param, vnode) {
    var value = param.value, oldValue = param.oldValue;
    el._modelValue = value;
    if ((0, $j3cSI.isArray)(value)) el.checked = (0, $j3cSI.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $j3cSI.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $j3cSI.looseEqual)(value, $4c9e11c6bdea98d0$var$getCheckboxValue(el, true));
}
var $4c9e11c6bdea98d0$export$b4356c59b38b7aa9 = {
    created: function(el, param, vnode) {
        var value = param.value;
        el.checked = (0, $j3cSI.looseEqual)(value, vnode.props.value);
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        $4c9e11c6bdea98d0$var$addEventListener(el, "change", function() {
            el._assign($4c9e11c6bdea98d0$var$getValue(el));
        });
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue;
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $j3cSI.looseEqual)(value, vnode.props.value);
    }
};
var $4c9e11c6bdea98d0$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created: function(el, param, vnode) {
        var value = param.value, number = param.modifiers.number;
        var isSetModel = (0, $j3cSI.isSet)(value);
        $4c9e11c6bdea98d0$var$addEventListener(el, "change", function() {
            var selectedVal = Array.prototype.filter.call(el.options, function(o) {
                return o.selected;
            }).map(function(o) {
                return number ? (0, $j3cSI.toNumber)($4c9e11c6bdea98d0$var$getValue(o)) : $4c9e11c6bdea98d0$var$getValue(o);
            });
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted: function(el, param) {
        var value = param.value;
        $4c9e11c6bdea98d0$var$setSelected(el, value);
    },
    beforeUpdate: function(el, _binding, vnode) {
        el._assign = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
    },
    updated: function(el, param) {
        var value = param.value;
        $4c9e11c6bdea98d0$var$setSelected(el, value);
    }
};
function $4c9e11c6bdea98d0$var$setSelected(el, value) {
    var isMultiple = el.multiple;
    if (isMultiple && !(0, $j3cSI.isArray)(value) && !(0, $j3cSI.isSet)(value)) return;
    for(var i = 0, l = el.options.length; i < l; i++){
        var option = el.options[i];
        var optionValue = $4c9e11c6bdea98d0$var$getValue(option);
        if (isMultiple) {
            if ((0, $j3cSI.isArray)(value)) option.selected = (0, $j3cSI.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $j3cSI.looseEqual)($4c9e11c6bdea98d0$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
// retrieve raw value set via :value bindings
function $4c9e11c6bdea98d0$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function $4c9e11c6bdea98d0$var$getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
var $4c9e11c6bdea98d0$export$5ad5c0e01ff62c5 = {
    created: function(el, binding, vnode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function(el, binding, vnode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function(el, binding, vnode, prevVNode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function(el, binding, vnode, prevVNode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    var modelToUse;
    switch(el.tagName){
        case "SELECT":
            modelToUse = $4c9e11c6bdea98d0$export$87d227567b51ca39;
            break;
        case "TEXTAREA":
            modelToUse = $4c9e11c6bdea98d0$export$f1f88689f5728478;
            break;
        default:
            switch(vnode.props && vnode.props.type){
                case "checkbox":
                    modelToUse = $4c9e11c6bdea98d0$export$8847c2e532b35714;
                    break;
                case "radio":
                    modelToUse = $4c9e11c6bdea98d0$export$b4356c59b38b7aa9;
                    break;
                default:
                    modelToUse = $4c9e11c6bdea98d0$export$f1f88689f5728478;
            }
    }
    var fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $4c9e11c6bdea98d0$var$initVModelForSSR() {
    $4c9e11c6bdea98d0$export$f1f88689f5728478.getSSRProps = function(param) {
        var value = param.value;
        return {
            value: value
        };
    };
    $4c9e11c6bdea98d0$export$b4356c59b38b7aa9.getSSRProps = function(param, vnode) {
        var value = param.value;
        if (vnode.props && (0, $j3cSI.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $4c9e11c6bdea98d0$export$8847c2e532b35714.getSSRProps = function(param, vnode) {
        var value = param.value;
        if ((0, $j3cSI.isArray)(value)) {
            if (vnode.props && (0, $j3cSI.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $j3cSI.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
}
var $4c9e11c6bdea98d0$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
var $4c9e11c6bdea98d0$var$modifierGuards = {
    stop: function(e) {
        return e.stopPropagation();
    },
    prevent: function(e) {
        return e.preventDefault();
    },
    self: function(e) {
        return e.target !== e.currentTarget;
    },
    ctrl: function(e) {
        return !e.ctrlKey;
    },
    shift: function(e) {
        return !e.shiftKey;
    },
    alt: function(e) {
        return !e.altKey;
    },
    meta: function(e) {
        return !e.metaKey;
    },
    left: function(e) {
        return "button" in e && e.button !== 0;
    },
    middle: function(e) {
        return "button" in e && e.button !== 1;
    },
    right: function(e) {
        return "button" in e && e.button !== 2;
    },
    exact: function(e, modifiers) {
        return $4c9e11c6bdea98d0$var$systemModifiers.some(function(m) {
            return e["".concat(m, "Key")] && !modifiers.includes(m);
        });
    }
};
/**
 * @private
 */ var $4c9e11c6bdea98d0$export$26bd3b8e29e6f273 = function(fn, modifiers) {
    return function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        for(var i = 0; i < modifiers.length; i++){
            var guard = $4c9e11c6bdea98d0$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn.apply(void 0, [
            event
        ].concat((0, $aYXpI._)(args)));
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
var $4c9e11c6bdea98d0$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
 * @private
 */ var $4c9e11c6bdea98d0$export$f691a8759658f782 = function(fn, modifiers) {
    return function(event) {
        if (!("key" in event)) return;
        var eventKey = (0, $j3cSI.hyphenate)(event.key);
        if (modifiers.some(function(k) {
            return k === eventKey || $4c9e11c6bdea98d0$var$keyNames[k] === eventKey;
        })) return fn(event);
    };
};
var $4c9e11c6bdea98d0$export$5cb4fcdc6937d7e1 = {
    beforeMount: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $4c9e11c6bdea98d0$var$setDisplay(el, value);
    },
    mounted: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        if (transition && value) transition.enter(el);
    },
    updated: function(el, param, param1) {
        var value = param.value, oldValue = param.oldValue, transition = param1.transition;
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $4c9e11c6bdea98d0$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, function() {
                $4c9e11c6bdea98d0$var$setDisplay(el, false);
            });
        } else $4c9e11c6bdea98d0$var$setDisplay(el, value);
    },
    beforeUnmount: function(el, param) {
        var value = param.value;
        $4c9e11c6bdea98d0$var$setDisplay(el, value);
    }
};
function $4c9e11c6bdea98d0$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $4c9e11c6bdea98d0$var$initVShowForSSR() {
    $4c9e11c6bdea98d0$export$5cb4fcdc6937d7e1.getSSRProps = function(param) {
        var value = param.value;
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
var $4c9e11c6bdea98d0$var$rendererOptions = (0, $j3cSI.extend)({
    patchProp: $4c9e11c6bdea98d0$var$patchProp
}, $4c9e11c6bdea98d0$var$nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
var $4c9e11c6bdea98d0$var$renderer;
var $4c9e11c6bdea98d0$var$enabledHydration = false;
function $4c9e11c6bdea98d0$var$ensureRenderer() {
    return $4c9e11c6bdea98d0$var$renderer || ($4c9e11c6bdea98d0$var$renderer = (0, $9pglz.createRenderer)($4c9e11c6bdea98d0$var$rendererOptions));
}
function $4c9e11c6bdea98d0$var$ensureHydrationRenderer() {
    $4c9e11c6bdea98d0$var$renderer = $4c9e11c6bdea98d0$var$enabledHydration ? $4c9e11c6bdea98d0$var$renderer : (0, $9pglz.createHydrationRenderer)($4c9e11c6bdea98d0$var$rendererOptions);
    $4c9e11c6bdea98d0$var$enabledHydration = true;
    return $4c9e11c6bdea98d0$var$renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
var $4c9e11c6bdea98d0$export$b3890eb0ae9dca99 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    (_ensureRenderer = $4c9e11c6bdea98d0$var$ensureRenderer()).render.apply(_ensureRenderer, (0, $aYXpI._)(args));
};
var $4c9e11c6bdea98d0$export$fa8d919ba61d84db = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (_ensureHydrationRenderer = $4c9e11c6bdea98d0$var$ensureHydrationRenderer()).hydrate.apply(_ensureHydrationRenderer, (0, $aYXpI._)(args));
};
var $4c9e11c6bdea98d0$export$4e373c34abfa8c68 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    var app = (_ensureRenderer = $4c9e11c6bdea98d0$var$ensureRenderer()).createApp.apply(_ensureRenderer, (0, $aYXpI._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $4c9e11c6bdea98d0$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        var component = app._component;
        if (!(0, $j3cSI.isFunction)(component) && !component.render && !component.template) // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's
        // rendered by the server, the template should not contain any user data.
        component.template = container.innerHTML;
        // clear content before mounting
        container.innerHTML = "";
        var proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var $4c9e11c6bdea98d0$export$35800275c0037383 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    var app = (_ensureHydrationRenderer = $4c9e11c6bdea98d0$var$ensureHydrationRenderer()).createApp.apply(_ensureHydrationRenderer, (0, $aYXpI._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $4c9e11c6bdea98d0$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $4c9e11c6bdea98d0$var$injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, "isNativeTag", {
        value: function(tag) {
            return (0, $j3cSI.isHTMLTag)(tag) || (0, $j3cSI.isSVGTag)(tag);
        },
        writable: false
    });
}
// dev only
function $4c9e11c6bdea98d0$var$injectCompilerOptionsCheck(app) {
    if ((0, $9pglz.isRuntimeOnly)()) {
        var isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function() {
                return isCustomElement;
            },
            set: function() {
                (0, $9pglz.warn)("The `isCustomElement` config option is deprecated. Use " + "`compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions = app.config.compilerOptions;
        var msg = "The `compilerOptions` config option is only respected when using " + 'a build of Vue.js that includes the runtime compiler (aka "full build"). ' + "Since you are using the runtime-only build, `compilerOptions` " + "must be passed to `@vue/compiler-dom` in the build setup instead.\n" + "- For vue-loader: pass it via vue-loader's `compilerOptions` loader option.\n" + "- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n" + "- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom";
        Object.defineProperty(app.config, "compilerOptions", {
            get: function() {
                (0, $9pglz.warn)(msg);
                return compilerOptions;
            },
            set: function() {
                (0, $9pglz.warn)(msg);
            }
        });
    }
}
function $4c9e11c6bdea98d0$var$normalizeContainer(container) {
    if ((0, $j3cSI.isString)(container)) {
        var res = document.querySelector(container);
        return res;
    }
    return container;
}
var $4c9e11c6bdea98d0$var$ssrDirectiveInitialized = false;
/**
 * @internal
 */ var $4c9e11c6bdea98d0$export$800b28255aa678d9 = function() {
    if (!$4c9e11c6bdea98d0$var$ssrDirectiveInitialized) {
        $4c9e11c6bdea98d0$var$ssrDirectiveInitialized = true;
        $4c9e11c6bdea98d0$var$initVModelForSSR();
        $4c9e11c6bdea98d0$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $Dz4HH);

});
parcelRegister("cquyX", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8; });
function $90bf9ee1e0f0ea97$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("jqfyu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e23c82ff3e4e415d$export$7e4530ad35d3bb8; });

var $3A6Ss = parcelRequire("3A6Ss");
function $e23c82ff3e4e415d$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $3A6Ss._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("3A6Ss", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $29ba11907b394831$export$c2c98ac76e997b63; });
function $29ba11907b394831$export$c2c98ac76e997b63(o, p) {
    $29ba11907b394831$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $29ba11907b394831$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("50zho", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3a5851a3803a7a32$export$8dd05c13f5255580; });

var $5yT7U = parcelRequire("5yT7U");

var $8ZYwq = parcelRequire("8ZYwq");

var $5uf4I = parcelRequire("5uf4I");
function $3a5851a3803a7a32$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $8ZYwq._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $5yT7U._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5yT7U._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5uf4I._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("5yT7U", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $40cae3b32ee7ab1c$export$f09211a7d3c496a1; });
function $40cae3b32ee7ab1c$export$f09211a7d3c496a1(o) {
    $40cae3b32ee7ab1c$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $40cae3b32ee7ab1c$export$f09211a7d3c496a1(o);
}

});

parcelRegister("8ZYwq", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $68d2f7aa73fd860f$export$685354647fba1516; });
function $68d2f7aa73fd860f$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("5uf4I", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $3feb72aea5525294$export$ef97c660ca164e52; });

var $cquyX = parcelRequire("cquyX");

var $6aBn7 = parcelRequire("6aBn7");
function $3feb72aea5525294$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $6aBn7._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $cquyX._assert_this_initialized)(self);
}

});





parcelRegister("8xLzG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63864f1697468b00$export$2e2bcd8739ae039; });
var $63864f1697468b00$var$NOOP = function() {};
var $63864f1697468b00$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("8FqXK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $64f711457ac3bd45$export$2e2bcd8739ae039; });
var $64f711457ac3bd45$export$2e2bcd8739ae039 = {};

});

parcelRegister("dMYgs", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $a09e8154b857a664$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
function $a09e8154b857a664$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_my_header = (0, $9pglz.resolveComponent)("my-header");
    var _component_router_view = (0, $9pglz.resolveComponent)("router-view");
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, [
        (0, $9pglz.createVNode)(_component_my_header),
        (0, $9pglz.createVNode)(_component_router_view)
    ], 64);
}

});

parcelRegister("ccJaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e29a3eb4cf0c3eb$export$2e2bcd8739ae039; });
var $8e29a3eb4cf0c3eb$var$NOOP = function() {};
var $8e29a3eb4cf0c3eb$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("5XCFB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $45707581343c7bbe$export$2e2bcd8739ae039; });
var $45707581343c7bbe$export$2e2bcd8739ae039 = {
    mounted: function() {
        window.scrollTo(0, 0);
    }
};

});

parcelRegister("ah3Fj", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $77ae55c82c349c9b$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");

var $dG2wI = parcelRequire("dG2wI");

var $iDLHE = parcelRequire("iDLHE");
var $77ae55c82c349c9b$var$_hoisted_1 = {
    id: "presentation"
};
var $77ae55c82c349c9b$var$_hoisted_2 = {
    id: "about"
};
var $77ae55c82c349c9b$var$_hoisted_3 = {
    id: "contact"
};
var $77ae55c82c349c9b$var$_hoisted_4 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("p", null, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("a", {
        class: "text",
        href: "mailto:mathis.brossier@gmail.com"
    }, "mathis.brossier@gmail.com"),
    /*#__PURE__*/ (0, $9pglz.createTextVNode)(" \u2014 (+33)7.81.40.33.66")
], -1);
var $77ae55c82c349c9b$var$_hoisted_5 = {
    id: "cv"
};
var $77ae55c82c349c9b$var$_hoisted_6 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("p", null, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("a", {
        class: "text",
        href: "CV_Mathis_Brossier_fr.pdf"
    }, [
        /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
            class: "flag",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dG2wI))),
            alt: "fran\xe7ais"
        }),
        /*#__PURE__*/ (0, $9pglz.createTextVNode)(" fran\xe7ais")
    ]),
    /*#__PURE__*/ (0, $9pglz.createTextVNode)(" \u2014 "),
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("a", {
        class: "text",
        href: "CV_Mathis_Brossier_en.pdf"
    }, [
        /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
            class: "flag",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($iDLHE))),
            alt: "english"
        }),
        /*#__PURE__*/ (0, $9pglz.createTextVNode)(" english")
    ])
], -1);
function $77ae55c82c349c9b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_my_title = (0, $9pglz.resolveComponent)("my-title");
    var _component_projects = (0, $9pglz.resolveComponent)("projects");
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, [
        (0, $9pglz.createElementVNode)("section", $77ae55c82c349c9b$var$_hoisted_1, [
            (0, $9pglz.createVNode)(_component_my_title, {
                text: "Mathis Brossier"
            }),
            (0, $9pglz.createElementVNode)("div", $77ae55c82c349c9b$var$_hoisted_2, [
                (0, $9pglz.createElementVNode)("p", null, (0, $j3cSI.toDisplayString)(_ctx.$t("subtitle")), 1),
                (0, $9pglz.createElementVNode)("p", null, (0, $j3cSI.toDisplayString)(_ctx.$t("internship")), 1)
            ])
        ]),
        (0, $9pglz.createVNode)(_component_projects),
        (0, $9pglz.createElementVNode)("section", $77ae55c82c349c9b$var$_hoisted_3, [
            (0, $9pglz.createElementVNode)("h2", null, (0, $j3cSI.toDisplayString)(_ctx.$t("titlecontact")), 1),
            (0, $9pglz.createElementVNode)("p", null, (0, $j3cSI.toDisplayString)(_ctx.$t("contactme")), 1),
            $77ae55c82c349c9b$var$_hoisted_4
        ]),
        (0, $9pglz.createElementVNode)("section", $77ae55c82c349c9b$var$_hoisted_5, [
            (0, $9pglz.createElementVNode)("h2", null, (0, $j3cSI.toDisplayString)(_ctx.$t("titlecv")), 1),
            (0, $9pglz.createElementVNode)("p", null, (0, $j3cSI.toDisplayString)(_ctx.$t("curriculum")), 1),
            $77ae55c82c349c9b$var$_hoisted_6
        ])
    ], 64);
}

});
parcelRegister("dG2wI", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "flag_fr.1e72d885.svg";

});

parcelRegister("iDLHE", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "flag_en.fc22f474.svg";

});


parcelRegister("4tj3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3418a6cf30acd25f$export$2e2bcd8739ae039; });
var $3418a6cf30acd25f$var$NOOP = function() {};
var $3418a6cf30acd25f$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("fRbzk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b8b4c79736d8b308$export$2e2bcd8739ae039; });
var $b8b4c79736d8b308$export$2e2bcd8739ae039 = {
    props: [
        "projectid"
    ],
    methods: {
        getImg: function() {
            return this.projects[this.projectid].img;
        },
        proj: function(attr) {
            return this.$t("projects." + this.projectid + "." + attr);
        }
    }
};

});

parcelRegister("e6wQP", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $a44b1bc6b3a10479$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $a44b1bc6b3a10479$var$_withScopeId = function(n) {
    return (0, $9pglz.pushScopeId)("data-v-8ff11a"), n = n(), (0, $9pglz.popScopeId)(), n;
};
var $a44b1bc6b3a10479$var$_hoisted_1 = {
    class: "card"
};
var $a44b1bc6b3a10479$var$_hoisted_2 = [
    "src"
];
var $a44b1bc6b3a10479$var$_hoisted_3 = {
    class: "brief"
};
function $a44b1bc6b3a10479$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_router_link = (0, $9pglz.resolveComponent)("router-link");
    return (0, $9pglz.openBlock)(), (0, $9pglz.createBlock)(_component_router_link, {
        to: {
            name: "project",
            params: {
                projectid: $props.projectid
            }
        }
    }, {
        default: (0, $9pglz.withCtx)(function() {
            return [
                (0, $9pglz.createElementVNode)("div", $a44b1bc6b3a10479$var$_hoisted_1, [
                    (0, $9pglz.createElementVNode)("img", {
                        src: $options.getImg(),
                        alt: ""
                    }, null, 8, $a44b1bc6b3a10479$var$_hoisted_2),
                    (0, $9pglz.createElementVNode)("h2", null, [
                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($options.proj("name")), 1)
                    ]),
                    (0, $9pglz.createElementVNode)("span", $a44b1bc6b3a10479$var$_hoisted_3, (0, $j3cSI.toDisplayString)($options.proj("brief")), 1),
                    (0, $9pglz.createElementVNode)("p", null, (0, $j3cSI.toDisplayString)($options.proj("desc")), 1)
                ])
            ];
        }),
        _: 1
    }, 8, [
        "to"
    ]);
}

});

parcelRegister("5INXe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42a7cfb3339f55fc$export$2e2bcd8739ae039; });
var $42a7cfb3339f55fc$var$NOOP = function() {};
var $42a7cfb3339f55fc$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("uLGMy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $05c7cb817f3b4242$export$2e2bcd8739ae039; });
var $05c7cb817f3b4242$export$2e2bcd8739ae039 = {
    data: function() {
        return {
            titleInterval: 0
        };
    },
    props: [
        "text"
    ],
    mounted: function() {
        var _this = this;
        var blinkCount = 4;
        var blinkInterval = 500;
        var typeInterval = 100;
        var t1 = this.$refs.title1;
        var t2 = this.$refs.title2;
        var cur = this.$refs.cursor;
        var text = this.text;
        this.titleInterval = setInterval(function() {
            cur.style.visibility = cur.style.visibility === "visible" ? "hidden" : "visible";
        }, blinkInterval);
        var index = 0;
        setTimeout(function() {
            cur.style.visibility = "visible";
            clearInterval(_this.titleInterval);
            _this.titleInterval = setInterval(function() {
                index++;
                t1.innerHTML = text.substring(0, index);
                t2.innerHTML = text.substring(index, text.length);
                if (index >= text.length) {
                    cur.style.visibility = "hidden";
                    clearInterval(_this.titleInterval);
                    _this.titleInterval = setInterval(function() {
                        cur.style.visibility = cur.style.visibility === "visible" ? "hidden" : "visible";
                    }, blinkInterval);
                }
            }, typeInterval);
        }, blinkInterval * blinkCount);
    },
    beforeUnmount: function() {
        clearInterval(this.titleInterval);
    }
};

});

parcelRegister("5vPiz", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $4037a3d2ae4471fe$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $4037a3d2ae4471fe$var$_hoisted_1 = {
    ref: "title1"
};
var $4037a3d2ae4471fe$var$_hoisted_2 = {
    ref: "cursor"
};
function $4037a3d2ae4471fe$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("h1", null, [
        (0, $9pglz.createElementVNode)("span", $4037a3d2ae4471fe$var$_hoisted_1, null, 512),
        (0, $9pglz.createElementVNode)("span", null, [
            (0, $9pglz.createElementVNode)("span", {
                ref: "title2"
            }, (0, $j3cSI.toDisplayString)($props.text), 513),
            (0, $9pglz.createElementVNode)("div", $4037a3d2ae4471fe$var$_hoisted_2, null, 512)
        ])
    ]);
}

});

parcelRegister("jYMMV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8b9773dc39e9dfe$export$2e2bcd8739ae039; });
var $e8b9773dc39e9dfe$var$NOOP = function() {};
var $e8b9773dc39e9dfe$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("20sZd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $176210edef5c373d$export$2e2bcd8739ae039; });
var $176210edef5c373d$export$2e2bcd8739ae039 = {};

});

parcelRegister("7Zccd", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $5d07b0cef234bbdb$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $5d07b0cef234bbdb$var$_hoisted_1 = {
    id: "projects"
};
var $5d07b0cef234bbdb$var$_hoisted_2 = {
    id: "cards"
};
function $5d07b0cef234bbdb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_card = (0, $9pglz.resolveComponent)("card");
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("section", $5d07b0cef234bbdb$var$_hoisted_1, [
        (0, $9pglz.createElementVNode)("h2", null, (0, $j3cSI.toDisplayString)(_ctx.$t("titleprojects")), 1),
        (0, $9pglz.createElementVNode)("div", $5d07b0cef234bbdb$var$_hoisted_2, [
            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)(Object.keys(_ctx.projects), function(proj) {
                return (0, $9pglz.openBlock)(), (0, $9pglz.createBlock)(_component_card, {
                    projectid: proj
                }, null, 8, [
                    "projectid"
                ]);
            }), 256))
        ])
    ]);
}

});

parcelRegister("jT2ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7a52530e3193b90$export$2e2bcd8739ae039; });
var $e7a52530e3193b90$var$NOOP = function() {};
var $e7a52530e3193b90$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("8qUxc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $623c9aff5a285053$export$2e2bcd8739ae039; });
var $623c9aff5a285053$export$2e2bcd8739ae039 = {
    mounted: function() {
        window.scrollTo(0, 0);
    },
    methods: {
        getImg: function() {
            var projectid = this.$route.params.projectid;
            return this.projects[projectid].img;
        },
        fmturl: function(url) {
            var re = /(?:https?:\/\/)?(.+?)\/?$/;
            var match = re.exec(url);
            if (match) return match[1];
            else return url;
        },
        projmeta: function(attr) {
            var projectid = this.$route.params.projectid;
            return this.projects[projectid][attr];
        },
        projmeta_e: function(attr) {
            var projectid = this.$route.params.projectid;
            return attr in this.projects[projectid];
        },
        proj: function(attr) {
            return this.$t("projects." + this.$route.params.projectid + "." + attr);
        },
        proj_e: function(attr) {
            return this.$te("projects." + this.$route.params.projectid + "." + attr);
        },
        getProjectContent: function() {
            var lang = this.$i18n.locale;
            var projectid = this.$route.params.projectid;
            var project = this.projects[projectid];
            if (project === undefined) return this.proj("desc");
            var content = project.content;
            if (content === undefined) return this.proj("desc");
            else return content[lang] || content["en"] || Object.values(content)[0];
        }
    }
};

});

parcelRegister("3QEE4", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2cd5c1be51cb3e1a$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $2cd5c1be51cb3e1a$var$_hoisted_1 = {
    class: "project-overview"
};
var $2cd5c1be51cb3e1a$var$_hoisted_2 = [
    "src"
];
var $2cd5c1be51cb3e1a$var$_hoisted_3 = {
    class: "left"
};
var $2cd5c1be51cb3e1a$var$_hoisted_4 = {
    class: "brief"
};
var $2cd5c1be51cb3e1a$var$_hoisted_5 = {
    class: "right"
};
var $2cd5c1be51cb3e1a$var$_hoisted_6 = {
    key: 0
};
var $2cd5c1be51cb3e1a$var$_hoisted_7 = {
    key: 1
};
var $2cd5c1be51cb3e1a$var$_hoisted_8 = [
    "href"
];
var $2cd5c1be51cb3e1a$var$_hoisted_9 = {
    key: 2
};
var $2cd5c1be51cb3e1a$var$_hoisted_10 = [
    "href"
];
var $2cd5c1be51cb3e1a$var$_hoisted_11 = [
    "innerHTML"
];
function $2cd5c1be51cb3e1a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("article", null, [
        (0, $9pglz.createElementVNode)("section", $2cd5c1be51cb3e1a$var$_hoisted_1, [
            (0, $9pglz.createElementVNode)("img", {
                src: $options.getImg()
            }, null, 8, $2cd5c1be51cb3e1a$var$_hoisted_2),
            (0, $9pglz.createElementVNode)("div", $2cd5c1be51cb3e1a$var$_hoisted_3, [
                (0, $9pglz.createElementVNode)("h1", null, [
                    (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($options.proj("name")), 1)
                ]),
                (0, $9pglz.createElementVNode)("h2", $2cd5c1be51cb3e1a$var$_hoisted_4, [
                    (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($options.proj("brief")), 1)
                ])
            ]),
            (0, $9pglz.createElementVNode)("div", $2cd5c1be51cb3e1a$var$_hoisted_5, [
                $options.projmeta_e("collab") ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $2cd5c1be51cb3e1a$var$_hoisted_6, [
                    (0, $9pglz.createElementVNode)("h3", null, (0, $j3cSI.toDisplayString)(_ctx.$t("projectcollab")), 1),
                    (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($options.projmeta("collab")), 1)
                ])) : (0, $9pglz.createCommentVNode)("", true),
                $options.projmeta_e("link") ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $2cd5c1be51cb3e1a$var$_hoisted_7, [
                    (0, $9pglz.createElementVNode)("h3", null, (0, $j3cSI.toDisplayString)(_ctx.$t("projectlink")), 1),
                    (0, $9pglz.createElementVNode)("a", {
                        href: $options.projmeta("link")
                    }, (0, $j3cSI.toDisplayString)($options.fmturl($options.projmeta("link"))), 9, $2cd5c1be51cb3e1a$var$_hoisted_8)
                ])) : (0, $9pglz.createCommentVNode)("", true),
                $options.projmeta_e("git") ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $2cd5c1be51cb3e1a$var$_hoisted_9, [
                    (0, $9pglz.createElementVNode)("h3", null, (0, $j3cSI.toDisplayString)(_ctx.$t("projectgit")), 1),
                    (0, $9pglz.createElementVNode)("a", {
                        href: $options.projmeta("git")
                    }, (0, $j3cSI.toDisplayString)($options.fmturl($options.projmeta("git"))), 9, $2cd5c1be51cb3e1a$var$_hoisted_10)
                ])) : (0, $9pglz.createCommentVNode)("", true)
            ])
        ]),
        (0, $9pglz.createElementVNode)("section", {
            class: "project",
            innerHTML: $options.getProjectContent()
        }, null, 8, $2cd5c1be51cb3e1a$var$_hoisted_11)
    ]);
}

});

parcelRegister("ipLlQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67f4ac9ee96d4f9$export$2e2bcd8739ae039; });
var $d67f4ac9ee96d4f9$var$NOOP = function() {};
var $d67f4ac9ee96d4f9$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("lF6C7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fc528eb1c0ac8b53$export$2e2bcd8739ae039; });
var $fc528eb1c0ac8b53$export$2e2bcd8739ae039 = {};

});

parcelRegister("9KZEc", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $71a83ad239e51090$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");

var $2fYGO = parcelRequire("2fYGO");

var $dG2wI = parcelRequire("dG2wI");

var $iDLHE = parcelRequire("iDLHE");
var $71a83ad239e51090$var$_hoisted_1 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
    id: "home",
    src: (0, (/*@__PURE__*/$parcel$interopDefault($2fYGO))),
    alt: "Mathis Brossier"
}, null, -1);
var $71a83ad239e51090$var$_hoisted_2 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
    class: "flag",
    src: (0, (/*@__PURE__*/$parcel$interopDefault($dG2wI))),
    alt: "fran\xe7ais"
}, null, -1);
var $71a83ad239e51090$var$_hoisted_3 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
    class: "flag",
    src: (0, (/*@__PURE__*/$parcel$interopDefault($iDLHE))),
    alt: "english"
}, null, -1);
function $71a83ad239e51090$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_router_link = (0, $9pglz.resolveComponent)("router-link");
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("header", null, [
        (0, $9pglz.createVNode)(_component_router_link, {
            to: {
                name: "home"
            }
        }, {
            default: (0, $9pglz.withCtx)(function() {
                return [
                    $71a83ad239e51090$var$_hoisted_1
                ];
            }),
            _: 1
        }),
        (0, $9pglz.createElementVNode)("nav", null, [
            (0, $9pglz.createVNode)(_component_router_link, {
                to: {
                    params: {
                        locale: "fr"
                    }
                }
            }, {
                default: (0, $9pglz.withCtx)(function() {
                    return [
                        $71a83ad239e51090$var$_hoisted_2
                    ];
                }),
                _: 1
            }),
            (0, $9pglz.createVNode)(_component_router_link, {
                to: {
                    params: {
                        locale: "en"
                    }
                }
            }, {
                default: (0, $9pglz.withCtx)(function() {
                    return [
                        $71a83ad239e51090$var$_hoisted_3
                    ];
                }),
                _: 1
            }),
            (0, $9pglz.createVNode)(_component_router_link, {
                to: {
                    name: "home",
                    hash: "#projects"
                }
            }, {
                default: (0, $9pglz.withCtx)(function() {
                    return [
                        (0, $9pglz.createTextVNode)((0, $j3cSI.toDisplayString)(_ctx.$t("navprojects")), 1)
                    ];
                }),
                _: 1
            }),
            (0, $9pglz.createVNode)(_component_router_link, {
                to: {
                    name: "home",
                    hash: "#contact"
                }
            }, {
                default: (0, $9pglz.withCtx)(function() {
                    return [
                        (0, $9pglz.createTextVNode)((0, $j3cSI.toDisplayString)(_ctx.$t("navcontact")), 1)
                    ];
                }),
                _: 1
            }),
            (0, $9pglz.createVNode)(_component_router_link, {
                to: {
                    name: "home",
                    hash: "#cv"
                }
            }, {
                default: (0, $9pglz.withCtx)(function() {
                    return [
                        (0, $9pglz.createTextVNode)((0, $j3cSI.toDisplayString)(_ctx.$t("navcv")), 1)
                    ];
                }),
                _: 1
            })
        ])
    ]);
}

});
parcelRegister("2fYGO", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "logo-light.c71fdb70.svg";

});


parcelRegister("eoUEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7bf4152fe7a3217$export$2e2bcd8739ae039; });
var $a7bf4152fe7a3217$var$NOOP = function() {};
var $a7bf4152fe7a3217$export$2e2bcd8739ae039 = function(script) {};

});

parcelRequire("hrKNH");
var $6zPDN = parcelRequire("6zPDN");
/*!
  * vue-i18n v9.2.0-beta.16
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */ function $d30aa9e28595ada5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d30aa9e28595ada5$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d30aa9e28595ada5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d30aa9e28595ada5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $6aBn7 = parcelRequire("6aBn7");
var $3433e5a3eb89c040$var$extendStatics = function extendStatics1(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function __assign1() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $6aBn7._)(x)) === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $6aBn7._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};


/*!
  * shared v9.2.0-beta.16
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ 
var $6aBn7 = parcelRequire("6aBn7");
var $0980d0a6486887c9$export$620a268685f0ac45 = typeof window !== "undefined";
var $0980d0a6486887c9$export$bf7f2fce5c1cf636;
var $0980d0a6486887c9$export$83602b44513dc228;
var $0980d0a6486887c9$var$tag, $0980d0a6486887c9$var$name, $0980d0a6486887c9$var$startTag, $0980d0a6486887c9$var$endTag;
var $0980d0a6486887c9$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $0980d0a6486887c9$export$d9468344d3651243(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (args.length === 1 && $0980d0a6486887c9$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($0980d0a6486887c9$var$RE_ARGS, function(match, identifier) {
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
var $0980d0a6486887c9$var$hasSymbol = typeof Symbol === "function" && (0, $6aBn7._)(Symbol.toStringTag) === "symbol";
var $0980d0a6486887c9$export$cd133c5e04906ece = function(name) {
    return $0980d0a6486887c9$var$hasSymbol ? Symbol(name) : name;
};
var $0980d0a6486887c9$export$5024ef1f92c9a364 = function(locale, key, source) {
    return $0980d0a6486887c9$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
};
var $0980d0a6486887c9$export$d704025436eaed65 = function(json) {
    return JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
};
var $0980d0a6486887c9$export$7e4aa119212bc614 = function(val) {
    return typeof val === "number" && isFinite(val);
};
var $0980d0a6486887c9$export$871608497c498473 = function(val) {
    return $0980d0a6486887c9$export$1dccc787cc36538b(val) === "[object Date]";
};
var $0980d0a6486887c9$export$49841c62b9eff15 = function(val) {
    return $0980d0a6486887c9$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $0980d0a6486887c9$export$83b788b1a3698c03 = function(val) {
    return $0980d0a6486887c9$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
};
function $0980d0a6486887c9$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn("[intlify] " + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
var $0980d0a6486887c9$export$e6e34fd1f2686227 = Object.assign;
var $0980d0a6486887c9$var$_globalThis;
var $0980d0a6486887c9$export$ff5f2eeb11fc7e14 = function() {
    // prettier-ignore
    return $0980d0a6486887c9$var$_globalThis || ($0980d0a6486887c9$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
function $0980d0a6486887c9$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
var $0980d0a6486887c9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0980d0a6486887c9$export$b5a638e9b3fff9f3(obj, key) {
    return $0980d0a6486887c9$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ var $0980d0a6486887c9$export$43bee75e5e14138e = Array.isArray;
var $0980d0a6486887c9$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $0980d0a6486887c9$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $0980d0a6486887c9$export$f9ce7b637dfbe238 = function(val) {
    return typeof val === "boolean";
};
var $0980d0a6486887c9$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $6aBn7._)(val)) === "symbol";
};
var $0980d0a6486887c9$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && typeof val === "object";
};
var $0980d0a6486887c9$export$4369c812aac99591 = function(val) {
    return $0980d0a6486887c9$export$a6cdc56e425d0d0a(val) && $0980d0a6486887c9$export$f6e2535fb5126e54(val.then) && $0980d0a6486887c9$export$f6e2535fb5126e54(val.catch);
};
var $0980d0a6486887c9$export$830c053460e5ddf6 = Object.prototype.toString;
var $0980d0a6486887c9$export$1dccc787cc36538b = function(value) {
    return $0980d0a6486887c9$export$830c053460e5ddf6.call(value);
};
var $0980d0a6486887c9$export$53b83ca8eaab0383 = function(val) {
    return $0980d0a6486887c9$export$1dccc787cc36538b(val) === "[object Object]";
};
// for converting list and named values to displayed strings.
var $0980d0a6486887c9$export$b5b1545233b45293 = function(val) {
    return val == null ? "" : $0980d0a6486887c9$export$43bee75e5e14138e(val) || $0980d0a6486887c9$export$53b83ca8eaab0383(val) && val.toString === $0980d0a6486887c9$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
var $0980d0a6486887c9$var$RANGE = 2;
function $0980d0a6486887c9$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(var j = i - $0980d0a6486887c9$var$RANGE; j <= i + $0980d0a6486887c9$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(3 - String(line).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $0980d0a6486887c9$export$6f5e8f34570e3ad1() {
    var events = new Map();
    var emitter = {
        events: events,
        on: function(event, handler) {
            var handlers = events.get(event);
            var added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off: function(event, handler) {
            var handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function(event, payload) {
            (events.get(event) || []).slice().map(function(handler) {
                return handler(payload);
            });
            (events.get("*") || []).slice().map(function(handler) {
                return handler(event, payload);
            });
        }
    };
    return emitter;
}


/*!
  * core-base v9.2.0-beta.16
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $aYXpI = parcelRequire("aYXpI");

/*!
  * message-compiler v9.2.0-beta.16
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $ect5N = parcelRequire("ect5N");

var $e463640186f24986$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 15
};
var $e463640186f24986$var$_obj;
/** @internal */ var $e463640186f24986$export$d8bd0967cb58683 = ($e463640186f24986$var$_obj = {}, // tokenizer error messages
(0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.EXPECTED_TOKEN, "Expected token: '{0}'"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, "Invalid token in placeholder: '{0}'"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, "Unterminated single quote in placeholder"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, "Unknown escape sequence: \\{0}"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, "Invalid unicode escape sequence: {0}"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, "Unbalanced closing brace"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, "Unterminated closing brace"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.EMPTY_PLACEHOLDER, "Empty placeholder"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, "Not allowed nest placeholder"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.INVALID_LINKED_FORMAT, "Invalid linked format"), // parser error messages
(0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, "Plural must have messages"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, "Unexpected empty linked modifier"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, "Unexpected empty linked key"), (0, $ect5N._)($e463640186f24986$var$_obj, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, "Unexpected lexical analysis in token: '{0}'"), $e463640186f24986$var$_obj);
function $e463640186f24986$export$21efa8bb37d5fecb(code, loc) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var domain = options.domain, messages = options.messages, args = options.args;
    var msg = code;
    var error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $e463640186f24986$export$ad0eb2c702f03471(error) {
    throw error;
}
var $e463640186f24986$export$9ba8fa38cb18b1f3 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $e463640186f24986$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $e463640186f24986$export$90c043f1c57770b8(start, end, source) {
    var loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
var $e463640186f24986$var$CHAR_SP = " ";
var $e463640186f24986$var$CHAR_CR = "\r";
var $e463640186f24986$var$CHAR_LF = "\n";
var $e463640186f24986$var$CHAR_LS = String.fromCharCode(0x2028);
var $e463640186f24986$var$CHAR_PS = String.fromCharCode(0x2029);
function $e463640186f24986$var$createScanner(str) {
    var _buf = str;
    var _index = 0;
    var _line = 1;
    var _column = 1;
    var _peekOffset = 0;
    var isCRLF = function(index) {
        return _buf[index] === $e463640186f24986$var$CHAR_CR && _buf[index + 1] === $e463640186f24986$var$CHAR_LF;
    };
    var isLF = function(index) {
        return _buf[index] === $e463640186f24986$var$CHAR_LF;
    };
    var isPS = function(index) {
        return _buf[index] === $e463640186f24986$var$CHAR_PS;
    };
    var isLS = function(index) {
        return _buf[index] === $e463640186f24986$var$CHAR_LS;
    };
    var isLineEnd = function(index) {
        return isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    };
    var index = function() {
        return _index;
    };
    var line = function() {
        return _line;
    };
    var column = function() {
        return _column;
    };
    var peekOffset = function() {
        return _peekOffset;
    };
    var charAt = function(offset) {
        return isCRLF(offset) || isPS(offset) || isLS(offset) ? $e463640186f24986$var$CHAR_LF : _buf[offset];
    };
    var currentChar = function() {
        return charAt(_index);
    };
    var currentPeek = function() {
        return charAt(_index + _peekOffset);
    };
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        _peekOffset = offset;
    }
    function skipToPeek() {
        var target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
var $e463640186f24986$var$EOF = undefined;
var $e463640186f24986$var$LITERAL_DELIMITER = "'";
var $e463640186f24986$var$ERROR_DOMAIN$1 = "tokenizer";
function $e463640186f24986$var$createTokenizer(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var location = options.location !== false;
    var _scnr = $e463640186f24986$var$createScanner(source);
    var currentOffset = function() {
        return _scnr.index();
    };
    var currentPosition = function() {
        return $e463640186f24986$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    };
    var _initLoc = currentPosition();
    var _initOffset = currentOffset();
    var _context = {
        currentType: 14 /* EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    var context = function() {
        return _context;
    };
    var onError = options.onError;
    function emitError(code, pos, offset) {
        for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
            args[_key - 3] = arguments[_key];
        }
        var ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            var loc = $e463640186f24986$export$90c043f1c57770b8(ctx.startLoc, pos);
            var err = $e463640186f24986$export$21efa8bb37d5fecb(code, loc, {
                domain: $e463640186f24986$var$ERROR_DOMAIN$1,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        var token = {
            type: type
        };
        if (location) token.loc = $e463640186f24986$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    var getEndToken = function(context) {
        return getToken(context, 14 /* EOF */ );
    };
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($e463640186f24986$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    }
    function peekSpaces(scnr) {
        var buf = "";
        while(scnr.currentPeek() === $e463640186f24986$var$CHAR_SP || scnr.currentPeek() === $e463640186f24986$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        var buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $e463640186f24986$var$EOF) return false;
        var cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $e463640186f24986$var$EOF) return false;
        var cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        var ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        var ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        var ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === $e463640186f24986$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 8 /* LinkedAlias */ ) return false;
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === "." /* LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 9 /* LinkedDot */ ) return false;
        peekSpaces(scnr);
        var ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        var currentType = context.currentType;
        if (!(currentType === 8 /* LinkedAlias */  || currentType === 12 /* LinkedModifier */ )) return false;
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === ":" /* LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 10 /* LinkedDelimiter */ ) return false;
        var fn = function() {
            var ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* LinkedAlias */  || ch === "%" /* Modulo */  || ch === "|" /* Pipe */  || ch === ":" /* LinkedDelimiter */  || ch === "." /* LinkedDot */  || ch === $e463640186f24986$var$CHAR_SP || !ch) return false;
            else if (ch === $e463640186f24986$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isIdentifierStart(ch);
        };
        var ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === "|" /* Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function isTextStart(scnr) {
        var reset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var fn = function() {
            var hasSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, prev = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", detectModulo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */ ) return prev === "%" /* Modulo */  ? false : hasSpace;
            else if (ch === "@" /* LinkedAlias */  || !ch) return prev === "%" /* Modulo */  ? true : hasSpace;
            else if (ch === "%" /* Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* Modulo */ , true);
            } else if (ch === "|" /* Pipe */ ) return prev === "%" /* Modulo */  || detectModulo ? true : !(prev === $e463640186f24986$var$CHAR_SP || prev === $e463640186f24986$var$CHAR_LF);
            else if (ch === $e463640186f24986$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $e463640186f24986$var$CHAR_SP, detectModulo);
            } else if (ch === $e463640186f24986$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $e463640186f24986$var$CHAR_LF, detectModulo);
            } else return true;
        };
        var ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        var ch = scnr.currentChar();
        if (ch === $e463640186f24986$var$EOF) return $e463640186f24986$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function takeIdentifierChar(scnr) {
        var closure = function(ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 97 && cc <= 122 || // a-z
            cc >= 65 && cc <= 90 || // A-Z
            cc >= 48 && cc <= 57 || // 0-9
            cc === 95 || // _
            cc === 36 // $
            ;
        };
        return takeChar(scnr, closure);
    }
    function takeDigit(scnr) {
        var closure = function(ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57; // 0-9
        };
        return takeChar(scnr, closure);
    }
    function takeHexDigit(scnr) {
        var closure = function(ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57 || // 0-9
            cc >= 65 && cc <= 70 || // A-F
            cc >= 97 && cc <= 102; // a-f
        };
        return takeChar(scnr, closure);
    }
    function getDigits(scnr) {
        var ch = "";
        var num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readText(scnr) {
        var buf = "";
        while(true){
            var ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */  || ch === "}" /* BraceRight */  || ch === "@" /* LinkedAlias */  || ch === "|" /* Pipe */  || !ch) break;
            else if (ch === "%" /* Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $e463640186f24986$var$CHAR_SP || ch === $e463640186f24986$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        var ch = "";
        var name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $e463640186f24986$var$EOF) emitError($e463640186f24986$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        var value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += "-".concat(getDigits(scnr));
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $e463640186f24986$var$EOF) emitError($e463640186f24986$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        eat(scnr, "'");
        var ch = "";
        var literal = "";
        var fn = function(x) {
            return x !== $e463640186f24986$var$LITERAL_DELIMITER && x !== $e463640186f24986$var$CHAR_LF;
        };
        while(ch = takeChar(scnr, fn))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        var current = scnr.currentChar();
        if (current === $e463640186f24986$var$CHAR_LF || current === $e463640186f24986$var$EOF) {
            emitError($e463640186f24986$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $e463640186f24986$var$CHAR_LF) {
                scnr.next();
                eat(scnr, "'");
            }
            return literal;
        }
        eat(scnr, "'");
        return literal;
    }
    function readEscapeSequence(scnr) {
        var ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case "'":
                scnr.next();
                return "\\".concat(ch);
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($e463640186f24986$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        var sequence = "";
        for(var i = 0; i < digits; i++){
            var ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($e463640186f24986$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, "\\".concat(unicode).concat(sequence).concat(scnr.currentChar()));
                break;
            }
            sequence += ch;
        }
        return "\\".concat(unicode).concat(sequence);
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        var ch = "";
        var identifiers = "";
        var closure = function(ch) {
            return ch !== "{" /* BraceLeft */  && ch !== "}" /* BraceRight */  && ch !== $e463640186f24986$var$CHAR_SP && ch !== $e463640186f24986$var$CHAR_LF;
        };
        while(ch = takeChar(scnr, closure))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        var ch = "";
        var name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        var fn = function() {
            var detect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, buf = arguments.length > 1 ? arguments[1] : void 0;
            var ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */  || ch === "%" /* Modulo */  || ch === "@" /* LinkedAlias */  || ch === "|" /* Pipe */  || !ch) return buf;
            else if (ch === $e463640186f24986$var$CHAR_SP) return buf;
            else if (ch === $e463640186f24986$var$CHAR_LF) {
                buf += ch;
                scnr.next();
                return fn(detect, buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(true, buf);
            }
        };
        return fn(false, "");
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        var plural = eat(scnr, "|" /* Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        var token = null;
        var ch = scnr.currentChar();
        switch(ch){
            case "{" /* BraceLeft */ :
                if (context.braceNest >= 1) emitError($e463640186f24986$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* BraceLeft */ , "{" /* BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* BraceLeft */ ) emitError($e463640186f24986$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* BraceRight */ , "}" /* BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* LinkedAlias */ :
                if (context.braceNest > 0) emitError($e463640186f24986$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                var validNamedIdentifier = true;
                var validListIdentifier = true;
                var validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) emitError($e463640186f24986$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 && (context.currentType === 5 /* Named */  || context.currentType === 6 /* List */  || context.currentType === 7 /* Literal */ )) {
                    emitError($e463640186f24986$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                    token = getToken(context, 5 /* Named */ , readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                    token = getToken(context, 6 /* List */ , readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (validLiteral = isLiteralStart(scnr, context)) {
                    token = getToken(context, 7 /* Literal */ , readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 13 /* InvalidPlace */ , readInvalidIdentifier(scnr));
                    emitError($e463640186f24986$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        var currentType = context.currentType;
        var token = null;
        var ch = scnr.currentChar();
        if ((currentType === 8 /* LinkedAlias */  || currentType === 9 /* LinkedDot */  || currentType === 12 /* LinkedModifier */  || currentType === 10 /* LinkedDelimiter */ ) && (ch === $e463640186f24986$var$CHAR_LF || ch === $e463640186f24986$var$CHAR_SP)) emitError($e463640186f24986$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* LinkedAlias */ , "@" /* LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* LinkedDot */ , "." /* LinkedDot */ );
            case ":" /* LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* LinkedDelimiter */ , ":" /* LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* LinkedAlias */ ) emitError($e463640186f24986$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        var token = {
            type: 14 /* EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        var ch = scnr.currentChar();
        switch(ch){
            case "{" /* BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* BraceRight */ :
                emitError($e463640186f24986$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* BraceRight */ , "}" /* BraceRight */ );
            case "@" /* LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isTextStart(scnr)) return getToken(context, 0 /* Text */ , readText(scnr));
                if (ch === "%" /* Modulo */ ) {
                    scnr.next();
                    return getToken(context, 4 /* Modulo */ , "%" /* Modulo */ );
                }
                break;
        }
        return token;
    }
    function nextToken() {
        var currentType = _context.currentType, offset = _context.offset, startLoc = _context.startLoc, endLoc = _context.endLoc;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $e463640186f24986$var$EOF) return getToken(_context, 14 /* EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
var $e463640186f24986$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
var $e463640186f24986$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $e463640186f24986$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case "\\\\":
            return "\\";
        case "\\'":
            return "'";
        default:
            {
                var codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $e463640186f24986$export$88a1156fad04455f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var location = options.location !== false;
    var onError = options.onError;
    function emitError(tokenzer, code, start, offset) {
        for(var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
            args[_key - 4] = arguments[_key];
        }
        var end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            var loc = $e463640186f24986$export$90c043f1c57770b8(start, end);
            var err = $e463640186f24986$export$21efa8bb37d5fecb(code, loc, {
                domain: $e463640186f24986$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        var node = {
            type: type,
            start: offset,
            end: offset
        };
        if (location) node.loc = {
            start: loc,
            end: loc
        };
        return node;
    }
    function endNode(node, offset, pos, type) {
        node.end = offset;
        if (type) node.type = type;
        if (location && node.loc) node.loc.end = pos;
    }
    function parseText(tokenizer, value) {
        var context = tokenizer.context();
        var node = startNode(3 /* Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get brace left loc
        var node = startNode(5 /* List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get brace left loc
        var node = startNode(4 /* Named */ , offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get brace left loc
        var node = startNode(9 /* Literal */ , offset, loc);
        node.value = value.replace($e463640186f24986$var$KNOWN_ESCAPES, $e463640186f24986$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        var token = tokenizer.nextToken();
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get linked dot loc
        var node = startNode(8 /* LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        var context = tokenizer.context();
        var node = startNode(7 /* LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        var context = tokenizer.context();
        var linkedNode = startNode(6 /* Linked */ , context.offset, context.startLoc);
        var token = tokenizer.nextToken();
        if (token.type === 9 /* LinkedDot */ ) {
            var parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* LinkedDelimiter */ ) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* Named */ :
                if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* List */ :
                if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* Literal */ :
                if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                // empty key
                emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                var nextContext = tokenizer.context();
                var emptyLinkedKeyNode = startNode(7 /* LinkedKey */ , nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = "";
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        var context = tokenizer.context();
        var startOffset = context.currentType === 1 /* Pipe */  ? tokenizer.currentOffset() : context.offset;
        var startLoc = context.currentType === 1 /* Pipe */  ? context.endLoc : context.startLoc;
        var node = startNode(2 /* Message */ , startOffset, startLoc);
        node.items = [];
        var nextToken = null;
        do {
            var token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* Text */ :
                    if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* List */ :
                    if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 5 /* Named */ :
                    if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || ""));
                    break;
                case 7 /* Literal */ :
                    if (token.value == null) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $e463640186f24986$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* LinkedAlias */ :
                    var parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
            }
        }while (context.currentType !== 14 /* EOF */  && context.currentType !== 1 /* Pipe */ );
        // adjust message node loc
        var endOffset = context.currentType === 1 /* Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        var endLoc = context.currentType === 1 /* Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        var context = tokenizer.context();
        var hasEmptyMessage = msgNode.items.length === 0;
        var node = startNode(1 /* Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            var msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        var context = tokenizer.context();
        var offset = context.offset, startLoc = context.startLoc;
        var msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        var tokenizer = $e463640186f24986$var$createTokenizer(source, (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, options));
        var context = tokenizer.context();
        var node = startNode(0 /* Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* EOF */ ) emitError(tokenizer, $e463640186f24986$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $e463640186f24986$var$getTokenCaption(token) {
    if (token.type === 14 /* EOF */ ) return "EOF";
    var name = (token.value || "").replace(RegExp("\\r?\\n", "gu"), "\\n");
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $e463640186f24986$var$createTransformer(ast) {
    var options = arguments.length > 1 && arguments[1] !== void 0 // eslint-disable-line
     ? arguments[1] : {};
    var _context = {
        ast: ast,
        helpers: new Set()
    };
    var context = function() {
        return _context;
    };
    var helper = function(name) {
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $e463640186f24986$var$traverseNodes(nodes, transformer) {
    for(var i = 0; i < nodes.length; i++)$e463640186f24986$var$traverseNode(nodes[i], transformer);
}
function $e463640186f24986$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* Plural */ :
            $e463640186f24986$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* PLURAL */ );
            break;
        case 2 /* Message */ :
            $e463640186f24986$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* Linked */ :
            var linked = node;
            $e463640186f24986$var$traverseNode(linked.key, transformer);
            transformer.helper("linked" /* LINKED */ );
            break;
        case 5 /* List */ :
            transformer.helper("interpolate" /* INTERPOLATE */ );
            transformer.helper("list" /* LIST */ );
            break;
        case 4 /* Named */ :
            transformer.helper("interpolate" /* INTERPOLATE */ );
            transformer.helper("named" /* NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $e463640186f24986$var$transform(ast) {
    var options = arguments.length > 1 && arguments[1] !== void 0 // eslint-disable-line
     ? arguments[1] : {};
    var transformer = $e463640186f24986$var$createTransformer(ast);
    transformer.helper("normalize" /* NORMALIZE */ );
    // traverse
    ast.body && $e463640186f24986$var$traverseNode(ast.body, transformer);
    // set meta information
    var context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $e463640186f24986$var$createCodeGenerator(ast, options) {
    var sourceMap = options.sourceMap, filename = options.filename, breakLineCode = options.breakLineCode, _needIndent = options.needIndent;
    var _context = {
        source: ast.loc.source,
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    var context = function() {
        return _context;
    };
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n) {
        var withBreakLine = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + "  ".repeat(n) : _breakLineCode);
    }
    function indent() {
        var withNewLine = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent() {
        var withNewLine = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    var helper = function(key) {
        return "_".concat(key);
    };
    var needIndent = function() {
        return _context.needIndent;
    };
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $e463640186f24986$var$generateLinkedNode(generator, node) {
    var helper = generator.helper;
    generator.push("".concat(helper("linked" /* LINKED */ ), "("));
    $e463640186f24986$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(", ");
        $e463640186f24986$var$generateNode(generator, node.modifier);
    }
    generator.push(")");
}
function $e463640186f24986$var$generateMessageNode(generator, node) {
    var helper = generator.helper, needIndent = generator.needIndent;
    generator.push("".concat(helper("normalize" /* NORMALIZE */ ), "(["));
    generator.indent(needIndent());
    var length = node.items.length;
    for(var i = 0; i < length; i++){
        $e463640186f24986$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $e463640186f24986$var$generatePluralNode(generator, node) {
    var helper = generator.helper, needIndent = generator.needIndent;
    if (node.cases.length > 1) {
        generator.push("".concat(helper("plural" /* PLURAL */ ), "(["));
        generator.indent(needIndent());
        var length = node.cases.length;
        for(var i = 0; i < length; i++){
            $e463640186f24986$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push("])");
    }
}
function $e463640186f24986$var$generateResource(generator, node) {
    if (node.body) $e463640186f24986$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $e463640186f24986$var$generateNode(generator, node) {
    var helper = generator.helper;
    switch(node.type){
        case 0 /* Resource */ :
            $e463640186f24986$var$generateResource(generator, node);
            break;
        case 1 /* Plural */ :
            $e463640186f24986$var$generatePluralNode(generator, node);
            break;
        case 2 /* Message */ :
            $e463640186f24986$var$generateMessageNode(generator, node);
            break;
        case 6 /* Linked */ :
            $e463640186f24986$var$generateLinkedNode(generator, node);
            break;
        case 8 /* LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* List */ :
            generator.push("".concat(helper("interpolate" /* INTERPOLATE */ ), "(").concat(helper("list" /* LIST */ ), "(").concat(node.index, "))"), node);
            break;
        case 4 /* Named */ :
            generator.push("".concat(helper("interpolate" /* INTERPOLATE */ ), "(").concat(helper("named" /* NAMED */ ), "(").concat(JSON.stringify(node.key), "))"), node);
            break;
        case 9 /* Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
var $e463640186f24986$var$generate = function(ast) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {} // eslint-disable-line
    ;
    var mode = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.mode) ? options.mode : "normal";
    var filename = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.filename) ? options.filename : "message.intl";
    var sourceMap = !!options.sourceMap;
    // prettier-ignore
    var breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    var needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    var helpers = ast.helpers || [];
    var generator = $e463640186f24986$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {");
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push("const { ".concat(helpers.map(function(s) {
            return "".concat(s, ": _").concat(s);
        }).join(", "), " } = ctx"));
        generator.newline();
    }
    generator.push("return ");
    $e463640186f24986$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push("}");
    var _generator_context = generator.context(), code = _generator_context.code, map = _generator_context.map;
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $e463640186f24986$export$3243579822c486a0(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var assignedOptions = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, options);
    // parse source codes
    var parser = $e463640186f24986$export$88a1156fad04455f(assignedOptions);
    var ast = parser.parse(source);
    // transform ASTs
    $e463640186f24986$var$transform(ast, assignedOptions);
    // generate javascript codes
    return $e463640186f24986$var$generate(ast, assignedOptions);
}


/*!
  * devtools-if v9.2.0-beta.16
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */ var $bc4c49435812e0c2$export$2058f72d18e5183a = {
    I18nInit: "i18n:init",
    FunctionTranslate: "function:translate"
};


var $5798ec4acd8ca2ee$var$pathStateMachine = [];
var $5798ec4acd8ca2ee$var$_obj;
$5798ec4acd8ca2ee$var$pathStateMachine[0 /* BEFORE_PATH */ ] = ($5798ec4acd8ca2ee$var$_obj = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj, "w" /* WORKSPACE */ , [
    0 /* BEFORE_PATH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj, "i" /* IDENT */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj, "o" /* END_OF_FAIL */ , [
    7 /* AFTER_PATH */ 
]), $5798ec4acd8ca2ee$var$_obj);
var $5798ec4acd8ca2ee$var$_obj1;
$5798ec4acd8ca2ee$var$pathStateMachine[1 /* IN_PATH */ ] = ($5798ec4acd8ca2ee$var$_obj1 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj1, "w" /* WORKSPACE */ , [
    1 /* IN_PATH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj1, "." /* DOT */ , [
    2 /* BEFORE_IDENT */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj1, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj1, "o" /* END_OF_FAIL */ , [
    7 /* AFTER_PATH */ 
]), $5798ec4acd8ca2ee$var$_obj1);
var $5798ec4acd8ca2ee$var$_obj2;
$5798ec4acd8ca2ee$var$pathStateMachine[2 /* BEFORE_IDENT */ ] = ($5798ec4acd8ca2ee$var$_obj2 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj2, "w" /* WORKSPACE */ , [
    2 /* BEFORE_IDENT */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj2, "i" /* IDENT */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj2, "0" /* ZERO */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), $5798ec4acd8ca2ee$var$_obj2);
var $5798ec4acd8ca2ee$var$_obj3;
$5798ec4acd8ca2ee$var$pathStateMachine[3 /* IN_IDENT */ ] = ($5798ec4acd8ca2ee$var$_obj3 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj3, "i" /* IDENT */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj3, "0" /* ZERO */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj3, "w" /* WORKSPACE */ , [
    1 /* IN_PATH */ ,
    1 /* PUSH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj3, "." /* DOT */ , [
    2 /* BEFORE_IDENT */ ,
    1 /* PUSH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj3, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ ,
    1 /* PUSH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj3, "o" /* END_OF_FAIL */ , [
    7 /* AFTER_PATH */ ,
    1 /* PUSH */ 
]), $5798ec4acd8ca2ee$var$_obj3);
var $5798ec4acd8ca2ee$var$_obj4;
$5798ec4acd8ca2ee$var$pathStateMachine[4 /* IN_SUB_PATH */ ] = ($5798ec4acd8ca2ee$var$_obj4 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj4, "'" /* SINGLE_QUOTE */ , [
    5 /* IN_SINGLE_QUOTE */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj4, '"' /* DOUBLE_QUOTE */ , [
    6 /* IN_DOUBLE_QUOTE */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj4, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ ,
    2 /* INC_SUB_PATH_DEPTH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj4, "]" /* RIGHT_BRACKET */ , [
    1 /* IN_PATH */ ,
    3 /* PUSH_SUB_PATH */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj4, "o" /* END_OF_FAIL */ , 8 /* ERROR */ ), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj4, "l" /* ELSE */ , [
    4 /* IN_SUB_PATH */ ,
    0 /* APPEND */ 
]), $5798ec4acd8ca2ee$var$_obj4);
var $5798ec4acd8ca2ee$var$_obj5;
$5798ec4acd8ca2ee$var$pathStateMachine[5 /* IN_SINGLE_QUOTE */ ] = ($5798ec4acd8ca2ee$var$_obj5 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj5, "'" /* SINGLE_QUOTE */ , [
    4 /* IN_SUB_PATH */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj5, "o" /* END_OF_FAIL */ , 8 /* ERROR */ ), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj5, "l" /* ELSE */ , [
    5 /* IN_SINGLE_QUOTE */ ,
    0 /* APPEND */ 
]), $5798ec4acd8ca2ee$var$_obj5);
var $5798ec4acd8ca2ee$var$_obj6;
$5798ec4acd8ca2ee$var$pathStateMachine[6 /* IN_DOUBLE_QUOTE */ ] = ($5798ec4acd8ca2ee$var$_obj6 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj6, '"' /* DOUBLE_QUOTE */ , [
    4 /* IN_SUB_PATH */ ,
    0 /* APPEND */ 
]), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj6, "o" /* END_OF_FAIL */ , 8 /* ERROR */ ), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj6, "l" /* ELSE */ , [
    6 /* IN_DOUBLE_QUOTE */ ,
    0 /* APPEND */ 
]), $5798ec4acd8ca2ee$var$_obj6);
/**
 * Check if an expression is a literal value.
 */ var $5798ec4acd8ca2ee$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $5798ec4acd8ca2ee$var$isLiteral(exp) {
    return $5798ec4acd8ca2ee$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $5798ec4acd8ca2ee$var$stripQuotes(str) {
    var a = str.charCodeAt(0);
    var b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $5798ec4acd8ca2ee$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* END_OF_FAIL */ ;
    var code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* WORKSPACE */ ;
    }
    return "i" /* IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $5798ec4acd8ca2ee$var$formatSubPath(path) {
    var trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $5798ec4acd8ca2ee$var$isLiteral(trimmed) ? $5798ec4acd8ca2ee$var$stripQuotes(trimmed) : "*" /* ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $5798ec4acd8ca2ee$export$98e6a39c04603d36(path) {
    var keys = [];
    var index = -1;
    var mode = 0 /* BEFORE_PATH */ ;
    var subPathDepth = 0;
    var c;
    var key; // eslint-disable-line
    var newChar;
    var type;
    var transition;
    var action;
    var typeMap;
    var actions = [];
    actions[0 /* APPEND */ ] = function() {
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* PUSH */ ] = function() {
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* INC_SUB_PATH_DEPTH */ ] = function() {
        actions[0 /* APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* PUSH_SUB_PATH */ ] = function() {
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* IN_SUB_PATH */ ;
            actions[0 /* APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $5798ec4acd8ca2ee$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        var nextChar = path[index + 1];
        if (mode === 5 /* IN_SINGLE_QUOTE */  && nextChar === "'" /* SINGLE_QUOTE */  || mode === 6 /* IN_DOUBLE_QUOTE */  && nextChar === '"' /* DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $5798ec4acd8ca2ee$var$getPathCharType(c);
        typeMap = $5798ec4acd8ca2ee$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* ELSE */ ] || 8 /* ERROR */ ;
        // check parse error
        if (transition === 8 /* ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* AFTER_PATH */ ) return keys;
    }
}
// path token cache
var $5798ec4acd8ca2ee$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $5798ec4acd8ca2ee$export$b365de4c3506886c(obj, path) {
    return (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $5798ec4acd8ca2ee$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(obj)) return null;
    // parse path
    var hit = $5798ec4acd8ca2ee$var$cache.get(path);
    if (!hit) {
        hit = $5798ec4acd8ca2ee$export$98e6a39c04603d36(path);
        if (hit) $5798ec4acd8ca2ee$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    var len = hit.length;
    var last = obj;
    var i = 0;
    while(i < len){
        var val = last[hit[i]];
        if (val === undefined) return null;
        last = val;
        i++;
    }
    return last;
}
var $5798ec4acd8ca2ee$var$DEFAULT_MODIFIER = function(str) {
    return str;
};
var $5798ec4acd8ca2ee$var$DEFAULT_MESSAGE = function(ctx) {
    return "";
}; // eslint-disable-line
var $5798ec4acd8ca2ee$export$12b53af6b8529bfc = "text";
var $5798ec4acd8ca2ee$var$DEFAULT_NORMALIZE = function(values) {
    return values.length === 0 ? "" : values.join("");
};
var $5798ec4acd8ca2ee$var$DEFAULT_INTERPOLATE = (0, $0980d0a6486887c9$export$b5b1545233b45293);
function $5798ec4acd8ca2ee$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $5798ec4acd8ca2ee$var$getPluralIndex(options) {
    // prettier-ignore
    var index = (0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.named.count) || (0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.named.n)) ? (0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.named.count) ? options.named.count : (0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.named.n) ? options.named.n : index : index;
}
function $5798ec4acd8ca2ee$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $5798ec4acd8ca2ee$export$70de3b14beda2f5e() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var locale = options.locale;
    var pluralIndex = $5798ec4acd8ca2ee$var$getPluralIndex(options);
    var pluralRule = (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $0980d0a6486887c9$export$844ec244b1367d54)(locale) && (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? options.pluralRules[locale] : $5798ec4acd8ca2ee$var$pluralDefault;
    var orgPluralRule = (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $0980d0a6486887c9$export$844ec244b1367d54)(locale) && (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? $5798ec4acd8ca2ee$var$pluralDefault : undefined;
    var plural = function(messages) {
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    var _list = options.list || [];
    var list = function(index) {
        return _list[index];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _named = options.named || {};
    (0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.pluralIndex) && $5798ec4acd8ca2ee$var$normalizeNamed(pluralIndex, _named);
    var named = function(key) {
        return _named[key];
    };
    // TODO: need to design resolve message function?
    function message(key) {
        // prettier-ignore
        var msg = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.messages) ? options.messages(key) : (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $5798ec4acd8ca2ee$var$DEFAULT_MESSAGE : msg;
    }
    var _modifier = function(name) {
        return options.modifiers ? options.modifiers[name] : $5798ec4acd8ca2ee$var$DEFAULT_MODIFIER;
    };
    var normalize = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.processor) && (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.processor.normalize) ? options.processor.normalize : $5798ec4acd8ca2ee$var$DEFAULT_NORMALIZE;
    var interpolate = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.processor) && (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.processor.interpolate) ? options.processor.interpolate : $5798ec4acd8ca2ee$var$DEFAULT_INTERPOLATE;
    var type = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.processor) && (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.processor.type) ? options.processor.type : $5798ec4acd8ca2ee$export$12b53af6b8529bfc;
    var _obj;
    var ctx = (_obj = {}, (0, $ect5N._)(_obj, "list" /* LIST */ , list), (0, $ect5N._)(_obj, "named" /* NAMED */ , named), (0, $ect5N._)(_obj, "plural" /* PLURAL */ , plural), (0, $ect5N._)(_obj, "linked" /* LINKED */ , function(key, modifier) {
        // TODO: should check `key`
        var msg = message(key)(ctx);
        return (0, $0980d0a6486887c9$export$844ec244b1367d54)(modifier) ? _modifier(modifier)(msg) : msg;
    }), (0, $ect5N._)(_obj, "message" /* MESSAGE */ , message), (0, $ect5N._)(_obj, "type" /* TYPE */ , type), (0, $ect5N._)(_obj, "interpolate" /* INTERPOLATE */ , interpolate), (0, $ect5N._)(_obj, "normalize" /* NORMALIZE */ , normalize), _obj);
    return ctx;
}
var $5798ec4acd8ca2ee$var$devtools = null;
function $5798ec4acd8ca2ee$export$c893d6c8966908b9(hook) {
    $5798ec4acd8ca2ee$var$devtools = hook;
}
function $5798ec4acd8ca2ee$export$8bd08e70642dc6f4() {
    return $5798ec4acd8ca2ee$var$devtools;
}
function $5798ec4acd8ca2ee$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $5798ec4acd8ca2ee$var$devtools && $5798ec4acd8ca2ee$var$devtools.emit((0, $bc4c49435812e0c2$export$2058f72d18e5183a).I18nInit, {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
var $5798ec4acd8ca2ee$export$190d71a47ff3f767 = /* #__PURE__*/ $5798ec4acd8ca2ee$var$createDevToolsHook((0, $bc4c49435812e0c2$export$2058f72d18e5183a).FunctionTranslate);
function $5798ec4acd8ca2ee$var$createDevToolsHook(hook) {
    return function(payloads) {
        return $5798ec4acd8ca2ee$var$devtools && $5798ec4acd8ca2ee$var$devtools.emit(hook, payloads);
    };
}
var $5798ec4acd8ca2ee$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    __EXTEND_POINT__: 7
};
var $5798ec4acd8ca2ee$var$_obj7;
/** @internal */ var $5798ec4acd8ca2ee$var$warnMessages = ($5798ec4acd8ca2ee$var$_obj7 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj7, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8.NOT_FOUND_KEY, "Not found '{key}' key in '{locale}' locale messages."), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj7, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE, "Fall back to translate '{key}' key with '{target}' locale."), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj7, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER, "Cannot format a number value due to not supported Intl.NumberFormat."), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj7, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT, "Fall back to number format '{key}' key with '{target}' locale."), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj7, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE, "Cannot format a date value due to not supported Intl.DateTimeFormat."), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj7, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT, "Fall back to datetime format '{key}' key with '{target}' locale."), $5798ec4acd8ca2ee$var$_obj7);
function $5798ec4acd8ca2ee$export$ae7a7631f2b2bb7(code) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $0980d0a6486887c9$export$d9468344d3651243).apply(void 0, [
        $5798ec4acd8ca2ee$var$warnMessages[code]
    ].concat((0, $aYXpI._)(args)));
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $5798ec4acd8ca2ee$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return (0, $aYXpI._)(new Set([
        start
    ].concat((0, $aYXpI._)((0, $0980d0a6486887c9$export$43bee75e5e14138e)(fallback) ? fallback : (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(fallback) ? Object.keys(fallback) : (0, $0980d0a6486887c9$export$844ec244b1367d54)(fallback) ? [
        fallback
    ] : [
        start
    ]))));
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $5798ec4acd8ca2ee$export$71df9db82dc445(ctx, fallback, start) {
    var startLocale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(start) ? start : $5798ec4acd8ca2ee$export$1af4c7e47ad72f44;
    var context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    var chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        var block = [
            start
        ];
        // while any intervening block found
        while((0, $0980d0a6486887c9$export$43bee75e5e14138e)(block))block = $5798ec4acd8ca2ee$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        var defaults = (0, $0980d0a6486887c9$export$43bee75e5e14138e)(fallback) || !(0, $0980d0a6486887c9$export$53b83ca8eaab0383)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $0980d0a6486887c9$export$844ec244b1367d54)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(block)) $5798ec4acd8ca2ee$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $5798ec4acd8ca2ee$var$appendBlockToChain(chain, block, blocks) {
    var follow = true;
    for(var i = 0; i < block.length && (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(follow); i++){
        var locale = block[i];
        if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(locale)) follow = $5798ec4acd8ca2ee$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $5798ec4acd8ca2ee$var$appendLocaleToChain(chain, locale, blocks) {
    var follow;
    var tokens = locale.split("-");
    do {
        var target = tokens.join("-");
        follow = $5798ec4acd8ca2ee$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $5798ec4acd8ca2ee$var$appendItemToChain(chain, target, blocks) {
    var follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            var locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $0980d0a6486887c9$export$43bee75e5e14138e)(blocks) || (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ var $5798ec4acd8ca2ee$export$a4ad2735b021c132 = "9.2.0-beta.16";
var $5798ec4acd8ca2ee$export$b7f13a18d1d0f835 = -1;
var $5798ec4acd8ca2ee$export$1af4c7e47ad72f44 = "en-US";
var $5798ec4acd8ca2ee$export$a04371e9dbb3870b = "";
function $5798ec4acd8ca2ee$var$getDefaultLinkedModifiers() {
    return {
        upper: function(val) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val) ? val.toUpperCase() : val;
        },
        lower: function(val) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val) ? val.toLowerCase() : val;
        },
        // prettier-ignore
        capitalize: function(val) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val) ? "".concat(val.charAt(0).toLocaleUpperCase()).concat(val.substr(1)) : val;
        }
    };
}
var $5798ec4acd8ca2ee$var$_compiler;
function $5798ec4acd8ca2ee$export$6ee2fbe83628b40b(compiler) {
    $5798ec4acd8ca2ee$var$_compiler = compiler;
}
var $5798ec4acd8ca2ee$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $5798ec4acd8ca2ee$export$45dacdc710815463(resolver) {
    $5798ec4acd8ca2ee$var$_resolver = resolver;
}
var $5798ec4acd8ca2ee$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $5798ec4acd8ca2ee$export$fd8ec9dd8067edec(fallbacker) {
    $5798ec4acd8ca2ee$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
var $5798ec4acd8ca2ee$var$_additionalMeta = null;
var $5798ec4acd8ca2ee$export$605703447dca72aa = function(meta) {
    $5798ec4acd8ca2ee$var$_additionalMeta = meta;
};
var $5798ec4acd8ca2ee$export$817795a14e5c6622 = function() {
    return $5798ec4acd8ca2ee$var$_additionalMeta;
};
// ID for CoreContext
var $5798ec4acd8ca2ee$var$_cid = 0;
function $5798ec4acd8ca2ee$export$3599d465b05a74a5() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // setup options
    var version = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.version) ? options.version : $5798ec4acd8ca2ee$export$a4ad2735b021c132;
    var locale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.locale) ? options.locale : $5798ec4acd8ca2ee$export$1af4c7e47ad72f44;
    var fallbackLocale = (0, $0980d0a6486887c9$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.fallbackLocale) || (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    var messages = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.messages) ? options.messages : (0, $ect5N._)({}, locale, {});
    var datetimeFormats = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : (0, $ect5N._)({}, locale, {});
    var numberFormats = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : (0, $ect5N._)({}, locale, {});
    var modifiers = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, options.modifiers || {}, $5798ec4acd8ca2ee$var$getDefaultLinkedModifiers());
    var pluralRules = options.pluralRules || {};
    var missing = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    var missingWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $0980d0a6486887c9$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    var fallbackWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $0980d0a6486887c9$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    var fallbackFormat = !!options.fallbackFormat;
    var unresolving = !!options.unresolving;
    var postTranslation = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    var processor = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.processor) ? options.processor : null;
    var warnHtmlMessage = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    var escapeParameter = !!options.escapeParameter;
    var messageCompiler = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.messageCompiler) ? options.messageCompiler : $5798ec4acd8ca2ee$var$_compiler;
    var messageResolver = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.messageResolver) ? options.messageResolver : $5798ec4acd8ca2ee$var$_resolver || $5798ec4acd8ca2ee$export$b365de4c3506886c;
    var localeFallbacker = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.localeFallbacker) ? options.localeFallbacker : $5798ec4acd8ca2ee$var$_fallbacker || $5798ec4acd8ca2ee$export$e3330076537ef9d1;
    var onWarn = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.onWarn) ? options.onWarn : (0, $0980d0a6486887c9$export$c106dd0671a0fc2d);
    // setup internal options
    var internalOptions = options;
    var __datetimeFormatters = (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    var __numberFormatters = (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    var __meta = (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(internalOptions.__meta) ? internalOptions.__meta : {};
    $5798ec4acd8ca2ee$var$_cid++;
    var context = {
        version: version,
        cid: $5798ec4acd8ca2ee$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $5798ec4acd8ca2ee$export$725afc6a300324a0(context, version, __meta);
    return context;
}
/** @internal */ function $5798ec4acd8ca2ee$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $5798ec4acd8ca2ee$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $5798ec4acd8ca2ee$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    var missing = context.missing, onWarn = context.onWarn;
    if (missing !== null) {
        var ret = missing(context, locale, key, type);
        return (0, $0980d0a6486887c9$export$844ec244b1367d54)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $5798ec4acd8ca2ee$export$c743ad8a3cc01530(ctx, locale, fallback) {
    var context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ var $5798ec4acd8ca2ee$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
var $5798ec4acd8ca2ee$var$WARN_MESSAGE = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function $5798ec4acd8ca2ee$var$checkHtmlMessage(source, options) {
    var warnHtmlMessage = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    if (warnHtmlMessage && $5798ec4acd8ca2ee$var$RE_HTML_TAG.test(source)) (0, $0980d0a6486887c9$export$c106dd0671a0fc2d)((0, $0980d0a6486887c9$export$d9468344d3651243)($5798ec4acd8ca2ee$var$WARN_MESSAGE, {
        source: source
    }));
}
var $5798ec4acd8ca2ee$var$defaultOnCacheKey = function(source) {
    return source;
};
var $5798ec4acd8ca2ee$var$compileCache = Object.create(null);
function $5798ec4acd8ca2ee$export$2683c80ae3fe544() {
    $5798ec4acd8ca2ee$var$compileCache = Object.create(null);
}
function $5798ec4acd8ca2ee$export$1ea8807c727891fc(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    {
        // check caches
        var onCacheKey = options.onCacheKey || $5798ec4acd8ca2ee$var$defaultOnCacheKey;
        var key = onCacheKey(source);
        var cached = $5798ec4acd8ca2ee$var$compileCache[key];
        if (cached) return cached;
        // compile error detecting
        var occurred = false;
        var onError = options.onError || (0, $e463640186f24986$export$ad0eb2c702f03471);
        options.onError = function(err) {
            occurred = true;
            onError(err);
        };
        // compile
        var code = (0, $e463640186f24986$export$3243579822c486a0)(source, options).code;
        // evaluate function
        var msg = new Function("return ".concat(code))();
        // if occurred compile error, don't cache
        return !occurred ? $5798ec4acd8ca2ee$var$compileCache[key] = msg : msg;
    }
}
var $5798ec4acd8ca2ee$var$code = (0, $e463640186f24986$export$77436aae039469c4).__EXTEND_POINT__;
var $5798ec4acd8ca2ee$var$inc = function() {
    return $5798ec4acd8ca2ee$var$code++;
};
var $5798ec4acd8ca2ee$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $5798ec4acd8ca2ee$var$code,
    INVALID_DATE_ARGUMENT: $5798ec4acd8ca2ee$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $5798ec4acd8ca2ee$var$inc(),
    __EXTEND_POINT__: $5798ec4acd8ca2ee$var$inc() // 18
};
function $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b(code) {
    return (0, $e463640186f24986$export$21efa8bb37d5fecb)(code, null, undefined);
}
var $5798ec4acd8ca2ee$var$_obj8;
/** @internal */ var $5798ec4acd8ca2ee$var$errorMessages = ($5798ec4acd8ca2ee$var$_obj8 = {}, (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj8, $5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ARGUMENT, "Invalid arguments"), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj8, $5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT, "The date provided is an invalid Date object.Make sure your Date represents a valid date."), (0, $ect5N._)($5798ec4acd8ca2ee$var$_obj8, $5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT, "The argument provided is not a valid ISO date string"), $5798ec4acd8ca2ee$var$_obj8);
var $5798ec4acd8ca2ee$var$NOOP_MESSAGE_FUNCTION = function() {
    return "";
};
var $5798ec4acd8ca2ee$export$92c0a039cf358271 = function(val) {
    return (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(val);
};
// implementation of `translate` function
function $5798ec4acd8ca2ee$export$d73ee8ef04f5226a(context) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var fallbackFormat = context.fallbackFormat, postTranslation = context.postTranslation, unresolving = context.unresolving, fallbackLocale = context.fallbackLocale, messages = context.messages;
    var _parseTranslateArgs_apply = (0, $fGQt0._)($5798ec4acd8ca2ee$export$8d9616744e22681a.apply(void 0, (0, $aYXpI._)(args)), 2), key = _parseTranslateArgs_apply[0], options = _parseTranslateArgs_apply[1];
    var missingWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    var fallbackWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    var escapeParameter = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    var resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    var defaultMsgOrKey = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.default) || (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.default) // default by function option
     ? !(0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.default) ? options.default : key : fallbackFormat // default by `fallbackFormat` option
     ? key : "";
    var enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    var locale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    // escape params
    escapeParameter && $5798ec4acd8ca2ee$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    var _ref = (0, $fGQt0._)(!resolvedMessage ? $5798ec4acd8ca2ee$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || {}
    ], 3), formatScope = _ref[0], targetLocale = _ref[1], message = _ref[2];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    var format = formatScope;
    // if you use default message, set it as message format!
    var cacheBaseKey = key;
    if (!resolvedMessage && !((0, $0980d0a6486887c9$export$844ec244b1367d54)(format) || $5798ec4acd8ca2ee$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $0980d0a6486887c9$export$844ec244b1367d54)(format) || $5798ec4acd8ca2ee$export$92c0a039cf358271(format)) || !(0, $0980d0a6486887c9$export$844ec244b1367d54)(targetLocale))) return unresolving ? $5798ec4acd8ca2ee$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    var occurred = false;
    var errorDetector = function() {
        occurred = true;
    };
    // compile message format
    var msg = !$5798ec4acd8ca2ee$export$92c0a039cf358271(format) ? $5798ec4acd8ca2ee$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    var ctxOptions = $5798ec4acd8ca2ee$var$getMessageContextOptions(context, targetLocale, message, options);
    var msgContext = $5798ec4acd8ca2ee$export$70de3b14beda2f5e(ctxOptions);
    var messaged = $5798ec4acd8ca2ee$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    var ret = postTranslation ? postTranslation(messaged) : messaged;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        var payloads = {
            timestamp: Date.now(),
            key: (0, $0980d0a6486887c9$export$844ec244b1367d54)(key) ? key : $5798ec4acd8ca2ee$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($5798ec4acd8ca2ee$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $0980d0a6486887c9$export$844ec244b1367d54)(format) ? format : $5798ec4acd8ca2ee$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, context.__meta, $5798ec4acd8ca2ee$export$817795a14e5c6622() || {});
        $5798ec4acd8ca2ee$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $5798ec4acd8ca2ee$var$escapeParams(options) {
    if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(options.list)) options.list = options.list.map(function(item) {
        return (0, $0980d0a6486887c9$export$844ec244b1367d54)(item) ? (0, $0980d0a6486887c9$export$4cf11838cdc2a8a8)(item) : item;
    });
    else if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.named)) Object.keys(options.named).forEach(function(key) {
        if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(options.named[key])) options.named[key] = (0, $0980d0a6486887c9$export$4cf11838cdc2a8a8)(options.named[key]);
    });
}
function $5798ec4acd8ca2ee$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    var messages = context.messages, onWarn = context.onWarn, resolveValue = context.messageResolver, localeFallbacker = context.localeFallbacker;
    var locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    var message = {};
    var targetLocale;
    var format = null;
    var from = locale;
    var to = null;
    var type = "translate";
    for(var i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || {};
        // for vue-devtools timeline event
        var start = null;
        var startTag = void 0;
        var endTag = void 0;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(format) || (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(format)) break;
        var missingRet = $5798ec4acd8ca2ee$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
        if (missingRet !== key) format = missingRet;
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $5798ec4acd8ca2ee$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) {
    var messageCompiler = context.messageCompiler, warnHtmlMessage = context.warnHtmlMessage;
    if ($5798ec4acd8ca2ee$export$92c0a039cf358271(format)) {
        var msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    // for vue-devtools timeline event
    var start = null;
    var startTag;
    var endTag;
    var msg1 = messageCompiler(format, $5798ec4acd8ca2ee$var$getCompileOptions(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, errorDetector));
    msg1.locale = targetLocale;
    msg1.key = key;
    msg1.source = format;
    return msg1;
}
function $5798ec4acd8ca2ee$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    var start = null;
    var startTag;
    var endTag;
    var messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $5798ec4acd8ca2ee$export$8d9616744e22681a() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $fGQt0._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
    var options = {};
    if (!(0, $0980d0a6486887c9$export$844ec244b1367d54)(arg1) && !(0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg1) && !$5798ec4acd8ca2ee$export$92c0a039cf358271(arg1)) throw $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b($5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    var key = (0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg1) ? String(arg1) : $5798ec4acd8ca2ee$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
    else if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg2)) options.default = arg2;
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg2) && !(0, $0980d0a6486887c9$export$83b788b1a3698c03)(arg2)) options.named = arg2;
    else if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(arg2)) options.list = arg2;
    if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg3)) options.plural = arg3;
    else if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg3)) options.default = arg3;
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg3)) (0, $0980d0a6486887c9$export$e6e34fd1f2686227)(options, arg3);
    return [
        key,
        options
    ];
}
function $5798ec4acd8ca2ee$var$getCompileOptions(context, locale, key, source, warnHtmlMessage, errorDetector) {
    return {
        warnHtmlMessage: warnHtmlMessage,
        onError: function(err) {
            errorDetector && errorDetector(err);
            throw err;
        },
        onCacheKey: function(source) {
            return (0, $0980d0a6486887c9$export$5024ef1f92c9a364)(locale, key, source);
        }
    };
}
function $5798ec4acd8ca2ee$var$getMessageContextOptions(context, locale, message, options) {
    var modifiers = context.modifiers, pluralRules = context.pluralRules, resolveValue = context.messageResolver;
    var resolveMessage = function(key) {
        var val = resolveValue(message, key);
        if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(val)) {
            var occurred = false;
            var errorDetector = function() {
                occurred = true;
            };
            var msg = $5798ec4acd8ca2ee$var$compileMessageFormat(context, key, locale, val, key, errorDetector);
            return !occurred ? msg : $5798ec4acd8ca2ee$var$NOOP_MESSAGE_FUNCTION;
        } else if ($5798ec4acd8ca2ee$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $5798ec4acd8ca2ee$var$NOOP_MESSAGE_FUNCTION;
    };
    var ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
var $5798ec4acd8ca2ee$var$intlDefined = typeof Intl !== "undefined";
var $5798ec4acd8ca2ee$var$Availabilities = {
    dateTimeFormat: $5798ec4acd8ca2ee$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $5798ec4acd8ca2ee$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $5798ec4acd8ca2ee$export$7ba4466dbd0f07e1(context) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var datetimeFormats = context.datetimeFormats, unresolving = context.unresolving, fallbackLocale = context.fallbackLocale, onWarn = context.onWarn, localeFallbacker = context.localeFallbacker;
    var __datetimeFormatters = context.__datetimeFormatters;
    var _parseDateTimeArgs_apply = (0, $fGQt0._)($5798ec4acd8ca2ee$export$165524b21a0d6b5e.apply(void 0, (0, $aYXpI._)(args)), 4), key = _parseDateTimeArgs_apply[0], value = _parseDateTimeArgs_apply[1], options = _parseDateTimeArgs_apply[2], overrides = _parseDateTimeArgs_apply[3];
    var missingWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    var fallbackWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    var part = !!options.part;
    var locale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    var locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $0980d0a6486887c9$export$844ec244b1367d54)(key) || key === "") return new Intl.DateTimeFormat(locale).format(value);
    // resolve format
    var datetimeFormat = {};
    var targetLocale;
    var format = null;
    var from = locale;
    var to = null;
    var type = "datetime format";
    for(var i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(format)) break;
        $5798ec4acd8ca2ee$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $0980d0a6486887c9$export$53b83ca8eaab0383)(format) || !(0, $0980d0a6486887c9$export$844ec244b1367d54)(targetLocale)) return unresolving ? $5798ec4acd8ca2ee$export$b7f13a18d1d0f835 : key;
    var id = "".concat(targetLocale, "__").concat(key);
    if (!(0, $0980d0a6486887c9$export$83b788b1a3698c03)(overrides)) id = "".concat(id, "__").concat(JSON.stringify(overrides));
    var formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ function $5798ec4acd8ca2ee$export$165524b21a0d6b5e() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $fGQt0._)(args, 4), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2], arg4 = _args[3];
    var options = {};
    var overrides = {};
    var value;
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        var matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b($5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        var dateTime = matches[3] ? matches[3].trim().startsWith("T") ? "".concat(matches[1].trim()).concat(matches[3].trim()) : "".concat(matches[1].trim(), "T").concat(matches[3].trim()) : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b($5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $0980d0a6486887c9$export$871608497c498473)(arg1)) {
        if (isNaN(arg1.getTime())) throw $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b($5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg1)) value = arg1;
    else throw $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b($5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg2)) options = arg2;
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $5798ec4acd8ca2ee$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    var context = ctx;
    for(var key in format){
        var id = "".concat(locale, "__").concat(key);
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $5798ec4acd8ca2ee$export$98e628dec113755e(context) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var numberFormats = context.numberFormats, unresolving = context.unresolving, fallbackLocale = context.fallbackLocale, onWarn = context.onWarn, localeFallbacker = context.localeFallbacker;
    var __numberFormatters = context.__numberFormatters;
    var _parseNumberArgs_apply = (0, $fGQt0._)($5798ec4acd8ca2ee$export$d0e2eec8b686cf72.apply(void 0, (0, $aYXpI._)(args)), 4), key = _parseNumberArgs_apply[0], value = _parseNumberArgs_apply[1], options = _parseNumberArgs_apply[2], overrides = _parseNumberArgs_apply[3];
    var missingWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    var fallbackWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    var part = !!options.part;
    var locale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    var locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $0980d0a6486887c9$export$844ec244b1367d54)(key) || key === "") return new Intl.NumberFormat(locale).format(value);
    // resolve format
    var numberFormat = {};
    var targetLocale;
    var format = null;
    var from = locale;
    var to = null;
    var type = "number format";
    for(var i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(format)) break;
        $5798ec4acd8ca2ee$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $0980d0a6486887c9$export$53b83ca8eaab0383)(format) || !(0, $0980d0a6486887c9$export$844ec244b1367d54)(targetLocale)) return unresolving ? $5798ec4acd8ca2ee$export$b7f13a18d1d0f835 : key;
    var id = "".concat(targetLocale, "__").concat(key);
    if (!(0, $0980d0a6486887c9$export$83b788b1a3698c03)(overrides)) id = "".concat(id, "__").concat(JSON.stringify(overrides));
    var formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ function $5798ec4acd8ca2ee$export$d0e2eec8b686cf72() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $fGQt0._)(args, 4), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2], arg4 = _args[3];
    var options = {};
    var overrides = {};
    if (!(0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg1)) throw $5798ec4acd8ca2ee$export$3d702f7ac45b0a6b($5798ec4acd8ca2ee$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    var value = arg1;
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg2)) options = arg2;
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $5798ec4acd8ca2ee$export$6a8717b3043a4f23(ctx, locale, format) {
    var context = ctx;
    for(var key in format){
        var id = "".concat(locale, "__").concat(key);
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $0980d0a6486887c9$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;


parcelRequire("hrKNH");
var $Dz4HH = parcelRequire("Dz4HH");
var $9pglz = parcelRequire("9pglz");
function $645e8d3b6ab1cfbf$export$5a2d366b2d9f38f6() {
    return $645e8d3b6ab1cfbf$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $645e8d3b6ab1cfbf$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
}
var $645e8d3b6ab1cfbf$export$bc32a04c49ed7464 = typeof Proxy === "function";


var $050a83d5dc1e2c41$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
var $050a83d5dc1e2c41$export$a0897f44accbe922 = "plugin:settings:set";




var $juqrk = parcelRequire("juqrk");

var $bNI6E = parcelRequire("bNI6E");

var $ect5N = parcelRequire("ect5N");
function $1928e6784807450d$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $ect5N._define_property)(target, key, source[key]);
        });
    }
    return target;
}



var $aYXpI = parcelRequire("aYXpI");


var $7d66437c79dc7eea$export$5728f3776e9b2ac1 = /*#__PURE__*/ function() {
    "use strict";
    function ApiProxy(plugin, hook) {
        var _this = this;
        (0, $juqrk._)(this, ApiProxy);
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        var defaultSettings = {};
        if (plugin.settings) for(var id in plugin.settings){
            var item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        var localSettingsSaveId = "__vue-devtools-plugin-settings__".concat(plugin.id);
        var currentSettings = (0, $1928e6784807450d$export$581ff339ea0ba762)({}, defaultSettings);
        try {
            var raw = localStorage.getItem(localSettingsSaveId);
            var data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings: function() {
                return currentSettings;
            },
            setSettings: function(value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            }
        };
        hook.on((0, $050a83d5dc1e2c41$export$a0897f44accbe922), function(pluginId, value) {
            if (pluginId === _this.plugin.id) _this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: function(_target, prop) {
                var _this1 = _this;
                if (_this.target) return _this.target.on[prop];
                else return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    _this1.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: function(_target, prop) {
                var _this1 = _this;
                if (_this.target) return _this.target[prop];
                else if (prop === "on") return _this.proxiedOn;
                else if (Object.keys(_this.fallbacks).includes(prop)) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _this_fallbacks;
                    _this1.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: function() {}
                    });
                    return (_this_fallbacks = _this1.fallbacks)[prop].apply(_this_fallbacks, (0, $aYXpI._)(args));
                };
                else return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return new Promise(function(resolve) {
                        _this1.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    (0, $bNI6E._)(ApiProxy, [
        {
            key: "setRealTarget",
            value: function setRealTarget(target) {
                var _this = this;
                return (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function() {
                    var _this_target_on, _this_target, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, item1, _, err;
                    return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.target = target;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = _this.onQueue[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        item = _step.value;
                                        (_this_target_on = _this.target.on)[item.method].apply(_this_target_on, (0, $aYXpI._)(item.args));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator1 = _this.targetQueue[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    5
                                ];
                                item1 = _step1.value;
                                _ = item1.resolve;
                                return [
                                    4,
                                    (_this_target = _this.target)[item1.method].apply(_this_target, (0, $aYXpI._)(item1.args))
                                ];
                            case 3:
                                _.apply(item1, [
                                    _state.sent()
                                ]);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ApiProxy;
}();




function $a3760ba8d19c2470$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    var target = (0, $645e8d3b6ab1cfbf$export$c22522a4dfa48e9c)();
    var hook = (0, $645e8d3b6ab1cfbf$export$5a2d366b2d9f38f6)();
    var enableProxy = (0, $645e8d3b6ab1cfbf$export$bc32a04c49ed7464) && pluginDescriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $050a83d5dc1e2c41$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        var proxy = enableProxy ? new (0, $7d66437c79dc7eea$export$5728f3776e9b2ac1)(pluginDescriptor, hook) : null;
        var list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: pluginDescriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


/*!
  * vue-devtools v9.2.0-beta.16
  * (c) 2021 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $ect5N = parcelRequire("ect5N");
var $eadacbcb3b1fc2cb$var$_obj;
var $eadacbcb3b1fc2cb$export$587da00aa063e3b8 = ($eadacbcb3b1fc2cb$var$_obj = {}, (0, $ect5N._)($eadacbcb3b1fc2cb$var$_obj, "vue-devtools-plugin-vue-i18n" /* PLUGIN */ , "Vue I18n devtools"), (0, $ect5N._)($eadacbcb3b1fc2cb$var$_obj, "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ , "I18n Resources"), (0, $ect5N._)($eadacbcb3b1fc2cb$var$_obj, "vue-i18n-timeline" /* TIMELINE */ , "Vue I18n"), $eadacbcb3b1fc2cb$var$_obj);
var $eadacbcb3b1fc2cb$export$51fbf4f94c542453 = (0, $ect5N._)({}, "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ , "Search for scopes ...");
var $eadacbcb3b1fc2cb$export$9698bf68c8ec8b3c = (0, $ect5N._)({}, "vue-i18n-timeline" /* TIMELINE */ , 0xffcd19);


/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ var $afed287e05d98684$export$a4ad2735b021c132 = "9.2.0-beta.16";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $afed287e05d98684$var$initFeatureFlags() {
    var needWarn = false;
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") {
        needWarn = true;
        (0, $0980d0a6486887c9$export$ff5f2eeb11fc7e14)().__VUE_I18N_FULL_INSTALL__ = true;
    }
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") {
        needWarn = true;
        (0, $0980d0a6486887c9$export$ff5f2eeb11fc7e14)().__VUE_I18N_LEGACY_API__ = true;
    }
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $0980d0a6486887c9$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
var $afed287e05d98684$var$code$1 = (0, $5798ec4acd8ca2ee$export$b6a676a18b27d4c8).__EXTEND_POINT__;
var $afed287e05d98684$var$inc$1 = function() {
    return $afed287e05d98684$var$code$1++;
};
var $afed287e05d98684$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $afed287e05d98684$var$code$1,
    NOT_SUPPORTED_PRESERVE: $afed287e05d98684$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $afed287e05d98684$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $afed287e05d98684$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $afed287e05d98684$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $afed287e05d98684$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $afed287e05d98684$var$inc$1(),
    NOT_SUPPORT_MULTI_I18N_INSTANCE: $afed287e05d98684$var$inc$1() // 14
};
var $afed287e05d98684$var$_obj;
var $afed287e05d98684$var$warnMessages = ($afed287e05d98684$var$_obj = {}, (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.FALLBACK_TO_ROOT, "Fall back to {type} '{key}' with root locale."), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE, "Not supported 'preserve'."), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER, "Not supported 'formatter'."), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE, "Not supported 'preserveDirectiveContent'."), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX, "Not supported 'getChoiceIndex'."), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE, "Component name legacy compatible: '{name}' -> 'i18n'"), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE, "Not found parent scope. use the global scope."), (0, $ect5N._)($afed287e05d98684$var$_obj, $afed287e05d98684$var$I18nWarnCodes.NOT_SUPPORT_MULTI_I18N_INSTANCE, "Not support multi i18n instance."), $afed287e05d98684$var$_obj);
function $afed287e05d98684$var$getWarnMessage(code) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $0980d0a6486887c9$export$d9468344d3651243).apply(void 0, [
        $afed287e05d98684$var$warnMessages[code]
    ].concat((0, $aYXpI._)(args)));
}
var $afed287e05d98684$var$code = (0, $e463640186f24986$export$77436aae039469c4).__EXTEND_POINT__;
var $afed287e05d98684$var$inc = function() {
    return $afed287e05d98684$var$code++;
};
var $afed287e05d98684$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $afed287e05d98684$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $afed287e05d98684$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $afed287e05d98684$var$inc(),
    NOT_INSLALLED: $afed287e05d98684$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $afed287e05d98684$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $afed287e05d98684$var$inc(),
    INVALID_VALUE: $afed287e05d98684$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $afed287e05d98684$var$inc(),
    NOT_INSLALLED_WITH_PROVIDE: $afed287e05d98684$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $afed287e05d98684$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $afed287e05d98684$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $afed287e05d98684$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $afed287e05d98684$var$inc() // 27
};
function $afed287e05d98684$var$createI18nError(code) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $e463640186f24986$export$21efa8bb37d5fecb)(code, null, undefined);
}
var $afed287e05d98684$var$_obj1;
var $afed287e05d98684$var$errorMessages = ($afed287e05d98684$var$_obj1 = {}, (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE, "Unexpected return type in composer"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.INVALID_ARGUMENT, "Invalid argument"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP, "Must be called at the top of a `setup` function"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.NOT_INSLALLED, "Need to install with `app.use` function"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR, "Unexpected error"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE, "Not available in legacy mode"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.REQUIRED_VALUE, "Required in value: {0}"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.INVALID_VALUE, "Invalid value"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN, "Cannot setup vue-devtools plugin"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE, "Need to install with `provide` function"), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N, "Not compatible legacy VueI18n."), (0, $ect5N._)($afed287e05d98684$var$_obj1, $afed287e05d98684$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY, "vue-i18n-bridge support Vue 2.x only"), $afed287e05d98684$var$_obj1);
var $afed287e05d98684$var$TransrateVNodeSymbol = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__transrateVNode");
var $afed287e05d98684$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__datetimeParts");
var $afed287e05d98684$var$NumberPartsSymbol = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__numberParts");
var $afed287e05d98684$var$EnableEmitter = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__enableEmitter");
var $afed287e05d98684$var$DisableEmitter = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__disableEmitter");
var $afed287e05d98684$var$SetPluralRulesSymbol = (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__setPluralRules");
(0, $0980d0a6486887c9$export$cd133c5e04906ece)("__intlifyMeta");
var $afed287e05d98684$var$InejctWithOption = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("__injectWithOption");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $afed287e05d98684$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(obj)) return obj;
    for(var key in obj){
        // check key
        if (!(0, $0980d0a6486887c9$export$b5a638e9b3fff9f3)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(obj[key])) $afed287e05d98684$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            var subKeys = key.split(".");
            var lastIndex = subKeys.length - 1;
            var currentObj = obj;
            for(var i = 0; i < lastIndex; i++){
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = {};
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            currentObj[subKeys[lastIndex]] = obj[key];
            delete obj[key];
            // recursive process value if value is also a object
            if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(currentObj[subKeys[lastIndex]])) $afed287e05d98684$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $afed287e05d98684$var$getLocaleMessages(locale, options) {
    var messages = options.messages, __i18n = options.__i18n, messageResolver = options.messageResolver, flatJson = options.flatJson;
    // prettier-ignore
    var ret = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(messages) ? messages : (0, $0980d0a6486887c9$export$43bee75e5e14138e)(__i18n) ? {} : (0, $ect5N._)({}, locale, {});
    // merge locale messages of i18n custom block
    if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(__i18n)) __i18n.forEach(function(custom) {
        if ("locale" in custom && "resource" in custom) {
            var _$locale = custom.locale, resource = custom.resource;
            if (_$locale) {
                ret[_$locale] = ret[_$locale] || {};
                $afed287e05d98684$var$deepCopy(resource, ret[_$locale]);
            } else $afed287e05d98684$var$deepCopy(resource, ret);
        } else (0, $0980d0a6486887c9$export$844ec244b1367d54)(custom) && $afed287e05d98684$var$deepCopy(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(var key in ret)if ((0, $0980d0a6486887c9$export$b5a638e9b3fff9f3)(ret, key)) $afed287e05d98684$var$handleFlatJson(ret[key]);
    }
    return ret;
}
var $afed287e05d98684$var$isNotObjectOrIsArray = function(val1) {
    return !(0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(val1) || (0, $0980d0a6486887c9$export$43bee75e5e14138e)(val1);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $afed287e05d98684$var$deepCopy(src, des) {
    // src and des should both be objects, and non of then can be a array
    if ($afed287e05d98684$var$isNotObjectOrIsArray(src) || $afed287e05d98684$var$isNotObjectOrIsArray(des)) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.INVALID_VALUE);
    for(var key in src)if ((0, $0980d0a6486887c9$export$b5a638e9b3fff9f3)(src, key)) {
        if ($afed287e05d98684$var$isNotObjectOrIsArray(src[key]) || $afed287e05d98684$var$isNotObjectOrIsArray(des[key])) // replace with src[key] when:
        // src[key] or des[key] is not a object, or
        // src[key] or des[key] is a array
        des[key] = src[key];
        else // src[key] and des[key] are both object, merge them
        $afed287e05d98684$var$deepCopy(src[key], des[key]);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $afed287e05d98684$var$getComponentOptions(instance) {
    return instance.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ var $afed287e05d98684$var$DEVTOOLS_META = "__INTLIFY_META__";
var $afed287e05d98684$var$composerID = 0;
function $afed287e05d98684$var$defineCoreMissingHandler(missing) {
    return function(ctx, locale, key, type) {
        return missing(locale, key, (0, $9pglz.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
var $afed287e05d98684$var$getMetaInfo = function() {
    var instance = (0, $9pglz.getCurrentInstance)();
    var meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $afed287e05d98684$var$getComponentOptions(instance)[$afed287e05d98684$var$DEVTOOLS_META]) ? (0, $ect5N._)({}, $afed287e05d98684$var$DEVTOOLS_META, meta) : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $afed287e05d98684$var$createComposer() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, VueI18nLegacy = arguments.length > 1 ? arguments[1] : void 0;
    var __root = options.__root;
    var _isGlobal = __root === undefined;
    var _inheritLocale = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    var _locale = (0, $Dz4HH.ref)(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $5798ec4acd8ca2ee$export$1af4c7e47ad72f44));
    var _fallbackLocale = (0, $Dz4HH.ref)(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.fallbackLocale) || (0, $0980d0a6486887c9$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    var _messages = (0, $Dz4HH.ref)($afed287e05d98684$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    var _datetimeFormats = (0, $Dz4HH.ref)((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : (0, $ect5N._)({}, _locale.value, {}));
    // prettier-ignore
    var _numberFormats = (0, $Dz4HH.ref)((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : (0, $ect5N._)({}, _locale.value, {}));
    // warning suppress options
    // prettier-ignore
    var _missingWarn = __root ? __root.missingWarn : (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $0980d0a6486887c9$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    var _fallbackWarn = __root ? __root.fallbackWarn : (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $0980d0a6486887c9$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    var _fallbackRoot = __root ? __root.fallbackRoot : (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    var _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    var _missing = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    var _runtimeMissing = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.missing) ? $afed287e05d98684$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    var _postTranslation = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    var _warnHtmlMessage = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    var _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    var _modifiers = __root ? __root.modifiers : (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    var _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    var _context;
    function getCoreContext() {
        var ctxOptions = {
            version: $afed287e05d98684$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(_context) ? _context.__numberFormatters : undefined;
        return (0, $5798ec4acd8ca2ee$export$3599d465b05a74a5)(ctxOptions);
    }
    _context = getCoreContext();
    (0, $5798ec4acd8ca2ee$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    var locale = (0, $Dz4HH.computed)({
        get: function() {
            return _locale.value;
        },
        set: function(val1) {
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    var fallbackLocale = (0, $Dz4HH.computed)({
        get: function() {
            return _fallbackLocale.value;
        },
        set: function(val1) {
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $5798ec4acd8ca2ee$export$c743ad8a3cc01530)(_context, _locale.value, val1);
        }
    });
    // messages
    var messages = (0, $Dz4HH.computed)(function() {
        return _messages.value;
    });
    // datetimeFormats
    var datetimeFormats = /* #__PURE__*/ (0, $Dz4HH.computed)(function() {
        return _datetimeFormats.value;
    });
    // numberFormats
    var numberFormats = /* #__PURE__*/ (0, $Dz4HH.computed)(function() {
        return _numberFormats.value;
    });
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $afed287e05d98684$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    }
    function wrapWithDeps(fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        var ret;
        if (__INTLIFY_PROD_DEVTOOLS__) try {
            (0, $5798ec4acd8ca2ee$export$605703447dca72aa)($afed287e05d98684$var$getMetaInfo());
            ret = fn(_context);
        } finally{
            (0, $5798ec4acd8ca2ee$export$605703447dca72aa)(null);
        }
        else ret = fn(_context);
        if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(ret) && ret === (0, $5798ec4acd8ca2ee$export$b7f13a18d1d0f835)) {
            var _argumentParser = (0, $fGQt0._)(argumentParser(), 2), key = _argumentParser[0], arg2 = _argumentParser[1];
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    }
    // t
    function t() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $5798ec4acd8ca2ee$export$d73ee8ef04f5226a), null, [
                context
            ].concat((0, $aYXpI._)(args)));
        }, function() {
            return (0, $5798ec4acd8ca2ee$export$8d9616744e22681a).apply(void 0, (0, $aYXpI._)(args));
        }, "translate", function(root) {
            return Reflect.apply(root.t, root, (0, $aYXpI._)(args));
        }, function(key) {
            return key;
        }, function(val1) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val1);
        });
    }
    // rt
    function rt() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args = (0, $fGQt0._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
        if (arg3 && !(0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(arg3)) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t.apply(void 0, [
            arg1,
            arg2,
            (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $5798ec4acd8ca2ee$export$7ba4466dbd0f07e1), null, [
                context
            ].concat((0, $aYXpI._)(args)));
        }, function() {
            return (0, $5798ec4acd8ca2ee$export$165524b21a0d6b5e).apply(void 0, (0, $aYXpI._)(args));
        }, "datetime format", function(root) {
            return Reflect.apply(root.d, root, (0, $aYXpI._)(args));
        }, function() {
            return 0, $5798ec4acd8ca2ee$export$a04371e9dbb3870b;
        }, function(val1) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val1);
        });
    }
    // n
    function n() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $5798ec4acd8ca2ee$export$98e628dec113755e), null, [
                context
            ].concat((0, $aYXpI._)(args)));
        }, function() {
            return (0, $5798ec4acd8ca2ee$export$d0e2eec8b686cf72).apply(void 0, (0, $aYXpI._)(args));
        }, "number format", function(root) {
            return Reflect.apply(root.n, root, (0, $aYXpI._)(args));
        }, function() {
            return 0, $5798ec4acd8ca2ee$export$a04371e9dbb3870b;
        }, function(val1) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val1);
        });
    }
    // for custom processor
    function normalize(values) {
        return values.map(function(val1) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val1) ? (0, $9pglz.createVNode)((0, $9pglz.Text), null, val1, 0) : val1;
        });
    }
    var interpolate = function(val1) {
        return val1;
    };
    var processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // transrateVNode, using for `i18n-t` component
    function transrateVNode() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _root;
        return wrapWithDeps(function(context) {
            var ret;
            var _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $5798ec4acd8ca2ee$export$d73ee8ef04f5226a), null, [
                    _context
                ].concat((0, $aYXpI._)(args)));
            } finally{
                _context.processor = null;
            }
            return ret;
        }, function() {
            return (0, $5798ec4acd8ca2ee$export$8d9616744e22681a).apply(void 0, (0, $aYXpI._)(args));
        }, "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function(root) {
            return (_root = root)[$afed287e05d98684$var$TransrateVNodeSymbol].apply(_root, (0, $aYXpI._)(args));
        }, function(key) {
            return [
                (0, $9pglz.createVNode)((0, $9pglz.Text), null, key, 0)
            ];
        }, function(val1) {
            return (0, $0980d0a6486887c9$export$43bee75e5e14138e)(val1);
        });
    }
    // numberParts, using for `i18n-n` component
    function numberParts() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _root;
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $5798ec4acd8ca2ee$export$98e628dec113755e), null, [
                context
            ].concat((0, $aYXpI._)(args)));
        }, function() {
            return (0, $5798ec4acd8ca2ee$export$d0e2eec8b686cf72).apply(void 0, (0, $aYXpI._)(args));
        }, "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function(root) {
            return (_root = root)[$afed287e05d98684$var$NumberPartsSymbol].apply(_root, (0, $aYXpI._)(args));
        }, function() {
            return [];
        }, function(val1) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val1) || (0, $0980d0a6486887c9$export$43bee75e5e14138e)(val1);
        });
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _root;
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $5798ec4acd8ca2ee$export$7ba4466dbd0f07e1), null, [
                context
            ].concat((0, $aYXpI._)(args)));
        }, function() {
            return (0, $5798ec4acd8ca2ee$export$165524b21a0d6b5e).apply(void 0, (0, $aYXpI._)(args));
        }, "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function(root) {
            return (_root = root)[$afed287e05d98684$var$DatetimePartsSymbol].apply(_root, (0, $aYXpI._)(args));
        }, function() {
            return [];
        }, function(val1) {
            return (0, $0980d0a6486887c9$export$844ec244b1367d54)(val1) || (0, $0980d0a6486887c9$export$43bee75e5e14138e)(val1);
        });
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        var targetLocale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(locale) ? locale : _locale.value;
        var message = getLocaleMessage(targetLocale);
        return _context.messageResolver(message, key) !== null;
    }
    function resolveMessages(key) {
        var messages = null;
        var locales = (0, $5798ec4acd8ca2ee$export$71df9db82dc445)(_context, _fallbackLocale.value, _locale.value);
        for(var i = 0; i < locales.length; i++){
            var targetLocaleMessages = _messages.value[locales[i]] || {};
            var messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        var messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        $afed287e05d98684$var$deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $5798ec4acd8ca2ee$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $5798ec4acd8ca2ee$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $5798ec4acd8ca2ee$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $5798ec4acd8ca2ee$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // for debug
    $afed287e05d98684$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root) {
        (0, $9pglz.watch)(__root.locale, function(val1) {
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $5798ec4acd8ca2ee$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $9pglz.watch)(__root.fallbackLocale, function(val1) {
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $5798ec4acd8ca2ee$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    var composer = (0, $ect5N._)({
        id: $afed287e05d98684$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $5798ec4acd8ca2ee$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler
    }, $afed287e05d98684$var$SetPluralRulesSymbol, setPluralRules);
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$afed287e05d98684$var$InejctWithOption] = options.__injectWithOption;
    composer[$afed287e05d98684$var$TransrateVNodeSymbol] = transrateVNode;
    composer[$afed287e05d98684$var$NumberPartsSymbol] = numberParts;
    composer[$afed287e05d98684$var$DatetimePartsSymbol] = datetimeParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $afed287e05d98684$var$convertComposerOptions(options) {
    var locale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $5798ec4acd8ca2ee$export$1af4c7e47ad72f44);
    var fallbackLocale = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.fallbackLocale) || (0, $0980d0a6486887c9$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    var missing = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.missing) ? options.missing : undefined;
    var missingWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.silentTranslationWarn) || (0, $0980d0a6486887c9$export$49841c62b9eff15)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    var fallbackWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.silentFallbackWarn) || (0, $0980d0a6486887c9$export$49841c62b9eff15)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    var fallbackRoot = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    var fallbackFormat = !!options.formatFallbackMessages;
    var modifiers = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    var pluralizationRules = options.pluralizationRules;
    var postTranslation = (0, $0980d0a6486887c9$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : undefined;
    var warnHtmlMessage = (0, $0980d0a6486887c9$export$844ec244b1367d54)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    var escapeParameter = !!options.escapeParameterHtml;
    var inheritLocale = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.sync) ? options.sync : true;
    var messages = options.messages;
    if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options.sharedMessages)) {
        var sharedMessages = options.sharedMessages;
        var locales = Object.keys(sharedMessages);
        messages = locales.reduce(function(messages, locale) {
            var message = messages[locale] || (messages[locale] = {});
            (0, $0980d0a6486887c9$export$e6e34fd1f2686227)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    var __i18n = options.__i18n, __root = options.__root, __injectWithOption = options.__injectWithOption;
    var datetimeFormats = options.datetimeFormats;
    var numberFormats = options.numberFormats;
    var flatJson = options.flatJson;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $afed287e05d98684$var$createVueI18n() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, VueI18nLegacy = arguments.length > 1 ? arguments[1] : void 0;
    {
        var composer = $afed287e05d98684$var$createComposer($afed287e05d98684$var$convertComposerOptions(options));
        // defines VueI18n
        var vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate: function() {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _args = (0, $fGQt0._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
                var options = {};
                var list = null;
                var named = null;
                if (!(0, $0980d0a6486887c9$export$844ec244b1367d54)(arg1)) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.INVALID_ARGUMENT);
                var key = arg1;
                if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Reflect.apply(composer.rt, composer, (0, $aYXpI._)(args));
            },
            // tc
            tc: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _args = (0, $fGQt0._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
                var options = {
                    plural: 1
                };
                var list = null;
                var named = null;
                if (!(0, $0980d0a6486887c9$export$844ec244b1367d54)(arg1)) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.INVALID_ARGUMENT);
                var key = arg1;
                if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
                else if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(arg3)) options.locale = arg3;
                else if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te: function(key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm: function(key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage: function(locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage: function(locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage: function(locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Reflect.apply(composer.d, composer, (0, $aYXpI._)(args));
            },
            // getDateTimeFormat
            getDateTimeFormat: function(locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat: function(locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat: function(locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Reflect.apply(composer.n, composer, (0, $aYXpI._)(args));
            },
            // getNumberFormat
            getNumberFormat: function(locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat: function(locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat: function(locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex: function(choice, choicesLength) {
                return -1;
            },
            // for internal
            __onComponentInstanceCreated: function(target) {
                var componentInstanceCreatedListener = options.componentInstanceCreatedListener;
                if (componentInstanceCreatedListener) componentInstanceCreatedListener(target, vueI18n);
            }
        };
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ var $afed287e05d98684$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: function(val1 /* ComponetI18nScope */ ) {
            return val1 === "parent" || val1 === "global";
        },
        default: "parent" /* ComponetI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n path="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ var $afed287e05d98684$export$b63289fbda65eed1 = /* #__PURE__*/ (0, $9pglz.defineComponent)({
    /* eslint-disable */ name: "i18n-t",
    props: (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: function(val1) {
                return (0, $0980d0a6486887c9$export$7e4aa119212bc614)(val1) || !isNaN(val1);
            }
        }
    }, $afed287e05d98684$var$baseFormatProps),
    /* eslint-enable */ setup: function(props, context) {
        var slots = context.slots, attrs = context.attrs;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        var i18n = props.i18n || $afed287e05d98684$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        var keys = Object.keys(slots).filter(function(key) {
            return key !== "_";
        });
        return function() {
            var options = {};
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $0980d0a6486887c9$export$844ec244b1367d54)(props.plural) ? +props.plural : props.plural;
            var arg = $afed287e05d98684$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var children = i18n[$afed287e05d98684$var$TransrateVNodeSymbol](props.keypath, arg, options);
            var assignedAttrs = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, attrs);
            var tag = (0, $0980d0a6486887c9$export$844ec244b1367d54)(props.tag) || (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : (0, $9pglz.Fragment);
            return (0, $9pglz.h)(tag, assignedAttrs, children);
        };
    }
});
function $afed287e05d98684$var$getInterpolateArg(param, keys) {
    var slots = param.slots;
    if (keys.length === 1 && keys[0] === "default") // default slot only
    return slots.default ? slots.default() : [];
    else // named slots
    return keys.reduce(function(arg, key) {
        var slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, {});
}
function $afed287e05d98684$var$renderFormatter(props, context, slotKeys, partFormatter) {
    var slots = context.slots, attrs = context.attrs;
    return function() {
        var options = {
            part: true
        };
        var overrides = {};
        if (props.locale) options.locale = props.locale;
        if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(props.format)) options.key = props.format;
        else if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce(function(options, prop) {
                return slotKeys.includes(prop) ? (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, options, (0, $ect5N._)({}, prop, props.format[prop])) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, {});
        }
        var parts = partFormatter.apply(void 0, [
            props.value,
            options,
            overrides
        ]);
        var children = [
            options.key
        ];
        if ((0, $0980d0a6486887c9$export$43bee75e5e14138e)(parts)) children = parts.map(function(part, index) {
            var slot = slots[part.type];
            var _obj;
            return slot ? slot((_obj = {}, (0, $ect5N._)(_obj, part.type, part.value), (0, $ect5N._)(_obj, "index", index), (0, $ect5N._)(_obj, "parts", parts), _obj)) : [
                part.value
            ];
        });
        else if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(parts)) children = [
            parts
        ];
        var assignedAttrs = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, attrs);
        var tag = (0, $0980d0a6486887c9$export$844ec244b1367d54)(props.tag) || (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : (0, $9pglz.Fragment);
        return (0, $9pglz.h)(tag, assignedAttrs, children);
    };
}
var $afed287e05d98684$var$NUMBER_FORMAT_KEYS = [
    "localeMatcher",
    "style",
    "unit",
    "unitDisplay",
    "currency",
    "currencyDisplay",
    "useGrouping",
    "numberingSystem",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "notation",
    "formatMatcher"
];
/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ var $afed287e05d98684$export$27bce688931fdfcc = /* #__PURE__*/ (0, $9pglz.defineComponent)({
    /* eslint-disable */ name: "i18n-n",
    props: (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $afed287e05d98684$var$baseFormatProps),
    /* eslint-enable */ setup: function(props, context) {
        var // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _i18n;
        var i18n = props.i18n || $afed287e05d98684$export$3f3caade1c12f8c9({
            useScope: "parent",
            __useComponent: true
        });
        return $afed287e05d98684$var$renderFormatter(props, context, $afed287e05d98684$var$NUMBER_FORMAT_KEYS, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (_i18n = i18n)[$afed287e05d98684$var$NumberPartsSymbol].apply(_i18n, (0, $aYXpI._)(args));
        });
    }
});
var $afed287e05d98684$var$DATETIME_FORMAT_KEYS = [
    "dateStyle",
    "timeStyle",
    "fractionalSecondDigits",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "localeMatcher",
    "timeZone",
    "hour12",
    "hourCycle",
    "formatMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName"
];
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ var $afed287e05d98684$export$64ca50867510e64e = /* #__PURE__*/ (0, $9pglz.defineComponent)({
    /* eslint-disable */ name: "i18n-d",
    props: (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $afed287e05d98684$var$baseFormatProps),
    /* eslint-enable */ setup: function(props, context) {
        var // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _i18n;
        var i18n = props.i18n || $afed287e05d98684$export$3f3caade1c12f8c9({
            useScope: "parent",
            __useComponent: true
        });
        return $afed287e05d98684$var$renderFormatter(props, context, $afed287e05d98684$var$DATETIME_FORMAT_KEYS, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (_i18n = i18n)[$afed287e05d98684$var$DatetimePartsSymbol].apply(_i18n, (0, $aYXpI._)(args));
        });
    }
});
function $afed287e05d98684$var$getComposer$2(i18n, instance) {
    var i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        var vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $afed287e05d98684$export$8a5a05546006d0b5(i18n) {
    var bind = function(el, param) {
        var instance = param.instance, value = param.value, modifiers = param.modifiers;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR);
        var composer = $afed287e05d98684$var$getComposer$2(i18n, instance.$);
        var parsedValue = $afed287e05d98684$var$parseValue(value);
        // el.textContent = composer.t(...makeParams(parsedValue))
        el.textContent = Reflect.apply(composer.t, composer, (0, $aYXpI._)($afed287e05d98684$var$makeParams(parsedValue)));
    };
    return {
        beforeMount: bind,
        beforeUpdate: bind
    };
}
function $afed287e05d98684$var$parseValue(value) {
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(value)) return {
        path: value
    };
    else if ((0, $0980d0a6486887c9$export$53b83ca8eaab0383)(value)) {
        if (!("path" in value)) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.INVALID_VALUE);
}
function $afed287e05d98684$var$makeParams(value) {
    var path = value.path, locale = value.locale, args = value.args, choice = value.choice, plural = value.plural;
    var options = {};
    var named = args || {};
    if ((0, $0980d0a6486887c9$export$844ec244b1367d54)(locale)) options.locale = locale;
    if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(choice)) options.plural = choice;
    if ((0, $0980d0a6486887c9$export$7e4aa119212bc614)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $afed287e05d98684$var$apply(app, i18n) {
    for(var _len = arguments.length, options = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        options[_key - 2] = arguments[_key];
    }
    var pluginOptions = (0, $0980d0a6486887c9$export$53b83ca8eaab0383)(options[0]) ? options[0] : {};
    var useI18nComponentName = !!pluginOptions.useI18nComponentName;
    var globalInstall = (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        // install components
        app.component(!useI18nComponentName ? $afed287e05d98684$export$b63289fbda65eed1.name : "i18n", $afed287e05d98684$export$b63289fbda65eed1);
        app.component($afed287e05d98684$export$27bce688931fdfcc.name, $afed287e05d98684$export$27bce688931fdfcc);
        app.component($afed287e05d98684$export$64ca50867510e64e.name, $afed287e05d98684$export$64ca50867510e64e);
    }
    app.directive("t", $afed287e05d98684$export$8a5a05546006d0b5(i18n));
}
var $afed287e05d98684$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
var $afed287e05d98684$var$devtoolsApi;
function $afed287e05d98684$var$enableDevTools(app, i18n) {
    return $afed287e05d98684$var$_enableDevTools.apply(this, arguments);
}
function $afed287e05d98684$var$_enableDevTools() {
    $afed287e05d98684$var$_enableDevTools = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(app, i18n) {
        return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        (0, $a3760ba8d19c2470$export$63b9a9bba9f20f3e)({
                            id: "vue-devtools-plugin-vue-i18n" /* PLUGIN */ ,
                            label: (0, $eadacbcb3b1fc2cb$export$587da00aa063e3b8)["vue-devtools-plugin-vue-i18n" /* PLUGIN */ ],
                            packageName: "vue-i18n",
                            homepage: "https://vue-i18n.intlify.dev",
                            logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                            componentStateTypes: [
                                $afed287e05d98684$var$VUE_I18N_COMPONENT_TYPES
                            ],
                            app: app
                        }, function(api) {
                            $afed287e05d98684$var$devtoolsApi = api;
                            api.on.visitComponentTree(function(param) {
                                var componentInstance = param.componentInstance, treeNode = param.treeNode;
                                $afed287e05d98684$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                            });
                            api.on.inspectComponent(function(param) {
                                var componentInstance = param.componentInstance, instanceData = param.instanceData;
                                if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                                    if (i18n.mode === "legacy") // ignore global scope on legacy mode
                                    {
                                        if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $afed287e05d98684$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                                    } else $afed287e05d98684$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                                }
                            });
                            api.addInspector({
                                id: "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ,
                                label: (0, $eadacbcb3b1fc2cb$export$587da00aa063e3b8)["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ],
                                icon: "language",
                                treeFilterPlaceholder: (0, $eadacbcb3b1fc2cb$export$51fbf4f94c542453)["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ]
                            });
                            api.on.getInspectorTree(function(payload) {
                                if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) $afed287e05d98684$var$registerScope(payload, i18n);
                            });
                            var roots = new Map();
                            api.on.getInspectorState(function() {
                                var _ref = (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function(payload) {
                                    var _ref, root, instance;
                                    return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ )) return [
                                                    3,
                                                    4
                                                ];
                                                api.unhighlightElement();
                                                $afed287e05d98684$var$inspectScope(payload, i18n);
                                                if (!(payload.nodeId === "global")) return [
                                                    3,
                                                    3
                                                ];
                                                if (!!roots.has(payload.app)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    api.getComponentInstances(payload.app)
                                                ];
                                            case 1:
                                                _ref = (0, $fGQt0._).apply(void 0, [
                                                    _state.sent(),
                                                    1
                                                ]), root = _ref[0];
                                                roots.set(payload.app, root);
                                                _state.label = 2;
                                            case 2:
                                                api.highlightElement(roots.get(payload.app));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                instance = $afed287e05d98684$var$getComponentInstance(payload.nodeId, i18n);
                                                instance && api.highlightElement(instance);
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(payload) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            api.on.editInspectorState(function(payload) {
                                if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) $afed287e05d98684$var$editScope(payload, i18n);
                            });
                            api.addTimelineLayer({
                                id: "vue-i18n-timeline" /* TIMELINE */ ,
                                label: (0, $eadacbcb3b1fc2cb$export$587da00aa063e3b8)["vue-i18n-timeline" /* TIMELINE */ ],
                                color: (0, $eadacbcb3b1fc2cb$export$9698bf68c8ec8b3c)["vue-i18n-timeline" /* TIMELINE */ ]
                            });
                            resolve(true);
                        });
                    } catch (e) {
                        console.error(e);
                        reject(false);
                    }
                })
            ];
        });
    });
    return $afed287e05d98684$var$_enableDevTools.apply(this, arguments);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $afed287e05d98684$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $afed287e05d98684$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    var global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            var tag = {
                label: "i18n (".concat($afed287e05d98684$var$getI18nScopeLable(instance), " Scope)"),
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $afed287e05d98684$var$inspectComposer(instanceData, composer) {
    var type = $afed287e05d98684$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $afed287e05d98684$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $afed287e05d98684$var$getLocaleMessageValue(messages) {
    var value = {};
    Object.keys(messages).forEach(function(key) {
        var v = messages[key];
        if ((0, $0980d0a6486887c9$export$f6e2535fb5126e54)(v) && "source" in v) value[key] = $afed287e05d98684$var$getMessageFunctionDetails(v);
        else if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(v)) value[key] = $afed287e05d98684$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
var $afed287e05d98684$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $afed287e05d98684$var$escape(s) {
    return s.replace(/[<>"&]/g, $afed287e05d98684$var$escapeChar);
}
function $afed287e05d98684$var$escapeChar(a) {
    return $afed287e05d98684$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $afed287e05d98684$var$getMessageFunctionDetails(func) {
    var argString = func.source ? '("'.concat($afed287e05d98684$var$escape(func.source), '")') : "(?)";
    return {
        _custom: {
            type: "function",
            display: "<span>\u0192</span> ".concat(argString)
        }
    };
}
function $afed287e05d98684$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    var global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = i18n.__instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fGQt0._)(_step.value, 2), keyInstance = _step_value[0], instance = _step_value[1];
            // prettier-ignore
            var composer = i18n.mode === "composition" ? instance : instance.__composer;
            if (global === composer) continue;
            payload.rootNodes.push({
                id: composer.id.toString(),
                label: "".concat($afed287e05d98684$var$getI18nScopeLable(keyInstance), " Scope")
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $afed287e05d98684$var$getComponentInstance(nodeId, i18n) {
    var instance = null;
    if (nodeId !== "global") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = i18n.__instances.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $fGQt0._)(_step.value, 2), component = _step_value[0], composer = _step_value[1];
                if (composer.id.toString() === nodeId) {
                    instance = component;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return instance;
}
function $afed287e05d98684$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        var instance = Array.from(i18n.__instances.values()).find(function(item) {
            return item.id.toString() === nodeId;
        });
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $afed287e05d98684$var$inspectScope(payload, i18n) {
    var composer = $afed287e05d98684$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $afed287e05d98684$var$makeScopeInspectState(composer);
    return null;
}
function $afed287e05d98684$var$makeScopeInspectState(composer) {
    var state = {};
    var localeType = "Locale related info";
    var localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    var localeMessagesType = "Locale messages info";
    var localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $afed287e05d98684$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        var datetimeFormatsType = "Datetime formats info";
        var datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        var numberFormatsType = "Datetime formats info";
        var numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $afed287e05d98684$var$addTimelineEvent(event, payload) {
    if ($afed287e05d98684$var$devtoolsApi) {
        var groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $afed287e05d98684$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* COMPILE_ERROR */  ? "error" : event === "fallback" /* FALBACK */  || event === "missing" /* MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $afed287e05d98684$var$editScope(payload, i18n) {
    var composer = $afed287e05d98684$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        var _payload_path = (0, $fGQt0._)(payload.path, 1), field = _payload_path[0];
        if (field === "locale" && (0, $0980d0a6486887c9$export$844ec244b1367d54)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $0980d0a6486887c9$export$844ec244b1367d54)(payload.state.value) || (0, $0980d0a6486887c9$export$43bee75e5e14138e)(payload.state.value) || (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $afed287e05d98684$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate: function() {
            var _this = this;
            var _this1 = this;
            var _this_$i18n, _this_$i18n1, _this_$i18n2, _this_$i18n3, _this_$i18n4;
            var instance = (0, $9pglz.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR);
            var options = this.$options;
            if (options.i18n) {
                var optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) this.$i18n = $afed287e05d98684$var$mergeToRoot(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    this.$i18n = $afed287e05d98684$var$createVueI18n(optionsI18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) this.$i18n = $afed287e05d98684$var$mergeToRoot(vuei18n, options);
                else this.$i18n = $afed287e05d98684$var$createVueI18n({
                    __i18n: options.__i18n,
                    __injectWithOption: true,
                    __root: composer
                });
            } else // set global
            this.$i18n = vuei18n;
            vuei18n.__onComponentInstanceCreated(this.$i18n);
            i18n.__setInstance(instance, this.$i18n);
            // defines vue-i18n legacy APIs
            this.$t = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n = _this1.$i18n).t.apply(_this_$i18n, (0, $aYXpI._)(args));
            };
            this.$rt = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n1 = _this1.$i18n).rt.apply(_this_$i18n1, (0, $aYXpI._)(args));
            };
            this.$tc = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n2 = _this1.$i18n).tc.apply(_this_$i18n2, (0, $aYXpI._)(args));
            };
            this.$te = function(key, locale) {
                return _this.$i18n.te(key, locale);
            };
            this.$d = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n3 = _this1.$i18n).d.apply(_this_$i18n3, (0, $aYXpI._)(args));
            };
            this.$n = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n4 = _this1.$i18n).n.apply(_this_$i18n4, (0, $aYXpI._)(args));
            };
            this.$tm = function(key) {
                return _this.$i18n.tm(key);
            };
        },
        mounted: function() {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true) {
                this.$el.__VUE_I18N__ = this.$i18n.__composer;
                var emitter = this.__v_emitter = (0, $0980d0a6486887c9$export$6f5e8f34570e3ad1)();
                var _vueI18n = this.$i18n;
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $afed287e05d98684$var$addTimelineEvent);
            }
        },
        unmounted: function() {
            var _this = this;
            var instance = (0, $9pglz.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR);
            (0, $9pglz.nextTick)(function() {
                /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true) {
                    if (_this.__v_emitter) {
                        _this.__v_emitter.off("*", $afed287e05d98684$var$addTimelineEvent);
                        delete _this.__v_emitter;
                    }
                    var _vueI18n = _this.$i18n;
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete _this.$el.__VUE_I18N__;
                }
                delete _this.$t;
                delete _this.$rt;
                delete _this.$tc;
                delete _this.$te;
                delete _this.$d;
                delete _this.$n;
                delete _this.$tm;
                i18n.__deleteInstance(instance);
                delete _this.$i18n;
            });
        }
    };
}
function $afed287e05d98684$var$mergeToRoot(root, options) {
    root.locale = options.locale || root.locale;
    root.fallbackLocale = options.fallbackLocale || root.fallbackLocale;
    root.missing = options.missing || root.missing;
    root.silentTranslationWarn = options.silentTranslationWarn || root.silentFallbackWarn;
    root.silentFallbackWarn = options.silentFallbackWarn || root.silentFallbackWarn;
    root.formatFallbackMessages = options.formatFallbackMessages || root.formatFallbackMessages;
    root.postTranslation = options.postTranslation || root.postTranslation;
    root.warnHtmlInMessage = options.warnHtmlInMessage || root.warnHtmlInMessage;
    root.escapeParameterHtml = options.escapeParameterHtml || root.escapeParameterHtml;
    root.sync = options.sync || root.sync;
    root.__composer[$afed287e05d98684$var$SetPluralRulesSymbol](options.pluralizationRules || root.pluralizationRules);
    var messages = $afed287e05d98684$var$getLocaleMessages(root.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach(function(locale) {
        return root.mergeLocaleMessage(locale, messages[locale]);
    });
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach(function(locale) {
        return root.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
    });
    if (options.numberFormats) Object.keys(options.numberFormats).forEach(function(locale) {
        return root.mergeNumberFormat(locale, options.numberFormats[locale]);
    });
    return root;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ var $afed287e05d98684$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $0980d0a6486887c9$export$cd133c5e04906ece)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $afed287e05d98684$export$920091e3d72d80ee() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, VueI18nLegacy = arguments.length > 1 ? arguments[1] : void 0;
    // prettier-ignore
    var __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $0980d0a6486887c9$export$f9ce7b637dfbe238)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    var __globalInjection = !!options.globalInjection;
    var __instances = new Map();
    var __global = $afed287e05d98684$var$createGlobal(options, __legacyMode);
    var symbol = (0, $0980d0a6486887c9$export$cd133c5e04906ece)("");
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        var i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            install: // install plugin
            function(app) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                return (0, $d30aa9e28595ada5$export$7c398597f8905a1)(function() {
                    var ret, emitter, _vueI18n, _composer;
                    return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                                app.__VUE_I18N_SYMBOL__ = symbol;
                                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                                // global method and properties injection for Composition API
                                if (!__legacyMode && __globalInjection) $afed287e05d98684$var$injectGlobalFields(app, i18n.global);
                                // install built-in components and directive
                                if (__VUE_I18N_FULL_INSTALL__) $afed287e05d98684$var$apply.apply(void 0, [
                                    app,
                                    i18n
                                ].concat((0, $aYXpI._)(options)));
                                // setup mixin for Legacy API
                                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($afed287e05d98684$var$defineMixin(__global, __global.__composer, i18n));
                                if (!(__VUE_PROD_DEVTOOLS__ && true)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $afed287e05d98684$var$enableDevTools(app, i18n)
                                ];
                            case 1:
                                ret = _state.sent();
                                if (!ret) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                                emitter = (0, $0980d0a6486887c9$export$6f5e8f34570e3ad1)();
                                if (__legacyMode) {
                                    _vueI18n = __global;
                                    _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                                } else {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    _composer = __global;
                                    _composer[$afed287e05d98684$var$EnableEmitter] && _composer[$afed287e05d98684$var$EnableEmitter](emitter);
                                }
                                emitter.on("*", $afed287e05d98684$var$addTimelineEvent);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            // global accessor
            get global () {
                return __global;
            },
            // @internal
            __instances: __instances,
            // @internal
            __getInstance: __getInstance,
            // @internal
            __setInstance: __setInstance,
            // @internal
            __deleteInstance: __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $afed287e05d98684$export$3f3caade1c12f8c9() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var instance = (0, $9pglz.getCurrentInstance)();
    if (instance == null) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.NOT_INSLALLED);
    var i18n = $afed287e05d98684$var$getI18nInstance(instance);
    var global = $afed287e05d98684$var$getGlobalComposer(i18n);
    var componentOptions = $afed287e05d98684$var$getComponentOptions(instance);
    var scope = $afed287e05d98684$var$getScope(options, componentOptions);
    if (scope === "global") {
        $afed287e05d98684$var$adjustI18nResources(global, options, componentOptions);
        return global;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var composer = $afed287e05d98684$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = global;
        return composer;
    }
    // scope 'local' case
    if (i18n.mode === "legacy") throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
    var i18nInternal = i18n;
    var composer1 = i18nInternal.__getInstance(instance);
    if (composer1 == null) {
        var composerOptions = (0, $0980d0a6486887c9$export$e6e34fd1f2686227)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (global) composerOptions.__root = global;
        composer1 = $afed287e05d98684$var$createComposer(composerOptions);
        $afed287e05d98684$var$setupLifeCycle(i18nInternal, instance, composer1);
        i18nInternal.__setInstance(instance, composer1);
    }
    return composer1;
}
function $afed287e05d98684$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    return __VUE_I18N_LEGACY_API__ && legacyMode ? $afed287e05d98684$var$createVueI18n(options) : $afed287e05d98684$var$createComposer(options);
}
function $afed287e05d98684$var$getI18nInstance(instance) {
    {
        var i18n = (0, $9pglz.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $afed287e05d98684$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $afed287e05d98684$var$createI18nError(!instance.isCE ? $afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR : $afed287e05d98684$var$I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $afed287e05d98684$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $0980d0a6486887c9$export$83b788b1a3698c03)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $afed287e05d98684$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $afed287e05d98684$var$adjustI18nResources(global, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    var messages = (0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.messages) ? options.messages : {};
    if ("__i18nGlobal" in componentOptions) messages = $afed287e05d98684$var$getLocaleMessages(global.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    var locales = Object.keys(messages);
    if (locales.length) locales.forEach(function(locale) {
        global.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.datetimeFormats)) {
        var locales1 = Object.keys(options.datetimeFormats);
        if (locales1.length) locales1.forEach(function(locale) {
            global.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $0980d0a6486887c9$export$a6cdc56e425d0d0a)(options.numberFormats)) {
        var locales2 = Object.keys(options.numberFormats);
        if (locales2.length) locales2.forEach(function(locale) {
            global.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $afed287e05d98684$var$getComposer(i18n, target) {
    var useComponent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var composer = null;
    var root = target.root;
    var current = target.parent;
    while(current != null){
        var i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            var vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$afed287e05d98684$var$InejctWithOption] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $afed287e05d98684$var$setupLifeCycle(i18n, target, composer) {
    var emitter = null;
    (0, $9pglz.onMounted)(function() {
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $0980d0a6486887c9$export$6f5e8f34570e3ad1)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var _composer = composer;
            _composer[$afed287e05d98684$var$EnableEmitter] && _composer[$afed287e05d98684$var$EnableEmitter](emitter);
            emitter.on("*", $afed287e05d98684$var$addTimelineEvent);
        }
    }, target);
    (0, $9pglz.onUnmounted)(function() {
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $afed287e05d98684$var$addTimelineEvent);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var _composer = composer;
            _composer[$afed287e05d98684$var$DisableEmitter] && _composer[$afed287e05d98684$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
    }, target);
}
var $afed287e05d98684$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
var $afed287e05d98684$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm"
];
function $afed287e05d98684$var$injectGlobalFields(app, composer) {
    var i18n = Object.create(null);
    $afed287e05d98684$var$globalExportProps.forEach(function(prop) {
        var desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR);
        var wrap = (0, $Dz4HH.isRef)(desc.value) // check computed props
         ? {
            get: function() {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set: function(val1) {
                desc.value.value = val1;
            }
        } : {
            get: function() {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $afed287e05d98684$var$globalExportMethods.forEach(function(method) {
        var desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $afed287e05d98684$var$createI18nError($afed287e05d98684$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, "$".concat(method), desc);
    });
}
// register message compiler at vue-i18n
(0, $5798ec4acd8ca2ee$export$6ee2fbe83628b40b)((0, $5798ec4acd8ca2ee$export$1ea8807c727891fc));
// register message resolver at vue-i18n
(0, $5798ec4acd8ca2ee$export$45dacdc710815463)((0, $5798ec4acd8ca2ee$export$d812c8e1906863d0));
// register fallback locale at vue-i18n
(0, $5798ec4acd8ca2ee$export$fd8ec9dd8067edec)((0, $5798ec4acd8ca2ee$export$71df9db82dc445));
$afed287e05d98684$var$initFeatureFlags();
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    var $afed287e05d98684$var$target = (0, $0980d0a6486887c9$export$ff5f2eeb11fc7e14)();
    $afed287e05d98684$var$target.__INTLIFY__ = true;
    (0, $5798ec4acd8ca2ee$export$c893d6c8966908b9)($afed287e05d98684$var$target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}


/*!
  * vue-router v4.0.12
  * (c) 2021 Eduardo San Martin Morote
  * @license MIT
  */ 
var $ect5N = parcelRequire("ect5N");

var $fGQt0 = parcelRequire("fGQt0");

var $6aBn7 = parcelRequire("6aBn7");
parcelRequire("hrKNH");
var $Dz4HH = parcelRequire("Dz4HH");
var $9pglz = parcelRequire("9pglz");

var $6986282d55d35034$var$hasSymbol = typeof Symbol === "function" && (0, $6aBn7._)(Symbol.toStringTag) === "symbol";
var $6986282d55d35034$var$PolySymbol = function(name) {
    return(// vr = vue router
    $6986282d55d35034$var$hasSymbol ? Symbol(name) : "_vr_" + name);
};
// rvlm = Router View Location Matched
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ var $6986282d55d35034$export$7f4879db1558672d = /*#__PURE__*/ $6986282d55d35034$var$PolySymbol("rvlm");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ var $6986282d55d35034$export$9b3825c34ca1427a = /*#__PURE__*/ $6986282d55d35034$var$PolySymbol("rvd");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ var $6986282d55d35034$export$b6c0da8b9dae491f = /*#__PURE__*/ $6986282d55d35034$var$PolySymbol("r");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ var $6986282d55d35034$export$3aca783e9a3e6e9e = /*#__PURE__*/ $6986282d55d35034$var$PolySymbol("rl");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ var $6986282d55d35034$export$54c8124bead129f8 = /*#__PURE__*/ $6986282d55d35034$var$PolySymbol("rvl");
var $6986282d55d35034$var$isBrowser = typeof window !== "undefined";
function $6986282d55d35034$var$isESModule(obj) {
    return obj.__esModule || $6986282d55d35034$var$hasSymbol && obj[Symbol.toStringTag] === "Module";
}
var $6986282d55d35034$var$assign = Object.assign;
function $6986282d55d35034$var$applyToParams(fn, params) {
    var newParams = {};
    for(var key in params){
        var value = params[key];
        newParams[key] = Array.isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
var $6986282d55d35034$var$noop = function() {};
function $6986282d55d35034$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    var args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
var $6986282d55d35034$var$TRAILING_SLASH_RE = /\/$/;
var $6986282d55d35034$var$removeTrailingSlash = function(path) {
    return path.replace($6986282d55d35034$var$TRAILING_SLASH_RE, "");
};
/**
 * Transforms an URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $6986282d55d35034$var$parseURL(parseQuery, location1) {
    var currentLocation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    var path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    var searchPos = location1.indexOf("?");
    var hashPos = location1.indexOf("#", searchPos > -1 ? searchPos : 0);
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $6986282d55d35034$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: hash
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $6986282d55d35034$var$stringifyURL(stringifyQuery, location1) {
    var query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non
 * case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $6986282d55d35034$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $6986282d55d35034$var$isSameRouteLocation(stringifyQuery, a, b) {
    var aLastIndex = a.matched.length - 1;
    var bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $6986282d55d35034$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $6986282d55d35034$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $6986282d55d35034$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $6986282d55d35034$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a){
        if (!$6986282d55d35034$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $6986282d55d35034$var$isSameRouteLocationParamsValue(a, b) {
    return Array.isArray(a) ? $6986282d55d35034$var$isEquivalentArray(a, b) : Array.isArray(b) ? $6986282d55d35034$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $6986282d55d35034$var$isEquivalentArray(a, b) {
    return Array.isArray(b) ? a.length === b.length && a.every(function(value, i) {
        return value === b[i];
    }) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $6986282d55d35034$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    var fromSegments = from.split("/");
    var toSegments = to.split("/");
    var position = fromSegments.length - 1;
    var toPosition;
    var segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // can't go below zero
        if (position === 1 || segment === ".") continue;
        if (segment === "..") position--;
        else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition - (toPosition === toSegments.length ? 1 : 0)).join("/");
}
var $6986282d55d35034$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($6986282d55d35034$var$NavigationType || ($6986282d55d35034$var$NavigationType = {}));
var $6986282d55d35034$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($6986282d55d35034$var$NavigationDirection || ($6986282d55d35034$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ var $6986282d55d35034$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $6986282d55d35034$var$normalizeBase(base) {
    if (!base) {
        if ($6986282d55d35034$var$isBrowser) {
            // respect <base> tag
            var baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $6986282d55d35034$var$removeTrailingSlash(base);
}
// remove any character before the hash
var $6986282d55d35034$var$BEFORE_HASH_RE = /^[^#]+#/;
function $6986282d55d35034$var$createHref(base, location1) {
    return base.replace($6986282d55d35034$var$BEFORE_HASH_RE, "#") + location1;
}
function $6986282d55d35034$var$getElementPosition(el, offset) {
    var docRect = document.documentElement.getBoundingClientRect();
    var elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
var $6986282d55d35034$var$computeScrollPosition = function() {
    return {
        left: window.pageXOffset,
        top: window.pageYOffset
    };
};
function $6986282d55d35034$var$scrollToPosition(position) {
    var scrollToOptions;
    if ("el" in position) {
        var positionEl = position.el;
        var isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        var el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $6986282d55d35034$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
}
function $6986282d55d35034$var$getScrollKey(path, delta) {
    var position = history.state ? history.state.position - delta : -1;
    return position + path;
}
var $6986282d55d35034$var$scrollPositions = new Map();
function $6986282d55d35034$var$saveScrollPosition(key, scrollPosition) {
    $6986282d55d35034$var$scrollPositions.set(key, scrollPosition);
}
function $6986282d55d35034$var$getSavedScrollPosition(key) {
    var scroll = $6986282d55d35034$var$scrollPositions.get(key);
    // consume it so it's not used again
    $6986282d55d35034$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
var $6986282d55d35034$var$createBaseLocation = function() {
    return location.protocol + "//" + location.host;
};
/**
 * Creates a normalized history location from a window.location object
 * @param location -
 */ function $6986282d55d35034$var$createCurrentLocation(base, location1) {
    var pathname = location1.pathname, search = location1.search, hash = location1.hash;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    var hashPos = base.indexOf("#");
    if (hashPos > -1) {
        var slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        var pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $6986282d55d35034$var$stripBase(pathFromHash, "");
    }
    var path = $6986282d55d35034$var$stripBase(pathname, base);
    return path + search + hash;
}
function $6986282d55d35034$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    var listeners = [];
    var teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    var pauseState = null;
    var popStateHandler = function(param) {
        var state = param.state;
        var to = $6986282d55d35034$var$createCurrentLocation(base, location);
        var from = currentLocation.value;
        var fromState = historyState.value;
        var delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // console.log({ deltaFromCurrent })
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach(function(listener) {
            listener(currentLocation.value, from, {
                delta: delta,
                type: $6986282d55d35034$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $6986282d55d35034$var$NavigationDirection.forward : $6986282d55d35034$var$NavigationDirection.back : $6986282d55d35034$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // setup the listener and prepare teardown callbacks
        listeners.push(callback);
        var teardown = function() {
            var index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        var history1 = window.history;
        if (!history1.state) return;
        history1.replaceState($6986282d55d35034$var$assign({}, history1.state, {
            scroll: $6986282d55d35034$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = teardowns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var teardown = _step.value;
                teardown();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // setup the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("beforeunload", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $6986282d55d35034$var$buildState(back, current, forward) {
    var replaced = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, computeScroll = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $6986282d55d35034$var$computeScrollPosition() : null
    };
}
function $6986282d55d35034$var$useHistoryStateNavigation(base) {
    var history1 = window.history, location1 = window.location;
    // private variables
    var currentLocation = {
        value: $6986282d55d35034$var$createCurrentLocation(base, location1)
    };
    var historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/vue-router-next/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ var hashIndex = base.indexOf("#");
        var url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $6986282d55d35034$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        var state = $6986282d55d35034$var$assign({}, history1.state, $6986282d55d35034$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        var currentState = $6986282d55d35034$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/vue-router-next/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $6986282d55d35034$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        var state = $6986282d55d35034$var$assign({}, $6986282d55d35034$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $6986282d55d35034$export$7b4942f78e7b8a49(base) {
    base = $6986282d55d35034$var$normalizeBase(base);
    var historyNavigation = $6986282d55d35034$var$useHistoryStateNavigation(base);
    var historyListeners = $6986282d55d35034$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta) {
        var triggerListeners = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    var routerHistory = $6986282d55d35034$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $6986282d55d35034$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: function() {
            return historyNavigation.location.value;
        }
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: function() {
            return historyNavigation.state.value;
        }
    });
    return routerHistory;
}
/**
 * Creates a in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $6986282d55d35034$export$2b76ad033c6e6d08() {
    var base = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var listeners = [];
    var queue = [
        $6986282d55d35034$var$START
    ];
    var position = 0;
    base = $6986282d55d35034$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position === queue.length) // we are at the end, we can simply append a new entry
        queue.push(location1);
        else {
            // we are in the middle, we remove everything from here in the queue
            queue.splice(position);
            queue.push(location1);
        }
    }
    function triggerListeners(to, from, param) {
        var direction = param.direction, delta = param.delta;
        var info = {
            direction: direction,
            delta: delta,
            type: $6986282d55d35034$var$NavigationType.pop
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                callback(to, from, info);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var routerHistory = {
        // rewritten by Object.defineProperty
        location: $6986282d55d35034$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $6986282d55d35034$var$createHref.bind(null, base),
        replace: function(to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push: function(to, data) {
            setLocation(to);
        },
        listen: function(callback) {
            listeners.push(callback);
            return function() {
                var index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy: function() {
            listeners = [];
            queue = [
                $6986282d55d35034$var$START
            ];
            position = 0;
        },
        go: function(delta) {
            var shouldTrigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var from = this.location;
            var direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $6986282d55d35034$var$NavigationDirection.back : $6986282d55d35034$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: function() {
            return queue[position];
        }
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g.
 * `file://`) or when configuring a server to handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname +
 * location.search` If there is a `<base>` tag in the `head`, its value will be
 * ignored in favor of this parameter **but note it affects all the
 * history.pushState() calls**, meaning that if you use a `<base>` tag, it's
 * `href` value **has to match this parameter** (ignoring anything after the
 * `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $6986282d55d35034$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $6986282d55d35034$export$7b4942f78e7b8a49(base);
}
function $6986282d55d35034$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $6986282d55d35034$var$isRouteName(name) {
    return typeof name === "string" || (typeof name === "undefined" ? "undefined" : (0, $6aBn7._)(name)) === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ var $6986282d55d35034$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
var $6986282d55d35034$var$NavigationFailureSymbol = /*#__PURE__*/ $6986282d55d35034$var$PolySymbol("nf");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $6986282d55d35034$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($6986282d55d35034$export$35710516f95d6a57 || ($6986282d55d35034$export$35710516f95d6a57 = {}));
var $6986282d55d35034$var$_obj;
// DEV only debug messages
var $6986282d55d35034$var$ErrorTypeMessages = ($6986282d55d35034$var$_obj = {}, (0, $ect5N._)($6986282d55d35034$var$_obj, 1 /* MATCHER_NOT_FOUND */ , function(param) {
    var location1 = param.location, currentLocation = param.currentLocation;
    return "No match for\n ".concat(JSON.stringify(location1)).concat(currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : "");
}), (0, $ect5N._)($6986282d55d35034$var$_obj, 2 /* NAVIGATION_GUARD_REDIRECT */ , function(param) {
    var from = param.from, to = param.to;
    return 'Redirected from "'.concat(from.fullPath, '" to "').concat($6986282d55d35034$var$stringifyRoute(to), '" via a navigation guard.');
}), (0, $ect5N._)($6986282d55d35034$var$_obj, 4 /* NAVIGATION_ABORTED */ , function(param) {
    var from = param.from, to = param.to;
    return 'Navigation aborted from "'.concat(from.fullPath, '" to "').concat(to.fullPath, '" via a navigation guard.');
}), (0, $ect5N._)($6986282d55d35034$var$_obj, 8 /* NAVIGATION_CANCELLED */ , function(param) {
    var from = param.from, to = param.to;
    return 'Navigation cancelled from "'.concat(from.fullPath, '" to "').concat(to.fullPath, '" with a new navigation.');
}), (0, $ect5N._)($6986282d55d35034$var$_obj, 16 /* NAVIGATION_DUPLICATED */ , function(param) {
    var from = param.from, to = param.to;
    return 'Avoided redundant navigation to current location: "'.concat(from.fullPath, '".');
}), $6986282d55d35034$var$_obj);
function $6986282d55d35034$var$createRouterError(type, params) {
    return $6986282d55d35034$var$assign(new Error(), (0, $ect5N._)({
        type: type
    }, $6986282d55d35034$var$NavigationFailureSymbol, true), params);
}
function $6986282d55d35034$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $6986282d55d35034$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
var $6986282d55d35034$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $6986282d55d35034$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if ("path" in to) return to.path;
    var location1 = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $6986282d55d35034$var$propertiesToLog[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key in to) location1[key] = to[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non greedy everything but /
var $6986282d55d35034$var$BASE_PARAM_PATTERN = "[^/]+?";
var $6986282d55d35034$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
var $6986282d55d35034$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $6986282d55d35034$var$tokensToParser(segments, extraOptions) {
    var options = $6986282d55d35034$var$assign({}, $6986282d55d35034$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    var score = [];
    // the regexp as a string
    var pattern = options.start ? "^" : "";
    // extracted keys
    var keys = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            // the root segment needs special treatment
            var segmentScores = segment.length ? [] : [
                90 /* Root */ 
            ];
            // allow trailing slash
            if (options.strict && !segment.length) pattern += "/";
            for(var tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
                var token = segment[tokenIndex];
                // resets the score if we are inside a sub segment /:a-other-:b
                var subSegmentScore = 40 /* Segment */  + (options.sensitive ? 0.25 /* BonusCaseSensitive */  : 0);
                if (token.type === 0 /* Static */ ) {
                    // prepend the slash if we are starting a new segment
                    if (!tokenIndex) pattern += "/";
                    pattern += token.value.replace($6986282d55d35034$var$REGEX_CHARS_RE, "\\$&");
                    subSegmentScore += 40 /* Static */ ;
                } else if (token.type === 1 /* Param */ ) {
                    var value = token.value, repeatable = token.repeatable, optional = token.optional, regexp = token.regexp;
                    keys.push({
                        name: value,
                        repeatable: repeatable,
                        optional: optional
                    });
                    var re = regexp ? regexp : $6986282d55d35034$var$BASE_PARAM_PATTERN;
                    // the user provided a custom regexp /:id(\\d+)
                    if (re !== $6986282d55d35034$var$BASE_PARAM_PATTERN) {
                        subSegmentScore += 10 /* BonusCustomRegExp */ ;
                        // make sure the regexp is valid before using it
                        try {
                            new RegExp("(".concat(re, ")"));
                        } catch (err) {
                            throw new Error('Invalid custom RegExp for param "'.concat(value, '" (').concat(re, "): ") + err.message);
                        }
                    }
                    // when we repeat we must take care of the repeating leading slash
                    var subPattern = repeatable ? "((?:".concat(re, ")(?:/(?:").concat(re, "))*)") : "(".concat(re, ")");
                    // prepend the slash if we are starting a new segment
                    if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                    // or /:p?-:p2
                    optional && segment.length < 2 ? "(?:/".concat(subPattern, ")") : "/" + subPattern;
                    if (optional) subPattern += "?";
                    pattern += subPattern;
                    subSegmentScore += 20 /* Dynamic */ ;
                    if (optional) subSegmentScore += -8 /* BonusOptional */ ;
                    if (repeatable) subSegmentScore += -20 /* BonusRepeatable */ ;
                    if (re === ".*") subSegmentScore += -50 /* BonusWildcard */ ;
                }
                segmentScores.push(subSegmentScore);
            }
            // an empty array like /home/ -> [[{home}], []]
            // if (!segment.length) pattern += '/'
            score.push(segmentScores);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        var i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    var re1 = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        var match = path.match(re1);
        var params = {};
        if (!match) return null;
        for(var i = 1; i < match.length; i++){
            var value = match[i] || "";
            var key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        var path = "";
        // for optional parameters to allow to be empty
        var avoidDuplicatedSlash = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var segment = _step.value;
                if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
                avoidDuplicatedSlash = false;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = segment[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var token = _step1.value;
                        if (token.type === 0 /* Static */ ) path += token.value;
                        else if (token.type === 1 /* Param */ ) {
                            var value = token.value, repeatable = token.repeatable, optional = token.optional;
                            var param = value in params ? params[value] : "";
                            if (Array.isArray(param) && !repeatable) throw new Error('Provided param "'.concat(value, '" is an array but it is not repeatable (* or + modifiers)'));
                            var text = Array.isArray(param) ? param.join("/") : param;
                            if (!text) {
                                if (optional) // if we have more than one optional param like /:a?-static we
                                // don't need to care about the optional param
                                {
                                    if (segment.length < 2) {
                                        // remove the last slash as we could be at the end
                                        if (path.endsWith("/")) path = path.slice(0, -1);
                                        else avoidDuplicatedSlash = true;
                                    }
                                } else throw new Error('Missing required param "'.concat(value, '"'));
                            }
                            path += text;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return path;
    }
    return {
        re: re1,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $6986282d55d35034$var$compareScoreArray(a, b) {
    var i = 0;
    while(i < a.length && i < b.length){
        var diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $6986282d55d35034$var$comparePathParserScore(a, b) {
    var i = 0;
    var aScore = a.score;
    var bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        var comp = $6986282d55d35034$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
var $6986282d55d35034$var$ROOT_TOKEN = {
    type: 0 /* Static */ ,
    value: ""
};
var $6986282d55d35034$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $6986282d55d35034$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $6986282d55d35034$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error('Invalid path "'.concat(path, '"'));
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error("ERR (".concat(state, ')/"').concat(buffer, '": ').concat(message));
    }
    var state = 0 /* Static */ ;
    var previousState = state;
    var tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    var segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    var i = 0;
    // char at index
    var char;
    // buffer of the value read
    var buffer = "";
    // custom regexp for a param
    var customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* Static */ ) segment.push({
            type: 0 /* Static */ ,
            value: buffer
        });
        else if (state === 1 /* Param */  || state === 2 /* ParamRegExp */  || state === 3 /* ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash("A repeatable param (".concat(buffer, ") must be alone in its segment. eg: '/:ids+."));
            segment.push({
                type: 1 /* Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* ParamRegExp */ ) {
            previousState = state;
            state = 4 /* EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* Param */ :
                if (char === "(") state = 2 /* ParamRegExp */ ;
                else if ($6986282d55d35034$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* ParamRegExp */ ) crash('Unfinished custom RegExp for param "'.concat(buffer, '"'));
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $6986282d55d35034$var$createRouteRecordMatcher(record, parent, options) {
    var parser = $6986282d55d35034$var$tokensToParser($6986282d55d35034$var$tokenizePath(record.path), options);
    var matcher = $6986282d55d35034$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $6986282d55d35034$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    var matchers = [];
    var matcherMap = new Map();
    globalOptions = $6986282d55d35034$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        var isRootAdd = !originalRecord;
        var mainNormalizedRecord = $6986282d55d35034$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        var options = $6986282d55d35034$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        var normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            var aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = aliases[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var alias = _step.value;
                    normalizedRecords.push($6986282d55d35034$var$assign({}, mainNormalizedRecord, {
                        // this allows us to hold a copy of the `components` option
                        // so that async components cache is hold on the original record
                        components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                        path: alias,
                        // we might be the child of an alias
                        aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
                    }));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var matcher;
        var originalMatcher;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = normalizedRecords[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var normalizedRecord = _step1.value;
                var path = normalizedRecord.path;
                // Build up the path for nested routes if the child isn't an absolute
                // route. Only add the / delimiter if the child path isn't empty and if the
                // parent path doesn't have a trailing slash
                if (parent && path[0] !== "/") {
                    var parentPath = parent.record.path;
                    var connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                    normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
                }
                // create the object before hand so it can be passed to children
                matcher = $6986282d55d35034$var$createRouteRecordMatcher(normalizedRecord, parent, options);
                // if we are an alias we must tell the original record that we exist
                // so we can be removed
                if (originalRecord) originalRecord.alias.push(matcher);
                else {
                    // otherwise, the first record is the original and others are aliases
                    originalMatcher = originalMatcher || matcher;
                    if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                    // remove the route if named and only for the top record (avoid in nested calls)
                    // this works because the original record is the first one
                    if (isRootAdd && record.name && !$6986282d55d35034$var$isAliasRecord(matcher)) removeRoute(record.name);
                }
                if ("children" in mainNormalizedRecord) {
                    var children = mainNormalizedRecord.children;
                    for(var i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
                }
                // if there was no original record, then the first one was not an alias and all
                // other alias (if any) need to reference this record when adding children
                originalRecord = originalRecord || matcher;
                // TODO: add normalized records for more flexibility
                // if (parent && isAliasRecord(originalRecord)) {
                //   parent.children.push(originalRecord)
                // }
                insertMatcher(matcher);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return originalMatcher ? function() {
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $6986282d55d35034$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($6986282d55d35034$var$isRouteName(matcherRef)) {
            var matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            var index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        var i = 0;
        // console.log('i is', { i })
        while(i < matchers.length && $6986282d55d35034$var$comparePathParserScore(matcher, matchers[i]) >= 0)i++;
        // console.log('END i is', { i })
        // while (i < matchers.length && matcher.score <= matchers[i].score) i++
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$6986282d55d35034$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        var matcher;
        var params = {};
        var path;
        var name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $6986282d55d35034$var$createRouterError(1 /* MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $6986282d55d35034$var$assign(// paramsFromLocation is a new object
            $6986282d55d35034$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter(function(k) {
                return !k.optional;
            }).map(function(k) {
                return k.name;
            })), location1.params);
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if ("path" in location1) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find(function(m) {
                return m.re.test(path);
            });
            // matcher should have a value after the loop
            if (matcher) {
                // TODO: dev warning of unused params if provided
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find(function(m) {
                return m.re.test(currentLocation.path);
            });
            if (!matcher) throw $6986282d55d35034$var$createRouterError(1 /* MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $6986282d55d35034$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        var matched = [];
        var parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $6986282d55d35034$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach(function(route) {
        return addRoute(route);
    });
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $6986282d55d35034$var$paramsFromLocation(params, keys) {
    var newParams = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key in params) newParams[key] = params[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $6986282d55d35034$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $6986282d55d35034$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || {} : {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $6986282d55d35034$var$normalizeRecordProps(record) {
    var propsObject = {};
    // props does not exist on redirect records but we can set false directly
    var props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(var name in record.components)propsObject[name] = typeof props === "boolean" ? props : props[name];
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $6986282d55d35034$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $6986282d55d35034$var$mergeMetaFields(matched) {
    return matched.reduce(function(meta, record) {
        return $6986282d55d35034$var$assign(meta, record.meta);
    }, {});
}
function $6986282d55d35034$var$mergeOptions(defaults, partialOptions) {
    var options = {};
    for(var key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $6986282d55d35034$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $6986282d55d35034$var$checkSameParams(a, b) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!key.optional && !b.keys.find($6986282d55d35034$var$isSameParam.bind(null, key))) return $6986282d55d35034$var$warn('Alias "'.concat(b.record.path, '" and the original record: "').concat(a.record.path, '" should have the exact same param named "').concat(key.name, '"'));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = b.keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            if (!key1.optional && !a.keys.find($6986282d55d35034$var$isSameParam.bind(null, key1))) return $6986282d55d35034$var$warn('Alias "'.concat(b.record.path, '" and the original record: "').concat(a.record.path, '" should have the exact same param named "').concat(key1.name, '"'));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
function $6986282d55d35034$var$checkMissingParamsInAbsolutePath(record, parent) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parent.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!record.keys.find($6986282d55d35034$var$isSameParam.bind(null, key))) return $6986282d55d35034$var$warn('Absolute path "'.concat(record.record.path, '" should have the exact same param named "').concat(key.name, '" as its parent "').concat(parent.record.path, '".'));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving unencoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
var $6986282d55d35034$var$HASH_RE = /#/g; // %23
var $6986282d55d35034$var$AMPERSAND_RE = /&/g; // %26
var $6986282d55d35034$var$SLASH_RE = /\//g; // %2F
var $6986282d55d35034$var$EQUAL_RE = /=/g; // %3D
var $6986282d55d35034$var$IM_RE = /\?/g; // %3F
var $6986282d55d35034$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ var $6986282d55d35034$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
var $6986282d55d35034$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
var $6986282d55d35034$var$ENC_CARET_RE = /%5E/g; // ^
var $6986282d55d35034$var$ENC_BACKTICK_RE = /%60/g; // `
var $6986282d55d35034$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
var $6986282d55d35034$var$ENC_PIPE_RE = /%7C/g; // |
var $6986282d55d35034$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
var $6986282d55d35034$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $6986282d55d35034$var$commonEncode(text) {
    return encodeURI("" + text).replace($6986282d55d35034$var$ENC_PIPE_RE, "|").replace($6986282d55d35034$var$ENC_BRACKET_OPEN_RE, "[").replace($6986282d55d35034$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $6986282d55d35034$var$encodeHash(text) {
    return $6986282d55d35034$var$commonEncode(text).replace($6986282d55d35034$var$ENC_CURLY_OPEN_RE, "{").replace($6986282d55d35034$var$ENC_CURLY_CLOSE_RE, "}").replace($6986282d55d35034$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $6986282d55d35034$var$encodeQueryValue(text) {
    return $6986282d55d35034$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($6986282d55d35034$var$PLUS_RE, "%2B").replace($6986282d55d35034$var$ENC_SPACE_RE, "+").replace($6986282d55d35034$var$HASH_RE, "%23").replace($6986282d55d35034$var$AMPERSAND_RE, "%26").replace($6986282d55d35034$var$ENC_BACKTICK_RE, "`").replace($6986282d55d35034$var$ENC_CURLY_OPEN_RE, "{").replace($6986282d55d35034$var$ENC_CURLY_CLOSE_RE, "}").replace($6986282d55d35034$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $6986282d55d35034$var$encodeQueryKey(text) {
    return $6986282d55d35034$var$encodeQueryValue(text).replace($6986282d55d35034$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $6986282d55d35034$var$encodePath(text) {
    return $6986282d55d35034$var$commonEncode(text).replace($6986282d55d35034$var$HASH_RE, "%23").replace($6986282d55d35034$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $6986282d55d35034$var$encodeParam(text) {
    return text == null ? "" : $6986282d55d35034$var$encodePath(text).replace($6986282d55d35034$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $6986282d55d35034$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $6986282d55d35034$export$1e8473eaf75b0d10(search) {
    var query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    var hasLeadingIM = search[0] === "?";
    var searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(var i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        var searchParam = searchParams[i].replace($6986282d55d35034$var$PLUS_RE, " ");
        // allow the = character
        var eqPos = searchParam.indexOf("=");
        var key = $6986282d55d35034$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        var value = eqPos < 0 ? null : $6986282d55d35034$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            var currentValue = query[key];
            if (!Array.isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $6986282d55d35034$export$d33b45a8f796a30(query) {
    var _loop = function(key1) {
        var value = query[key1];
        key1 = $6986282d55d35034$var$encodeQueryKey(key1);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key1;
            return key = key1, "continue";
        }
        // keep null values
        var values = Array.isArray(value) ? value.map(function(v) {
            return v && $6986282d55d35034$var$encodeQueryValue(v);
        }) : [
            value && $6986282d55d35034$var$encodeQueryValue(value)
        ];
        values.forEach(function(value) {
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key1;
                if (value != null) search += "=" + value;
            }
        });
        key = key1, void 0;
    };
    var search = "";
    for(var key in query)_loop(key);
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $6986282d55d35034$var$normalizeQuery(query) {
    var normalizedQuery = {};
    for(var key in query){
        var value = query[key];
        if (value !== undefined) normalizedQuery[key] = Array.isArray(value) ? value.map(function(v) {
            return v == null ? null : "" + v;
        }) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $6986282d55d35034$var$useCallbacks() {
    var handlers = [];
    function add(handler) {
        handlers.push(handler);
        return function() {
            var i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: function() {
            return handlers;
        },
        reset: reset
    };
}
function $6986282d55d35034$var$registerGuard(record, name, guard) {
    var removeFromList = function() {
        record[name].delete(guard);
    };
    (0, $9pglz.onUnmounted)(removeFromList);
    (0, $9pglz.onDeactivated)(removeFromList);
    (0, $9pglz.onActivated)(function() {
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $6986282d55d35034$export$d7fcdd004b009a9e(leaveGuard) {
    var activeRecord = (0, $9pglz.inject)($6986282d55d35034$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $6986282d55d35034$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $6986282d55d35034$export$46b4cb99461f4cc7(updateGuard) {
    var activeRecord = (0, $9pglz.inject)($6986282d55d35034$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $6986282d55d35034$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $6986282d55d35034$var$guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    var enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return function() {
        return new Promise(function(resolve, reject) {
            var next = function(valid) {
                if (valid === false) reject($6986282d55d35034$var$createRouterError(4 /* NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($6986282d55d35034$var$isRouteLocation(valid)) reject($6986282d55d35034$var$createRouterError(2 /* NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            var guardReturn = guard.call(record && record.instances[name], to, from, next);
            var guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch(function(err) {
                return reject(err);
            });
        });
    };
}
function $6986282d55d35034$var$canOnlyBeCalledOnce(next, to, from) {
    var called = 0;
    return function() {
        if (called++ === 1) $6986282d55d35034$var$warn('The "next" callback was called more than once in one navigation guard when going from "'.concat(from.fullPath, '" to "').concat(to.fullPath, '". It should be called exactly one time in each navigation guard. This will fail in production.'));
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $6986282d55d35034$var$extractComponentsGuards(matched, guardType, to, from) {
    var guards = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _loop = function(name) {
                var rawComponent = record.components[name];
                // skip update and leave guards if the route component is not mounted
                if (guardType !== "beforeRouteEnter" && !record.instances[name]) return "continue";
                if ($6986282d55d35034$var$isRouteComponent(rawComponent)) {
                    // __vccOpts is added by vue-class-component and contain the regular options
                    var options = rawComponent.__vccOpts || rawComponent;
                    var guard = options[guardType];
                    guard && guards.push($6986282d55d35034$var$guardToPromiseFn(guard, to, from, record, name));
                } else {
                    // start requesting the chunk already
                    var componentPromise = rawComponent();
                    guards.push(function() {
                        return componentPromise.then(function(resolved) {
                            if (!resolved) return Promise.reject(new Error("Couldn't resolve component \"".concat(name, '" at "').concat(record.path, '"')));
                            var resolvedComponent = $6986282d55d35034$var$isESModule(resolved) ? resolved.default : resolved;
                            // replace the function with the resolved component
                            record.components[name] = resolvedComponent;
                            // __vccOpts is added by vue-class-component and contain the regular options
                            var options = resolvedComponent.__vccOpts || resolvedComponent;
                            var guard = options[guardType];
                            return guard && $6986282d55d35034$var$guardToPromiseFn(guard, to, from, record, name)();
                        });
                    });
                }
            };
            var record = _step.value;
            for(var name in record.components)_loop(name);
        };
        for(var _iterator = matched[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 *
 * @param component
 */ function $6986282d55d35034$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $6986282d55d35034$export$dcf14c9974fe2767(props) {
    var router = (0, $9pglz.inject)($6986282d55d35034$export$b6c0da8b9dae491f);
    var currentRoute = (0, $9pglz.inject)($6986282d55d35034$export$3aca783e9a3e6e9e);
    var route = (0, $Dz4HH.computed)(function() {
        return router.resolve((0, $Dz4HH.unref)(props.to));
    });
    var activeRecordIndex = (0, $Dz4HH.computed)(function() {
        var matched = route.value.matched;
        var length = matched.length;
        var routeMatched = matched[length - 1];
        var currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        var index = currentMatched.findIndex($6986282d55d35034$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        var parentRecordPath = $6986282d55d35034$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $6986282d55d35034$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($6986282d55d35034$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    var isActive = (0, $Dz4HH.computed)(function() {
        return activeRecordIndex.value > -1 && $6986282d55d35034$var$includesParams(currentRoute.params, route.value.params);
    });
    var isExactActive = (0, $Dz4HH.computed)(function() {
        return activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $6986282d55d35034$var$isSameRouteLocationParams(currentRoute.params, route.value.params);
    });
    function navigate() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if ($6986282d55d35034$var$guardEvent(e)) return router[(0, $Dz4HH.unref)(props.replace) ? "replace" : "push"]((0, $Dz4HH.unref)(props.to)).catch($6986282d55d35034$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $6986282d55d35034$var$isBrowser) {
        var instance = (0, $9pglz.getCurrentInstance)();
        if (instance) {
            var linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $9pglz.watchEffect)(function() {
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: "post"
            });
        }
    }
    return {
        route: route,
        href: (0, $Dz4HH.computed)(function() {
            return route.value.href;
        }),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
var $6986282d55d35034$var$RouterLinkImpl = /*#__PURE__*/ (0, $9pglz.defineComponent)({
    name: "RouterLink",
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $6986282d55d35034$export$dcf14c9974fe2767,
    setup: function(props, param) {
        var slots = param.slots;
        var link = (0, $Dz4HH.reactive)($6986282d55d35034$export$dcf14c9974fe2767(props));
        var options = (0, $9pglz.inject)($6986282d55d35034$export$b6c0da8b9dae491f).options;
        var elClass = (0, $Dz4HH.computed)(function() {
            var _obj;
            return _obj = {}, (0, $ect5N._)(_obj, $6986282d55d35034$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active"), link.isActive), // [getLinkClass(
            //   props.inactiveClass,
            //   options.linkInactiveClass,
            //   'router-link-inactive'
            // )]: !link.isExactActive,
            (0, $ect5N._)(_obj, $6986282d55d35034$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active"), link.isExactActive), _obj;
        });
        return function() {
            var children = slots.default && slots.default(link);
            return props.custom ? children : (0, $9pglz.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ var $6986282d55d35034$export$fce709ebdac448ed = $6986282d55d35034$var$RouterLinkImpl;
function $6986282d55d35034$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        var target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $6986282d55d35034$var$includesParams(outer, inner) {
    var _loop = function(key) {
        var innerValue = inner[key];
        var outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return {
                v: false
            };
        } else {
            if (!Array.isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some(function(value, i) {
                return value !== outerValue[i];
            })) return {
                v: false
            };
        }
    };
    for(var key in inner){
        var _ret = _loop(key);
        if ((0, $6aBn7._)(_ret) === "object") return _ret.v;
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $6986282d55d35034$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ var $6986282d55d35034$var$getLinkClass = function(propClass, globalClass, defaultClass) {
    return propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
};
var $6986282d55d35034$var$RouterViewImpl = /*#__PURE__*/ (0, $9pglz.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    setup: function(props, param) {
        var attrs = param.attrs, slots = param.slots;
        var injectedRoute = (0, $9pglz.inject)($6986282d55d35034$export$54c8124bead129f8);
        var routeToDisplay = (0, $Dz4HH.computed)(function() {
            return props.route || injectedRoute.value;
        });
        var depth = (0, $9pglz.inject)($6986282d55d35034$export$9b3825c34ca1427a, 0);
        var matchedRouteRef = (0, $Dz4HH.computed)(function() {
            return routeToDisplay.value.matched[depth];
        });
        (0, $9pglz.provide)($6986282d55d35034$export$9b3825c34ca1427a, depth + 1);
        (0, $9pglz.provide)($6986282d55d35034$export$7f4879db1558672d, matchedRouteRef);
        (0, $9pglz.provide)($6986282d55d35034$export$54c8124bead129f8, routeToDisplay);
        var viewRef = (0, $Dz4HH.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $9pglz.watch)(function() {
            return [
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ];
        }, function(param, param1) {
            var _param = (0, $fGQt0._)(param, 3), instance = _param[0], to = _param[1], name = _param[2], _param1 = (0, $fGQt0._)(param1, 3), oldInstance = _param1[0], from = _param1[1], oldName = _param1[2];
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$6986282d55d35034$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach(function(callback) {
                return callback(instance);
            });
        }, {
            flush: "post"
        });
        return function() {
            var route = routeToDisplay.value;
            var matchedRoute = matchedRouteRef.value;
            var ViewComponent = matchedRoute && matchedRoute.components[props.name];
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            var currentName = props.name;
            if (!ViewComponent) return $6986282d55d35034$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            var routePropsOption = matchedRoute.props[props.name];
            var routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            var onVnodeUnmounted = function(vnode) {
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            var component = (0, $9pglz.h)(ViewComponent, $6986282d55d35034$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $6986282d55d35034$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                var info = {
                    depth: depth,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                var internalInstances = Array.isArray(component.ref) ? component.ref.map(function(r) {
                    return r.i;
                }) : [
                    component.ref.i
                ];
                internalInstances.forEach(function(instance) {
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $6986282d55d35034$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $6986282d55d35034$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    var slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ var $6986282d55d35034$export$d941f00e9b9a537 = $6986282d55d35034$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $6986282d55d35034$var$warnDeprecatedUsage() {
    var instance = (0, $9pglz.getCurrentInstance)();
    var parentName = instance.parent && instance.parent.type.name;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition"))) {
        var comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $6986282d55d35034$var$warn("<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n" + "Use slot props instead:\n\n" + '<router-view v-slot="{ Component }">\n' + "  <".concat(comp, ">\n") + '    <component :is="Component" />\n' + "  </".concat(comp, ">\n") + "</router-view>");
    }
}
function $6986282d55d35034$var$formatRouteLocation(routeLocation, tooltip) {
    var copy = $6986282d55d35034$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map(function(matched) {
            return $6986282d55d35034$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]);
        })
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $6986282d55d35034$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
var $6986282d55d35034$var$routerId = 0;
function $6986282d55d35034$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    var id = $6986282d55d35034$var$routerId++;
    (0, $a3760ba8d19c2470$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://next.router.vuejs.org/",
        logo: "https://vuejs.org/images/icons/favicon-96x96.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, function(api) {
        // display state added by the router
        api.on.inspectComponent(function(payload, ctx) {
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $6986282d55d35034$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(function(param) {
            var node = param.treeNode, componentInstance = param.componentInstance;
            if (componentInstance.__vrv_devtools) {
                var info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? "".concat(info.name.toString(), ": ") : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $6986282d55d35034$var$PINK_500
                });
            }
            // if multiple useLink are used
            if (Array.isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach(function(devtoolsData) {
                    var backgroundColor = $6986282d55d35034$var$ORANGE_400;
                    var tooltip = "";
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $6986282d55d35034$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $6986282d55d35034$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $9pglz.watch)(router.currentRoute, function() {
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        var navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: "Router".concat(id ? " " + id : "", " Navigations"),
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError(function(error, to) {
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: Date.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        var navigationId = 0;
        router.beforeEach(function(to, from) {
            var data = {
                guard: $6986282d55d35034$var$formatDisplay("beforeEach"),
                from: $6986282d55d35034$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $6986282d55d35034$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: Date.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach(function(to, from, failure) {
            var data = {
                guard: $6986282d55d35034$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $6986282d55d35034$var$formatDisplay("\u274C");
            } else data.status = $6986282d55d35034$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $6986282d55d35034$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $6986282d55d35034$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: Date.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ var routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            var payload = activeRoutesPayload;
            // children routes will appear as nested
            var routes = matcher.getRoutes().filter(function(route) {
                return !route.parent;
            });
            // reset match state to false
            routes.forEach($6986282d55d35034$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter(function(route) {
                return(// save matches state based on the payload
                $6986282d55d35034$var$isRouteMatching(route, payload.filter.toLowerCase()));
            });
            // mark active routes
            routes.forEach(function(route) {
                return $6986282d55d35034$var$markRouteRecordActive(route, router.currentRoute.value);
            });
            payload.rootNodes = routes.map($6986282d55d35034$var$formatRouteRecordForInspector);
        }
        var activeRoutesPayload;
        api.on.getInspectorTree(function(payload) {
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                var routes = matcher.getRoutes();
                var route = routes.find(function(route) {
                    return route.record.__vd_id === payload.nodeId;
                });
                if (route) payload.state = {
                    options: $6986282d55d35034$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $6986282d55d35034$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $6986282d55d35034$var$formatRouteRecordMatcherForStateInspector(route) {
    var record = route.record;
    var fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map(function(key) {
                    return "".concat(key.name).concat($6986282d55d35034$var$modifierForKey(key));
                }).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map(function(alias) {
            return alias.record.path;
        })
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map(function(score) {
                    return score.join(", ");
                }).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ var $6986282d55d35034$var$PINK_500 = 0xec4899;
var $6986282d55d35034$var$BLUE_600 = 0x2563eb;
var $6986282d55d35034$var$LIME_500 = 0x84cc16;
var $6986282d55d35034$var$CYAN_400 = 0x22d3ee;
var $6986282d55d35034$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
var $6986282d55d35034$var$DARK = 0x666666;
function $6986282d55d35034$var$formatRouteRecordForInspector(route) {
    var tags = [];
    var record = route.record;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $6986282d55d35034$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $6986282d55d35034$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $6986282d55d35034$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $6986282d55d35034$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $6986282d55d35034$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: "redirect: " + (typeof record.redirect === "string" ? record.redirect : "Object"),
        textColor: 0xffffff,
        backgroundColor: $6986282d55d35034$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    var id = record.__vd_id;
    if (id == null) {
        id = String($6986282d55d35034$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($6986282d55d35034$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
var $6986282d55d35034$var$routeRecordId = 0;
var $6986282d55d35034$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $6986282d55d35034$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    var isExactActive = currentRoute.matched.length && $6986282d55d35034$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some(function(match) {
        return $6986282d55d35034$var$isSameRouteRecord(match, route.record);
    });
    route.children.forEach(function(childRoute) {
        return $6986282d55d35034$var$markRouteRecordActive(childRoute, currentRoute);
    });
}
function $6986282d55d35034$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($6986282d55d35034$var$resetMatchStateOnRouteRecord);
}
function $6986282d55d35034$var$isRouteMatching(route, filter) {
    var found = String(route.re).match($6986282d55d35034$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    var nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach(function(child) {
            return $6986282d55d35034$var$isRouteMatching(child, filter);
        });
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    var path = route.record.path.toLowerCase();
    var decodedPath = $6986282d55d35034$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some(function(child) {
        return $6986282d55d35034$var$isRouteMatching(child, filter);
    });
}
function $6986282d55d35034$var$omit(obj, keys) {
    var ret = {};
    for(var key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $6986282d55d35034$export$baddd0131ee8c05b(options) {
    var matcher = $6986282d55d35034$export$36302c85fdcc95a8(options.routes, options);
    var parseQuery$1 = options.parseQuery || $6986282d55d35034$export$1e8473eaf75b0d10;
    var stringifyQuery$1 = options.stringifyQuery || $6986282d55d35034$export$d33b45a8f796a30;
    var routerHistory = options.history;
    var beforeGuards = $6986282d55d35034$var$useCallbacks();
    var beforeResolveGuards = $6986282d55d35034$var$useCallbacks();
    var afterGuards = $6986282d55d35034$var$useCallbacks();
    var currentRoute = (0, $Dz4HH.shallowRef)($6986282d55d35034$export$e44be9a9779c480b);
    var pendingLocation = $6986282d55d35034$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($6986282d55d35034$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    var normalizeParams = $6986282d55d35034$var$applyToParams.bind(null, function(paramValue) {
        return "" + paramValue;
    });
    var encodeParams = $6986282d55d35034$var$applyToParams.bind(null, $6986282d55d35034$var$encodeParam);
    var decodeParams = // @ts-expect-error: intentionally avoid the type check
    $6986282d55d35034$var$applyToParams.bind(null, $6986282d55d35034$var$decode);
    function addRoute(parentOrRoute, route) {
        var parent;
        var record;
        if ($6986282d55d35034$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        var recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map(function(routeMatcher) {
            return routeMatcher.record;
        });
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $6986282d55d35034$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            var locationNormalized = $6986282d55d35034$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            var matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            var href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $6986282d55d35034$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $6986282d55d35034$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        var matcherLocation;
        // path could be relative in object as well
        if ("path" in rawLocation) matcherLocation = $6986282d55d35034$var$assign({}, rawLocation, {
            path: $6986282d55d35034$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            var targetParams = $6986282d55d35034$var$assign({}, rawLocation.params);
            for(var key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher so it can produce encoded path and fullPath
            matcherLocation = $6986282d55d35034$var$assign({}, rawLocation, {
                params: encodeParams(rawLocation.params)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        var matchedRoute1 = matcher.resolve(matcherLocation, currentLocation);
        var hash = rawLocation.hash || "";
        // decoding them) the matcher might have merged current location params so
        // we need to run the decoding again
        matchedRoute1.params = normalizeParams(decodeParams(matchedRoute1.params));
        var fullPath = $6986282d55d35034$var$stringifyURL(stringifyQuery$1, $6986282d55d35034$var$assign({}, rawLocation, {
            hash: $6986282d55d35034$var$encodeHash(hash),
            path: matchedRoute1.path
        }));
        var href1 = routerHistory.createHref(fullPath);
        return $6986282d55d35034$var$assign({
            fullPath: fullPath,
            // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash: hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/vue-router-next/issues/328#issuecomment-649481567
            stringifyQuery$1 === $6986282d55d35034$export$d33b45a8f796a30 ? $6986282d55d35034$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute1, {
            redirectedFrom: undefined,
            href: href1
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $6986282d55d35034$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $6986282d55d35034$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $6986282d55d35034$var$createRouterError(8 /* NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($6986282d55d35034$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        var lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            var redirect = lastMatched.redirect;
            var newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $6986282d55d35034$var$assign({
                query: to.query,
                hash: to.hash,
                params: to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        var targetLocation = pendingLocation = resolve(to);
        var from = currentRoute.value;
        var data = to.state;
        var force = to.force;
        // to could be a string where `replace` is a function
        var _$replace = to.replace === true;
        var shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($6986282d55d35034$var$assign(locationAsObject(shouldRedirect), {
            state: data,
            force: force,
            replace: _$replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        var toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        var failure;
        if (!force && $6986282d55d35034$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $6986282d55d35034$var$createRouterError(16 /* NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch(function(error) {
            return $6986282d55d35034$export$873de56207a30e5a(error) ? error : triggerError(error, toLocation, from);
        }).then(function(failure) {
            if (failure) {
                if ($6986282d55d35034$export$873de56207a30e5a(failure, 2 /* NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $6986282d55d35034$var$assign(locationAsObject(failure.to), {
                    state: data,
                    force: force,
                    replace: _$replace
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, _$replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        var error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        var guards;
        var _extractChangingRecords = (0, $fGQt0._)($6986282d55d35034$var$extractChangingRecords(to, from), 3), leavingRecords = _extractChangingRecords[0], updatingRecords = _extractChangingRecords[1], enteringRecords = _extractChangingRecords[2];
        // all components here have been resolved once because we are leaving
        guards = $6986282d55d35034$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // leavingRecords is already reversed
            for(var _iterator = leavingRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var record = _step.value;
                record.leaveGuards.forEach(function(guard) {
                    guards.push($6986282d55d35034$var$guardToPromiseFn(guard, to, from));
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return $6986282d55d35034$var$runGuardQueue(guards).then(function() {
            // check global guards beforeEach
            guards = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = beforeGuards.list()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var guard = _step.value;
                    guards.push($6986282d55d35034$var$guardToPromiseFn(guard, to, from));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            return $6986282d55d35034$var$runGuardQueue(guards);
        }).then(function() {
            // check in components beforeRouteUpdate
            guards = $6986282d55d35034$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = updatingRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var record = _step.value;
                    record.updateGuards.forEach(function(guard) {
                        guards.push($6986282d55d35034$var$guardToPromiseFn(guard, to, from));
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $6986282d55d35034$var$runGuardQueue(guards);
        }).then(function() {
            // check the route beforeEnter
            guards = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = to.matched[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var record = _step.value;
                    // do not trigger beforeEnter on reused views
                    if (record.beforeEnter && !from.matched.includes(record)) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (Array.isArray(record.beforeEnter)) try {
                            for(var _iterator1 = record.beforeEnter[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var beforeEnter = _step1.value;
                                guards.push($6986282d55d35034$var$guardToPromiseFn(beforeEnter, to, from));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else guards.push($6986282d55d35034$var$guardToPromiseFn(record.beforeEnter, to, from));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $6986282d55d35034$var$runGuardQueue(guards);
        }).then(function() {
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach(function(record) {
                return record.enterCallbacks = {};
            });
            // check in-component beforeRouteEnter
            guards = $6986282d55d35034$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $6986282d55d35034$var$runGuardQueue(guards);
        }).then(function() {
            // check global guards beforeResolve
            guards = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = beforeResolveGuards.list()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var guard = _step.value;
                    guards.push($6986282d55d35034$var$guardToPromiseFn(guard, to, from));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            return $6986282d55d35034$var$runGuardQueue(guards);
        })// catch any navigation canceled
        .catch(function(err) {
            return $6986282d55d35034$export$873de56207a30e5a(err, 8 /* NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err);
        });
    }
    function triggerAfterEach(to, from, failure) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // navigation is confirmed, call afterGuards
            // TODO: wrap with error handlers
            for(var _iterator = afterGuards.list()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var guard = _step.value;
                guard(to, from, failure);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        var error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        var isFirstNavigation = from === $6986282d55d35034$export$e44be9a9779c480b;
        var state = !$6986282d55d35034$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $6986282d55d35034$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    var removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        removeHistoryListener = routerHistory.listen(function(to, _from, info) {
            // cannot be a redirect route because it was in history
            var toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            var shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($6986282d55d35034$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($6986282d55d35034$var$noop);
                return;
            }
            pendingLocation = toLocation;
            var from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($6986282d55d35034$var$isBrowser) $6986282d55d35034$var$saveScrollPosition($6986282d55d35034$var$getScrollKey(from.fullPath, info.delta), $6986282d55d35034$var$computeScrollPosition());
            navigate(toLocation, from).catch(function(error) {
                if ($6986282d55d35034$export$873de56207a30e5a(error, 12 /* NAVIGATION_CANCELLED */ )) return error;
                if ($6986282d55d35034$export$873de56207a30e5a(error, 2 /* NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is not guarantee for
                    // it to work on every browser. So Instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then(function(failure) {
                        // manual change in hash history #916 ending up in the URL not
                        // changing but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($6986282d55d35034$export$873de56207a30e5a(failure, 20 /* NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $6986282d55d35034$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($6986282d55d35034$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then(function(failure) {
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta) routerHistory.go(-info.delta, false);
                    else if (info.type === $6986282d55d35034$var$NavigationType.pop && $6986282d55d35034$export$873de56207a30e5a(failure, 20 /* NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch($6986282d55d35034$var$noop);
        });
    }
    // Initialization and Errors
    var readyHandlers = $6986282d55d35034$var$useCallbacks();
    var errorHandlers = $6986282d55d35034$var$useCallbacks();
    var ready;
    /**
     * Trigger errorHandlers added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        var list = errorHandlers.list();
        if (list.length) list.forEach(function(handler) {
            return handler(error, to, from);
        });
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $6986282d55d35034$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    /**
     * Mark the router as ready, resolving the promised returned by isReady(). Can
     * only be called once, otherwise does nothing.
     * @param err - optional error
     */ function markAsReady(err) {
        if (ready) return;
        ready = true;
        setupListeners();
        readyHandlers.list().forEach(function(param) {
            var _param = (0, $fGQt0._)(param, 2), _$resolve = _param[0], reject = _param[1];
            return err ? reject(err) : _$resolve();
        });
        readyHandlers.reset();
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        var scrollBehavior = options.scrollBehavior;
        if (!$6986282d55d35034$var$isBrowser || !scrollBehavior) return Promise.resolve();
        var scrollPosition = !isPush && $6986282d55d35034$var$getSavedScrollPosition($6986282d55d35034$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $9pglz.nextTick)().then(function() {
            return scrollBehavior(to, from, scrollPosition);
        }).then(function(position) {
            return position && $6986282d55d35034$var$scrollToPosition(position);
        }).catch(function(err) {
            return triggerError(err, to, from);
        });
    }
    var go = function(delta) {
        return routerHistory.go(delta);
    };
    var started;
    var installedApps = new Set();
    var router = {
        currentRoute: currentRoute,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: function() {
            return go(-1);
        },
        forward: function() {
            return go(1);
        },
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorHandlers.add,
        isReady: isReady,
        install: function(app) {
            var _loop = function(key) {
                // @ts-expect-error: the key matches
                reactiveRoute[key] = (0, $Dz4HH.computed)(function() {
                    return currentRoute.value[key];
                });
            };
            var router = this;
            app.component("RouterLink", $6986282d55d35034$export$fce709ebdac448ed);
            app.component("RouterView", $6986282d55d35034$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: function() {
                    return (0, $Dz4HH.unref)(currentRoute);
                }
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($6986282d55d35034$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $6986282d55d35034$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch(function(err) {});
            }
            var reactiveRoute = {};
            for(var key in $6986282d55d35034$export$e44be9a9779c480b)_loop(key);
            app.provide($6986282d55d35034$export$b6c0da8b9dae491f, router);
            app.provide($6986282d55d35034$export$3aca783e9a3e6e9e, (0, $Dz4HH.reactive)(reactiveRoute));
            app.provide($6986282d55d35034$export$54c8124bead129f8, currentRoute);
            var unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $6986282d55d35034$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    currentRoute.value = $6986282d55d35034$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && $6986282d55d35034$var$isBrowser) $6986282d55d35034$var$addDevtools(app, router, matcher);
        }
    };
    return router;
}
function $6986282d55d35034$var$runGuardQueue(guards) {
    return guards.reduce(function(promise, guard) {
        return promise.then(function() {
            return guard();
        });
    }, Promise.resolve());
}
function $6986282d55d35034$var$extractChangingRecords(to, from) {
    var _loop = function(i) {
        var recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find(function(record) {
                return $6986282d55d35034$var$isSameRouteRecord(record, recordFrom);
            })) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        var recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find(function(record) {
                return $6986282d55d35034$var$isSameRouteRecord(record, recordTo);
            })) enteringRecords.push(recordTo);
        }
    };
    var leavingRecords = [];
    var updatingRecords = [];
    var enteringRecords = [];
    var len = Math.max(from.matched.length, to.matched.length);
    for(var i = 0; i < len; i++)_loop(i);
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $6986282d55d35034$export$9a302a45f65d0572() {
    return (0, $9pglz.inject)($6986282d55d35034$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $6986282d55d35034$export$3f79f0b98112cf57() {
    return (0, $9pglz.inject)($6986282d55d35034$export$3aca783e9a3e6e9e);
}


var $450cd9afaeb1592d$var$script;



var $450cd9afaeb1592d$var$initialize = function() {
    $450cd9afaeb1592d$var$script = (parcelRequire("kvz0p"));
    if ($450cd9afaeb1592d$var$script.__esModule) $450cd9afaeb1592d$var$script = $450cd9afaeb1592d$var$script.default;
    $450cd9afaeb1592d$var$script.render = (parcelRequire("j2Oe7")).render;
    (parcelRequire("8xLzG")).default($450cd9afaeb1592d$var$script);
    $450cd9afaeb1592d$var$script.__scopeId = "data-v-335b60";
    $450cd9afaeb1592d$var$script.__file = "Root.vue";
};
$450cd9afaeb1592d$var$initialize();
var $450cd9afaeb1592d$export$2e2bcd8739ae039 = $450cd9afaeb1592d$var$script;


var $58bc8bd34e1d1cd3$var$script;



var $58bc8bd34e1d1cd3$var$initialize = function() {
    $58bc8bd34e1d1cd3$var$script = (parcelRequire("8FqXK"));
    if ($58bc8bd34e1d1cd3$var$script.__esModule) $58bc8bd34e1d1cd3$var$script = $58bc8bd34e1d1cd3$var$script.default;
    $58bc8bd34e1d1cd3$var$script.render = (parcelRequire("dMYgs")).render;
    (parcelRequire("ccJaj")).default($58bc8bd34e1d1cd3$var$script);
    $58bc8bd34e1d1cd3$var$script.__scopeId = "data-v-d2722d";
    $58bc8bd34e1d1cd3$var$script.__file = "App.vue";
};
$58bc8bd34e1d1cd3$var$initialize();
var $58bc8bd34e1d1cd3$export$2e2bcd8739ae039 = $58bc8bd34e1d1cd3$var$script;


var $665fb4b7d4f27076$var$script;




var $665fb4b7d4f27076$var$initialize = function() {
    $665fb4b7d4f27076$var$script = (parcelRequire("5XCFB"));
    if ($665fb4b7d4f27076$var$script.__esModule) $665fb4b7d4f27076$var$script = $665fb4b7d4f27076$var$script.default;
    $665fb4b7d4f27076$var$script.render = (parcelRequire("ah3Fj")).render;
    $665fb4b7d4f27076$var$script.__cssModules = {};
    (parcelRequire("4tj3t")).default($665fb4b7d4f27076$var$script);
    $665fb4b7d4f27076$var$script.__scopeId = "data-v-601f7c";
    $665fb4b7d4f27076$var$script.__file = "Home.vue";
};
$665fb4b7d4f27076$var$initialize();
var $665fb4b7d4f27076$export$2e2bcd8739ae039 = $665fb4b7d4f27076$var$script;


var $7f5ac3a3e41340d3$var$script;




var $7f5ac3a3e41340d3$var$initialize = function() {
    $7f5ac3a3e41340d3$var$script = (parcelRequire("fRbzk"));
    if ($7f5ac3a3e41340d3$var$script.__esModule) $7f5ac3a3e41340d3$var$script = $7f5ac3a3e41340d3$var$script.default;
    $7f5ac3a3e41340d3$var$script.render = (parcelRequire("e6wQP")).render;
    $7f5ac3a3e41340d3$var$script.__cssModules = {};
    (parcelRequire("5INXe")).default($7f5ac3a3e41340d3$var$script);
    $7f5ac3a3e41340d3$var$script.__scopeId = "data-v-8ff11a";
    $7f5ac3a3e41340d3$var$script.__file = "Card.vue";
};
$7f5ac3a3e41340d3$var$initialize();
var $7f5ac3a3e41340d3$export$2e2bcd8739ae039 = $7f5ac3a3e41340d3$var$script;


var $ffae8c228c0868b6$var$script;




var $ffae8c228c0868b6$var$initialize = function() {
    $ffae8c228c0868b6$var$script = (parcelRequire("uLGMy"));
    if ($ffae8c228c0868b6$var$script.__esModule) $ffae8c228c0868b6$var$script = $ffae8c228c0868b6$var$script.default;
    $ffae8c228c0868b6$var$script.render = (parcelRequire("5vPiz")).render;
    $ffae8c228c0868b6$var$script.__cssModules = {};
    (parcelRequire("jYMMV")).default($ffae8c228c0868b6$var$script);
    $ffae8c228c0868b6$var$script.__scopeId = "data-v-cfa3c3";
    $ffae8c228c0868b6$var$script.__file = "Title.vue";
};
$ffae8c228c0868b6$var$initialize();
var $ffae8c228c0868b6$export$2e2bcd8739ae039 = $ffae8c228c0868b6$var$script;


var $ae2f9c0b280185c4$var$script;




var $ae2f9c0b280185c4$var$initialize = function() {
    $ae2f9c0b280185c4$var$script = (parcelRequire("20sZd"));
    if ($ae2f9c0b280185c4$var$script.__esModule) $ae2f9c0b280185c4$var$script = $ae2f9c0b280185c4$var$script.default;
    $ae2f9c0b280185c4$var$script.render = (parcelRequire("7Zccd")).render;
    $ae2f9c0b280185c4$var$script.__cssModules = {};
    (parcelRequire("jT2ze")).default($ae2f9c0b280185c4$var$script);
    $ae2f9c0b280185c4$var$script.__scopeId = "data-v-6f1940";
    $ae2f9c0b280185c4$var$script.__file = "Projects.vue";
};
$ae2f9c0b280185c4$var$initialize();
var $ae2f9c0b280185c4$export$2e2bcd8739ae039 = $ae2f9c0b280185c4$var$script;


var $df2692fa06efa23e$var$script;




var $df2692fa06efa23e$var$initialize = function() {
    $df2692fa06efa23e$var$script = (parcelRequire("8qUxc"));
    if ($df2692fa06efa23e$var$script.__esModule) $df2692fa06efa23e$var$script = $df2692fa06efa23e$var$script.default;
    $df2692fa06efa23e$var$script.render = (parcelRequire("3QEE4")).render;
    $df2692fa06efa23e$var$script.__cssModules = {};
    (parcelRequire("ipLlQ")).default($df2692fa06efa23e$var$script);
    $df2692fa06efa23e$var$script.__scopeId = "data-v-82a9c0";
    $df2692fa06efa23e$var$script.__file = "Project.vue";
};
$df2692fa06efa23e$var$initialize();
var $df2692fa06efa23e$export$2e2bcd8739ae039 = $df2692fa06efa23e$var$script;


var $e1ba05b0b482fba0$var$script;




var $e1ba05b0b482fba0$var$initialize = function() {
    $e1ba05b0b482fba0$var$script = (parcelRequire("lF6C7"));
    if ($e1ba05b0b482fba0$var$script.__esModule) $e1ba05b0b482fba0$var$script = $e1ba05b0b482fba0$var$script.default;
    $e1ba05b0b482fba0$var$script.render = (parcelRequire("9KZEc")).render;
    $e1ba05b0b482fba0$var$script.__cssModules = {};
    (parcelRequire("eoUEK")).default($e1ba05b0b482fba0$var$script);
    $e1ba05b0b482fba0$var$script.__scopeId = "data-v-ab399b";
    $e1ba05b0b482fba0$var$script.__file = "Header.vue";
};
$e1ba05b0b482fba0$var$initialize();
var $e1ba05b0b482fba0$export$2e2bcd8739ae039 = $e1ba05b0b482fba0$var$script;


var $dc67fde8a3a75c29$exports = {};
$dc67fde8a3a75c29$exports = "<p><a href=\"https://perfanalytics.fr/\">Perfanalytics</a> est un projet de recherche porté par <a href=\"https://www.inria.fr/fr\">l'institut national de recherche en sciences et technologies du numérique (INRIA)</a> en vue des Jeux Olympiques et Paralympiques de Paris 2024. Il vise le développement des outils d'analyse vidéo pour fournir des indicateurs de performance aux entraîneurs et athlètes.</p><p>En 2021 j'ai réalisé un stage à Grenoble pour développer des outils numériques dans le cadre de ce projet. J'ai notament travaillé sur de la <strong>détection d'objets</strong> par I.A. et des projections de vidéos dans un environnement <strong>3D</strong>.</p><img src=\"/detections.3948b0cd.webp\" alt=\"Détections de prises d'escalade\"><div class=\"img-desc\">Détections de prises d'escalade avec le modèle YOLO</div><img src=\"/proj.62c3a323.webp\" alt=\"Projection de la vidéo dans un monde virtuel\"><div class=\"img-desc\">Projection de la vidéo dans un monde virtuel</div><p>L'expérience était très enrichissante : j'ai eu l'occasion de travailler sur plusieurs sujets et technologies, allant de la programmation de <em>Dashboards</em> en Python ; à l'entraînement de modèles d'Intelligence Artificielle ; à la 3D et la modélisation.</p>";


var $a7213980b3075060$exports = {};
$a7213980b3075060$exports = "<p><a href=\"https://perfanalytics.fr/\">Perfanalytics</a> is an ongoing research project aiming at developing performance indicators using video analysis. The project is lead by the <a href=\"https://www.inria.fr/en\">French National Institute for Research in Digital Science and Technology (INRIA)</a></p><p>I worked on a variety of subjects, such as A.I. <strong>Object Detection</strong>, <strong>3D projections</strong> and <strong>web interfaces</strong>.</p><img src=\"/detections.3948b0cd.webp\" alt=\"Climbing holds detection\"><div class=\"img-desc\">Climbing Holds detection on a video using the YOLO A.I. model</div><img src=\"/proj.62c3a323.webp\" alt=\"Video projection in a virtual world\"><div class=\"img-desc\">Video projection in a virtual world</div><p>It was an very enriching experience, during which I had the opportunity to work on a multiplicity of subjects, such as training of Deep Learning models, python Dashboards and 3D graphics.</p>";


var $d1fb2d8500acb245$exports = {};
$d1fb2d8500acb245$exports = "<p>Réalisation d'une application mobile pour Android permettant d'accéder à l'emploi du temps par les élèves de <a href=\"https://www.polytech.universite-paris-saclay.fr/\">Polytech Paris-Saclay</a>. Les données sont récoltées à l'aide d'un scrapper et sont sauvegardés sur l'appareil, puis mises à jour régulièrement. L'affichage des cours est personnalisé en fonction du profil de l'élève.</p><div style=\"grid-template-columns:1fr 1fr;gap:2rem;display:grid\"><img src=\"/1.e202ac0c.webp\" alt=\"Une journée de cours\"><img src=\"/2.ce8ec2a6.webp\" alt=\"Paramètres d'affichage\"></div><p><img src=\"/5.5a89cf7b.webp\" alt=\"Format paysage\"></p><p>L'application est à ce jour utilisée par la majorité des élèves de Polytech (500 utilisateurs réguliers). Ce projet m'aura permis de découvrir l'écosystème Android et la distribution d'applications sur le Play Store.</p>";


var $fc2b07c6f0963e5e$exports = {};
$fc2b07c6f0963e5e$exports = "<p>Android mobile app to access the timetable for <a href=\"https://www.polytech.universite-paris-saclay.fr/en\">Polytech Paris-Saclay</a> students. Data is scrapped from a website and stored on user's device. It is then updated regularly. Displayed Courses are filtered for a user's profile.</p><div style=\"grid-template-columns:1fr 1fr;gap:2rem;display:grid\"><img src=\"/1.e202ac0c.webp\" alt=\"The home screen\"><img src=\"/2.ce8ec2a6.webp\" alt=\"The app settings\"></div><p><img src=\"/5.5a89cf7b.webp\" alt=\"Format paysage\"></p><p>The app is actively used by a majority of students on the campus (~500 active users). The project allowed me to discover the Android ecosystem and publishing process.</p>";


var $34cd4961ee318d00$exports = {};
$34cd4961ee318d00$exports = "<p><a href=\"https://moncraft.thissma.fr/\">MonCraft</a> est un jeu vidéo conçu initialement pour le cours d'OpenGL dispensé à Polytech Paris-Saclay par <a href=\"https://tobias.isenberg.cc/\">M. Isenberg</a>. Le sujet nous ayant particulièrement intéressé, Pierre et moi-même avons décidé de poursuivre le développement.</p><p>MonCraft est codé à partir de zéro ou presque, nous permettant d'expérimenter et d'apprendre au mieux le fonctionnement des applications 3D. De nombreuses fonctionnalités ont étés implémentées : Une <strong>génération procédurale</strong> infinie, un mode <strong>multijoueur</strong>, une <strong><a href=\"https://moncraft.thissma.fr/\">version web</a></strong> de démo.</p><img src=\"/moncraft.7686432e.webp\" alt=\"Capture d'écran en jeu\"><div class=\"img-desc\">Une capture d'écran du jeu</div><p>Minecraft is an interesting game to code, as it groups together a number of interesting 3D graphics challenges. The most prevalent are detailled below.</p><h2>Procedural generation</h2><p>The world generation is <em>procedural</em>, <em>infinite</em> and <em>reproducible</em> (seeded). It means that we can generate infinitely many different worlds, that are (almost) infinitely large, and entierely controlled by a single number : the <em>seed</em>.</p><p>World generation combines mathematical knowledge about random number generators (PRNGs), hash functions, voronoi patterns, procedural noises (perlin), … With performance and artistic concerns.</p><img src=\"/collage.d02b6bc7.webp\" alt=\"Images générées procéduralement\"><div class=\"img-desc\">Images procédurales pour la génération des \"biomes\"</div><p>As you can see, generation can also be an artistic process. This is merely an overview of the plethora of images we generated while calibrating our random number engines and developped the different <em>biomes</em>. The game includes different landscapes such as forests, plains, deserts, oceans, mountains…</p><h2>Light and Shadows</h2><p>Shadows are casted using <em>Cascading Shadow Maps</em> it means that at each frame, the world is rendered both from the player- and the sun's perspective. There are three levels or details, allowing to concentrate the shadow details near the player and leverage computing power.</p><p>The water surface has animated reflections using a <em>normal map</em> generated procedurally. The game includes a day/light cycle.</p><h2>Chunking and Meshing</h2><p>The world is sliced in regions of 16×16×16 blocks called <em>Chunks</em>. This allows to load and unload parts of the world around the player as it moves. Each chunk is responsible for a <em>mesh</em> (a renderable 3D model). For optimal performances, only visible block faces are loaded and only chunks in front of the player are rendered.</p><p>The chunks are <em>serializable</em>, meaning the world can be sent over the network or saved on the disk when modified.</p><img src=\"/chunks.60a05870.webp\" alt=\"Overview of the chunks in the world\"><div class=\"img-desc\">Overview of the chunks in the world</div>";


var $b9933f57f04ad148$exports = {};
$b9933f57f04ad148$exports = "<p><a href=\"https://moncraft.thissma.fr/\">MonCraft</a> is a 3D video game inspired by <a href=\"https://minecraft.net/\">Minecraft</a>. Development began during a course dispensed by <a href=\"https://tobias.isenberg.cc/\">Dr. Isenberg</a> at the engineering school Polytech Paris-Saclay. Development continued after the course as the subject interessed us particularly.</p><p>MonCraft is build from scratch, allowing us to experiment and try our ideas in 3D rendering. Many features have been implemented, such as: an infinite <strong>procedural generation</strong>, a <strong>multiplayer</strong> mode, a demo <strong><a href=\"https://moncraft.thissma.fr/\">web version</a></strong>.</p><img src=\"/moncraft.7686432e.webp\" alt=\"An in-game screenshot\"><div class=\"img-desc\">An in-game screenshot</div><p>Minecraft is an interesting game to code, as it groups together a number of interesting 3D graphics challenges. The most prevalent are detailled below.</p><h2>Procedural generation</h2><p>The world generation is <em>procedural</em>, <em>infinite</em> and <em>reproducible</em> (seeded). It means that we can generate infinitely many different worlds, that are (almost) infinitely large, and entierely controlled by a single number : the <em>seed</em>.</p><p>World generation combines mathematical knowledge about random number generators (PRNGs), hash functions, voronoi patterns, procedural noises (perlin), … With performance and artistic concerns.</p><img src=\"/collage.d02b6bc7.webp\" alt=\"Procedurally generated images\"><div class=\"img-desc\">Procedurally generated images used for biome generation</div><p>As you can see, generation can also be an artistic process. This is merely an overview of the plethora of images we generated while calibrating our random number engines and developped the different <em>biomes</em>. The game includes different landscapes such as forests, plains, deserts, oceans, mountains…</p><h2>Light and Shadows</h2><p>Shadows are casted using <em>Cascading Shadow Maps</em> it means that at each frame, the world is rendered both from the player- and the sun's perspective. There are three levels or details, allowing to concentrate the shadow details near the player and leverage computing power.</p><p>The water surface has animated reflections using a <em>normal map</em> generated procedurally. The game includes a day/light cycle.</p><h2>Chunking and Meshing</h2><p>The world is sliced in regions of 16×16×16 blocks called <em>Chunks</em>. This allows to load and unload parts of the world around the player as it moves. Each chunk is responsible for a <em>mesh</em> (a renderable 3D model). For optimal performances, only visible block faces are loaded and only chunks in front of the player are rendered.</p><p>The chunks are <em>serializable</em>, meaning the world can be sent over the network or saved on the disk when modified.</p><img src=\"/chunks.60a05870.webp\" alt=\"Overview of the chunks in the world\"><div class=\"img-desc\">Overview of the chunks in the world</div>";


var $214bf3974bc676c3$exports = {};
$214bf3974bc676c3$exports = "<p>Le <a href=\"https://fr.wikipedia.org/wiki/Jeu_royal_d%27Ur\">Jeu Royal d'Ur</a> est l'un des plus vieux jeux de plateau dont on ait pu retrouver les règles. Il apparaît en Mésopotamie vers -2600 av. J.C.</p><p>J'ai créé une <a href=\"https://ur.thissma.fr/\">version web</a> du jeu, avec plusieurs modes : deux joueurs, multijoueur en réseau ou contre un bot.</p><div style=\"grid-template-columns:3fr 2fr;gap:2rem;display:grid\"><img src=\"/ur.11f6db8e.webp\" alt=\"The Royal Game of Ur\"><img src=\"/ur_rules.1354d0eb.webp\" alt=\"The Royal Game of Ur\"></div><br><i>Pour plus d'informations sur le jeu, voir la vidéo de Tom Scott sur la chaîne Youtube du <a href=\"https://youtu.be/WZskjLq040I\">British Museum</a>. [en anglais]</i>";


var $74df9dfe037b05a3$exports = {};
$74df9dfe037b05a3$exports = "<p>The <a href=\"https://en.wikipedia.org/wiki/Royal_Game_of_Ur\">Royal Game of Ur</a> is one of the oldest board games still playable today. It was popular in ancient Mesopotamia around 2600 BC.</p><p>I built an <a href=\"https://ur.thissma.fr/\">online version</a> of the game, supporting 3 game modes : 1v1, multiplayer online and against a bot.</p><div style=\"grid-template-columns:3fr 2fr;gap:2rem;display:grid\"><img src=\"/ur.11f6db8e.webp\" alt=\"The Royal Game of Ur\"><img src=\"/ur_rules.1354d0eb.webp\" alt=\"The Royal Game of Ur\"></div><br><i>For more informations about the game, go watch the playthrough starring Tom Scott on the <a href=\"https://youtu.be/WZskjLq040I\">British Museum YT channel</a>.</i>";


var $c8f91688671860fe$exports = {};
$c8f91688671860fe$exports = "<p>Pixels est un mini-jeu dans lequel les joueurs colorent des pixels sur un canvas, en temps réel. Les joueurs collaborent à la création de pixel art en réseau.</p><p>L'idée provient de l'expérience virale <a href=\"https://en.wikipedia.org/wiki/Place_(Reddit)\">r/place</a> menée par le réseau social <a href=\"https://www.reddit.com/r/place/\">Reddit</a>.</p><img src=\"/rplace.b1c5f4a9.webp\" alt=\"Capture de r/place sur Reddit.\"><div class=\"img-desc\">Capture d'écran de r/place sur Reddit.</div>";


var $b2fd2f943dd4e99a$exports = {};
$b2fd2f943dd4e99a$exports = "<p>Pixels is a mini-game where players collaborate in real time on a canvas to draw pixel art.</p><p>The idea came from the viral '<a href=\"https://en.wikipedia.org/wiki/Place_(Reddit)\">r/place</a>' experiment that took place on <a href=\"https://www.reddit.com/r/place/\">Reddit</a>.</p><img src=\"/rplace.b1c5f4a9.webp\" alt=\"Screen capture of r/place from Reddit.\"><div class=\"img-desc\">Screen capture of r/place from Reddit.</div>";


var $79a43741b02e5ce3$exports = {};
$79a43741b02e5ce3$exports = "<p>Teeworlds est un jeu de plateforme multijoueur comprenant une multitude de modes de jeu. Le jeu est développé en Open Source et de nombreuses variantes ont vu le jour au fil des années, notament la version DDRaceNetwork actuellement la plus populaire.</p><p>DDRace est un mode de jeu collaboratif où les joueurs doivent s'entraîder pour parvenir à la fin de la map le plus vite possible. Les maps sont créées par les joueurs et proposées à la communauté pour être intégrées sur les serveurs. J'ai développé un éditeur de map en ligne, où tout le monde peut se connecter et créer des maps ensemble. Les modifications sont synchronisées en temps réel entre les différents utilisateurs. Les joueurs peuvent désormais créer des maps collaborativement !</p>";


var $001124cadde089a8$exports = {};
$001124cadde089a8$exports = "<p>Teeworlds is a popular platformer video game comprising a variety of game modes. The game is Open-Source and multiple variations of the original game exist. The most popular is DDRaceNetwork, in which players collaborate to reach the end of the map as fast as possible.</p><p>The game maps are created by the players and submitted to the community to be included in the Teeworlds servers. I created an online map editor in which multiple users can connect simultaneously, and modifications are synchronized in real time. That way, players can create maps collaboratively!</p>";


var $3e4c7914eee62d62$exports = {};
$3e4c7914eee62d62$exports = "<p>J'ai réalisé un stage de trois mois pendant l'été 2022, durant lequel j'ai développé une visualisation intéractive de molécules dans le logiciel OpenSpace. OpenSpace est un logiciel de visualisation de l'univers à plusieurs échelles, de l'échelle sub-planétaire à l'échelle de l'univers. Mon stage constitue un premier pas dans l'intégration de l'échelle moléculaire dans ce logiciel.</p><p>Lien vers la [https://www.youtube.com/watch?v=Rc_XvKVcmgg](vidéo de présentation) et [https://doi.org/10.1016/j.cag.2023.02.006](la publication).</p>";


var $510bb46ccdef3cdc$exports = {};
$510bb46ccdef3cdc$exports = "<p>During the summer of 2022, I did an internship in the Scientific Visualization Group at the Liköping University, Sweden. I worked on a rendering of molecular dynamics in <a href=\"OpenSpace\">https://www.openspaceproject.com/</a>.</p><p>Check out the [https://www.youtube.com/watch?v=Rc_XvKVcmgg](presentation video) and the <a href=\"paper\">https://doi.org/10.1016/j.cag.2023.02.006</a>.</p>";


var $6348dbe9c789379a$exports = {};

$6348dbe9c789379a$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "moncraft.f7a273ff.webp";


var $d3a6193ee72e8467$exports = {};

$d3a6193ee72e8467$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "sunny.9f9bc85b.webp";


var $1cda263e5abcc2ca$exports = {};

$1cda263e5abcc2ca$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "moliverse.307a19ce.webp";


var $42ddfb8e46e07b02$exports = {};

$42ddfb8e46e07b02$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "perfanalytics.94c5ff60.webp";


var $4bedc711404e7643$exports = {};

$4bedc711404e7643$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "edt.7cf28a9a.webp";


var $98f95c50afbbeb7c$exports = {};

$98f95c50afbbeb7c$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "gameofur.fb4d886d.webp";


var $371415ccfe32bd14$exports = {};

$371415ccfe32bd14$exports = (parcelRequire("aNJCr")).getBundleURL("13ph5") + "pixels.c9ce1e84.webp";


var $454c9ac5aedb0901$var$MyProjects = {
    moncraft: {
        img: new URL($6348dbe9c789379a$exports),
        collab: "Pierre Surer, Houssem Mahmoud",
        link: "https://moncraft.thissma.fr/",
        git: "https://github.com/k2d222/MonCraft",
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($34cd4961ee318d00$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($b9933f57f04ad148$exports)))
        }
    },
    twwe: {
        img: new URL($d3a6193ee72e8467$exports),
        link: "https://tw.thissma.fr/",
        git: "https://github.com/k2d222/twwe",
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($79a43741b02e5ce3$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($001124cadde089a8$exports)))
        }
    },
    moliverse: {
        img: new URL($1cda263e5abcc2ca$exports),
        link: "https://youtu.be/Rc_XvKVcmgg?si=K-W8hFFBSJ_w-hXG",
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($3e4c7914eee62d62$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($510bb46ccdef3cdc$exports)))
        }
    },
    perfanalytics: {
        img: new URL($42ddfb8e46e07b02$exports),
        link: "https://perfanalytics.fr",
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($dc67fde8a3a75c29$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($a7213980b3075060$exports)))
        }
    },
    edt: {
        img: new URL($4bedc711404e7643$exports),
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($d1fb2d8500acb245$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($fc2b07c6f0963e5e$exports)))
        }
    },
    ur: {
        img: new URL($98f95c50afbbeb7c$exports),
        link: "https://ur.thissma.fr/",
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($214bf3974bc676c3$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($74df9dfe037b05a3$exports)))
        }
    },
    pixels: {
        img: new URL($371415ccfe32bd14$exports),
        collab: "S\xe9bastien Pereira",
        link: "https://pixels.thissma.fr/",
        content: {
            fr: (0, (/*@__PURE__*/$parcel$interopDefault($c8f91688671860fe$exports))),
            en: (0, (/*@__PURE__*/$parcel$interopDefault($b2fd2f943dd4e99a$exports)))
        }
    }
};
var $454c9ac5aedb0901$export$2e2bcd8739ae039 = $454c9ac5aedb0901$var$MyProjects;


var $4572864467590719$exports = {};
$4572864467590719$exports = {
    "subtitle": "Doctorant en informatique \xe0 l'universit\xe9 de Link\xf6ping (Su\xe8de).",
    "internship": "Portfolio de mes projets pass\xe9s.",
    "contactme": "Contactez-moi par mail ou bien directement par t\xe9l\xe9phone.",
    "curriculum": "Retrouvez mon C.V. en version pdf.",
    "navprojects": "Projets",
    "navcontact": "Contact",
    "navcv": "C.V.",
    "titleprojects": "Mes Derniers Projets",
    "titlecontact": "Contactez-moi",
    "titlecv": "Curriculum Vitae",
    "projectlink": "Lien",
    "projectgit": "Git",
    "projectcollab": "Collaboration",
    "projects": {
        "moncraft": {
            "name": "MonCraft",
            "brief": "Jeu vid\xe9o inspir\xe9 de Minecraft",
            "desc": 'Jeu vid\xe9o R\xe9alis\xe9 "from sratch" en C++ et OpenGL. Jouable en multijoueur, sur PC ou navigateur.'
        },
        "twwe": {
            "name": "Teeworlds Web Editor",
            "brief": "\xc9diteur de maps Teeworlds",
            "desc": '\xc9diteur de maps en ligne et collaboratif pour jeu vid\xe9o "Teeworlds".'
        },
        "moliverse": {
            "name": "Moliverse",
            "brief": "Rendu de mol\xe9cules dans OpenSpace",
            "desc": "Stage de recherche \xe0 Norrk\xf6ping en Su\xe8de."
        },
        "perfanalytics": {
            "name": "PerfAnalytics",
            "brief": "Traitement de vid\xe9os d'escalade",
            "desc": "Stage dans un laboratoire de recherche \xe0 Grenoble."
        },
        "edt": {
            "name": "Polytech EDT",
            "brief": "Application Emploi du Temps",
            "desc": "Application Android pour l'\xe9cole Polytech Paris-Saclay."
        },
        "ur": {
            "name": "Jeu de Ur",
            "brief": "Jeu de plateau dans le navigateur",
            "desc": "Animations, Impl\xe9mentation d'un bot et d'un mode multijoueur avec un serveur."
        },
        "pixels": {
            "name": "Pixels",
            "brief": "Dessin \xe0 plusieurs dans le navigateur",
            "desc": 'Inspir\xe9 par l\'exp\xe9rience "r/place" de Reddit.'
        },
        "podelium": {
            "name": "Podelium [En cours]",
            "brief": "Jeu vid\xe9o \u2013 Tower Defense",
            "desc": "Jeu vid\xe9o m\xealant strat\xe9gie, coop\xe9ration et comp\xe9tition."
        },
        "goteka": {
            "name": "Goteka [Exp\xe9rimental]",
            "brief": "Transpilation de GTK dans le navigateur",
            "desc": "Ambitieux projet de portage de GTK avec WebAssembly et un transpilateur \xe9crit en Rust."
        }
    }
};


var $1b5fe4a4a0087499$exports = {};
$1b5fe4a4a0087499$exports = {
    "subtitle": "PhD student at Link\xf6ping Universitet (Sweden).",
    "internship": "Portfolio of my past projects.",
    "contactme": "Don't hesitate to send me an email or message me on Whatsapp/Signal/Telegram.",
    "curriculum": "Download my resume in pdf.",
    "navprojects": "Projects",
    "navcontact": "Contact",
    "navcv": "Resume",
    "titleprojects": "My Latest Projects",
    "titlecontact": "Get in touch",
    "titlecv": "Resume",
    "projectlink": "Link",
    "projectgit": "Git",
    "projectcollab": "Collaboration",
    "projects": {
        "moncraft": {
            "name": "MonCraft",
            "brief": "Voxel game inspired by Minecraft",
            "desc": 'Video game made "from sratch" in C++ and OpenGL. Playable in single- or multiplayer mode, on PC or in the browser.'
        },
        "twwe": {
            "name": "Teeworlds Web Editor",
            "brief": "Map Editor for Teeworlds",
            "desc": 'Online and collaborative editor for the video game "Teeworlds"'
        },
        "moliverse": {
            "name": "Moliverse",
            "brief": "Molecular rendering in OpenSpace",
            "desc": "Internship in a research lab in Sweden."
        },
        "perfanalytics": {
            "name": "PerfAnalytics",
            "brief": "Computer Vision internship",
            "desc": "Climbing holds detection and transformations in 3D space."
        },
        "edt": {
            "name": "Polytech EDT",
            "brief": "Timetable application",
            "desc": "Android app for Polytech Paris-Saclay engineering school"
        },
        "ur": {
            "name": "Royal Game of Ur",
            "brief": "Board game in a web browser",
            "desc": "Features include animations, a bot adversary as well as a web server to play with friends."
        },
        "pixels": {
            "name": "Pixels",
            "brief": "Draw together on a pixelated canvas",
            "desc": 'Inspired by the viral "r/place" experiment hosted on Reddit.'
        },
        "podelium": {
            "name": "Podelium [Ongoing]",
            "brief": "Browser Video Game \u2013 Tower Defense",
            "desc": "A complex multiplayer, strategy and tower defense game."
        },
        "goteka": {
            "name": "Goteka [Experimental]",
            "brief": "Compiling GTK for web browsers",
            "desc": "Porting the GTK toolkit using WebAssembly and a homemade transpiler written in Rust."
        }
    }
};


var $095eea52e952c4fb$var$i18n = (0, $afed287e05d98684$export$920091e3d72d80ee)({
    locale: navigator.language.substr(0, 2),
    fallbackLocale: "en",
    messages: {
        fr: (0, (/*@__PURE__*/$parcel$interopDefault($4572864467590719$exports))),
        en: (0, (/*@__PURE__*/$parcel$interopDefault($1b5fe4a4a0087499$exports)))
    }
});
var $095eea52e952c4fb$var$localeGuard = function(to, from) {
    var locale = to.params.locale;
    var locales = $095eea52e952c4fb$var$i18n.global.availableLocales;
    if (typeof locale === "string" && locales.includes(locale)) $095eea52e952c4fb$var$i18n.global.locale = locale;
    else return {
        params: {
            locale: "en"
        },
        redirect: true
    };
};
var $095eea52e952c4fb$var$router = (0, $6986282d55d35034$export$baddd0131ee8c05b)({
    history: (0, $6986282d55d35034$export$7b4942f78e7b8a49)(),
    scrollBehavior: function(to, from, savedPosition) {
        if (to.hash) return {
            el: to.hash,
            behavior: "smooth"
        };
        else return {
            to: 0
        };
    },
    routes: [
        {
            path: "/:locale",
            component: (0, $58bc8bd34e1d1cd3$export$2e2bcd8739ae039),
            children: [
                {
                    name: "home",
                    path: "",
                    component: (0, $665fb4b7d4f27076$export$2e2bcd8739ae039)
                },
                {
                    name: "project",
                    path: "projects/:projectid",
                    component: (0, $df2692fa06efa23e$export$2e2bcd8739ae039)
                }
            ]
        },
        {
            path: "/",
            redirect: {
                name: "home",
                params: {
                    locale: "fr"
                }
            }
        }
    ]
});
$095eea52e952c4fb$var$router.beforeEach($095eea52e952c4fb$var$localeGuard);
var $095eea52e952c4fb$var$app = (0, $6zPDN.createApp)((0, $450cd9afaeb1592d$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.config.globalProperties.projects = (0, $454c9ac5aedb0901$export$2e2bcd8739ae039);
$095eea52e952c4fb$var$app.use($095eea52e952c4fb$var$i18n);
$095eea52e952c4fb$var$app.use($095eea52e952c4fb$var$router);
$095eea52e952c4fb$var$app.component("home", (0, $665fb4b7d4f27076$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.component("card", (0, $7f5ac3a3e41340d3$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.component("my-header", (0, $e1ba05b0b482fba0$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.component("my-title", (0, $ffae8c228c0868b6$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.component("projects", (0, $ae2f9c0b280185c4$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.component("project", (0, $df2692fa06efa23e$export$2e2bcd8739ae039));
$095eea52e952c4fb$var$app.mount("#app");

})();
//# sourceMappingURL=index.b233faae.js.map
